import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  Flex, FormControl,
  FormErrorMessage,
  HStack,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Select,
  Switch,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
  VStack,
  useDisclosure,
  useToast
} from "@chakra-ui/react";
import { BarElement, CategoryScale, Chart as ChartJS, Filler, Legend, LegendItem, LineElement, LinearScale, PointElement, Tooltip } from "chart.js";
import annotationPlugin, { AnnotationOptions, LabelPosition } from 'chartjs-plugin-annotation';
import Decimal from 'decimal.js';
import React, { forwardRef, useCallback, useContext, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import { Chart, Line } from "react-chartjs-2";
import { v4 } from 'uuid';
import { WebAPIContext } from '../../contexts/WebAPIContext';
import ConfirmDialog from '../../components/ConfirmDialog';
import ReadOnlyExemptButton from '../../components/ReadOnlyExemptButton';
import {
  CurrencyNameJPY,
  CustomerIndustry,
  DownsideItems,
  DownsideItemsTitle,
  Messages,
  ProfitAndLossItems,
  WorkflowId,
  ProfitRateChartYAxisMax,
  ProfitRateChartYAxisMin,
  getCustomerIndustryTypeNameByCode,
  EquipmentUsageType,
  RecoverySimulationItems,
  FlowKb,
} from '../../contexts/constants';
import {
  BomData,
  ConfirmorInfo,
  Currency,
  CycleTimeImprovement,
  DownsideIndex,
  DownsideIndexEnableType,
  DownsideIndexType,
  EquipmentExtType,
  EquipmentType,
  Errors,
  LaborCostScenario,
  MergedChartData,
  MonthlyExpenseData,
  MonthlyProfitAndLossData,
  NonWorkingHoursType,
  OriginalProfitAndLossByMonthTable,
  PagePermissions,
  PartNo,
  PriceRows,
  PricingAgreementFormType,
  ProductionLineType,
  ProjectContextType,
  ProjectWithRdsData,
  QuantityAndPriceMonthTable,
  SalesByPartNo,
  SavedEquipmentConfig,
  SavedSimulationConfig,
  TScenario,
  UniqueProcessType,
  WorkingDaysType,
  YearData,
  YieldRateImprovement,
  CapacityDetailsData,
  ProductionQuantityDetailsData,
  competitiorCondition,
  competitorType,
} from '../../contexts/types';

import {
  calcEquipmentQuantity,
  calcProfitRate,
  calcRecoverySimulation,
  isSameFiscalYear
} from "../../utils/calculation";
import { getBilingualDisplayName } from "../../utils/i18nDisplay";

import dayjs from "dayjs";
import { useTranslation } from 'react-i18next';
import Draggable from "react-draggable";
import { useAppSelector } from "../../store/hooks";
import { convertCurrency, convertChartDatasets } from '../../utils/CurrencyConverter';
import type { ConvertFn } from '../../utils/reviewCalculation';
import { convertCurrencyByMonth } from '../../utils/reviewCalculation';
import { calcMonthsBetweenDates, convertEquipmentData, getMaterialCostByPartNoByMonth, calcEquipmentDepreciationByYearMonth, getTotalFiscalYearsByPartNo, calcTotalCycleTimeByMonth, applyBaseUpRateToLaborCost, getQuantitiesByPartNoMonth, calcTotalQuantityByMonth, calcCycleTimeBasedCost, applyScenarioLaborCostToProjectData } from "../../utils/calculation";
import { formatNumber, formatRecoveryMonths, hasDecimal, getLocalCurrencyId, getLocationCountry, formatYearMonthByLocale, splitEscapedList, resolveChartDatasetLabels } from '../../utils/utils';
import { findMissingPastPartNos } from '../../utils/partNoConsistency';
import { getConfirmor, updateConfirm } from "../../utils/workflow";
import '../common.css';
import ConfirmorList from "./ConfirmorList";
import SalesDataLinkage from "./TabPanels/SalesDataLinkage";
import { FactorDef } from "./TabPanels/types";
import QuantityAndPriceSection from "./QuantityAndPriceSection";
import EquipmentPersonnelChangeSection from "./EquipmentPersonnelChangeSection";
import PhasedEquipmentInvestmentSection from "./PhasedEquipmentInvestmentSection";
import ProductionFactoryCostSection from "./ProductionFactoryCostSection";

// コンテキスト
import { RiSparklingFill } from "react-icons/ri";
import AIAnalysisModal from "../Modal/AIAnalysisModal";
import { generateSimulationNewProductPrompt, AI_ANALYSIS_TITLES } from "../../utils/aiPrompt";
import { ProjectContext, getPermissions } from "./InvestmentScreeningDetail";
import NonWorkingHours from "./NonWorkingHours";
import WorkingDays from "./WorkingDays";
import { calcMaterialCost, calcMergedChartData, calcMergedChartDataSet, calcOriginalCombinedChartDataSet, calcDownsideSalesChartDataSet, calcProfitByMonth, calcQuantitiesChartDataSet, calcRecoverySimulationForNewProduct, calcYAxisRange, computeCommonScaleSalesChart, getDownsideIndexToCost, getDownsideIndexToPeriod, getDownsideIndexToQuantity, getDownsideIndexToValue, getPriceData, getQuantities, calcOriginalSalesChartDataSet, calcDownsideCombinedChartDataSet, calcTotalProfitAndRate, calcYearlyRoundedProfitTotal, generateRecoveryPointAnnotationOptions, generateAnnotationStarLabels, changeChartData, calcMonthlyProfitAndLossDetails, calcRealProfitRate, calcRealProfitRateByMonth, calcMonthlyProfitInDisplayCurrency, calcRealProfitRateCommon } from "../../utils/chartDataCalculation";
import * as XLSX from "xlsx";
import GoogleAPI, { GoogleAPIBatchCollector } from '../../utils/GoogleAPI';
import HelpIcon from "./HelpIcon";

// SpreadSheet同期用カスタムフック
import {
  workingDaysToSpreadSheetData,
  spreadSheetDataToWorkingDays,
  nonWorkingHoursToSpreadSheetData,
  spreadSheetDataToNonWorkingHours,
  multiPartQuantityAndPriceToSpreadSheetData,
  spreadSheetDataToMultiPartQuantityAndPrice,
  equipmentStaffingToSpreadSheetData,
  spreadSheetDataToEquipmentStaffing,
  setupEquipmentStaffingSheet,
  phasedCapitalInvestmentToSpreadSheetData,
  spreadSheetDataToPhasedCapitalInvestment,
  setupPhasedCapitalInvestmentSheet,
  yieldImprovementToSpreadSheetData,
  spreadSheetDataToYieldImprovement,
  setupYieldImprovementSheet,
  cycleTimeReductionToSpreadSheetData,
  spreadSheetDataToCycleTimeReduction,
  setupCycleTimeReductionSheet,
  laborCostToSpreadSheetData,
  spreadSheetDataToLaborCost,
  setupLaborCostSheet,
  SHEET_NAME_QUANTITY_AND_PRICE,
  SHEET_NAME_EQUIPMENT_STAFFING,
  SHEET_NAME_PHASED_CAPITAL_INVESTMENT,
  SHEET_NAME_OPERATING_DAYS,
  SHEET_NAME_DOWNTIME,
  SHEET_NAME_YIELD_IMPROVEMENT,
  SHEET_NAME_CYCLE_TIME_REDUCTION,
  SHEET_NAME_LABOR_COST,
  type WorkingDaysYearData,
  type NonWorkingHoursYearData,
} from '../../hooks';
import YieldImprovementRow from "./YieldImprovementRow";
import CycleTimeImprovementRow from "./CycleTimeImprovementRow";
import { ExistingLineCapacityPanel } from "./ExistingLineCapacityPanel";
import { createExistingLineCapacitySectionRows, TExistingLineCapacitySource, TExistingLineCapacityVersion } from "../../utils/existingLineCapacityChart";
import { useExistingLineCapacity } from "../../hooks/useExistingLineCapacity";

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, BarElement, annotationPlugin, Tooltip, Legend, Filler);

/**
 * 条件テーブル
 */
export interface ConditionTable {

  /** 顧客業界(コード) */
  customerIndustry: string,

  /** 顧客業界(名称) */
  customerIndustryName: string,

  /** 顧客国籍 */
  customerNationality: string,

  /** 顧客名 */
  customerName: string,

  /** エンドユーザ名 */
  endUserName: string,

  /** 工場為替 */
  factoryExchange?: Currency,

  /** 販売為替 */
  salesExchange?: Currency,

  /** 工場拠点国 */
  factoryLocationCountry: string[]

}

/**
 * ストレス指数(画面表示用)
 */
interface DownsideIndexDisplay {

  /** 数量経時変化(画面表示用) */
  quantityChangeOverTimeString: string,

  /** 数量上下変動(画面表示用) */
  fluctuationInQuantityString: string,

  /** 単価経時変化(画面表示用) */
  priceChangeOverTimeString: string,

  /** 顧客製品寿命(画面表示用) */
  customerProductLifecycleString: string,

  /** 為替変動(画面表示用) */
  currencyFluctuationString: string,

  /** 材料高騰(画面表示用) */
  risingMaterialCostsString: string,

  /** 労務費高騰(画面表示用) */
  risingLaborCostsString: string,

  /** 競合状態(画面表示用) */
  competitorConditionString: string,

}

/**
 * ストレス指数(表)(画面表示用)
 */
interface DownsideIndexTableRowDisplay {

  /** 年(画面表示用) */
  yearString: string,
  /** 年index(更新用) */
  yearIndex: number,

  /** 数量経時変化(画面表示用) */
  quantityChangeOverTimeString: string,
  quantityChangeOverTimeId: string,
  quantityChangeOverTime: number,

  /** 数量上下変動(画面表示用) */
  fluctuationInQuantityString: string,
  fluctuationInQuantityId: string,
  fluctuationInQuantity: number,

  /** 単価経時変化(画面表示用) */
  priceChangeOverTimeString: string,
  priceChangeOverTimeId: string,
  priceChangeOverTime: number,

  /** 顧客製品寿命(画面表示用) */
  customerProductLifecycleString: string,
  customerProductLifecycleId: string,
  customerProductLifecycle: number,

  /** 為替変動（単価）(画面表示用) */
  currencyFluctuationToPriceString: string,
  currencyFluctuationToPriceId: string,
  currencyFluctuationToPrice: number,

  /** 為替変動（原価）(画面表示用) */
  currencyFluctuationToCostString: string,
  currencyFluctuationToCostId: string,
  currencyFluctuationToCost: number,

  /** 材料高騰(画面表示用) */
  risingMaterialCostsString: string,
  risingMaterialCostsId: string,
  risingMaterialCosts: number,

  /** 労務費高騰(画面表示用) */
  risingLaborCostsString: string,
  risingLaborCostsId: string,
  risingLaborCosts: number,

  /** 競合状態（数量）(画面表示用) */
  competitorConditionToQuantityString: string,
  competitorConditionToQuantityStringPre: string,
  competitorConditionToQuantityId: string,
  competitorConditionToQuantity: number,

  /** 競合状態（単価）(画面表示用) */
  competitorConditionToPriceString: string,
  competitorConditionToPriceStringPre: string,
  competitorConditionToPriceId: string,
  competitorConditionToPrice: number,
}

/**
 * ストレス指数(有効・無効)
 */
interface DownsideIndexEnable {
  /** 数量経時変化(有効/無効) */
  isEnabledQuantityChangeOverTime: boolean,

  /** 数量上下変動(有効/無効) */
  isEnabledFluctuationInQuantity: boolean,

  /** 単価経時変化(有効/無効) */
  isEnabledPriceChangeOverTime: boolean,

  /** 顧客製品寿命(有効/無効) */
  isEnabledCustomerProductLifecycle: boolean,

  /** 為替変動（単価）(有効/無効) */
  isEnabledCurrencyFluctuationToPrice: boolean,

  /** 為替変動（原価）(有効/無効) */
  isEnabledCurrencyFluctuationToCost: boolean,

  /** 材料高騰(有効/無効) */
  isEnabledRisingMaterialCosts: boolean,

  /** 労務費高騰(有効/無効) */
  isEnabledRisingLaborCosts: boolean,

  /** 競合状態（数量）(有効/無効) */
  isEnabledCompetitorConditionToQuantity: boolean,

  /** 競合状態（単価）(有効/無効) */
  isEnabledCompetitorConditionToPrice: boolean
}



/**
 * Simulation（新製品製造）パラメータ
 */
interface SimulationNewProductProps {
  /** プロジェクトID */
  projectId: string;
  /** 月別レートMap（振り返りモード用） */
  monthlyRateMap?: Map<string, Currency[]>;
}

/**
 * 確認担当者
 */
interface Confirmor {
  simulationNewProduct?: {
    companyDivision?: string[];
    companyHeadDivision?: string[];
  };
}

/** テキストエリアのref型定義 */
interface TextareaHandle {
  getValue: () => string | null;
  setValue: (value: string | null) => void;
}

/** ダウンサイドリスク対応テキストエリア（親の再レンダリングから隔離） */
const DownsideRiskTextarea = forwardRef<TextareaHandle, {
  initialValue?: string | null;
  /** 入力値変更時に親へ通知するコールバック（親のドラフトref更新用） */
  onValueChange?: (value: string) => void;
}>(
  ({ initialValue, onValueChange }, ref) => {
    const { t } = useTranslation();
    const [value, setValue] = useState<string | null>(initialValue ?? null);

    useImperativeHandle(ref, () => ({
      getValue: () => value,
      setValue: (v: string | null) => setValue(v),
    }));

    return (
      <Box mt={4}>
        <Heading size="md" mb={2}>
          {t('features.InvestmentScreening.SimulationNewProduct.heading.downsideRiskMeasures')}
        </Heading>
        <Textarea
          value={value ?? ""}
          onChange={(e) => {
            setValue(e.target.value);
            onValueChange?.(e.target.value);
          }}
          width="70%"
        />
      </Box>
    );
  }
);

/** 最終的な投資判断の理由テキストエリア（親の再レンダリングから隔離） */
const FinalInvestmentReasonTextarea = forwardRef<TextareaHandle, {
  initialValue?: string | null;
  /** 入力値変更時に親へ通知するコールバック（親のドラフトref更新用） */
  onValueChange?: (value: string) => void;
  error: { isError: boolean; errorMessage: string };
}>(
  ({ initialValue, onValueChange, error }, ref) => {
    const { t } = useTranslation();
    const [value, setValue] = useState<string | null>(initialValue ?? null);

    useImperativeHandle(ref, () => ({
      getValue: () => value,
      setValue: (v: string | null) => setValue(v),
    }));

    return (
      <FormControl mt={2} isInvalid={error.isError}>
        <Box mt={4}>
          <VStack spacing={4} align="stretch">
            <Heading size="md" mb={2}>
              {t('features.InvestmentScreening.SimulationNewProduct.heading.finalInvestmentReason')}
            </Heading>
            <Box display="flex" justifyContent="flex-start">
              <Textarea
                name="finalInvestmentReason"
                value={value ?? ""}
                onChange={(e) => {
                  setValue(e.target.value);
                  onValueChange?.(e.target.value);
                }}
                placeholder={t('features.InvestmentScreening.SimulationNewProduct.placeholder.finalInvestmentReason')}
                width="88%"
                isInvalid={error.isError}
              />
            </Box>
            <FormErrorMessage mt={0}>{error.errorMessage}</FormErrorMessage>
          </VStack>
        </Box>
      </FormControl>
    );
  }
);

/** デフォルト値固定 */
const ZERO_DECIMAL = new Decimal(0);

/**
 * 競合情報が未登録の場合の補完値（競合なし扱い）
 * 顧客取り決め事項が未保存、または競合項目追加前の既存データでは competitor が存在しないため使用する
 */
const NO_COMPETITOR_DEFAULT: PricingAgreementFormType["competitor"] = {
  competitorType: competitorType.NoCompetitor.value,
  competitiorCondition: null,
  selectedCompetitors: [],
  competitorNameOther: null,
  shareOfCompetitorAndCompany: null,
  sharePercentage: 100,
};

/**
 * 新規投資申請画面(Simulation（新製品製造）)
 */
const SimulationNewProduct: React.FC<SimulationNewProductProps> = ({ projectId, monthlyRateMap = new Map() }) => {

  const { t, i18n } = useTranslation();

  /** トースト表示用 */
  const toast = useToast();

  /** 通信オブジェクト */
  const WebAPI = useContext(WebAPIContext);

  // -----------------------------
  // 権限情報
  // -----------------------------
  const { userPermissions, reviewDate, currencyData, currencyStatus } = useContext(ProjectContext) as ProjectContextType;

  /** ログインユーザー：従業員ID */
  const employeeId = useAppSelector((state) => state.employee.employeeId);

  /** ログインユーザー：部署ID */
  const divisionId = useAppSelector((state) => state.employee.divisionId);

  /** 生成AI利用制限フラグ（案件の申請部署ベース） */
  const isAIRestricted = useAppSelector((state) => state.employee.isAIRestricted);
  /** システム全体AI利用可否フラグ（GCP Gemini利用グループへの所属） */
  const isAIEnabled = useAppSelector((state) => state.employee.isAIEnabled);

  /** 画面タイトル */
  const TITLE = t('features.InvestmentScreening.SimulationNewProduct.title');

  /** 必須データを促すメッセージ */
  /** i18n: validation.registerFrom */

  /** ポップアップ本体幅 */
  const POPUP_WIDTH = 1155;
  /** ポップアップ本体高さ */
  const POPUP_HEIGHT = 630;

  /** ストレス指数ポップアップ本体幅 */
  // 多言語対応: 英語は「Competitor Status」列見出しが長くなるため、
  // 列幅・テーブル幅・ポップアップ幅を言語に応じて広げ、モーダルからの
  // はみ出し（突き抜け）を防ぐ
  const DOWNSIDE_INDEX_POPUP_WIDTH = i18n.language === "en" ? 1868 : 1768;

  /** ストレス指数ポップアップ本体幅 */
  const DOWNSIDE_INDEX_TABLE_WIDTH = i18n.language === "en" ? "1810px" : "1730px";

  /** ストレス指数列幅 */
  const DOWNSIDE_INDEX_COLUMN_WIDTH = "130px";

  /** サイクルタイムの最大値 */
  const CYCLE_TIME_MAX = 9999;

  // 精度を50桁に設定
  Decimal.set({ precision: 50 });

  // AI分析
  const [isAIModalOpen, setIsAIModalOpen] = useState(false);
  const [adjustedOrders, setAdjustedOrders] = useState<number[]>([]); // 月ごとの受注数量データ
  const [productionCapacityData, setProductionCapacityData] = useState<number[]>([]); // 月ごとの生産キャパデータ

  /** 条件テーブル */
  const [conditionTable, setConditionTable] = useState<ConditionTable>();

  /** ストレス指数 */
  const [downsideIndex, setDownsideIndex] = useState<DownsideIndex>({

    /** 数量経時変化 */
    quantityChangeOverTime: [],

    /** 数量上下変動 */
    quantityFluctuation: [],

    /** 単価経時変化 */
    priceChangeOverTime: [],

    /** 顧客製品寿命 */
    customerProductLifecycle: 0,

    /** 為替変動（単価） */
    exchangeRateFluctuationToPrice: [],

    /** 為替変動（原価） */
    exchangeRateFluctuationToCost: [],

    /** 材料高騰 */
    materialCostIncrease: [],

    /** 労務費高騰 */
    laborCostIncrease: [],

    /** 競合状態（数量） */
    competitorStatusToQuantity: [],

    /** 競合状態（単価） */
    competitorStatusToPrice: [],

  });

  /** ストレス指数（リセット用） */
  const [downsideIndexForReset, setDownsideIndexForReset] = useState<DownsideIndex>({
    quantityChangeOverTime: [],
    quantityFluctuation: [],
    priceChangeOverTime: [],
    customerProductLifecycle: 0,
    exchangeRateFluctuationToPrice: [],
    exchangeRateFluctuationToCost: [],
    materialCostIncrease: [],
    laborCostIncrease: [],
    competitorStatusToQuantity: [],
    competitorStatusToPrice: []
  });

  /** ストレス指数（有効・無効）（リセット用） */
  const [downsideIndexEnableForReset, setDownsideIndexEnableForReset] = useState<DownsideIndexEnable>({
    // 数量経時変化
    isEnabledQuantityChangeOverTime: true,
    // 数量上下変動
    isEnabledFluctuationInQuantity: true,
    // 単価経時変化
    isEnabledPriceChangeOverTime: true,
    // 顧客製品寿命
    isEnabledCustomerProductLifecycle: true,
    // 為替変動（単価）
    isEnabledCurrencyFluctuationToPrice: true,
    // 為替変動（原価）
    isEnabledCurrencyFluctuationToCost: true,
    // 材料高騰
    isEnabledRisingMaterialCosts: true,
    // 労務費高騰
    isEnabledRisingLaborCosts: true,
    // 競合状態（数量）
    isEnabledCompetitorConditionToQuantity: true,
    // 競合状態（単価）
    isEnabledCompetitorConditionToPrice: true
  });

  /** ストレス指数（グラフ用） */
  const [downsideIndexGraph, setDownsideIndexGraph] = useState<DownsideIndex>({

    /** 数量経時変化 */
    quantityChangeOverTime: [],

    /** 数量上下変動 */
    quantityFluctuation: [],

    /** 単価経時変化 */
    priceChangeOverTime: [],

    /** 顧客製品寿命 */
    customerProductLifecycle: 0,

    /** 為替変動（単価） */
    exchangeRateFluctuationToPrice: [],

    /** 為替変動（原価） */
    exchangeRateFluctuationToCost: [],

    /** 材料高騰 */
    materialCostIncrease: [],

    /** 労務費高騰 */
    laborCostIncrease: [],

    /** 競合状態（数量） */
    competitorStatusToQuantity: [],

    /** 競合状態（単価） */
    competitorStatusToPrice: [],

  });

  // ストレス反映トグルの入力状態（設定タブ用）
  const [applyDownsideInput, setApplyDownsideInput] = useState<boolean>(true);

  // ストレスOFF時に使用する全値ゼロのダウンサイドインデックス
  const neutralDownsideIndex = useMemo(() => ({
    quantityChangeOverTime: downsideIndexGraph.quantityChangeOverTime.map(() => 0),
    quantityFluctuation: downsideIndexGraph.quantityFluctuation.map(() => 0),
    priceChangeOverTime: downsideIndexGraph.priceChangeOverTime.map(() => 0),
    customerProductLifecycle: 0,
    exchangeRateFluctuationToPrice: downsideIndexGraph.exchangeRateFluctuationToPrice.map(() => 0),
    exchangeRateFluctuationToCost: downsideIndexGraph.exchangeRateFluctuationToCost.map(() => 0),
    materialCostIncrease: downsideIndexGraph.materialCostIncrease.map(() => 0),
    laborCostIncrease: downsideIndexGraph.laborCostIncrease.map(() => 0),
    competitorStatusToQuantity: downsideIndexGraph.competitorStatusToQuantity.map(() => 0),
    competitorStatusToPrice: downsideIndexGraph.competitorStatusToPrice.map(() => 0),
  }), [downsideIndexGraph]);

  // ストレス指数入力欄にフォーカスした際の一時的な値を保持するRef
  const focusedValueRef = useRef<number | null>(null);

  /** ストレス指数の最大値 */
  const DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH = "80px";

  /** ストレス指数の最大値 */
  const DOWNSIDE_INDEX_MAX = 999;

  /** ストレス指数の最小値 */
  const DOWNSIDE_INDEX_MIN = -999;

  /** ストレス指数(顧客製品寿命)の最大値 */
  const DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MAX = 0;

  /** ストレス指数(顧客製品寿命)の最小値 */
  //const DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MIN = 1;
  const DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MIN = -98;

  /** ストレス指数（画面表示用） */
  const [downsideIndexDisplay, setDownsideIndexDisplay] = useState<DownsideIndexDisplay>({

    /** 数量経時変化 */
    quantityChangeOverTimeString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),

    /** 数量上下変動 */
    fluctuationInQuantityString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),

    /** 単価経時変化 */
    priceChangeOverTimeString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),

    /** 顧客製品寿命 */
    customerProductLifecycleString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),

    /** 為替変動 */
    currencyFluctuationString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),

    /** 材料高騰 */
    risingMaterialCostsString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),

    /** 労務費高騰 */
    risingLaborCostsString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),

    /** 競合状態 */
    competitorConditionString: t('features.InvestmentScreening.SimulationNewProduct.label.noCompetitor'),

  });

  /** ストレス指数(表)（画面表示用） */
  const [downsideIndexTableDisplay, setDownsideIndexTableDisplay] = useState<DownsideIndexTableRowDisplay[]>([]);

  /** ストレス指数(表)（リセット用） */
  const [downsideIndexTableDisplayForReset, setDownsideIndexTableDisplayForReset] = useState<DownsideIndexTableRowDisplay[]>([]);

  /** ストレス指数（有効/無効） */
  const [downsideIndexEnable, setDownsideIndexEnable] = useState<DownsideIndexEnable>({

    /** 数量経時変化 */
    isEnabledQuantityChangeOverTime: true,

    /** 数量上下変動 */
    isEnabledFluctuationInQuantity: true,

    /** 単価経時変化 */
    isEnabledPriceChangeOverTime: true,

    /** 顧客製品寿命 */
    isEnabledCustomerProductLifecycle: true,

    /** 為替変動（単価） */
    isEnabledCurrencyFluctuationToPrice: true,

    /** 為替変動（原価） */
    isEnabledCurrencyFluctuationToCost: true,

    /** 材料高騰 */
    isEnabledRisingMaterialCosts: true,

    /** 労務費高騰 */
    isEnabledRisingLaborCosts: true,

    /** 競合状態（数量） */
    isEnabledCompetitorConditionToQuantity: true,

    /** 競合状態（単価） */
    isEnabledCompetitorConditionToPrice: true,

  });

  /** 【参照データ】プロジェクト情報 */
  const [projectData, setProjectData] = useState<ProjectWithRdsData | null>();
  /** 【メモ化データ】プロジェクト情報 */
  const safeProjectData = useMemo(() => {
    return {
      ...projectData,
      projectStartDate: projectData?.projectStartDate || dayjs().format("YYYY-MM-DD"),
      projectEndDate: projectData?.projectEndDate,
    };
  }, [projectData]);

  /** 汎用設備かどうか */
  const isGeneralPurpose = projectData?.equipmentUsageType === EquipmentUsageType.GeneralPurpose.code;
  const labelQuantity = isGeneralPurpose ? t('features.InvestmentScreening.SimulationNewProduct.label.estimatedQuantity') : t('features.InvestmentScreening.SimulationNewProduct.label.salesQuantity');
  const labelPrice = isGeneralPurpose ? t('features.InvestmentScreening.SimulationNewProduct.label.estimatedPrice') : t('features.InvestmentScreening.SimulationNewProduct.label.salesPrice');
  const labelQuantityAndPrice = isGeneralPurpose ? t('features.InvestmentScreening.SimulationNewProduct.label.estimatedQuantityAndPrice') : t('features.InvestmentScreening.SimulationNewProduct.label.salesQuantityAndPrice');

  /** 【参照データ】工程情報（C/T計算用） */
  const [uniqueProcessData, setUniqueProcessData] = useState<UniqueProcessType[]>([]);

  /** 【参照データ】プロジェクト情報（オリジナル(当初損益)）（「対象プロジェクトの利益試算」で登録データ） */
  // const [originalProfitAndLoss, setOriginalProfitAndLoss] = useState<OriginalProfitAndLossTable>();//おそらく不要

  /** 【参照データ】プロジェクト情報（オリジナル月別(当初損益月別)）（「対象プロジェクトの利益試算」で登録データ） */
  const [originalProfitAndLossByMonth, setOriginalProfitAndLossByMonth] = useState<OriginalProfitAndLossByMonthTable>();

  /** 【参照データ】プロジェクト情報（オリジナル月別(当初損益月別)）- JPY版（二重通貨変換回避用） */
  const [displayOriginalProfitAndLossByMonth, setDisplayOriginalProfitAndLossByMonth] = useState<OriginalProfitAndLossByMonthTable>();

  /** 【参照データ】設備情報（M_CEAS_EQUIPMENT）（「設備投資」で登録したデータ） */
  const [equipmentAmounts, setEquipmentAmounts] = useState<EquipmentExtType[]>([]);
  /** 初期表示の設備情報（当初計画・ダウンサイド用） */
  const [originalEquipmentAmounts, setOriginalEquipmentAmounts] = useState<EquipmentExtType[]>([]);

  /** 初期表示の過去設備情報（当初投資・回収用） */
  const [pastEquipmentAmounts, setPastEquipmentAmounts] = useState<EquipmentExtType[]>([]);
  /**
   * 【参照データ】過去プロジェクト情報
   * ■ 新製品の過去PJ紐づけの用途:
   *   新製品を試しに投資申請して軌道にのってから、再度追加で投資申請を出すパターン。
   *   （同じ製品・パーツNoで、当初の試作投資 → 追加の量産投資）
   *   過去PJ = 当初の試作投資、現在PJ = 追加の量産投資として、
   *   「プロジェクト全体投資回収」と「当初投資・回収」のチャートで回収状況を評価する。
   */
  const [pastProjectData, setPastProjectData] = useState<ProjectWithRdsData | null>();
  /** 【参照データ】「数量・単価」で登録したデータ(過去プロジェクト) */
  const [pastCapexPartNo, setPastCapexPartNo] = useState<PartNo[]>([]);
  /** 通貨情報（過去プロジェクト） */
  const [pastCurrencyData, setPastCurrencyData] = useState<Currency[]>([]);
  /** 過去プロジェクトのPart Noのうち、本プロジェクトに含まれないPart No（データ取得時の判定結果。不整合なしは空配列） */
  const [missingPastPartNoList, setMissingPastPartNoList] = useState<string[]>([]);
  /** データ取得時の不整合トーストを表示済みかどうか（再レンダリングでの重複表示を防ぐ） */
  const pastPartNoToastShownRef = useRef<boolean>(false);

  /** 【シミュレーション設定用】数量・単価情報（M_CEAS_PART_NO.quantityAndPrice）（「設備投資」で登録したデータ） */
  const [quantityAndPriceTables, setQuantityAndPriceTables] = useState<{ data: QuantityAndPriceMonthTable, edited: boolean }[]>([]);
  /** 初期表示の数量・単価情報（当初計画・ダウンサイド用） */
  const [originalQuantityAndPriceTables, setOriginalQuantityAndPriceTables] = useState<{ data: QuantityAndPriceMonthTable, edited: boolean }[]>([]);

  /** シミュレーション設定（労務費）：生産工場労務費（月別） */
  const [scenarioLaborCostByMonth, setScenarioLaborCostByMonth] = useState<number[]>([]);
  /** シミュレーション設定（労務費）：償却費以外の工場経費（月別） */
  const [scenarioOverseasFactoryExpensesByMonth, setScenarioOverseasFactoryExpensesByMonth] = useState<number[]>([]);
  /** 労務費自動算出中フラグ */
  const [isLaborCostCalculating, setIsLaborCostCalculating] = useState<boolean>(false);

  /** シミュレーション設定（労務費）：生産工場労務費単価（費用画面の設定値を初期表示、シミュレーション変更可） */
  const [scenarioProductionFactoryLaborUnitPrice, setScenarioProductionFactoryLaborUnitPrice] = useState<number | null>(null);
  /** シミュレーション設定（労務費）：生産工場経費単価（費用画面の設定値を初期表示、シミュレーション変更可） */
  const [scenarioProductionFactoryExpenseUnitPrice, setScenarioProductionFactoryExpenseUnitPrice] = useState<number | null>(null);
  /** シミュレーション設定（労務費）：労務費ベースアップ率（費用画面の設定値を初期表示、シミュレーション変更可） */
  const [scenarioBaseLaborCostIncreaseRate, setScenarioBaseLaborCostIncreaseRate] = useState<number | null>(null);

  /**
   * 費用画面で設定した「生産工場労務費単価・生産工場経費単価・労務費ベースアップ率」を
   * シミュレーション設定の初期値として反映する（projectData取得時に一度だけ設定）
   */
  useEffect(() => {
    setScenarioProductionFactoryLaborUnitPrice(projectData?.productionFactoryLaborUnitPrice ?? null);
    setScenarioProductionFactoryExpenseUnitPrice(projectData?.productionFactoryExpenseUnitPrice ?? null);
    setScenarioBaseLaborCostIncreaseRate(projectData?.baseLaborCostIncreaseRate ?? null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectData?.productionFactoryLaborUnitPrice, projectData?.productionFactoryExpenseUnitPrice, projectData?.baseLaborCostIncreaseRate]);

  /**
   * 費用画面で登録された月別「生産工場労務費」「償却費以外の工場経費」を
   * originalProfitAndLossByMonth.labels の年月順に並べた配列を返す。
   * （オリジナルデータを初期表示・リセットの基準値として使用）
   */
  const getOriginalLaborCostArrays = (): { laborCost: number[]; overseasExpenses: number[] } => {
    const labels = originalProfitAndLossByMonth?.labels ?? [];
    let monthly: MonthlyExpenseData[] = [];
    try {
      monthly = projectData?.monthlyExpenseData ? JSON.parse(projectData.monthlyExpenseData) : [];
    } catch {
      monthly = [];
    }
    const laborCost = labels.map((label) => {
      const [year, month] = label.split("/").map(Number);
      return monthly.find((d) => d.year === year && d.month === month)?.productionLaborCost ?? 0;
    });
    const overseasExpenses = labels.map((label) => {
      const [year, month] = label.split("/").map(Number);
      return monthly.find((d) => d.year === year && d.month === month)?.overseasFactoryExpenses ?? 0;
    });
    return { laborCost, overseasExpenses };
  };

  /**
   * 画面初期表示時、月別「生産工場労務費」「償却費以外の工場経費」に
   * 費用画面で登録済みのオリジナル値を初期表示する（未設定=空配列のときのみ）。
   */
  useEffect(() => {
    const labels = originalProfitAndLossByMonth?.labels ?? [];
    if (labels.length === 0) return;
    // 既に値がある場合（自動算出・シナリオ読込・ユーザー編集後）は上書きしない
    if (scenarioLaborCostByMonth.length > 0 || scenarioOverseasFactoryExpensesByMonth.length > 0) return;
    const { laborCost, overseasExpenses } = getOriginalLaborCostArrays();
    setScenarioLaborCostByMonth(laborCost);
    setScenarioOverseasFactoryExpensesByMonth(overseasExpenses);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [originalProfitAndLossByMonth?.labels, projectData?.monthlyExpenseData]);

  // 単価行データ
  const [priceRows, setPriceRows] = useState<{ id: string; rows: PriceRows[] }[]>([]);

  /** 初期表示のシミュレーション設定（当初計画・ダウンサイド用） */
  const [originalImprovedWorkingDaysData, setOriginalImprovedWorkingDaysData] = useState<{ fiscalYear: string, workingDaysData: WorkingDaysType }[]>([]);
  const [originalImprovedNonWorkingHoursData, setOriginalImprovedNonWorkingHoursData] = useState<{ fiscalYear: string, nonWorkingHoursByMonth: NonWorkingHoursType[] }[]>([]);
  const [originalImprovedYieldRateList, setOriginalImprovedYieldRateList] = useState<YieldRateImprovement[]>([]);
  const [originalImprovedCycleTimeList, setOriginalImprovedCycleTimeList] = useState<CycleTimeImprovement[]>([]);

  /** 設備情報（選択済みのみ） */
  const selectedEquipmentAmounts = equipmentAmounts.filter(e => e.selected);

  /** 合計設備金額 */
  const sumEquipmentAmount = useMemo(() => equipmentAmounts.reduce((sum: Decimal, e) =>
    sum.plus(new Decimal(e.amount || 0) || 0), new Decimal(0)) ?? 0, [equipmentAmounts]);

  /** 合計設備金額(選択) */
  const sumSelectedEquipmentAmount = useMemo(() => equipmentAmounts.reduce((sum: Decimal, e) =>
    sum.plus(e.selected ? (new Decimal(e.amount || 0)) : 0), new Decimal(0)) ?? 0, [equipmentAmounts]);

  /** 増減率(設備投資金額) */
  const rateOfChangeAmount = useMemo(() =>
    sumSelectedEquipmentAmount.div(sumEquipmentAmount).mul(100).round().minus(100).toNumber(),
    [sumSelectedEquipmentAmount, sumEquipmentAmount]);

  /** 製造ライン情報 */
  const [productionLine, setProductionLine] = useState<ProductionLineType>({});

  /** BOMデータ */
  const [bomData, setBomData] = useState<BomData[]>([]);

  // ▼ 通貨
  /** 販売通貨名 */
  const [salesCurrencyName, setSalesCurrencyName] = useState<string>("");
  /** ローカル通貨名 */
  const [localCurrencyName, setLocalCurrencyName] = useState<string>("");

  // 基準年度
  const [baseStartYear, setBaseStartYear] = useState<number>(0);
  // 選択通貨（PartNo単位）
  const [selectedCurrencyByPartNo, setSelectedCurrencyByPartNo] = useState<{ tableId: string; partNo: string; id: string; name: string }[]>([]);
  /** 表示通貨情報（通貨切り替え用） */
  const [selectedCurrency, setSelectedCurrency] = useState<{ id: string; name: string }>({
    id: "",
    name: ""
  });

  /** 通貨選択オプション（ローカル通貨とJPYのみ） */
  const localCurrencyId = getLocalCurrencyId(projectData?.companyPlantSnapshot);
  const currencyOptions = useMemo(() => {
    return currencyData.filter(
      (currencyItem) =>
        currencyItem.currencyId === localCurrencyId ||
        currencyItem.currencyName === CurrencyNameJPY
    )
      .map((currencyItem) => ({
        value: currencyItem.currencyId || "",
        label: currencyItem.currencyName || ""
      }));
  }, [currencyData, localCurrencyId]);

  /** displayOriginalProfitAndLossByMonthの通貨名（常にJPY固定） */
  const savedDisplayCurrencyName = CurrencyNameJPY;

  /** TODO プロジェクト情報にないもの（今後使う） */
  // const [projectProcess, setProjectProcess] = useState<any>(null);

  // ▼ 売上チャートデータ
  /** 売上（当初計画） */
  const [salesChartData, setSalesChartData] = useState<any>(null);
  /** 売上（ダウンサイド） */
  const [salesChartDataModified, setSalesChartDataModified] = useState<any>(null);
  /** 売上（保存済み設定用）配列形式 */
  const [salesChartDataForSavedConfig, setSalesChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);
  /** 売上（ダウンサイド）パーツNo別 */
  const [monthlySalesModifiedByPartNo, setMonthlySalesModifiedByPartNo] = useState<SalesByPartNo>({});

  // ▼ 売上チャートデータ（JPY版：displayOriginalProfitAndLossByMonthから計算）
  /** 売上（当初計画）JPY版 */
  const [displayVersionSalesChartData, setDisplayVersionSalesChartData] = useState<any>(null);
  /** 売上（ダウンサイド）JPY版 */
  const [displayVersionSalesChartDataModified, setDisplayVersionSalesChartDataModified] = useState<any>(null);

  // ▼ 売上チャートデータ（表示用：選択通貨）
  /** 売上（当初計画）表示用 */
  const [displaySalesChartData, setDisplaySalesChartData] = useState<any>(null);
  /** 売上（ダウンサイド）表示用 */
  const [displaySalesChartDataModified, setDisplaySalesChartDataModified] = useState<any>(null);
  /** 売上（保存済み設定用）表示用 */
  const [displaySalesChartDataForSavedConfig, setDisplaySalesChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);

  // ▼ 投資回収チャートデータ
  /** 投資回収（当初計画） */
  const [combinedChartData, setCombinedChartData] = useState<any>(null);
  /** 投資回収（ダウンサイド） */
  const [combinedChartDataModified, setCombinedChartDataModified] = useState<any>(null);
  /** 投資回収（保存済み設定用）配列形式 */
  const [combinedChartDataForSavedConfig, setCombinedChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);

  // ▼ プロジェクト全体投資回収チャートデータ
  /** 投資回収（プロジェクト全体投資回収） */
  const [combinedChartDataAll, setCombinedChartDataAll] = useState<any>(null);
  /** 売上チャートデータ（プロジェクト全体投資回収用） */
  const [salesChartDataAll, setSalesChartDataAll] = useState<any>(null);
  /** 投資回収（当初投資・回収） */
  const [combinedChartDataPast, setCombinedChartDataPast] = useState<any>(null);
  /** 売上チャートデータ（当初投資・回収用） */
  const [salesChartDataPast, setSalesChartDataPast] = useState<any>(null);

  // ▼ 増分キャッシュフロー Excel出力用データ
  /** 増分キャッシュフロー（当初計画）Excel出力用 */
  const [incrementalCashFlowOriginal, setIncrementalCashFlowOriginal] = useState<any>(null);
  /** 増分キャッシュフロー（ダウンサイド）Excel出力用 */
  const [incrementalCashFlowDownside, setIncrementalCashFlowDownside] = useState<any>(null);
  /** 増分キャッシュフロー（保存済み設定）Excel出力用 */
  const [incrementalCashFlowForSavedConfig, setIncrementalCashFlowForSavedConfig] = useState<{ configId: string; data: any }[]>([]);
  /** 増分キャッシュフロー（PJ全体）Excel出力用 */
  const [incrementalCashFlowAll, setIncrementalCashFlowAll] = useState<any>(null);
  /** 増分キャッシュフロー（当初投資）Excel出力用 */
  const [incrementalCashFlowPast, setIncrementalCashFlowPast] = useState<any>(null);

  // ▼ 営業利益合計と営業利益率（当初計画）
  /** 営業利益合計（当初計画） */
  const [totalProfitOriginal, setTotalProfitOriginal] = useState<Decimal | null>(null);
  /** 営業利益率（当初計画） */
  const [profitRateOriginal, setProfitRateOriginal] = useState<string | null>(null);

  // ▼ 営業利益合計と営業利益率（ダウンサイド）
  /** 営業利益合計（ダウンサイド） */
  const [totalProfitModified, setTotalProfitModified] = useState<Decimal | null>(null);
  /** 営業利益率（ダウンサイド） */
  const [profitRateModified, setProfitRateModified] = useState<string | null>(null);

  // ▼ 実質的営業利益率（当初計画・ダウンサイド）- DB保存用
  /** 実質的営業利益率（当初計画） */
  const [realProfitRateOriginal, setRealProfitRateOriginal] = useState<string | null>(null);
  /** 実質的営業利益率（ダウンサイド） */
  const [realProfitRateModified, setRealProfitRateModified] = useState<string | null>(null);
  /** 実質的営業利益率 月次データ（当初計画） */
  const [realProfitRateByMonthOriginal, setRealProfitRateByMonthOriginal] = useState<number[]>([]);
  /** 実質的営業利益率 月次データ（ダウンサイド） */
  const [realProfitRateByMonthModified, setRealProfitRateByMonthModified] = useState<number[]>([]);

  // ▼ 投資回収チャートデータ（JPY版：displayOriginalProfitAndLossByMonthから計算）
  /** 投資回収（当初計画）JPY版 */
  const [displayVersionCombinedChartData, setDisplayVersionCombinedChartData] = useState<any>(null);
  /** 投資回収（ダウンサイド）JPY版 */
  const [displayVersionCombinedChartDataModified, setDisplayVersionCombinedChartDataModified] = useState<any>(null);

  // ▼ 投資回収チャートデータ（表示用：選択通貨）
  /** 投資回収（当初計画）表示用 */
  const [displayCombinedChartData, setDisplayCombinedChartData] = useState<any>(null);
  /** 投資回収（ダウンサイド）表示用 */
  const [displayCombinedChartDataModified, setDisplayCombinedChartDataModified] = useState<any>(null);
  /** 投資回収（保存済み設定用）表示用 */
  const [displayCombinedChartDataForSavedConfig, setDisplayCombinedChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);

  // ▼ 数量（Part別 月次数量）チャートデータ (オリジナル / 修正後) の2種類
  /** 数量（当初計画） */
  const [quantitiesChartDataOriginal, setQuantitiesChartDataOriginal] = useState<any>(null);
  /** 数量（ダウンサイド） */
  const [quantitiesChartDataModified, setQuantitiesChartDataModified] = useState<any>(null);
  /** 数量（保存済み設定用）配列形式 */
  const [quantitiesChartDataForSavedConfig, setQuantitiesChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);

  // ▼ 価格と材料単価（Price & Material）チャートデータ (オリジナル / 修正後) の2種類
  /** 価格と材料単価（当初計画） */
  const [mergedChartDataOriginal, setMergedChartDataOriginal] = useState<any>(null);
  /** 価格と材料単価（ダウンサイド） */
  const [mergedChartDataModified, setMergedChartDataModified] = useState<any>(null);
  /** 価格と材料単価（保存済み設定用）配列形式 */
  const [mergedChartDataForSavedConfig, setMergedChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);

  // ▼ 価格と材料単価チャートデータ（JPY版：displayOriginalProfitAndLossByMonthから計算）
  /** 価格と材料単価（当初計画）JPY版 */
  const [displayVersionMergedChartDataOriginal, setDisplayVersionMergedChartDataOriginal] = useState<any>(null);
  /** 価格と材料単価（ダウンサイド）JPY版 */
  const [displayVersionMergedChartDataModified, setDisplayVersionMergedChartDataModified] = useState<any>(null);
  /** 価格と材料単価（保存済み設定用）JPY版 */
  const [displayVersionMergedChartDataForSavedConfig, setDisplayVersionMergedChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);
  /** 売上（保存済み設定用）JPY版 */
  const [displayVersionSalesChartDataForSavedConfig, setDisplayVersionSalesChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);

  // ▼ 価格と材料単価チャートデータ（表示用：選択通貨）
  /** 価格と材料単価（当初計画）表示用 */
  const [displayMergedChartDataOriginal, setDisplayMergedChartDataOriginal] = useState<any>(null);
  /** 価格と材料単価（ダウンサイド）表示用 */
  const [displayMergedChartDataModified, setDisplayMergedChartDataModified] = useState<any>(null);
  /** 価格と材料単価（保存済み設定用）表示用 */
  const [displayMergedChartDataForSavedConfig, setDisplayMergedChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);

  // ▼ 選択される顧客製品
  /** 選択顧客製品（顧客業界）|「ダウンサイド」ボタン押下時に設定 */
  const [selectedCustomerProduct, setSelectedCustomerProduct] = useState<string | null>(null);

  /** 回収時期ｎヶ月目（当初計画） */
  const [monthOfRecoveryOriginal, setMonthOfRecoveryOriginal] = useState<number[]>([]);
  /** 回収時期ｎヶ月目（ダウンサイド） */
  const [monthOfRecoveryModified, setMonthOfRecoveryModified] = useState<number[]>([]);
  /** 回収時期ｎヶ月目（プロジェクト全体投資回収） */
  const [monthOfRecoveryAll, setMonthOfRecoveryAll] = useState<number[]>([]);
  /** 回収時期ｎヶ月目（当初投資・回収） */
  const [monthOfRecoveryPast, setMonthOfRecoveryPast] = useState<number[]>([]);
  /** 回収時期（保存済み設定用）配列形式 */
  const [monthOfRecoveryForSavedConfig, setMonthOfRecoveryForSavedConfig] = useState<{ configId: string; data: number[] }[]>([]);

  /** 新製品投資量産開始年月（★ラベル表示位置） */
  const [newProductStartYearMonth, setNewProductStartYearMonth] = useState<string>("");

  /** 最終的な投資判断の理由（ref経由で子コンポーネントにアクセス） */
  const finalInvestmentReasonRef = useRef<TextareaHandle>(null);

  /** ダウンサイドリスク対応（ref経由で子コンポーネントにアクセス） */
  const downsideRiskRef = useRef<TextareaHandle>(null);

  /** 最終的な投資判断の理由の入力値（タブ切替でテキストエリアがアンマウントされても保持する） */
  const finalInvestmentReasonDraftRef = useRef<string | null>(null);
  /** ダウンサイドリスク対応の入力値（同上） */
  const downsideRiskDraftRef = useRef<string | null>(null);

  // ▼ 顧客需要と設備キャパシティチャートデータ
  // 顧客需要と設備キャパシティ(当初計画)
  const [gapChartDataOriginal, setGapChartDataOriginal] = useState<any>(null);
  // 顧客需要と設備キャパシティ(ダウンサイド)
  const [gapChartDataModified, setGapChartDataModified] = useState<any>(null);
  // 顧客需要と設備キャパシティ(保存済み設定用)配列形式
  const [gapChartDataForSavedConfig, setGapChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);

  // ▼ 設備生産数量からのギャップチャートデータ
  // 設備生産数量からのギャップ(当初計画)
  const [productionQuantityChartDataOriginal, setProductionQuantityChartDataOriginal] = useState<any>(null);
  // 設備生産数量からのギャップ(ダウンサイド)
  const [productionQuantityChartDataModified, setProductionQuantityChartDataModified] = useState<any>(null);
  // 設備生産数量からのギャップ(保存済み設定用)配列形式
  const [productionQuantityChartDataForSavedConfig, setProductionQuantityChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);

  // ▼ 生産キャパグラフ（既存ライン含む）
  // 案件品のPartNo別数量とキャパ（「顧客需要と設備キャパシティ」の計算から切り出し）
  // 要否・既存ライン生産数量・グラフデータは useExistingLineCapacity で管理
  const [existingLineCapacitySource, setExistingLineCapacitySource] = useState<TExistingLineCapacitySource | null>(null);

  // 【参照データ】 月別工場稼働日数（カレンダー上の稼働日数）
  const [factoryWorkingDayByYear, setFactoryWorkingDayByYear] = useState<{ fiscalYear: string, workingDay: number[] }[]>([]);
  // 【参照データ】 月別稼働日数
  const [workingDayByYear, setWorkingDayByYear] = useState<{ fiscalYear: string, workingDay: number[] }[]>([]);
  // 【参照データ】 改善後月別稼働日数
  const [improvedWorkingDayByYear, setImprovedWorkingDayByYear] = useState<{ fiscalYear: string, workingDay: number[] }[]>([]);
  // 【参照データ】 月別ライン数
  const [lineCountByYear, setLineCountByYear] = useState<{ fiscalYear: string, lineCount: number[] }[]>([]);
  // 【参照データ】 改善後月別ライン数
  const [improvedLineCountByYear, setImprovedLineCountByYear] = useState<{ fiscalYear: string, lineCount: number[] }[]>([]);
  // 【参照データ】 休日出勤日数
  const [holidayByYear, setHolidayByYear] = useState<{ fiscalYear: string, holiday: number[] }[]>([]);
  // 【参照データ】 改善後月別休日出勤日数
  const [improvedHolidayByYear, setImprovedHolidayByYear] = useState<{ fiscalYear: string, holiday: number[] }[]>([]);
  // 【参照データ】 稼働率
  const [availabilityRateByMonth, setAvailabilityRateByMonth] = useState<{ fiscalYear: string, availabilityRate: number[] }[]>([]);
  // 【参照データ】 改善後稼働率
  const [improvedAvailabilityRateByMonth, setImprovedAvailabilityRateByMonth] = useState<{ fiscalYear: string, availabilityRate: number[] }[]>([]);
  // 【参照データ】 改善後歩留リスト (日付別)
  const [improvedYieldRateList, setImprovedYieldRateList] = useState<YieldRateImprovement[]>([]);
  // 【参照データ】 改善後歩留 (後方互換用 - 最初の改善値または基本値)
  const [improvedYieldRate, setImprovedYieldRate] = useState<number>(0);
  // 【参照データ】 改善後歩留 画面表示用 (後方互換用)
  const [improvedYieldRateText, setImprovedYieldRateText] = useState<string>("0.0");
  // 【参照データ】 短縮後サイクルタイムリスト (日付別)
  const [improvedCycleTimeList, setImprovedCycleTimeList] = useState<CycleTimeImprovement[]>([]);
  // 【参照データ】 短縮後サイクルタイム (後方互換用 - 最初の改善値または基本値)
  const [improvedCycleTime, setImprovedCycleTime] = useState<number>(0);
  // 【参照データ】 短縮後サイクルタイムテキスト (後方互換用)
  const [improvedCycleTimeText, setImprovedCycleTimeText] = useState<string>("0.0");
  // 【参照データ】 稼働日数
  const [workingDaysData, setWorkingDaysData] = useState<{ fiscalYear: string, workingDaysData: WorkingDaysType }[]>([]);
  // 【参照データ】 改善後稼働日数
  const [improvedWorkingDaysData, setImprovedWorkingDaysData] = useState<{ fiscalYear: string, workingDaysData: WorkingDaysType }[]>([]);
  // 【参照データ】 稼働日数入力チェック結果
  const [isValidWorkingDays, setIsValidWorkingDays] = useState<boolean>(false);
  // 【参照データ】 非稼働時間
  const [nonWorkingHoursData, setNonWorkingHoursData] = useState<{ fiscalYear: string, nonWorkingHoursByMonth: NonWorkingHoursType[] }[]>([]);
  // 【参照データ】 改善後非稼働時間
  const [improvedNonWorkingHoursData, setImprovedNonWorkingHoursData] = useState<{ fiscalYear: string, nonWorkingHoursByMonth: NonWorkingHoursType[] }[]>([]);

  // SpreadSheet同期用状態変数（1つのSpreadSheetで稼働日数・非稼働時間を管理）
  const [spreadSheetWindow, setSpreadSheetWindow] = useState<Window | null>(null);
  const [isSpreadSheetLoading, setIsSpreadSheetLoading] = useState<boolean>(false);
  const [inputModeSimulation, setInputModeSimulation] = useState<"google" | "manual">("manual");
  const [activeSpreadsheetId, setActiveSpreadsheetId] = useState<string | null>(null);
  const [qpSyncError, setQpSyncError] = useState<{ invalidValueErrors: string[]; warnings: string[] }>({ invalidValueErrors: [], warnings: [] });
  const [esSyncError, setEsSyncError] = useState<{ invalidValueErrors: string[] }>({ invalidValueErrors: [] });
  const [lcSyncError, setLcSyncError] = useState<{ invalidValueErrors: string[] }>({ invalidValueErrors: [] });
  const [pciSyncError, setPciSyncError] = useState<{ invalidValueErrors: string[] }>({ invalidValueErrors: [] });
  const [workingDaysSyncError, setWorkingDaysSyncError] = useState<{ invalidValueErrors: string[] }>({ invalidValueErrors: [] });
  const [nonWorkingHoursSyncError, setNonWorkingHoursSyncError] = useState<{ workingHoursErrors: string[]; nonWorkingHourErrors: string[]; invalidValueErrors: string[] }>({ workingHoursErrors: [], nonWorkingHourErrors: [], invalidValueErrors: [] });
  const [yiSyncError, setYiSyncError] = useState<{ invalidValueErrors: string[] }>({ invalidValueErrors: [] });
  const [ctrSyncError, setCtrSyncError] = useState<{ invalidValueErrors: string[] }>({ invalidValueErrors: [] });

  // Google API インスタンス
  const googleAPI = useMemo(() => new GoogleAPI(), []);

  // Google API 初期化
  useEffect(() => {
    const initGapi = async () => {
      try {
        if (!await googleAPI.initGapi()) {
          throw new Error("initGapi error");
        }
      } catch (error) {
        console.error("Google API 初期化エラー:", error);
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationNewProduct.message.googleApiInitFailed'),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    };
    initGapi();
  }, [googleAPI, toast]);

  /**
   * スプレッドシートのシートにデータを書き込む
   */
  const writeSheetData = async (api: GoogleAPI, spreadsheetId: string, sheetName: string, data: any[][], sheetId: number) => {
    // 初期化は呼び出し元の googleAPI.clear（シート全体）で実施済みのため、ここではデータ書き込みのみ行う
    await api.spreadSheetSetValue(spreadsheetId, sheetName, 1, 1, data);
  };

  /**
   * 「画面で入力」ボタン押下
   */
  const handleManualClick = () => {
    spreadSheetWindow?.close();
  };

  /**
   * 「GoogleSpread」ボタン押下
   * 1つのSpreadSheetに以下のシートを作成してデータを書き込む
   * シート順: QP → ES → PCI → OD → DT → YI → CTR
   */
  const handleGoogleSpreadClick = async () => {
    if (inputModeSimulation === "google") {
      return;
    }

    try {
      setIsSpreadSheetLoading(true);
      setInputModeSimulation("google");

      // ポップアップブロック回避：非同期処理より前にユーザー操作起因でウィンドウを確保
      const newWindow = window.open("", "_blank");

      if (!await googleAPI.signIn()) {
        throw new Error("signIn error");
      }

      const fileName = "SimulationSettings";
      const folderPath = `CEAS/SpreadSheet/Simulation/${projectId}`;

      let folderId = await googleAPI.createFolderPath(folderPath, null);
      if (!folderId) { folderId = ""; }

      const spreadsheetId = await googleAPI.createSpreadSheet(fileName, folderId, null);
      setActiveSpreadsheetId(spreadsheetId);

      if (spreadsheetId) {
        // シートを追加（デフォルトシートは自動削除される）
        // シートIDは addSheets の戻り値を使用（シート情報の再取得を省略。並べ替えではIDは変わらない）
        const sheetNameToId = await googleAPI.addSheets(spreadsheetId, [SHEET_NAME_QUANTITY_AND_PRICE, SHEET_NAME_EQUIPMENT_STAFFING, SHEET_NAME_PHASED_CAPITAL_INVESTMENT, SHEET_NAME_OPERATING_DAYS, SHEET_NAME_DOWNTIME, SHEET_NAME_LABOR_COST, SHEET_NAME_YIELD_IMPROVEMENT, SHEET_NAME_CYCLE_TIME_REDUCTION]);

        // シートを並べ替え
        await googleAPI.reorderSheets(spreadsheetId, [SHEET_NAME_QUANTITY_AND_PRICE, SHEET_NAME_EQUIPMENT_STAFFING, SHEET_NAME_PHASED_CAPITAL_INVESTMENT, SHEET_NAME_OPERATING_DAYS, SHEET_NAME_DOWNTIME, SHEET_NAME_LABOR_COST, SHEET_NAME_YIELD_IMPROVEMENT, SHEET_NAME_CYCLE_TIME_REDUCTION]);

        const qpSheetId = sheetNameToId[SHEET_NAME_QUANTITY_AND_PRICE] ?? 0;
        const equipmentStaffingSheetId = sheetNameToId[SHEET_NAME_EQUIPMENT_STAFFING] ?? 0;
        const phasedCapitalInvestmentSheetId = sheetNameToId[SHEET_NAME_PHASED_CAPITAL_INVESTMENT] ?? 0;
        const workingDaysSheetId = sheetNameToId[SHEET_NAME_OPERATING_DAYS] ?? 0;
        const nonWorkingHoursSheetId = sheetNameToId[SHEET_NAME_DOWNTIME] ?? 0;
        const laborCostSheetId = sheetNameToId[SHEET_NAME_LABOR_COST] ?? 0;
        const yieldImprovementSheetId = sheetNameToId[SHEET_NAME_YIELD_IMPROVEMENT] ?? 0;
        const cycleTimeReductionSheetId = sheetNameToId[SHEET_NAME_CYCLE_TIME_REDUCTION] ?? 0;

        // 前回設定した書式・入力規則を初期化（列構成変更時に古い設定が残らないようにする）。
        // 値の書き込みより前に送る必要があるため、batch に溜めず即時送信する
        await googleAPI.resetSheetFormatAndValidation(spreadsheetId, Object.values(sheetNameToId));

        // 値・書式・入力規則の書き込みを溜め、最後に flush() でまとめて送信する
        const batch = new GoogleAPIBatchCollector(spreadsheetId);

        // --- 各シートにデータを書き込む（シート順: QP → ES → PCI → OD → DT → YI → CTR） ---

        // [QP] QuantityAndPriceシートに複数パーツのデータをまとめて書き込む
        const qpData = multiPartQuantityAndPriceToSpreadSheetData(
          quantityAndPriceTables.map(t => t.data),
          baseStartYear,
          projectData?.projectStartDate,
          undefined,
          capexPartNo
        );
        await batch.clear(spreadsheetId, SHEET_NAME_QUANTITY_AND_PRICE);
        await writeSheetData(batch, spreadsheetId, SHEET_NAME_QUANTITY_AND_PRICE, qpData, qpSheetId);

        // [ES] 設備・人員構成変更シートにデータを書き込む
        const equipmentStaffingSheetData = equipmentStaffingToSpreadSheetData(equipmentAmounts);
        await batch.clear(spreadsheetId, SHEET_NAME_EQUIPMENT_STAFFING);
        await writeSheetData(batch, spreadsheetId, SHEET_NAME_EQUIPMENT_STAFFING, equipmentStaffingSheetData, equipmentStaffingSheetId);
        await setupEquipmentStaffingSheet(batch, spreadsheetId, equipmentStaffingSheetId, equipmentAmounts);

        // [PCI] 段階的設備投資シートにデータを書き込む
        const phasedCapitalInvestmentSheetData = phasedCapitalInvestmentToSpreadSheetData(equipmentAmounts);
        await batch.clear(spreadsheetId, SHEET_NAME_PHASED_CAPITAL_INVESTMENT);
        await writeSheetData(batch, spreadsheetId, SHEET_NAME_PHASED_CAPITAL_INVESTMENT, phasedCapitalInvestmentSheetData, phasedCapitalInvestmentSheetId);
        await setupPhasedCapitalInvestmentSheet(batch, spreadsheetId, phasedCapitalInvestmentSheetId, equipmentAmounts);

        // [OD] 稼働日数シートにデータを書き込む
        const workingDaysSheetData = workingDaysToSpreadSheetData(improvedWorkingDaysData as WorkingDaysYearData[]);
        await batch.clear(spreadsheetId, SHEET_NAME_OPERATING_DAYS);
        await writeSheetData(batch, spreadsheetId, SHEET_NAME_OPERATING_DAYS, workingDaysSheetData, workingDaysSheetId);

        // [DT] 非稼働時間シートにデータを書き込む
        const nonWorkingHoursSheetData = nonWorkingHoursToSpreadSheetData(improvedNonWorkingHoursData as NonWorkingHoursYearData[]);
        await batch.clear(spreadsheetId, SHEET_NAME_DOWNTIME);
        await writeSheetData(batch, spreadsheetId, SHEET_NAME_DOWNTIME, nonWorkingHoursSheetData, nonWorkingHoursSheetId);

        // [LC] 生産工場費用設定シートにデータを書き込む
        const laborCostSheetData = laborCostToSpreadSheetData(
          originalProfitAndLossByMonth?.labels ?? [],
          scenarioLaborCostByMonth,
          scenarioOverseasFactoryExpensesByMonth,
          scenarioProductionFactoryLaborUnitPrice,
          scenarioProductionFactoryExpenseUnitPrice,
          scenarioBaseLaborCostIncreaseRate,
        );
        await batch.clear(spreadsheetId, SHEET_NAME_LABOR_COST);
        await writeSheetData(batch, spreadsheetId, SHEET_NAME_LABOR_COST, laborCostSheetData, laborCostSheetId);
        await setupLaborCostSheet(batch, spreadsheetId, laborCostSheetId);

        // [YI] 歩留改善シートにデータを書き込む
        const yieldImprovementSheetData = yieldImprovementToSpreadSheetData(improvedYieldRateList);
        await batch.clear(spreadsheetId, SHEET_NAME_YIELD_IMPROVEMENT);
        await writeSheetData(batch, spreadsheetId, SHEET_NAME_YIELD_IMPROVEMENT, yieldImprovementSheetData, yieldImprovementSheetId);
        await setupYieldImprovementSheet(batch, spreadsheetId, yieldImprovementSheetId);

        // [CTR] サイクルタイム短縮シートにデータを書き込む
        const cycleTimeReductionSheetData = cycleTimeReductionToSpreadSheetData(improvedCycleTimeList);
        await batch.clear(spreadsheetId, SHEET_NAME_CYCLE_TIME_REDUCTION);
        await writeSheetData(batch, spreadsheetId, SHEET_NAME_CYCLE_TIME_REDUCTION, cycleTimeReductionSheetData, cycleTimeReductionSheetId);
        await setupCycleTimeReductionSheet(batch, spreadsheetId, cycleTimeReductionSheetId);

        // 溜めた書き込みをまとめて送信（クリア → 値 → 書式・入力規則 の順）
        await batch.flush();

        // --- データ設定完了後にSpreadSheetを新しいタブで表示する ---
        // 事前確保したウィンドウをスプレッドシートに遷移
        if (newWindow) {
          newWindow.location.href = googleAPI.getOpenSpradSheetUrl(spreadsheetId);
          setSpreadSheetWindow(newWindow);

          // GoogleSpreadシートウィンドウを手動で閉じられた場合
          const interval = setInterval(() => {
            if (newWindow.closed) {
              clearInterval(interval); // 監視を停止
              setInputModeSimulation("manual");
            }
          }, 500); // 500ms ごとに監視
        }

        setInputModeSimulation("google");
      }

    } catch (error) {
      console.error("Change GoogleSpread Error.", error);
      spreadSheetWindow?.close();
      setInputModeSimulation("manual");

      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.googleSpreadUnavailable'),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsSpreadSheetLoading(false);
    }
  };

  /**
   * 「データ連携」ボタン押下
   * 各シートからデータを取得して画面に反映する
   * 取得順: QP → ES → PCI → OD → DT → YI → CTR
   */
  const handleSyncData = async () => {
    if (!activeSpreadsheetId || inputModeSimulation !== "google") {
      return;
    }

    try {
      setIsSpreadSheetLoading(true);

      // トークンの有効性を確認
      if (!await googleAPI.ensureValidToken()) {
        googleAPI.signIn();
      }

      // --- 各シートからデータを取得して反映（シート順: QP → ES → PCI → OD → DT → YI → CTR） ---

      // [QP] QuantityAndPriceシートから複数パーツのデータを一括取得
      let qpErrors: string[] = [];
      const qpRange = `${SHEET_NAME_QUANTITY_AND_PRICE}!A1:ZZ`;
      const qpResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, qpRange);
      if (qpResult.values && qpResult.values.length > 0) {
        const partNos = quantityAndPriceTables.map(t => t.data.partNo);
        const { results: qpResults, errors: qpErrs, warnings: qpWarns } = spreadSheetDataToMultiPartQuantityAndPrice(
          qpResult.values,
          partNos,
          baseStartYear,
          { projectStartDate: projectData?.projectStartDate, projectEndDate: projectData?.projectEndDate },
          undefined,
          undefined,
          isGeneralPurpose,
        );

        qpErrors = qpErrs;
        setQpSyncError({ invalidValueErrors: qpErrors, warnings: qpWarns });

        const updatedTables = quantityAndPriceTables.map(t => {
          const conversionResult = qpResults.get(t.data.partNo);
          if (conversionResult) {
            return {
              ...t,
              data: { ...t.data, data: conversionResult.data },
              edited: true,
            };
          }
          return t;
        });
        setQuantityAndPriceTables(updatedTables);
      }

      // [ES] 設備・人員構成変更データを取得（A3:G、ヒント行+ヘッダー行をスキップ）
      const equipmentStaffingRange = `${SHEET_NAME_EQUIPMENT_STAFFING}!A3:G`;
      const equipmentStaffingResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, equipmentStaffingRange);
      const { data: equipmentStaffingData, errors: esErrors } = spreadSheetDataToEquipmentStaffing(
        equipmentStaffingResult.values || [],
        equipmentAmounts
      );
      setEsSyncError({ invalidValueErrors: esErrors });

      // [PCI] 段階的設備投資データを取得（A3:H、ヒント行+ヘッダー行をスキップ）
      const phasedCapitalInvestmentRange = `${SHEET_NAME_PHASED_CAPITAL_INVESTMENT}!A3:H`;
      const phasedCapitalInvestmentResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, phasedCapitalInvestmentRange);
      const { data: phasedCapitalInvestmentData, errors: pciErrors } = spreadSheetDataToPhasedCapitalInvestment(
        phasedCapitalInvestmentResult.values || [],
        equipmentStaffingData.length > 0 ? equipmentStaffingData : equipmentAmounts
      );
      setPciSyncError({ invalidValueErrors: pciErrors });

      // [ES/PCI] 設備データを更新（段階的設備投資の結果を優先、なければ設備・人員構成変更の結果）
      if (phasedCapitalInvestmentData.length > 0) {
        setEquipmentAmounts(phasedCapitalInvestmentData);
      } else if (equipmentStaffingData.length > 0) {
        setEquipmentAmounts(equipmentStaffingData);
      }

      // [OD] 稼働日数データを取得
      const workingDaysRange = `${SHEET_NAME_OPERATING_DAYS}!B1:M`;
      const workingDaysResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, workingDaysRange);
      const { data: workingDaysData, errors: workingDaysErrors } = spreadSheetDataToWorkingDays(
        workingDaysResult.values || [],
        improvedWorkingDaysData as WorkingDaysYearData[]
      );
      setWorkingDaysSyncError({ invalidValueErrors: workingDaysErrors });
      if (workingDaysData.length > 0) {
        setImprovedWorkingDaysData(workingDaysData);
      }

      // [DT] 非稼働時間データを取得
      const nonWorkingHoursRange = `${SHEET_NAME_DOWNTIME}!B2:M`;
      const nonWorkingHoursResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, nonWorkingHoursRange);
      const nonWorkingHoursConvResult = spreadSheetDataToNonWorkingHours(
        nonWorkingHoursResult.values || [],
        improvedNonWorkingHoursData as NonWorkingHoursYearData[]
      );
      const { data: nonWorkingHoursData, errors: nonWorkingHoursErrors } = nonWorkingHoursConvResult;
      setNonWorkingHoursSyncError({
        workingHoursErrors: nonWorkingHoursErrors.workingHoursErrors,
        nonWorkingHourErrors: nonWorkingHoursErrors.nonWorkingHourErrors,
        invalidValueErrors: nonWorkingHoursErrors.invalidValueErrors
      });
      if (nonWorkingHoursData.length > 0) {
        setImprovedNonWorkingHoursData(nonWorkingHoursData);

        // improvedWorkingDaysDataのrequiredOverTimesも同期（残業時間欄に値が入っているかどうかから算出する）
        setImprovedWorkingDaysData(prev => prev.map(wd => {
          const match = nonWorkingHoursData.find(r => isSameFiscalYear(r.fiscalYear, wd.fiscalYear));
          if (match) {
            return {
              ...wd,
              workingDaysData: {
                ...wd.workingDaysData,
                requiredOverTimes: match.nonWorkingHoursByMonth.map(
                  (monthData) => !!monthData.overTime && monthData.overTime !== "00:00"
                ),
              },
            };
          }
          return wd;
        }));
      }

      // [LC] 生産工場費用設定データを取得（A1:ZZ、ヘッダー行含む）
      const laborCostRange = `${SHEET_NAME_LABOR_COST}!A1:ZZ`;
      const laborCostResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, laborCostRange);
      const laborCostConv = spreadSheetDataToLaborCost(
        laborCostResult.values || [],
        (originalProfitAndLossByMonth?.labels ?? []).length,
      );
      const lcErrors = laborCostConv.errors;
      setLcSyncError({ invalidValueErrors: lcErrors });
      setScenarioLaborCostByMonth(laborCostConv.productionLaborCostByMonth);
      setScenarioOverseasFactoryExpensesByMonth(laborCostConv.overseasFactoryExpensesByMonth);
      setScenarioProductionFactoryLaborUnitPrice(laborCostConv.productionFactoryLaborUnitPrice);
      setScenarioProductionFactoryExpenseUnitPrice(laborCostConv.productionFactoryExpenseUnitPrice);
      setScenarioBaseLaborCostIncreaseRate(laborCostConv.baseLaborCostIncreaseRate);

      // [YI] 歩留改善データを取得（A2:B、ヘッダー行をスキップ）
      const yieldImprovementRange = `${SHEET_NAME_YIELD_IMPROVEMENT}!A2:B`;
      const yieldImprovementResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, yieldImprovementRange);
      const { data: yieldImprovementData, errors: yiErrors } = spreadSheetDataToYieldImprovement(
        yieldImprovementResult.values || [],
        projectData?.projectStartDate,
        projectData?.projectEndDate,
      );
      setYiSyncError({ invalidValueErrors: yiErrors });
      setImprovedYieldRateList(yieldImprovementData);
      if (yieldImprovementData.length > 0) {
        setImprovedYieldRate(yieldImprovementData[0].yieldRate);
        setImprovedYieldRateText(yieldImprovementData[0].yieldRateText);
      }

      // [CTR] サイクルタイム短縮データを取得（A2:B、ヘッダー行をスキップ）
      const cycleTimeReductionRange = `${SHEET_NAME_CYCLE_TIME_REDUCTION}!A2:B`;
      const cycleTimeReductionResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, cycleTimeReductionRange);
      const { data: cycleTimeReductionData, errors: ctrErrors } = spreadSheetDataToCycleTimeReduction(
        cycleTimeReductionResult.values || [],
        projectData?.projectStartDate,
        projectData?.projectEndDate,
      );
      setCtrSyncError({ invalidValueErrors: ctrErrors });
      setImprovedCycleTimeList(cycleTimeReductionData);
      if (cycleTimeReductionData.length > 0) {
        setImprovedCycleTime(cycleTimeReductionData[0].cycleTime);
        setImprovedCycleTimeText(cycleTimeReductionData[0].cycleTimeText);
      }

      const hasAnyError = qpErrors.length > 0
        || esErrors.length > 0
        || pciErrors.length > 0
        || workingDaysErrors.length > 0
        || nonWorkingHoursErrors.workingHoursErrors.length > 0
        || nonWorkingHoursErrors.nonWorkingHourErrors.length > 0
        || nonWorkingHoursErrors.invalidValueErrors.length > 0
        || yiErrors.length > 0
        || ctrErrors.length > 0
        || lcErrors.length > 0;

      toast({
        title: TITLE,
        description: hasAnyError
          ? <>{t('features.InvestmentScreening.SimulationNewProduct.message.dataSyncCompleted')}<br />{t('features.InvestmentScreening.SimulationNewProduct.message.dataSyncPartialFailed')}</>
          : <>{t('features.InvestmentScreening.SimulationNewProduct.message.dataSyncCompleted')}</>,
        status: hasAnyError ? 'warning' : 'success',
        duration: hasAnyError ? 5000 : 3000,
        isClosable: true,
      });

    } catch (error) {
      console.error("Sync Data Error.", error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.dataSyncFailed'),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsSpreadSheetLoading(false);
    }
  };

  // SpreadSheetウィンドウの状態監視
  useEffect(() => {
    if (spreadSheetWindow) {
      setInputModeSimulation("google");
    } else {
      setInputModeSimulation("manual");
    }
  }, [spreadSheetWindow]);

  // アンマウント時（画面遷移等）にGoogleSpreadを閉じる（cleanupで最新の参照を使うためrefに保持）
  const spreadSheetWindowRef = useRef<Window | null>(null);
  useEffect(() => {
    spreadSheetWindowRef.current = spreadSheetWindow;
  }, [spreadSheetWindow]);
  useEffect(() => {
    return () => {
      if (spreadSheetWindowRef.current && !spreadSheetWindowRef.current.closed) {
        spreadSheetWindowRef.current.close();
      }
    };
  }, []);

  // manualモードに切り替わったらエラーメッセージをクリア
  useEffect(() => {
    if (inputModeSimulation === "manual") {
      setQpSyncError({ invalidValueErrors: [], warnings: [] });
      setEsSyncError({ invalidValueErrors: [] });
      setPciSyncError({ invalidValueErrors: [] });
      setWorkingDaysSyncError({ invalidValueErrors: [] });
      setNonWorkingHoursSyncError({ workingHoursErrors: [], nonWorkingHourErrors: [], invalidValueErrors: [] });
      setYiSyncError({ invalidValueErrors: [] });
      setCtrSyncError({ invalidValueErrors: [] });
      setLcSyncError({ invalidValueErrors: [] });
    }
  }, [inputModeSimulation]);

  /** ストレス指数（表）をリセットする */
  const resetStressIndex = (): void => {

    // ストレス指数(表)をリセット
    updateDownsideIndexTableDisplay(JSON.parse(JSON.stringify(downsideIndexTableDisplayForReset)));

    // ストレス指数をリセット
    setDownsideIndex(JSON.parse(JSON.stringify(downsideIndexForReset)));

    // ストレス指数(表)のヘッダー(有効・無効)をリセット
    setDownsideIndexEnable(downsideIndexEnableForReset);
  };

  /**
   * TScenarioデータをSavedSimulationConfig形式に変換する
   * @param scenario TScenario型のデータ
   * @returns SavedSimulationConfig形式のデータ
   */
  const convertTScenarioToSavedConfig = (scenario: TScenario): SavedSimulationConfig => {
    // workingDaysが文字列の場合はパース、オブジェクトの場合はそのまま使用
    const workingDays = typeof scenario.workingDays === 'string'
      ? JSON.parse(scenario.workingDays)
      : scenario.workingDays;

    // nonWorkingHoursが文字列の場合はパース、オブジェクトの場合はそのまま使用
    const nonWorkingHours = typeof scenario.nonWorkingHours === 'string'
      ? JSON.parse(scenario.nonWorkingHours)
      : scenario.nonWorkingHours;

    // yieldRateが文字列の場合はパース、オブジェクトの場合はそのまま使用
    const yieldRate = typeof scenario.yieldRate === 'string'
      ? JSON.parse(scenario.yieldRate)
      : scenario.yieldRate;

    // cycleTimeが文字列の場合はパース、オブジェクトの場合はそのまま使用
    const cycleTime = typeof scenario.cycleTime === 'string'
      ? JSON.parse(scenario.cycleTime)
      : scenario.cycleTime;

    // equipmentが文字列の場合はパース、オブジェクトの場合はそのまま使用
    const equipment = typeof scenario.equipment === 'string'
      ? JSON.parse(scenario.equipment)
      : scenario.equipment;

    // quantityAndPriceが文字列の場合はパース、オブジェクトの場合はそのまま使用
    const quantityAndPrice = typeof scenario.quantityAndPrice === 'string'
      ? JSON.parse(scenario.quantityAndPrice)
      : scenario.quantityAndPrice;

    // laborCostが文字列の場合はパース、オブジェクトの場合はそのまま使用
    const laborCost: LaborCostScenario | undefined = typeof scenario.laborCost === 'string'
      ? JSON.parse(scenario.laborCost)
      : scenario.laborCost;

    return {
      id: scenario.scenarioId,
      name: scenario.scenarioName,
      updateDate: scenario.updateDate,
      improvedWorkingDayByYear: workingDays?.workingDay || [],
      improvedHolidayByYear: workingDays?.holiday || [],
      improvedLineCountByYear: workingDays?.lineCount || [],
      improvedOverTimeByYear: nonWorkingHours?.overTime || [],
      improvedAvailabilityRateByMonth: nonWorkingHours?.availabilityRate || [],
      improvedYieldRateList: yieldRate?.yieldRateData ? JSON.parse(yieldRate.yieldRateData) : [],
      improvedCycleTimeList: cycleTime?.cycleTimeData ? JSON.parse(cycleTime.cycleTimeData) : [],
      improvedWorkingDaysData: workingDays?.workingDaysData || [],
      improvedNonWorkingHoursData: nonWorkingHours?.nonWorkingHoursData || [],
      equipmentAmounts: equipment?.equipmentsData ? JSON.parse(equipment.equipmentsData) : [],
      quantityAndPrice: quantityAndPrice?.quantityAndPriceData ? JSON.parse(quantityAndPrice.quantityAndPriceData) : [],
      scenarioLaborCostByMonth: laborCost?.productionLaborCostByMonth ?? [],
      scenarioOverseasFactoryExpensesByMonth: laborCost?.overseasFactoryExpensesByMonth ?? [],
      scenarioProductionFactoryLaborUnitPrice: laborCost?.productionFactoryLaborUnitPrice ?? null,
      scenarioProductionFactoryExpenseUnitPrice: laborCost?.productionFactoryExpenseUnitPrice ?? null,
      scenarioBaseLaborCostIncreaseRate: laborCost?.baseLaborCostIncreaseRate ?? null,
      applyDownside: scenario.applyDownside ?? true,
    };
  };

  /**
   * シミュレーション設定の入力値を初期値にリセットする
   * @param showToast トーストメッセージを表示するかどうか（デフォルト: false）
   */
  const resetSimulationConfigInputs = (showToast: boolean = false) => {
    // 設定名をクリア
    setConfigNameInput("");

    // ストレス反映フラグを初期値に戻す
    setApplyDownsideInput(true);

    // 数量・単価を初期値に戻す
    setQuantityAndPriceTables(originalQuantityAndPriceTables);

    // 設備・人員構成を初期値に戻す
    setEquipmentAmounts(originalEquipmentAmounts);

    // 稼働日数関連を初期値に戻す
    setImprovedWorkingDaysData(originalImprovedWorkingDaysData);
    if (originalImprovedWorkingDaysData && originalImprovedWorkingDaysData.length > 0) {
      const workingDayByYearData = originalImprovedWorkingDaysData.map((workingDays) => ({
        fiscalYear: workingDays.fiscalYear,
        workingDay: workingDays.workingDaysData.workingDays,
      }));
      setImprovedWorkingDayByYear(workingDayByYearData);

      setImprovedHolidayByYear(
        originalImprovedWorkingDaysData.map((workingDays) => ({
          fiscalYear: workingDays.fiscalYear,
          holiday: workingDays.workingDaysData.workOnWeekendAndHolidays,
        }))
      );

      setImprovedLineCountByYear(
        originalImprovedWorkingDaysData.map((workingDays) => ({
          fiscalYear: workingDays.fiscalYear,
          lineCount: workingDays.workingDaysData.lineCount || Array(12).fill(1),
        }))
      );
    }

    // 非稼働時間を初期値に戻す
    setImprovedNonWorkingHoursData(originalImprovedNonWorkingHoursData);
    if (originalImprovedNonWorkingHoursData && originalImprovedNonWorkingHoursData.length > 0) {
      const availabilityRates = originalImprovedNonWorkingHoursData.map(({ fiscalYear, nonWorkingHoursByMonth }) => ({
        fiscalYear,
        availabilityRate: nonWorkingHoursByMonth.map((item) => Number(item?.availabilityRate ?? 0)),
      }));
      setImprovedAvailabilityRateByMonth(availabilityRates);
    }

    // 歩留改善を初期値に戻す
    setImprovedYieldRateList(originalImprovedYieldRateList);
    if (originalImprovedYieldRateList && originalImprovedYieldRateList.length > 0) {
      setImprovedYieldRate(originalImprovedYieldRateList[0].yieldRate);
      setImprovedYieldRateText(originalImprovedYieldRateList[0].yieldRateText);
    }

    // サイクルタイム改善を初期値に戻す
    setImprovedCycleTimeList(originalImprovedCycleTimeList);
    if (originalImprovedCycleTimeList && originalImprovedCycleTimeList.length > 0) {
      setImprovedCycleTime(originalImprovedCycleTimeList[0].cycleTime);
      setImprovedCycleTimeText(originalImprovedCycleTimeList[0].cycleTimeText);
    }

    // 労務費（月別）を費用画面のオリジナル値に戻す
    {
      const { laborCost, overseasExpenses } = getOriginalLaborCostArrays();
      setScenarioLaborCostByMonth(laborCost);
      setScenarioOverseasFactoryExpensesByMonth(overseasExpenses);
    }
    // 単価・ベースアップ率を費用画面の設定値（初期値）に戻す
    setScenarioProductionFactoryLaborUnitPrice(projectData?.productionFactoryLaborUnitPrice ?? null);
    setScenarioProductionFactoryExpenseUnitPrice(projectData?.productionFactoryExpenseUnitPrice ?? null);
    setScenarioBaseLaborCostIncreaseRate(projectData?.baseLaborCostIncreaseRate ?? null);

    // 保存済み設定一覧の選択状態をクリア
    setSelectedConfigIdForInput(null);

    // トーストメッセージを表示
    if (showToast) {
      toast({
        title: t('features.InvestmentScreening.SimulationNewProduct.message.resetCompleted'),
        description: t('features.InvestmentScreening.SimulationNewProduct.message.resetSimulation'),
        status: "info",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  /**
   * 保存された設定をシミュレーション設定の入力項目に反映する
   */
  const loadConfigToInputFields = (config: SavedSimulationConfig) => {
    // 設定名を反映
    setConfigNameInput(config.name);

    // ストレス反映フラグを反映
    setApplyDownsideInput(config.applyDownside ?? true);

    // 数量・単価を反映
    // setQuantityAndPriceTables(config.quantityAndPrice.length === 0 ? originalQuantityAndPriceTables : config.quantityAndPrice);

    // 数量・単価を反映（初期値をベースに、保存済み設定に含まれるPartNoの数量・単価のみを反映する）
    const mergedQuantityAndPrice = originalQuantityAndPriceTables.map(quantityAndPrice => {
      const savedQuantityAndPrice = config.quantityAndPrice.find(e => e.partNo === quantityAndPrice.data.partNo);
      if (savedQuantityAndPrice) {
        // 保存済み設定に含まれているPartNoの場合、保存済みの値を使用
        return { data: savedQuantityAndPrice, edited: true };
      } else {
        // 保存済み設定に含まれていないPartNoの場合、初期値をベース
        return { data: quantityAndPrice.data, edited: false };
      }
    });
    setQuantityAndPriceTables(mergedQuantityAndPrice);

    // 設備・人員構成を反映（初期値をベースに、保存済み設定に含まれる設備のみを有効にする）
    const mergedEquipments = originalEquipmentAmounts.map(equipment => {
      const savedConfig = config.equipmentAmounts.find(e => e.equipmentId === equipment.equipmentId);
      if (savedConfig) {
        // 保存済み設定に含まれている設備の場合、初期値に保存済みの拡張フィールドをマージ
        // 数量変更に合わせて金額も再計算
        const newAmount = new Decimal(equipment.unitPrice || 0).mul(savedConfig.changeInQuantity).toString();
        return {
          ...equipment,
          selected: true,
          changeInQuantity: savedConfig.changeInQuantity,
          changedAcceptanceMonth: savedConfig.changedAcceptanceMonth,
          changedDepreciationStartMonth: savedConfig.changedDepreciationStartMonth,
          amount: newAmount
        };
      } else {
        // 保存済み設定に含まれていない設備の場合、初期値をベースに無効化
        return { ...equipment, selected: false };
      }
    });
    setEquipmentAmounts(mergedEquipments);

    // 稼働日数関連を反映
    setImprovedWorkingDaysData(config.improvedWorkingDaysData);
    if (config.improvedWorkingDaysData && config.improvedWorkingDaysData.length > 0) {
      const workingDayByYearData = config.improvedWorkingDaysData.map((workingDays) => ({
        fiscalYear: workingDays.fiscalYear,
        workingDay: workingDays.workingDaysData.workingDays,
      }));
      setImprovedWorkingDayByYear(workingDayByYearData);

      setImprovedHolidayByYear(
        config.improvedWorkingDaysData.map((workingDays) => ({
          fiscalYear: workingDays.fiscalYear,
          holiday: workingDays.workingDaysData.workOnWeekendAndHolidays,
        }))
      );

      setImprovedLineCountByYear(
        config.improvedWorkingDaysData.map((workingDays) => ({
          fiscalYear: workingDays.fiscalYear,
          lineCount: workingDays.workingDaysData.lineCount || Array(12).fill(1),
        }))
      );
    }

    // 非稼働時間を反映
    setImprovedNonWorkingHoursData(config.improvedNonWorkingHoursData);
    if (config.improvedNonWorkingHoursData && config.improvedNonWorkingHoursData.length > 0) {
      const availabilityRates = config.improvedNonWorkingHoursData.map(({ fiscalYear, nonWorkingHoursByMonth }) => ({
        fiscalYear,
        availabilityRate: nonWorkingHoursByMonth.map((item) => Number(item?.availabilityRate ?? 0)),
      }));
      setImprovedAvailabilityRateByMonth(availabilityRates);
    }

    // 歩留改善を反映
    setImprovedYieldRateList(config.improvedYieldRateList);
    if (config.improvedYieldRateList && config.improvedYieldRateList.length > 0) {
      setImprovedYieldRate(config.improvedYieldRateList[0].yieldRate);
      setImprovedYieldRateText(config.improvedYieldRateList[0].yieldRateText);
    }

    // サイクルタイム改善を反映
    setImprovedCycleTimeList(config.improvedCycleTimeList);
    if (config.improvedCycleTimeList && config.improvedCycleTimeList.length > 0) {
      setImprovedCycleTime(config.improvedCycleTimeList[0].cycleTime);
      setImprovedCycleTimeText(config.improvedCycleTimeList[0].cycleTimeText);
    }

    // 労務費を反映
    setScenarioLaborCostByMonth(config.scenarioLaborCostByMonth ?? []);
    setScenarioOverseasFactoryExpensesByMonth(config.scenarioOverseasFactoryExpensesByMonth ?? []);
    // 単価・ベースアップ率を反映（旧データにない場合は費用画面の値を初期値とする）
    setScenarioProductionFactoryLaborUnitPrice(config.scenarioProductionFactoryLaborUnitPrice ?? projectData?.productionFactoryLaborUnitPrice ?? null);
    setScenarioProductionFactoryExpenseUnitPrice(config.scenarioProductionFactoryExpenseUnitPrice ?? projectData?.productionFactoryExpenseUnitPrice ?? null);
    setScenarioBaseLaborCostIncreaseRate(config.scenarioBaseLaborCostIncreaseRate ?? projectData?.baseLaborCostIncreaseRate ?? null);

    toast({
      title: t('features.InvestmentScreening.SimulationNewProduct.message.configLoaded'),
      description: t('features.InvestmentScreening.SimulationNewProduct.message.configReflected', { configName: config.name }),
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  /**
   * 保存済み設定の入力項目反映用チェックボックスの変更ハンドラー
   */
  const handleConfigSelectionForInput = (configId: string) => {
    if (selectedConfigIdForInput === configId) {
      // 既に選択されている場合は解除
      setSelectedConfigIdForInput(null);
    } else {
      // 選択されていない場合は選択して入力項目に反映
      const config = savedConfigs.find(c => c.id === configId);
      if (config) {
        setSelectedConfigIdForInput(configId);
        loadConfigToInputFields(config);
      }
    }

    // エラー情報初期化
    clearConfigErrors();
  };

  /**
   * シミュレーション設定を保存する
   */
  const saveSimulationConfig = async () => {
    if (!configNameInput.trim()) {
      toast({
        title: t('features.InvestmentScreening.SimulationNewProduct.message.enterConfigName'),
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // 保存前のデータ妥当性チェック
    if (
      !improvedWorkingDaysData ||
      improvedWorkingDaysData.length === 0 ||
      !improvedNonWorkingHoursData ||
      improvedNonWorkingHoursData.length === 0
    ) {
      toast({
        title: t('features.InvestmentScreening.SimulationNewProduct.message.dataError'),
        description: t('features.InvestmentScreening.SimulationNewProduct.message.incompleteWorkingDays'),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // 各要素にnonWorkingHoursByMonthが存在することを確認
    const hasValidNonWorkingHoursData = improvedNonWorkingHoursData.every(
      item => item.nonWorkingHoursByMonth && item.nonWorkingHoursByMonth.length > 0
    );

    if (!hasValidNonWorkingHoursData) {
      toast({
        title: t('features.InvestmentScreening.SimulationNewProduct.message.dataError'),
        description: t('features.InvestmentScreening.SimulationNewProduct.message.incompleteNonWorkingHours'),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      console.error('Invalid nonWorkingHoursData before save:', improvedNonWorkingHoursData);
      return;
    }

    // 既存の設定を更新する場合は、savedConfigsから該当する設定を取得
    let scenarioId: string | undefined;
    let updateDate: string | undefined;

    if (selectedConfigIdForInput) {
      // savedConfigsから選択された設定を検索
      const targetConfig = savedConfigs.find((config) => config.id === selectedConfigIdForInput);

      if (targetConfig) {
        // 既存の設定を更新する場合は、scenarioIdとupdateDateを使用
        scenarioId = targetConfig.id;
        updateDate = targetConfig.updateDate;
      } else {
        toast({
          title: t('features.InvestmentScreening.SimulationNewProduct.message.configNotFound'),
          description: t('features.InvestmentScreening.SimulationNewProduct.message.configDeletedNewSave'),
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
      }
    }

    let error = false;

    // エラー情報初期化
    clearConfigErrors();

    quantityAndPriceTables.forEach((t) => {
      const table = t.data;

      const decimalCurrency = hasDecimal(selectedCurrencyByPartNo.find((item) => item.partNo === table.partNo)?.name ?? "");

      table.years.forEach((year, yearIndex) => {
        const yearMonths = table.data[year]?.months || {};
        if (validateMonthsPrice(yearMonths, `partNoTables-${table.id}-${year}`, decimalCurrency)) {
          error = true;
        }
      });
    });

    if (error) {
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.inputError'),
        status: 'warning',
        duration: 2000,
        isClosable: true,
      });
      return;
    }

    // DB保存
    const result = await saveScenarioData(false, updateDate, scenarioId);

    // 処理失敗時は中止
    if (!result) return;

    // 初期化
    resetSimulationConfigInputs();

    // DB取得
    const scenarioData = await fetchScenarioData();

    // DB から取得したデータを SavedSimulationConfig 形式に変換
    const convertedConfigs = scenarioData.map(convertTScenarioToSavedConfig);

    // 保存済み設定一覧を更新
    setSavedConfigs(convertedConfigs);

    // 入力項目反映用の選択状態もクリア
    setSelectedConfigIdForInput(null);

  };

  /**
   * シミュレーション設定を削除する
   */
  const deleteSimulationConfig = async (configId: string) => {
    const functionName = "deleteSimulationConfig";

    // DB から最新のシナリオデータを取得
    const scenarioData = await fetchScenarioData();

    // 削除対象のシナリオを検索（hasDeleted: falseで取得しているので、削除済みは含まれない）
    const targetScenario = scenarioData.find((scenario: TScenario) => scenario.scenarioId === configId);

    if (!targetScenario) {
      toast({
        title: t('features.InvestmentScreening.SimulationNewProduct.message.deleteFailed'),
        description: t('features.InvestmentScreening.SimulationNewProduct.message.scenarioNotFound'),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // GraphQL mutation（物理削除）
    const query = `
      mutation deleteScenario($input: DeleteScenarioInput!) {
        deleteScenario(input: $input) {
          status
        }
      }
    `;

    try {
      const result = await WebAPI.request({
        query: query,
        variables: {
          input: {
            projectId: targetScenario.projectId,
            scenarioId: targetScenario.scenarioId,
            ...(reviewDate && { reviewDate }),
          },
        },
      });

      // console.log(`${functionName} result: `, JSON.stringify(result));

      // APIレスポンスのステータスチェック
      const status = result?.data?.deleteScenario?.status;

      if (status === "success") {
        toast({
          title: t('features.InvestmentScreening.SimulationNewProduct.message.configDeleted'),
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        console.log(`${functionName}: 削除成功`);

        // シミュレーション設定の入力値を初期値にリセット
        resetSimulationConfigInputs();

        // 最新データを再取得して保存済み設定一覧を更新
        const updatedScenarioData = await fetchScenarioData();

        // エラー情報初期化
        clearConfigErrors();
        const convertedConfigs = updatedScenarioData.map(convertTScenarioToSavedConfig);

        setSavedConfigs(convertedConfigs);

        // 削除された設定が選択中の場合、選択状態から除外
        setSelectedConfigIds(prev => prev.filter(id => id !== configId));

        // 削除された設定のグラフデータを配列から削除
        setSalesChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
        setQuantitiesChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
        setMergedChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
        setGapChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
        setProductionQuantityChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
        setCombinedChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
        setMonthOfRecoveryForSavedConfig(prev => prev.filter(item => item.configId !== configId));
        setIncrementalCashFlowForSavedConfig(prev => prev.filter(item => item.configId !== configId));

        // 削除された設定が入力項目反映用に選択されていた場合、クリア
        if (selectedConfigIdForInput === configId) {
          setSelectedConfigIdForInput(null);
        }
      } else if (status === "expired") {
        toast({
          title: TITLE,
          description: Messages.expiredMessage,
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
        console.warn(`${functionName}: Conflict error. データが期限切れです。`);
      } else {
        toast({
          title: t('features.InvestmentScreening.SimulationNewProduct.message.deleteFailed'),
          description: t('features.InvestmentScreening.SimulationNewProduct.message.deleteProcessFailed'),
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        console.error(`${functionName}: Failed to call API. Errors: `, result?.errors);
      }
    } catch (error) {
      toast({
        title: t('features.InvestmentScreening.SimulationNewProduct.message.systemError'),
        description: t('features.InvestmentScreening.SimulationNewProduct.message.errorDuringDelete'),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      console.error(`${functionName} ERROR:`, error);
    }
  };

  /**
   * シミュレーション設定の選択をトグルする（最大2つ）
   */
  const toggleConfigSelection = (configId: string) => {
    if (selectedConfigIds.includes(configId)) {
      // 既に選択されている場合は解除
      const newSelectedIds = selectedConfigIds.filter(id => id !== configId);
      setSelectedConfigIds(newSelectedIds);

      // 解除された設定のグラフデータを配列から削除
      setSalesChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
      setQuantitiesChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
      setMergedChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
      setGapChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
      setProductionQuantityChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
      setCombinedChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
      setMonthOfRecoveryForSavedConfig(prev => prev.filter(item => item.configId !== configId));
      setIncrementalCashFlowForSavedConfig(prev => prev.filter(item => item.configId !== configId));
    } else {
      // 選択されていない場合
      if (selectedConfigIds.length >= 2) {
        toast({
          title: t('features.InvestmentScreening.SimulationNewProduct.message.maxTwoSelection'),
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      // 選択を追加（useEffectで自動的にグラフが生成される）
      const newSelectedIds = [...selectedConfigIds, configId];
      setSelectedConfigIds(newSelectedIds);
    }
  };

  /** 「ストレス指数」モーダル制御用 */
  const [isOpenDownsideIndex, setIsOpenDownsideIndex] = useState<boolean>(false);

  /**
   * エラー情報をクリアする。
   * @returns デフォルトエラー情報
   */
  const clearErrors = (): Errors => {
    return {
      yieldRate: {
        isError: false,
        errorMessage: "",
      },
      cycleTime: {
        isError: false,
        errorMessage: "",
      },
      finalInvestmentReason: {
        isError: false,
        errorMessage: "",
      },

    };
  }

  /**
   * シミュレーション設定保存時のエラー情報のみクリアする。
   * @returns デフォルトエラー情報
   */
  const clearConfigErrors = () => {
    setErrors((prev) => {
      const keepKeys = ["yieldRate", "cycleTime", "finalInvestmentReason"];
      const newErrors: Errors = {};

      keepKeys.forEach((key) => {
        if (prev[key]) newErrors[key] = prev[key];
      });

      return newErrors;
    });
  }

  /**
   * エラー情報を変更する。
   * @param propertyName プロパティ名
   * @param isError true：入力エラー、false：入力正常
   * @param errorMessage エラーメッセージ
   */
  const changeErrors = (propertyName: string, isError: boolean, errorMessage: string) => {
    setErrors((prevState => ({
      ...prevState,
      [propertyName]: {
        isError: isError,
        errorMessage: errorMessage,
      },
    })));
  }

  /** バリデーションエラー情報 */
  const [errors, setErrors] = useState<Errors>(clearErrors());

  /**
   * 年度調整された年月を取得する関数
   * 稼働日数・休日・稼働率データの取得に使用（年度ベースのデータ配列用）
   * @param labels 年月ラベル配列
   * @param index インデックス
   * @returns 年度調整された年月（1-3月の場合、yearを-1する）
   */
  const getFiscalYearMonth = (labels: string[], index: number): { year: number, month: number } => {
    const year = parseInt(labels[index].split("/")[0]);
    const month = parseInt(labels[index].split("/")[1]);
    const adjustedYear = month >= 1 && month <= 3 ? year - 1 : year;
    return { year: adjustedYear, month: month };
  };

  /**
   * グラフの開始月を取得する
   * @returns 開始月 (YYYY-MM形式)
   */
  const getGraphStartMonth = useCallback((): string => {
    if (originalProfitAndLossByMonth?.labels && originalProfitAndLossByMonth.labels.length > 0) {
      return originalProfitAndLossByMonth.labels[0].replace("/", "-");
    }
    return "";
  }, [originalProfitAndLossByMonth]);

  /**
   * グラフの終了月を取得する
   * @returns 終了月 (YYYY-MM形式)
   */
  const getGraphEndMonth = useCallback((): string => {
    if (originalProfitAndLossByMonth?.labels && originalProfitAndLossByMonth.labels.length > 0) {
      return originalProfitAndLossByMonth.labels[originalProfitAndLossByMonth.labels.length - 1].replace("/", "-");
    }
    return "";
  }, [originalProfitAndLossByMonth]);

  /**
   * 指定した年月に適用すべき歩留を取得する
   * @param targetYearMonth 対象年月 (YYYY/MM形式)
   * @param yieldRateList 改善後歩留リスト
   * @param getBomYieldRate BOMから月別歩留を取得する関数（改善適用前に使用）
   * @returns 適用すべき歩留 (0-1の範囲)
   */
  const getApplicableYieldRate = (
    targetYearMonth: string,
    yieldRateList: YieldRateImprovement[],
    getBomYieldRate?: (targetYearMonth: string) => number | null
  ): number => {
    // 常に現在の改善データを使用
    const yieldRateListToUse = yieldRateList || [];

    // targetYearMonthをYYYY-MM形式に変換
    const targetMonth = targetYearMonth.replace("/", "-");

    // 適用可能な歩留改善を日付順にソート
    const sortedImprovements = [...yieldRateListToUse]
      .filter(item => item.month !== "")
      .sort((a, b) => a.month.localeCompare(b.month));

    // 改善リストが空、または最初の改善適用月より前の場合はBOMデータを使用
    if (sortedImprovements.length === 0) {
      if (getBomYieldRate) {
        const bomValue = getBomYieldRate(targetYearMonth);
        return bomValue ?? 0;
      }
      return 0;
    }

    // 最初の改善適用月より前の場合はBOMデータを使用
    const firstImprovementMonth = sortedImprovements[0].month;
    if (targetMonth < firstImprovementMonth) {
      if (getBomYieldRate) {
        const bomValue = getBomYieldRate(targetYearMonth);
        return bomValue ?? 0;
      }
      return 0;
    }

    // 改善適用月以降は、対象月以前で最も新しい改善値を使用
    let applicableYieldRate = sortedImprovements[0].yieldRate;
    for (const improvement of sortedImprovements) {
      if (improvement.month <= targetMonth) {
        applicableYieldRate = improvement.yieldRate;
      } else {
        break;
      }
    }

    return applicableYieldRate;
  };

  /**
   * 歩留改善項目を追加する
   */
  const addYieldRateImprovement = useCallback(() => {
    // 日付未選択時は0を初期値とする（月選択時にBOM歩留を取得して設定）
    // ※対応D: 関数型更新にすることでuseCallbackを依存配列なしで安定化し、行コンポーネントのReact.memoを効かせる
    setImprovedYieldRateList(prev => [
      ...prev,
      {
        month: "",
        yieldRate: 0,
        yieldRateText: "0.0",
      }
    ]);
  }, []);

  /**
   * 歩留改善項目を削除する
   * @param index 削除する項目のインデックス
   */
  const removeYieldRateImprovement = useCallback((index: number) => {
    setImprovedYieldRateList(prev => prev.filter((_, i) => i !== index));
  }, []);

  /**
   * BOMデータ全件から「年月キー（YYYY-MM）→ 歩留累積値（0-1の範囲）」の事前計算Mapを生成する
   * ※ `bomData`が変化した時のみ再計算する（毎レンダリングでのBOM全走査＋JSON.parseを回避するための対応A）
   * 既存の`getYieldRateFromBom`が行っていた「全工程の積をDecimalで積算する」ロジックをそのまま踏襲する
   */
  const yieldRateByYearMonthMap = useMemo(() => {
    const productMap = new Map<string, Decimal>();
    const hasValueMap = new Map<string, boolean>();
    if (!bomData || bomData.length === 0) {
      return new Map<string, number>();
    }

    for (const bom of bomData) {
      if (bom.yieldMonthly) {
        try {
          const monthlyData = JSON.parse(bom.yieldMonthly);
          for (const [yearMonthKey, value] of Object.entries(monthlyData)) {
            if (value !== undefined && value !== null && value !== "") {
              const yieldValue = parseFloat(value as string);
              if (!isNaN(yieldValue)) {
                const currentProduct = productMap.get(yearMonthKey) ?? new Decimal(1);
                productMap.set(yearMonthKey, currentProduct.mul(new Decimal(yieldValue).div(100)));
                hasValueMap.set(yearMonthKey, true);
              }
            }
          }
        } catch (e) {
          console.warn("Failed to parse yieldMonthly:", e);
        }
      }
    }

    const map = new Map<string, number>();
    for (const [yearMonthKey, hasValue] of hasValueMap.entries()) {
      if (hasValue) {
        map.set(yearMonthKey, productMap.get(yearMonthKey)!.toNumber());
      }
    }

    return map;
  }, [bomData]);


  /**
   * BOMデータ全件から「年月キー（YYYY-MM）→ サイクルタイム最大値（秒）」の事前計算Mapを生成する
   * ※ `bomData`が変化した時のみ再計算する（毎レンダリングでのBOM全走査＋JSON.parseを回避するための対応A）
   * 既存の`getCycleTimeFromBom`が行っていた「複数BOMがある場合は最大値＝ネック工程を採用する」ロジックをそのまま踏襲する
   */
  const cycleTimeByYearMonthMap = useMemo(() => {
    const map = new Map<string, number>();
    if (!bomData || bomData.length === 0) {
      return map;
    }

    for (const bom of bomData) {
      if (bom.cycleTimeMonthly) {
        try {
          const monthlyData = JSON.parse(bom.cycleTimeMonthly);
          for (const [yearMonthKey, value] of Object.entries(monthlyData)) {
            if (value !== undefined && value !== null && value !== "") {
              const cycleTimeValue = parseFloat(value as string);
              const currentMax = map.get(yearMonthKey);
              if (!isNaN(cycleTimeValue) && (currentMax === undefined || cycleTimeValue > currentMax)) {
                map.set(yearMonthKey, cycleTimeValue);
              }
            }
          }
        } catch (e) {
          console.warn("Failed to parse cycleTimeMonthly:", e);
        }
      }
    }

    return map;
  }, [bomData]);

  /**
   * BOMデータから指定した年月の歩留（累積＝全工程の積）を取得する
   * ※事前計算済みの`yieldRateByYearMonthMap`を参照するだけの軽量関数（対応A：Map lookup化）
   * @param targetYearMonth 対象年月 (YYYY/MM形式)
   * @returns 歩留（0-1の範囲）、データがない場合はnull
   */
  const getYieldRateFromBom = useCallback(
    (targetYearMonth: string): number | null => {
      // YYYY/MM → YYYY-MM 形式に変換
      const yearMonthKey = targetYearMonth.replace("/", "-");
      return yieldRateByYearMonthMap.has(yearMonthKey) ? yieldRateByYearMonthMap.get(yearMonthKey)! : null;
    },
    [yieldRateByYearMonthMap]
  );

  /**
   * 歩留改善項目の月を更新する
   * @param index 更新する項目のインデックス
   * @param month 新しい月
   */
  const updateYieldRateMonth = useCallback((index: number, month: string) => {
    // 選択された月のBOM歩留を取得して初期値として設定（YYYY-MM → YYYY/MM形式に変換）
    const bomYieldRate = (month ? getYieldRateFromBom(month.replace("-", "/")) : null) || 0;
    const yieldRateValue = bomYieldRate * 100;
    setImprovedYieldRateList(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        month,
        yieldRate: bomYieldRate,
        yieldRateText: yieldRateValue.toFixed(1)
      };
      return updated;
    });
  }, [getYieldRateFromBom]);

  /**
   * 歩留改善項目の歩留テキストのみを更新する（入力中の再レンダリング範囲を最小化するため）
   * @param index 更新する項目のインデックス
   * @param yieldRateText 歩留テキスト
   */
  const updateYieldRateText = useCallback((index: number, yieldRateText: string) => {
    setImprovedYieldRateList(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], yieldRateText };
      return updated;
    });
  }, []);

  /**
   * 歩留改善項目の歩留を更新する
   * @param index 更新する項目のインデックス
   * @param yieldRateText 歩留テキスト
   */
  const updateYieldRateValue = useCallback((index: number, yieldRateText: string) => {
    const parsedValue = Number(yieldRateText);
    const clampedValue = Math.min(Math.max(parsedValue, 0), 100);
    const formattedValue = Number(clampedValue || 0).toFixed(1);
    const newYieldRate = Number(new Decimal(formattedValue).div(100));
    setImprovedYieldRateList(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        yieldRateText: formattedValue,
        yieldRate: newYieldRate
      };

      // 後方互換用の値も更新（最初の項目の値を使用）
      if (index === 0 || prev.length === 1) {
        setImprovedYieldRate(newYieldRate);
        setImprovedYieldRateText(formattedValue);
      }
      return updated;
    });
  }, []);

  /**
   * 指定した年月に適用すべきサイクルタイムを取得する
   * @param targetYearMonth 対象年月 (YYYY/MM形式)
   * @param cycleTimeList 改善後サイクルタイムリスト
   * @param getBomCycleTime BOMから月別サイクルタイムを取得する関数（改善適用前に使用）
   * @returns 適用すべきサイクルタイム (秒)
   */
  const getApplicableCycleTime = (
    targetYearMonth: string,
    cycleTimeList: CycleTimeImprovement[],
    getBomCycleTime?: (targetYearMonth: string) => number | null
  ): number => {
    // 常に現在の改善データを使用
    const cycleTimeListToUse = cycleTimeList || [];

    // targetYearMonthをYYYY-MM形式に変換
    const targetMonth = targetYearMonth.replace("/", "-");

    // 適用可能なサイクルタイム改善を日付順にソート
    const sortedImprovements = [...cycleTimeListToUse]
      .filter(item => item.month !== "")
      .sort((a, b) => a.month.localeCompare(b.month));

    // 改善リストが空、または最初の改善適用月より前の場合はBOMデータを使用
    if (sortedImprovements.length === 0) {
      if (getBomCycleTime) {
        const bomValue = getBomCycleTime(targetYearMonth);
        return bomValue ?? 0;
      }
      return 0;
    }

    // 最初の改善適用月より前の場合はBOMデータを使用
    const firstImprovementMonth = sortedImprovements[0].month;
    if (targetMonth < firstImprovementMonth) {
      if (getBomCycleTime) {
        const bomValue = getBomCycleTime(targetYearMonth);
        return bomValue ?? 0;
      }
      return 0;
    }

    // 改善適用月以降は、対象月以前で最も新しい改善値を使用
    let applicableCycleTime = sortedImprovements[0].cycleTime;
    for (const improvement of sortedImprovements) {
      if (improvement.month <= targetMonth) {
        applicableCycleTime = improvement.cycleTime;
      } else {
        break;
      }
    }

    return applicableCycleTime;
  };

  /**
   * サイクルタイム改善項目を追加する
   */
  const addCycleTimeImprovement = useCallback(() => {
    // BOMがない場合の初期値は0
    // ※対応D: 関数型更新にすることでuseCallbackを依存配列なしで安定化し、行コンポーネントのReact.memoを効かせる
    setImprovedCycleTimeList(prev => [
      ...prev,
      {
        month: "", // 日付入力フィールドはそのまま（空欄）
        cycleTime: 0,
        cycleTimeText: "0.0",
      }
    ]);
  }, []);

  /**
   * サイクルタイム改善項目を削除する
   * @param index 削除する項目のインデックス
   */
  const removeCycleTimeImprovement = useCallback((index: number) => {
    setImprovedCycleTimeList(prev => prev.filter((_, i) => i !== index));
  }, []);

  /**
   * BOMデータから指定した年月のサイクルタイム（最大値＝ネック工程）を取得する
   * ※事前計算済みの`cycleTimeByYearMonthMap`を参照するだけの軽量関数（対応A：Map lookup化）
   * @param targetYearMonth 対象年月 (YYYY/MM形式)
   * @returns サイクルタイム（秒）、データがない場合はnull
   */
  const getCycleTimeFromBom = useCallback(
    (targetYearMonth: string): number | null => {
      // YYYY/MM → YYYY-MM 形式に変換
      const yearMonthKey = targetYearMonth.replace("/", "-");
      return cycleTimeByYearMonthMap.has(yearMonthKey) ? cycleTimeByYearMonthMap.get(yearMonthKey)! : null;
    },
    [cycleTimeByYearMonthMap]
  );

  /**
   * サイクルタイム改善項目の月を更新する
   * @param index 更新する項目のインデックス
   * @param month 新しい月
   */
  const updateCycleTimeMonth = useCallback((index: number, month: string) => {
    // 選択された月のBOMサイクルタイムを取得、なければ0
    const bomCycleTime = (month ? getCycleTimeFromBom(month.replace("-", "/")) : null) || 0;
    const cycleTimeValue = bomCycleTime;
    setImprovedCycleTimeList(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        month,
        cycleTime: bomCycleTime,
        cycleTimeText: cycleTimeValue.toFixed(1)
      };
      return updated;
    });
  }, [getCycleTimeFromBom]);

  /**
   * サイクルタイム改善項目のサイクルタイムテキストのみを更新する（入力中の再レンダリング範囲を最小化するため）
   * @param index 更新する項目のインデックス
   * @param cycleTimeText サイクルタイムテキスト
   */
  const updateCycleTimeText = useCallback((index: number, cycleTimeText: string) => {
    setImprovedCycleTimeList(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], cycleTimeText };
      return updated;
    });
  }, []);

  /**
   * サイクルタイム改善項目のサイクルタイムを更新する
   * @param index 更新する項目のインデックス
   * @param cycleTimeText サイクルタイムテキスト
   */
  const updateCycleTimeValue = useCallback((index: number, cycleTimeText: string) => {
    const parsedValue = Number(cycleTimeText);
    const clampedValue = Math.max(parsedValue, 0);
    const formattedValue = Number(clampedValue || 0).toFixed(1);
    setImprovedCycleTimeList(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        cycleTimeText: formattedValue,
        cycleTime: Number(formattedValue)
      };

      // 後方互換用の値も更新（最初の項目の値を使用）
      if (index === 0 || prev.length === 1) {
        setImprovedCycleTime(Number(formattedValue));
        setImprovedCycleTimeText(formattedValue);
      }
      return updated;
    });
  }, []);

  // ▼ 保存されたシミュレーション設定
  /** 保存されたシミュレーション設定リスト */
  const [savedConfigs, setSavedConfigs] = useState<SavedSimulationConfig[]>([]);
  /** 選択されたシミュレーション設定のID（最大2つ） */
  const [selectedConfigIds, setSelectedConfigIds] = useState<string[]>([]);
  /** 設定保存時の名前入力値（onBlurで更新し、入力中の再レンダリングを防ぐ） */
  const [configNameInput, setConfigNameInput] = useState<string>("");
  /** シミュレーション設定の入力項目に反映する設定ID */
  const [selectedConfigIdForInput, setSelectedConfigIdForInput] = useState<string | null>(null);
  /** 選択状態復元済みフラグ（初回のみ実行） */
  const [hasRestoredSelection, setHasRestoredSelection] = useState<boolean>(false);

  // ▼ PartNo データ
  /** 【参照データ】「数量・単価」で登録したデータ */
  const [capexPartNo, setCapexPartNo] = useState<PartNo[]>([]);

  /** 月別材料費単価（パーツNo別、キー: YYYY-MM形式）- ローカル通貨版 */
  const [partNoToMonthlyMaterialCost, setPartNoToMonthlyMaterialCost] = useState<Map<string, Record<string, Decimal>> | null>(null);

  /** 月別材料費単価（パーツNo別、キー: YYYY-MM形式）- JPY版（二重変換回避用） */
  const [displayVersionPartNoToMonthlyMaterialCost, setDisplayVersionPartNoToMonthlyMaterialCost] = useState<Map<string, Record<string, Decimal>> | null>(null);

  /** どの部署の確認かを表す */
  const [confirmSource, setConfirmSource] = useState<string>("");

  /** モーダル表示制御用：確認モーダル */
  const { isOpen: isOpenConfirmModal, onOpen: onOpenConfirmModal, onClose: onCloseConfirmModal } = useDisclosure()

  /** モーダル保存ボタンの活性制御 */
  const [isSaving, setIsSaving] = useState(false);

  // 数量・単価で入力した通貨の小数有無を管理
  const [decimalCurrency, setDecimalCurrency] = useState<boolean>(false);

  /**
   * 営業利益合計をcostBreakdown経由で年度丸め方式で計算（表示通貨）
   * Simulation画面とReportAndDraftの営業利益合計を一致させるため使用
   */
  const calcDisplayTotalProfit = (chartData: any): Decimal => {
    if (!chartData?.datasets) return new Decimal(0);
    // 振り返りモード: profit[] は月別レートで表示通貨に変換済み。
    // calcYearlyRoundedProfitTotal はソース通貨+単一レートで再計算するため使用不可。
    if (reviewDate) {
      return calcTotalProfitAndRate(chartData).totalProfit;
    }
    // 通常モード: costBreakdownがある場合は対象PJと同じ年度丸め方式で計算
    if (chartData.costBreakdown) {
      // 対象PJと一致させるため、changedDepreciationStartMonth適用前の元の設備データで計算
      const inputs = chartData.equipmentDepreciationInputs;
      const equipInputs = inputs?.originalEquipments
        ? { ...inputs, equipments: inputs.originalEquipments }
        : inputs;
      return calcYearlyRoundedProfitTotal(
        chartData.costBreakdown,
        localCurrencyName,
        selectedCurrency.name,
        currencyData,
        equipInputs,
        chartData.scrapCostInputs,
      );
    }
    // フォールバック: costBreakdownがない場合（合計→変換方式）
    const chartTotal = calcTotalProfitAndRate(chartData).totalProfit;
    if (localCurrencyName === selectedCurrency.name) {
      return chartTotal;
    }
    const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
    return convertCurrency(chartTotal, localCurrencyName, selectedCurrency.name, currencyData)
      .toDecimalPlaces(dp);
  };

  /** 確認担当者 */
  const [confirmor, setConfirmor] = useState<Confirmor | null>(null);

  /** 確認ボタン横幅 */
  const [buttonWidths, setButtonWidths] = useState<Record<string, number>>({});

  /** 確認ボタン下担当者名 */
  const [names, setNames] = useState<Record<string, ConfirmorInfo[]>>({
    companyDivision: [],
    companyHeadDivision: [],
  });

  /** 表示位置制御用 */
  const [position, setPosition] = useState({ x: 0, y: 0 });

  /** 表示状態管理 */
  const [mode, setMode] = useState("view"); // 初期表示状態は「シミュレーション表示」

  /** 営業データ連携タブの入力内容が未保存（初期値から変更あり）かどうか */
  const [isSalesDataLinkageDirty, setIsSalesDataLinkageDirty] = useState(false);
  /** タブ切替時の破棄確認ダイアログの開閉制御 */
  const { isOpen: isTabSwitchConfirmOpen, onOpen: onOpenTabSwitchConfirm, onClose: onCloseTabSwitchConfirm } = useDisclosure();
  /** 確認ダイアログで承認された場合に実際に遷移する先のmode */
  const pendingModeRef = useRef<string | null>(null);

  /** タブ切替要求。営業データ連携タブに未保存の入力がある場合は確認ダイアログを挟む */
  const requestModeChange = (nextMode: string) => {
    if (mode === "salesDataLinkage" && isSalesDataLinkageDirty && nextMode !== "salesDataLinkage") {
      pendingModeRef.current = nextMode;
      onOpenTabSwitchConfirm();
      return;
    }
    setMode(nextMode);
  };

  /** 権限用 画面パーミッション */
  const [pagePermissions, setPagePermissions] = useState<PagePermissions>();

  /** 振り返りモード用月別レート変換関数。reviewDate が null の場合は通常の convertCurrency を使用 */
  const convertWithRate = useCallback<ConvertFn>(
    (amount, from, to, yearMonth) => {
      if (yearMonth) {
        return convertCurrencyByMonth(amount, from, to, yearMonth, monthlyRateMap, currencyData);
      }
      return convertCurrency(amount, from, to, currencyData);
    },
    [monthlyRateMap, currencyData]
  );

  /** 設備データ（通貨変換前）。振り返りモードで月別レート到着後に再変換するために保持 */
  const rawEquipmentDataRef = useRef<EquipmentType[] | null>(null);

  /**
   * 振り返りモード: 設備金額を検収月の月別レートでローカル通貨に再変換する
   * fetchData が月別レート取得前に実行された場合でも、レート到着後に損益試算画面と同じレートへ揃える。
   * 選択状態・増減数等のユーザー編集項目は保持し、金額・単価・通貨のみ差し替える。
   */
  useEffect(() => {
    const rawEquipmentData = rawEquipmentDataRef.current;
    if (!reviewDate || monthlyRateMap.size === 0 || !rawEquipmentData || !localCurrencyName) {
      return;
    }
    const convertedById = new Map(
      convertEquipmentData(rawEquipmentData, localCurrencyName, currencyData, convertWithRate)
        .map(e => [e.equipmentId, e])
    );
    const applyConverted = (list: EquipmentExtType[]) => {
      let changed = false;
      const next = list.map(e => {
        const c = convertedById.get(e.equipmentId);
        if (!c || (c.amount === e.amount && c.unitPrice === e.unitPrice)) return e;
        changed = true;
        return { ...e, unitPrice: c.unitPrice, amount: c.amount, currencyId: c.currencyId, currencyName: c.currencyName };
      });
      // 差分がなければ同一参照を返し、不要な再計算を防ぐ
      return changed ? next : list;
    };
    setEquipmentAmounts(prev => applyConverted(prev));
    setOriginalEquipmentAmounts(prev => applyConverted(prev));
    // originalEquipmentAmounts: fetchData による設備読込完了をトリガーにする（差分なしなら同一参照のためループしない）
  }, [reviewDate, monthlyRateMap, localCurrencyName, currencyData, convertWithRate, originalEquipmentAmounts]);

  /** 「営業利益合計」ラベル横のヘルプアイコン（EOL後の残存減価償却費を含む旨を説明） */
  const operatingProfitTotalHelpIcon = (
    <Box as="span" display="inline-block" mx={1} verticalAlign="middle">
      <HelpIcon size="14" placement="top">
        <Text>{t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitTotalHelp')}</Text>
      </HelpIcon>
    </Box>
  );

  /** 実質的営業利益率（当初計画）※calcRealProfitRateData(salesChartData, displaySalesChartData, false)相当をuseMemo化したもの */
  const realProfitRateDataMemo = useMemo(() => {
    const originalChartData = salesChartData;
    const displayChartData = displaySalesChartData;
    const isDownside = false;
    if (!originalChartData?.datasets || !displayChartData?.datasets || !originalProfitAndLossByMonth?.labels || !capexPartNo || capexPartNo.length === 0) {
      return { realProfitRate: "", realProfitRateByMonth: [] as number[] };
    }
    // 顧客指定部品の有無判断
    const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
    if (!a) return { realProfitRate: "", realProfitRateByMonth: [] as number[] };

    const originalSalesDataset = originalChartData.datasets.find((d: any) => d.id === "sales");
    if (!originalSalesDataset) {
      return { realProfitRate: "", realProfitRateByMonth: [] as number[] };
    }
    const sales = originalSalesDataset.data.map((v: number) => new Decimal(v));
    const materialCosts = calcMaterialCost(
      isDownside ? mergedChartDataModified : mergedChartDataOriginal,
      isDownside ? quantitiesChartDataModified : quantitiesChartDataOriginal,
      capexPartNo,
      originalProfitAndLossByMonth.labels,
      projectData?.projectId!,
      localCurrencyName,
      currencyData
    );
    const monthlyData = calcMonthlyProfitAndLossDetails(
      sales,
      materialCosts || [],
      originalProfitAndLossByMonth.labels,
      isDownside,
      originalEquipmentAmounts,
      projectData!,
      capexPartNo,
      localCurrencyName,
      currencyData,
      downsideIndexGraph,
      decimalCurrency,
      uniqueProcessData,
      bomData,
      projectData?.moldSalesByProject,
      projectData?.developmentSalesByProject,
      projectData?.equipmentSalesByProject,
    );
    if (!monthlyData) {
      return { realProfitRate: "", realProfitRateByMonth: [] as number[] };
    }

    const localCurrency = currencyData.find(c => c.currencyId === localCurrencyId);
    const customerSpecifiedPartsCostConverted = monthlyData.customerSpecifiedPartsCost.map((cost, i) => {
      if (selectedCurrency.id !== localCurrencyId && localCurrency?.currencyName) {
        if (reviewDate) {
          const yearMonth = originalProfitAndLossByMonth.labels[i]?.replace("/", "-");
          return new Decimal(convertWithRate(cost, localCurrency.currencyName, selectedCurrency.name, yearMonth));
        }
        return convertCurrency(cost, localCurrency.currencyName, selectedCurrency.name, currencyData);
      }
      return cost;
    });

    const displaySalesDataset = displayChartData.datasets.find((d: any) => d.id === "sales");
    const displayProfitDataset = displayChartData.datasets.find((d: any) => d.id === "profit");
    if (!displaySalesDataset || !displayProfitDataset) {
      return { realProfitRate: "", realProfitRateByMonth: [] as number[] };
    }
    const displaySalesData = displaySalesDataset.data as number[];
    const displayProfitData = displayProfitDataset.data as number[];

    const totalSales = displaySalesData.reduce((sum, v) => sum + (v || 0), 0);
    const totalProfitVal = displayProfitData.reduce((sum, v) => sum + (v || 0), 0);
    const totalCustomerCost = customerSpecifiedPartsCostConverted.reduce((sum, v) => sum.plus(v), new Decimal(0));
    const realProfitRateVal = calcRealProfitRate(new Decimal(totalSales), new Decimal(totalProfitVal), totalCustomerCost);

    const realProfitRateByMonth = calcRealProfitRateByMonth(
      displaySalesData,
      displayProfitData,
      customerSpecifiedPartsCostConverted
    );
    return { realProfitRate: realProfitRateVal, realProfitRateByMonth };
  }, [salesChartData, displaySalesChartData, originalProfitAndLossByMonth, capexPartNo, mergedChartDataOriginal, quantitiesChartDataOriginal, projectData, localCurrencyName, currencyData, originalEquipmentAmounts, downsideIndexGraph, decimalCurrency, uniqueProcessData, bomData, selectedCurrency, localCurrencyId, reviewDate, convertWithRate]);

  /** 実質的営業利益率（ダウンサイド）※calcRealProfitRateData(salesChartDataModified, displaySalesChartDataModified, true)相当をuseMemo化したもの */
  const realProfitRateDataModifiedMemo = useMemo(() => {
    const originalChartData = salesChartDataModified;
    const displayChartData = displaySalesChartDataModified;
    const isDownside = true;
    if (!originalChartData?.datasets || !displayChartData?.datasets || !originalProfitAndLossByMonth?.labels || !capexPartNo || capexPartNo.length === 0) {
      return { realProfitRate: "", realProfitRateByMonth: [] as number[] };
    }
    // 顧客指定部品の有無判断
    const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
    if (!a) return { realProfitRate: "", realProfitRateByMonth: [] as number[] };

    const originalSalesDataset = originalChartData.datasets.find((d: any) => d.id === "sales");
    if (!originalSalesDataset) {
      return { realProfitRate: "", realProfitRateByMonth: [] as number[] };
    }
    const sales = originalSalesDataset.data.map((v: number) => new Decimal(v));
    const materialCosts = calcMaterialCost(
      isDownside ? mergedChartDataModified : mergedChartDataOriginal,
      isDownside ? quantitiesChartDataModified : quantitiesChartDataOriginal,
      capexPartNo,
      originalProfitAndLossByMonth.labels,
      projectData?.projectId!,
      localCurrencyName,
      currencyData
    );

    // データの実期間に調整
    const labels = (originalProfitAndLossByMonth.labels).slice(0, sales.length);

    const monthlyData = calcMonthlyProfitAndLossDetails(
      sales,
      materialCosts || [],
      labels,
      isDownside,
      originalEquipmentAmounts,
      projectData!,
      capexPartNo,
      localCurrencyName,
      currencyData,
      downsideIndexGraph,
      decimalCurrency,
      uniqueProcessData,
      bomData,
      projectData?.moldSalesByProject,
      projectData?.developmentSalesByProject,
      projectData?.equipmentSalesByProject,
    );
    if (!monthlyData) {
      return { realProfitRate: "", realProfitRateByMonth: [] as number[] };
    }

    const localCurrency = currencyData.find(c => c.currencyId === localCurrencyId);
    const customerSpecifiedPartsCostConverted = monthlyData.customerSpecifiedPartsCost.map((cost, i) => {
      if (selectedCurrency.id !== localCurrencyId && localCurrency?.currencyName) {
        if (reviewDate) {
          const yearMonth = originalProfitAndLossByMonth.labels[i]?.replace("/", "-");
          return new Decimal(convertWithRate(cost, localCurrency.currencyName, selectedCurrency.name, yearMonth));
        }
        return convertCurrency(cost, localCurrency.currencyName, selectedCurrency.name, currencyData);
      }
      return cost;
    });

    const displaySalesDataset = displayChartData.datasets.find((d: any) => d.id === "sales");
    const displayProfitDataset = displayChartData.datasets.find((d: any) => d.id === "profit");
    if (!displaySalesDataset || !displayProfitDataset) {
      return { realProfitRate: "", realProfitRateByMonth: [] as number[] };
    }
    const displaySalesData = displaySalesDataset.data as number[];
    const displayProfitData = displayProfitDataset.data as number[];

    const totalSales = displaySalesData.reduce((sum, v) => sum + (v || 0), 0);
    // No.411追加対応: 表示期間外（生産終了後）に残る減価償却費を分子に加算し、
    // 保存済み設定側（calcRealProfitRateForConfig）と算出方式を統一する。
    // residualDepreciationTotalはローカル通貨のため、totalCustomerCostと同じ通貨変換を適用してから加算する。
    const residualDepreciationTotal = monthlyData.residualDepreciationTotal ?? new Decimal(0);
    const convertedResidual = selectedCurrency.id !== localCurrencyId && localCurrency?.currencyName
      ? convertCurrency(residualDepreciationTotal, localCurrency.currencyName, selectedCurrency.name, currencyData)
      : residualDepreciationTotal;
    const totalProfitVal = displayProfitData.reduce((sum, v) => sum + (v || 0), 0) + convertedResidual.toNumber();
    const totalCustomerCost = customerSpecifiedPartsCostConverted.reduce((sum, v) => sum.plus(v), new Decimal(0));
    const realProfitRateVal = calcRealProfitRate(new Decimal(totalSales), new Decimal(totalProfitVal), totalCustomerCost);
    const realProfitRateByMonth = calcRealProfitRateByMonth(
      displaySalesData,
      displayProfitData,
      customerSpecifiedPartsCostConverted
    );
    return { realProfitRate: realProfitRateVal, realProfitRateByMonth };
  }, [salesChartDataModified, displaySalesChartDataModified, originalProfitAndLossByMonth, capexPartNo, mergedChartDataModified, quantitiesChartDataModified, projectData, localCurrencyName, currencyData, originalEquipmentAmounts, downsideIndexGraph, decimalCurrency, uniqueProcessData, bomData, selectedCurrency, localCurrencyId, reviewDate, convertWithRate]);

  /** 実質的営業利益率（投資回収Combined・当初計画）※calcRealProfitRateForCombined(salesChartData, displaySalesChartData, false)相当をuseMemo化したもの */
  const realProfitRateForCombinedMemo = useMemo(() => {
    const originalChartData = salesChartData;
    const displayChartData = displaySalesChartData;
    const isDownside = false;
    if (!originalChartData?.datasets || !displayChartData?.datasets || !originalProfitAndLossByMonth?.labels || !capexPartNo || capexPartNo.length === 0) {
      return "";
    }
    // 顧客指定部品の有無判断
    const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
    if (!a) return "";

    const originalSalesDataset = originalChartData.datasets.find((d: any) => d.id === "sales");
    if (!originalSalesDataset) {
      return "";
    }
    const sales = originalSalesDataset.data.map((v: number) => new Decimal(v));
    const materialCosts = calcMaterialCost(
      isDownside ? mergedChartDataModified : mergedChartDataOriginal,
      isDownside ? quantitiesChartDataModified : quantitiesChartDataOriginal,
      capexPartNo,
      originalProfitAndLossByMonth.labels,
      projectData?.projectId!,
      localCurrencyName,
      currencyData
    );
    const monthlyData = calcMonthlyProfitAndLossDetails(
      sales,
      materialCosts || [],
      originalProfitAndLossByMonth.labels,
      isDownside,
      originalEquipmentAmounts,
      projectData!,
      capexPartNo,
      localCurrencyName,
      currencyData,
      downsideIndexGraph,
      decimalCurrency,
      uniqueProcessData,
      bomData,
      projectData?.moldSalesByProject,
      projectData?.developmentSalesByProject,
      projectData?.equipmentSalesByProject,
    );
    if (!monthlyData) {
      return "";
    }

    const localCurrency = currencyData.find(c => c.currencyId === localCurrencyId);
    let totalCustomerCost: Decimal;
    if (selectedCurrency.id !== localCurrencyId && localCurrency?.currencyName) {
      if (reviewDate) {
        totalCustomerCost = monthlyData.customerSpecifiedPartsCost.reduce((sum, cost, i) => {
          const yearMonth = originalProfitAndLossByMonth.labels[i]?.replace("/", "-");
          const converted = new Decimal(convertWithRate(cost, localCurrency.currencyName!, selectedCurrency.name, yearMonth));
          return sum.plus(converted);
        }, new Decimal(0));
      } else {
        totalCustomerCost = convertCurrency(
          monthlyData.customerSpecifiedPartsCost.reduce((sum, v) => sum.plus(v), new Decimal(0)),
          localCurrency.currencyName,
          selectedCurrency.name,
          currencyData
        );
      }
    } else {
      totalCustomerCost = monthlyData.customerSpecifiedPartsCost.reduce((sum, v) => sum.plus(v), new Decimal(0));
    }

    const displaySalesDataset = displayChartData.datasets.find((d: any) => d.id === "sales");
    const displayProfitDataset = displayChartData.datasets.find((d: any) => d.id === "profit");
    if (!displaySalesDataset || !displayProfitDataset) {
      return "";
    }
    const totalSales = (displaySalesDataset.data as number[]).reduce((sum, v) => sum + (v || 0), 0);
    // No.411追加対応: 表示期間外（生産終了後）に残る減価償却費を分子に加算し、
    // 「売上・利益」画面のrealProfitRateOriginal（DB保存用）と算出方式を統一する。
    // residualDepreciationTotalはローカル通貨のため、totalCustomerCostと同じ通貨変換を適用してから加算する。
    const residualDepreciationTotal = monthlyData.residualDepreciationTotal ?? new Decimal(0);
    const convertedResidual = selectedCurrency.id !== localCurrencyId && localCurrency?.currencyName
      ? convertCurrency(residualDepreciationTotal, localCurrency.currencyName, selectedCurrency.name, currencyData)
      : residualDepreciationTotal;
    const totalProfitVal = (displayProfitDataset.data as number[]).reduce((sum, v) => sum + (v || 0), 0) + convertedResidual.toNumber();
    return calcRealProfitRate(new Decimal(totalSales), new Decimal(totalProfitVal), totalCustomerCost);
  }, [salesChartData, displaySalesChartData, originalProfitAndLossByMonth, capexPartNo, mergedChartDataOriginal, quantitiesChartDataOriginal, projectData, localCurrencyName, currencyData, originalEquipmentAmounts, downsideIndexGraph, decimalCurrency, uniqueProcessData, bomData, selectedCurrency, localCurrencyId, reviewDate, convertWithRate]);

  /** 実質的営業利益率（投資回収Combined・ダウンサイド）※calcRealProfitRateForCombined(salesChartDataModified, displaySalesChartDataModified, true)相当をuseMemo化したもの */
  const realProfitRateForCombinedModifiedMemo = useMemo(() => {
    const originalChartData = salesChartDataModified;
    const displayChartData = displaySalesChartDataModified;
    const isDownside = true;
    if (!originalChartData?.datasets || !displayChartData?.datasets || !originalProfitAndLossByMonth?.labels || !capexPartNo || capexPartNo.length === 0) {
      return "";
    }
    // 顧客指定部品の有無判断
    const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
    if (!a) return "";

    const originalSalesDataset = originalChartData.datasets.find((d: any) => d.id === "sales");
    if (!originalSalesDataset) {
      return "";
    }
    const sales = originalSalesDataset.data.map((v: number) => new Decimal(v));
    const materialCosts = calcMaterialCost(
      isDownside ? mergedChartDataModified : mergedChartDataOriginal,
      isDownside ? quantitiesChartDataModified : quantitiesChartDataOriginal,
      capexPartNo,
      originalProfitAndLossByMonth.labels,
      projectData?.projectId!,
      localCurrencyName,
      currencyData
    );

    // データの実期間に調整
    const labels = (originalProfitAndLossByMonth.labels).slice(0, sales.length);
    const monthlyData = calcMonthlyProfitAndLossDetails(
      sales,
      materialCosts || [],
      labels,
      isDownside,
      originalEquipmentAmounts,
      projectData!,
      capexPartNo,
      localCurrencyName,
      currencyData,
      downsideIndexGraph,
      decimalCurrency,
      uniqueProcessData,
      bomData,
      projectData?.moldSalesByProject,
      projectData?.developmentSalesByProject,
      projectData?.equipmentSalesByProject,
    );
    if (!monthlyData) {
      return "";
    }

    const localCurrency = currencyData.find(c => c.currencyId === localCurrencyId);
    let totalCustomerCost: Decimal;
    if (selectedCurrency.id !== localCurrencyId && localCurrency?.currencyName) {
      if (reviewDate) {
        totalCustomerCost = monthlyData.customerSpecifiedPartsCost.reduce((sum, cost, i) => {
          const yearMonth = originalProfitAndLossByMonth.labels[i]?.replace("/", "-");
          const converted = new Decimal(convertWithRate(cost, localCurrency.currencyName!, selectedCurrency.name, yearMonth));
          return sum.plus(converted);
        }, new Decimal(0));
      } else {
        totalCustomerCost = convertCurrency(
          monthlyData.customerSpecifiedPartsCost.reduce((sum, v) => sum.plus(v), new Decimal(0)),
          localCurrency.currencyName,
          selectedCurrency.name,
          currencyData
        );
      }
    } else {
      totalCustomerCost = monthlyData.customerSpecifiedPartsCost.reduce((sum, v) => sum.plus(v), new Decimal(0));
    }

    const displaySalesDataset = displayChartData.datasets.find((d: any) => d.id === "sales");
    const displayProfitDataset = displayChartData.datasets.find((d: any) => d.id === "profit");
    if (!displaySalesDataset || !displayProfitDataset) {
      return "";
    }
    const totalSales = (displaySalesDataset.data as number[]).reduce((sum, v) => sum + (v || 0), 0);
    // No.411追加対応: 表示期間外（生産終了後）に残る減価償却費を分子に加算し、
    // 「売上・利益」画面のrealProfitRateModified（DB保存用）と算出方式を統一する。
    // residualDepreciationTotalはローカル通貨のため、totalCustomerCostと同じ通貨変換を適用してから加算する。
    const residualDepreciationTotal = monthlyData.residualDepreciationTotal ?? new Decimal(0);
    const convertedResidual = selectedCurrency.id !== localCurrencyId && localCurrency?.currencyName
      ? convertCurrency(residualDepreciationTotal, localCurrency.currencyName, selectedCurrency.name, currencyData)
      : residualDepreciationTotal;
    const totalProfitVal = (displayProfitDataset.data as number[]).reduce((sum, v) => sum + (v || 0), 0) + convertedResidual.toNumber();

    return calcRealProfitRate(new Decimal(totalSales), new Decimal(totalProfitVal), totalCustomerCost);
  }, [salesChartDataModified, displaySalesChartDataModified, originalProfitAndLossByMonth, capexPartNo, mergedChartDataModified, quantitiesChartDataModified, projectData, localCurrencyName, currencyData, originalEquipmentAmounts, downsideIndexGraph, decimalCurrency, uniqueProcessData, bomData, selectedCurrency, localCurrencyId, reviewDate, convertWithRate]);

  /** useRef */
  const refs: Record<string, React.RefObject<HTMLButtonElement>> = {
    companyDivision: useRef<HTMLButtonElement>(null),
    companyHeadDivision: useRef<HTMLButtonElement>(null),
    salesDivision: useRef<HTMLButtonElement>(null),
    procurementDivision: useRef<HTMLButtonElement>(null),
  };

  /** 条件テーブル/ダウンサイドテーブルヘッダーセル */
  // 多言語対応: 英語など日本語より長いラベルが入っても隣列に被らないよう、
  // nowrap(横一列固定)ではなく折返し表示にする
  const thStyle = {
    whiteSpace: "normal",
    overflowWrap: "break-word" as const,
    wordBreak: "break-word" as const,
  };

  /** 条件テーブル/ダウンサイドテーブルボディセル */
  const tdStyle = {
    // whiteSpace: "nowrap"
  };

  // -----------------------------
  // 入力項目イベント
  // -----------------------------
  // 数量・単価テキスト入力変更時のイベント
  // 保持しているテーブルの値を更新
  const handleInputChange = useCallback(
    (tableId: string, year: number, month: number, field: "quantity" | "price", value: number | null) => {
      setQuantityAndPriceTables((prevTables) =>
        prevTables.map((table) => {
          if (table.data.id !== tableId) { return table; }

          // ネストデータの値を更新
          const updatedInnerData = updateNestedField(table.data.data, [year, "months", month, field], value);

          const updatedData = {
            ...table.data,
            data: updatedInnerData,
          };

          return {
            ...table,
            data: updatedData,
            edited: true,
          };
        })
      );
    },
    [] // 関数型更新を使っているため、依存配列は空でOK
  );

  /**
  * データ取得
  */
  const fetchData = async (options?: { preserveTextDraft?: boolean }) => {

    try {
      const payload = {
        query: `
          query fetchSimulationNewProductData($projectId: String, $useRDSData: Boolean, $reviewDate: String) {
            getProjectById(projectId: $projectId, useRDSData: $useRDSData, reviewDate: $reviewDate) {
              projectId
              pastProjectId
              pastReviewDate
              customerId
              customerName
              endUserName
              customerIndustry
              customerIndustryHierarchy
              customerNationality
              currencyId
              baseLaborCostIncreaseRate
              salesManagementRate
              otherEquipmentCost
              otherEquipmentCostCurrencyId
              devCost
              devCostCurrencyId
              otherCost
              otherCostCurrencyId
              monthlyExpenseData
              pastEquipmentCostCurrencyId
              productionLaborCostCurrencyId
              overseasFactoryExpensesCurrencyId
              outsourcingProcessingCostCurrencyId
              factoryBuildingDepreciationCurrencyId
              royaltyCurrencyId
              domesticLaborCostCurrencyId
              domesticSgaExpensesCurrencyId
              productionSgaExpensesCurrencyId
              domesticFactoryExpensesCurrencyId
              domesticInvestmentDepreciationCurrencyId
              domesticFactoryBuildingDepreciationCurrencyId
              domesticOtherDepreciationCurrencyId
              salesCompanySgaCurrencyId
              originalProfitAndLossByMonth
              displayOriginalProfitAndLossByMonth
              currencyId
              companyPlantId
              companyPlantSnapshot
              downsideRisk
              downsideIndex
              downsideIndexEnable
              registrantDivisionId
              updateDate
              productionLineId
              pricingAgreement
              finalInvestmentReason
              moldSalesByProject
              developmentSalesByProject
              equipmentSalesByProject
              projectStartDate
              projectEndDate
              newProductStartDate
              selectedSimulationConfigIds
              purpose
              equipmentUsageType
              productionFactoryLaborUnitPrice
              productionFactoryExpenseUnitPrice
            }
            getEquipmentByProjectId(projectId: $projectId, reviewDate: $reviewDate) {
              equipmentId
              equipmentName
              unitPrice
              quantity
              amount
              currencyId
              numberOfPeopleRequiredForEquipment
              unskilledWorker
              multiSkilledWorker
              technician
              numberOfPeopleRequiredForWithoutEquipment
              depreciationPeriod
              depreciationStartMonth
              acceptanceMonth
            }
            getPartNo(projectId: $projectId, reviewDate: $reviewDate) {
              partNo
              displayPartNo
              quantityAndPrice
              moldSalesByPartNo
              developmentSalesByPartNo
              inhousePart
              processes
            }
          }`,
        variables: {
          projectId: projectId,
          useRDSData: true,
          ...(reviewDate && { reviewDate })
        }
      };

      // プロジェクト情報取得（dynamodb、RDS）
      const response = await WebAPI.request(payload);
      let project: ProjectWithRdsData | null = null;
      let pastProjData: ProjectWithRdsData = {};
      let pastPartNo: PartNo[] = [];
      let labels = [];

      let pastEquipment: EquipmentExtType[] = [];

      if (response?.data?.getProjectById?.projectId) {
        // プロジェクト情報
        project = response.data.getProjectById;

        // プロジェクト情報セット
        setProjectData(project);

        if (!options?.preserveTextDraft) {
          // 最終的な投資判断の理由セット（ドラフトrefとテキストエリアの両方）
          finalInvestmentReasonDraftRef.current = project?.finalInvestmentReason ?? null;
          finalInvestmentReasonRef.current?.setValue(project?.finalInvestmentReason ?? null);

          // ダウンサイドリスク対応セット（同上）
          downsideRiskDraftRef.current = project?.downsideRisk ?? null;
          downsideRiskRef.current?.setValue(project?.downsideRisk ?? null);
        }

        // オリジナル(当初損益) ⇒ 対象プロジェクトの利益試算で登録 ⇒ STEP2ではセットしない。(不要かも)
        // if (project?.originalProfitAndLoss) {
        //   setOriginalProfitAndLoss(JSON.parse(project?.originalProfitAndLoss));
        // }

        // オリジナル月別(当初損益月別) ⇒（対象プロジェクトの利益試算で登録）
        if (project?.originalProfitAndLossByMonth) {
          const tempOriginalProfitAndLossByMonth = JSON.parse(project?.originalProfitAndLossByMonth);

          // EOL予定日までの月数でフィルタリング
          const visibleMonths = calcMonthsBetweenDates(
            project.projectStartDate,
            project.projectEndDate
          );

          if (visibleMonths > 0 && tempOriginalProfitAndLossByMonth.labels &&
            visibleMonths < tempOriginalProfitAndLossByMonth.labels.length) {
            // labels をフィルタリング
            tempOriginalProfitAndLossByMonth.labels = tempOriginalProfitAndLossByMonth.labels.slice(0, visibleMonths);
            // totalSales をフィルタリング
            if (tempOriginalProfitAndLossByMonth.totalSales) {
              tempOriginalProfitAndLossByMonth.totalSales = tempOriginalProfitAndLossByMonth.totalSales.slice(0, visibleMonths);
            }
            // profit をフィルタリング
            if (tempOriginalProfitAndLossByMonth.profit) {
              tempOriginalProfitAndLossByMonth.profit = tempOriginalProfitAndLossByMonth.profit.slice(0, visibleMonths);
            }
            // quantityByPartNo を各PartNo毎にフィルタリング
            if (tempOriginalProfitAndLossByMonth.quantityByPartNo) {
              Object.keys(tempOriginalProfitAndLossByMonth.quantityByPartNo).forEach(partNo => {
                tempOriginalProfitAndLossByMonth.quantityByPartNo[partNo] =
                  tempOriginalProfitAndLossByMonth.quantityByPartNo[partNo].slice(0, visibleMonths);
              });
            }
          }

          labels = tempOriginalProfitAndLossByMonth.labels;

          if (response?.data?.getPartNo) {
            // パーツNoの整合性チェック
            const isPartNoIntegrity = response.data.getPartNo.every((p: PartNo) => {
              const hasPartNo = tempOriginalProfitAndLossByMonth?.quantityByPartNo?.hasOwnProperty(p.partNo) || false;
              if (!hasPartNo) {
                console.warn(`Simuration unmatch partNo. BasicInfo PartNo = ${p.partNo}`);
              }
              return hasPartNo;
            })

            if (isPartNoIntegrity) {
              setOriginalProfitAndLossByMonth(tempOriginalProfitAndLossByMonth);
            }
          }
        }

        // JPY版データの読み込み（二重通貨変換回避用）
        if (project?.displayOriginalProfitAndLossByMonth) {
          const tempDisplayProfitAndLossByMonth = JSON.parse(project.displayOriginalProfitAndLossByMonth);

          // EOL予定日までの月数でフィルタリング（ローカル通貨版と同様）
          const visibleMonths = calcMonthsBetweenDates(
            project.projectStartDate,
            project.projectEndDate
          );

          if (visibleMonths > 0 && tempDisplayProfitAndLossByMonth.labels &&
            visibleMonths < tempDisplayProfitAndLossByMonth.labels.length) {
            tempDisplayProfitAndLossByMonth.labels = tempDisplayProfitAndLossByMonth.labels.slice(0, visibleMonths);
            if (tempDisplayProfitAndLossByMonth.totalSales) {
              tempDisplayProfitAndLossByMonth.totalSales = tempDisplayProfitAndLossByMonth.totalSales.slice(0, visibleMonths);
            }
            if (tempDisplayProfitAndLossByMonth.profit) {
              tempDisplayProfitAndLossByMonth.profit = tempDisplayProfitAndLossByMonth.profit.slice(0, visibleMonths);
            }
          }

          setDisplayOriginalProfitAndLossByMonth(tempDisplayProfitAndLossByMonth);
        }

        if (project?.pastProjectId) {
          // 紐づけ時点の承認済み振り返り日（保存済みの pastReviewDate、申請のみの場合は null）
          const pastReviewDate = project.pastReviewDate ?? null;

          // 過去プロジェクトの設備投資情報(現時点で数量しか使用していないので表示通貨になっていないので注意！)
          pastEquipment = await fetchEquipments(project.pastProjectId, t('features.InvestmentScreening.SimulationNewProduct.message.pastEquipmentInfo'), undefined, undefined, pastReviewDate, projectId);
          setPastEquipmentAmounts(pastEquipment);

          // 新製品投資量産開始年月（★ラベル表示位置）
          if (project?.newProductStartDate) {
            const npStartDate = new Date(project.newProductStartDate);
            const npLabel = `${npStartDate.getFullYear()}/${String(npStartDate.getMonth() + 1).padStart(2, "0")}`;
            setNewProductStartYearMonth(npLabel);
          }

          // 過去プロジェクト情報取得
          pastProjData = await fetchProject(project.pastProjectId, t('features.InvestmentScreening.SimulationNewProduct.message.pastProjectInfo'), pastReviewDate, projectId);
          setPastProjectData(pastProjData);

          // 過去パーツ情報取得
          pastPartNo = await fetchPartNo(project.pastProjectId, t('features.InvestmentScreening.SimulationNewProduct.message.pastPartNoInfo'), pastReviewDate, projectId);
          setPastCapexPartNo(pastPartNo);

          // 過去通貨情報取得（通貨はプロジェクト単位マスタのため振り返り対応不要）
          const pastCurrency = await fetchCurrency(project.pastProjectId, t('features.InvestmentScreening.SimulationNewProduct.message.pastCurrencyInfo'), projectId);
          setPastCurrencyData(pastCurrency);
        }
      } else {
        showApiError(`プロジェクト情報`, `getProjectById`, response.errors);
        return;
      }

      // #region ストレス指数の初期化

      if (project?.downsideIndex) {
        console.log("project downsideIndex exists.");

        // T_CEAS_PROJECT ストレス指数を取得
        const downsideIndex = JSON.parse(project.downsideIndex) as DownsideIndexType[];

        // T_CEAS_PROJECT 顧客取り決め事項を取得
        const agreement: PricingAgreementFormType =
          project?.pricingAgreement ? JSON.parse(project?.pricingAgreement) : [];

        // ストレス指数（画面表示用）の初期化
        setInitialDownsideIndexDisplay(downsideIndex, agreement);

        // ストレス指数(表)（画面表示用）の初期化
        setInitialDownsideIndexTableDisplay(downsideIndex, agreement, labels);

        // ストレス指数の初期化
        setInitialDownsideIndex(downsideIndex, agreement);

        if (project?.downsideIndexEnable) {
          let enDwnidx = JSON.parse(project.downsideIndexEnable) as DownsideIndexEnableType[];
          // ストレス指数(表)のヘッダー(有効・無効)を設定
          updateEnabledDownsideIndex(enDwnidx);
          // リセット用にコピーを保持
          setDownsideIndexEnableForReset(downsideIndexEnable);
        };

      } else {

        // M_CEAS_DOWNSIDE_INDEX データを取得
        const mDownsideIndex = await fetchDownsideIndex("001");

        // T_CEAS_PROJECT 顧客取り決め事項を取得
        const agreement: PricingAgreementFormType =
          project?.pricingAgreement ? JSON.parse(project?.pricingAgreement) : [];

        // ストレス指数（画面表示用）の初期化
        setInitialDownsideIndexDisplayNew(mDownsideIndex, agreement);

        // ストレス指数(表)（画面表示用）の初期化
        setInitialDownsideIndexTableDisplayNew(mDownsideIndex, agreement, labels);

        // ストレス指数の初期化
        setInitialDownsideIndexNew(mDownsideIndex, agreement);

      }

      // #endregion

      // 通貨マスタ（ProjectContext から取得。InvestmentScreeningDetail で一括取得済み）
      if (currencyStatus === 'empty') {
        // 案件コピー直後など、基本情報が未保存で通貨情報が存在しない場合は保存を案内する
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationNewProduct.message.registerFromBasicInfo'),
          status: 'warning',
          duration: 5000,
          isClosable: true,
        });
        return;
      }
      if (!currencyData || currencyData.length === 0) {
        showApiError(`通貨情報`, `getCurrencyById`, undefined);
        return;
      }

      // 各通貨を取得
      const salesExchange = currencyData.find(c => c.currencyId === project?.currencyId);
      const projectLocalCurrencyId = getLocalCurrencyId(project?.companyPlantSnapshot);
      const factoryExchange = currencyData.find(c => c.currencyId === projectLocalCurrencyId);

      // 通貨名を設定
      const salesCurrencyName = salesExchange?.currencyName || '';
      const localCurrencyName = factoryExchange?.currencyName || '';

      // 販売通貨設定
      setSalesCurrencyName(salesCurrencyName);
      // ローカル通貨設定
      setLocalCurrencyName(localCurrencyName);

      // 小数点以下が必要かどうか ⇒ TODO シミュレーション計算に対するものなので、PLの通貨にすべきか要検討
      setDecimalCurrency(hasDecimal(localCurrencyName));

      // 表示通貨の初期値をJPYに設定
      if (localCurrencyName && currencyData.length > 0) {
        const jpyCurrency = currencyData.find(currency => currency.currencyName === CurrencyNameJPY);
        if (jpyCurrency?.currencyId && jpyCurrency?.currencyName) {
          setSelectedCurrency({ id: jpyCurrency.currencyId, name: jpyCurrency.currencyName });
        }
      }

      // BOMデータ取得
      const bomDataResult = await getBomByProjectId(projectId);
      setBomData(bomDataResult);

      // 製造ライン情報取得
      let productionLine: ProductionLineType = {};
      if (project?.productionLineId) {
        productionLine = await fetchProductLine(project.productionLineId);
        // 製造ライン情報を更新
        setProductionLine(productionLine);
        // 稼働日数を更新
        if (productionLine?.workingDays) {
          const workingDaysData: { fiscalYear: string, workingDaysData: WorkingDaysType }[]
            = JSON.parse(productionLine.workingDays);
          // ポップアップ
          setWorkingDaysData(workingDaysData);
          setImprovedWorkingDaysData(workingDaysData);
          setOriginalImprovedWorkingDaysData(workingDaysData); // 初期値として保存
          // 工場稼働日数（カレンダー上の稼働日数）
          setFactoryWorkingDayByYear(
            workingDaysData.map((wd) => ({
              fiscalYear: wd.fiscalYear,
              workingDay: wd.workingDaysData.factoryWorkingDays,
            }))
          );
          // 稼働日数
          const workingDayByYearData = workingDaysData.map((workingDays) => ({
            fiscalYear: workingDays.fiscalYear,
            workingDay: workingDays.workingDaysData.workingDays,
          }));
          setWorkingDayByYear(workingDayByYearData);
          setImprovedWorkingDayByYear(workingDayByYearData);
          // 休日出勤
          setHolidayByYear(
            workingDaysData.map((workingDays) => ({
              fiscalYear: workingDays.fiscalYear,
              holiday: workingDays.workingDaysData.workOnWeekendAndHolidays,
            }))
          );
          setImprovedHolidayByYear(
            workingDaysData.map((workingDays) => ({
              fiscalYear: workingDays.fiscalYear,
              holiday: workingDays.workingDaysData.workOnWeekendAndHolidays,
            }))
          );
          // ライン数
          setLineCountByYear(
            workingDaysData.map((workingDays) => ({
              fiscalYear: workingDays.fiscalYear,
              lineCount: workingDays.workingDaysData.lineCount || Array(12).fill(1),
            }))
          );
          setImprovedLineCountByYear(
            workingDaysData.map((workingDays) => ({
              fiscalYear: workingDays.fiscalYear,
              lineCount: workingDays.workingDaysData.lineCount || Array(12).fill(1),
            }))
          );
        }
        // 非稼働時間を更新
        if (productionLine?.nonWorkingHours) {
          const nonWorkingHours: { fiscalYear: string, nonWorkingHoursByMonth: NonWorkingHoursType[] }[]
            = JSON.parse(productionLine.nonWorkingHours);
          // ポップアップ
          setNonWorkingHoursData(nonWorkingHours);
          setImprovedNonWorkingHoursData(nonWorkingHours);
          setOriginalImprovedNonWorkingHoursData(nonWorkingHours); // 初期値として保存

          const availabilityRates: {
            fiscalYear: string;
            availabilityRate: number[];
          }[] = []; // 新しい構造：年度ごとの稼働率

          if (productionLine?.workingDays) {
            const workingDaysData: {
              fiscalYear: string;
              workingDaysData: WorkingDaysType;
            }[] = JSON.parse(productionLine.workingDays);

            // 稼働日数情報の年度でループ処理
            workingDaysData.forEach(({ fiscalYear, workingDaysData }) => {
              // 年度に紐づく非稼働時間情報を取得（会計年度文字列は表示言語で変わるため年数値で判定する）
              const matchingNonWorkingHours = nonWorkingHours.find((data) => isSameFiscalYear(data.fiscalYear, fiscalYear));
              if (matchingNonWorkingHours) {
                // 月度に紐づく稼働率を取得
                const availabilityRateByMonth = workingDaysData.requiredOverTimes.map((_, index) => {
                  return Number(matchingNonWorkingHours.nonWorkingHoursByMonth[index]?.availabilityRate ?? 0);
                });
                // 結果を配列に格納
                availabilityRates.push({
                  fiscalYear,
                  availabilityRate: availabilityRateByMonth,
                });
              }
            });
          }

          setAvailabilityRateByMonth(availabilityRates);
          setImprovedAvailabilityRateByMonth(availabilityRates);
        }
        // 歩留改善リストを初期化（BOMから取得するため初期値は0）
        const initialYieldRateList = [{
          month: "",
          yieldRate: 0,
          yieldRateText: "0.0"
        }];
        setImprovedYieldRateList(initialYieldRateList);
        setOriginalImprovedYieldRateList(initialYieldRateList);
        // サイクルタイム改善リストを初期化（BOMから取得するため初期値は0）
        const initialCycleTimeList = [{
          month: "",
          cycleTime: 0,
          cycleTimeText: "0.0"
        }];
        setImprovedCycleTimeList(initialCycleTimeList);
        setOriginalImprovedCycleTimeList(initialCycleTimeList);
      }

      // 工程情報取得（C/T計算用）
      if (project?.projectId) {
        const uniqueProcess = await fetchUniqueProcessData(project.projectId);
        setUniqueProcessData(uniqueProcess);
      }

      // 設備情報取得
      let equipmentData: EquipmentExtType[] = [];
      if (response && response.data && response.data.getEquipmentByProjectId) {
        const rawEquipmentData: EquipmentType[] = response.data.getEquipmentByProjectId;
        // 月別レート到着後の再変換用に変換前データを保持
        rawEquipmentDataRef.current = rawEquipmentData;
        // 設備の通貨変換
        // 振り返りモード: 対象PJの損益試算画面と同じく検収月の月別レートで変換（利益計算時の逆変換とレートを揃える）
        const convertedData: EquipmentType[] = convertEquipmentData(rawEquipmentData, localCurrencyName, currencyData,
          reviewDate && monthlyRateMap.size > 0 ? convertWithRate : undefined);
        // EquipmentType => EquipmentExtType へのマッピング
        equipmentData = convertedData.map(item => ({
          ...item,
          selected: false,       // 初期化（拡張プロパティ）
          changeInQuantity: 0,   // 初期化（拡張プロパティ）
        }));

        // 数量（増減数）設定
        equipmentData = calcEquipmentQuantity(equipmentData, (e) => {
          // デフォルト選択
          e.selected = true;
        });

        setEquipmentAmounts(equipmentData);
        setOriginalEquipmentAmounts(equipmentData); // 初期表示用に保存
      } else {
        showApiError(`設備情報`, `getEquipmentByProjectId`, response.errors);
        return;
      }

      // プロジェクトIDからパーツNoを取得
      let partNo: PartNo[] = [];
      if (response && response.data && response.data.getPartNo) {
        const partNoList: PartNo[] = response.data.getPartNo;

        // 各PartNoのmaterialCostを取得してマージ
        partNo = await Promise.all(
          partNoList.map(async (part) => {
            const materialCostData = await getMaterialCost(projectId, part.partNo!);
            return {
              ...part,
              materialCost: materialCostData?.materialCost,
              materialCostWithInhouseProfit: materialCostData?.materialCostWithInhouseProfit,
            };
          })
        );

        setCapexPartNo(partNo);

        if (project?.projectStartDate) {
          // 数量・単価情報設定
          const parsedTables = partNo.map((item: PartNo) => {
            if (!item.quantityAndPrice) { return null; }
            const quantityAndPriceJson = JSON.parse(item.quantityAndPrice);

            if (quantityAndPriceJson.currencyAndRatio) {
              try {
                let selectedCurrencies = JSON.parse(quantityAndPriceJson.currencyAndRatio);
                if (!Array.isArray(selectedCurrencies)) { selectedCurrencies = [selectedCurrencies]; }
                updateSelectedCurrency(quantityAndPriceJson.id, quantityAndPriceJson.partNo, selectedCurrencies, currencyData);
              } catch (error) {
                console.error("Failed to parse JSON:", error);
              }
            }

            return {
              id: quantityAndPriceJson.id,
              partNo: quantityAndPriceJson.partNo,
              years: quantityAndPriceJson.years,
              data: quantityAndPriceJson.data,
              currencyAndRatio: quantityAndPriceJson.currencyAndRatio
                ? (typeof quantityAndPriceJson.currencyAndRatio === 'string'
                  ? JSON.parse(quantityAndPriceJson.currencyAndRatio)
                  : quantityAndPriceJson.currencyAndRatio)
                : [],
            } as QuantityAndPriceMonthTable;
          }).filter((item): item is QuantityAndPriceMonthTable => item !== null)
            .map((table) => ({
              data: table, edited: false
            }));

          const startDate = new Date(project.projectStartDate);
          const year = startDate.getFullYear();
          const month = startDate.getMonth() + 1;
          const fiscalYear = month >= 4 ? year : year - 1;
          setBaseStartYear(fiscalYear);

          setQuantityAndPriceTables(parsedTables);
          setOriginalQuantityAndPriceTables(parsedTables); // 初期表示用に保存
        }
      } else {
        showApiError(`Part No.`, `getPartNo`, response.errors);
        return;
      }

      // 顧客国籍名を取得
      let customerNationalityName = "";
      if (project?.customerNationality) {
        try {
          const natPayload = {
            query: `
              query getNationalityById($nationalityId: String) {
                getNationalityById(nationalityId: $nationalityId) {
                  nationalityId
                  nationalityNameJpn
                  nationalityNameEng
                }
              }
            `,
            variables: { nationalityId: project.customerNationality },
          };
          const natResponse = await WebAPI.request(natPayload);
          customerNationalityName = getBilingualDisplayName(
            natResponse?.data?.getNationalityById,
            'nationalityNameJpn',
            'nationalityNameEng',
          );
        } catch (error) {
          console.error("getNationalityById error:", error);
        }
      }

      // 条件テーブル設定
      setConditionTable({
        /** 顧客業界（コード） */
        customerIndustry: project?.customerIndustry || "",
        /** 顧客業界（名称） */
        customerIndustryName: project?.customerIndustryHierarchy || getCustomerIndustryTypeNameByCode(project?.customerIndustry || "") || project?.customerIndustry || "",
        /** 顧客国籍 */
        customerNationality: customerNationalityName,
        /** 顧客名 */
        customerName: (project?.customerName && project?.customerName === project?.customerId
          ? splitEscapedList(project?.customerName)[0]
          : project?.customerName) || "",
        /** エンドユーザ名 */
        endUserName: project?.endUserName || "",
        /** 工場為替 */
        factoryExchange: factoryExchange,
        /** 販売為替 */
        salesExchange: salesExchange,
        /** 工場拠点国 */
        factoryLocationCountry: getLocationCountry(project?.companyPlantSnapshot, true),
      });

      // ストレスシナリオが常にONとするため、選択顧客製品を設定
      setSelectedCustomerProduct(project?.customerIndustryHierarchy || getCustomerIndustryTypeNameByCode(project?.customerIndustry || "") || project?.customerIndustry || "");

      // 表示対象選択の選択状態を保持（ストレス指数保存時は選択状態を維持）
      // setSelectedConfigIds([]); // コメントアウト：選択状態を保持

      // 必須データチェック
      requiredDataNotice(project as ProjectWithRdsData, partNo, equipmentData, productionLine);

      // 過去プロジェクトとのPart No整合性判定（トースト表示はpagePermissions確定後にuseEffectで行う）
      if (project?.pastProjectId) {
        setMissingPastPartNoList(findMissingPastPartNos(partNo, pastPartNo));
      } else {
        setMissingPastPartNoList([]);
      }
    } catch (error) {
      console.error("データ取得エラー:", error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.fetchDataFailed'),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  /**
   * ストレス指数情報取得
   * 
   * @param {string} customerProductCategoryId 顧客製品分類ID
   * @returns {DownsideIndexType[]} M_CEAS_DOWNSIDE データ
   */
  const fetchDownsideIndex = async (customerProductCategoryId: string): Promise<DownsideIndexType[]> => {

    try {

      // 変数宣言
      const payload = {
        query: `
          query getDownsideIndexById($customerProductCategoryId: String) {
            getDownsideIndexById(customerProductCategoryId: $customerProductCategoryId) {
              downsideId
              customerProductCategoryId
              customerProductCategoryName
              itemId
              itemName
              yearIndex
              stressIndex
              updateDate
            }
          }`,
        variables: { customerProductCategoryId }
      };

      // DBデータ取得
      const response = await WebAPI.request(payload);

      // データ取得失敗の場合
      if (!response?.data?.getDownsideIndexById) {
        console.error(`Failed to call API getDownsideIndexById. errors = `, response?.errors);
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationNewProduct.message.downsideIndexFetchFailed'),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        return [];
      }

      // データ取得結果を返却
      return response.data.getDownsideIndexById;

    } catch (error) {
      console.error("データ取得失敗:", error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.fetchDataFailed'),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return [];
    }

  }

  /**
   * BOMデータ取得
   * @param projectId プロジェクトID
   */
  const getBomByProjectId = async (projectId: string): Promise<BomData[]> => {
    const functionName = "getBomByProjectId";
    try {
      const response = await WebAPI.request({
        query: `
          query getBomByProjectId($projectId: String, $reviewDate: String) {
            getBomByProjectId(projectId: $projectId, reviewDate: $reviewDate) {
              projectId
              partNo
              seq
              level
              isCustomerSpecifiedParts
              purchaseCurrencyId
              amountMonthly
              cycleTimeMonthly
              yieldMonthly
            }
          }`,
        variables: { projectId, ...(reviewDate && { reviewDate }) }
      });
      if (!response?.data[functionName]) {
        console.log(`${functionName} データなし`);
        return [];
      }
      return response?.data[functionName];
    } catch (error) {
      console.error(`${functionName} エラー:`, error);
      return [];
    }
  };

  /**
   * 製造ライン情報取得
   * @param productionLineId 製造ラインID
   */
  const fetchProductLine = async (productionLineId: string, reviewDateOverride?: string | null): Promise<ProductionLineType> => {
    try {
      const effectiveReviewDate = reviewDateOverride === undefined ? reviewDate : reviewDateOverride;
      const payload = {
        query: `
          query getProductionLineById($projectId: String, $productionLineId: String, $reviewDate: String) {
            getProductionLineById(projectId: $projectId, productionLineId: $productionLineId, reviewDate: $reviewDate) {
              productionLineId
              cycleTime
              workingDays
              nonWorkingHours
              yieldRate
              improvementBaseMonthYield
              improvementBaseMonthAvailability
              improvementBaseMonthCycleTime
            }
          }`,
        variables: { projectId, productionLineId, ...(effectiveReviewDate && { reviewDate: effectiveReviewDate }) }
      };

      // DB情報取得
      const response = await WebAPI.request(payload);

      // 製造ライン情報取得
      if (!response?.data?.getProductionLineById?.productionLineId) {
        console.error(`Failed to call API getProductionLineById. errors = `, response?.errors);
        // データ取得失敗の場合
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationNewProduct.message.fetchProductionLineFailed'),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }

      return response.data.getProductionLineById;

    } catch (error) {
      console.error("データ取得失敗:", error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.fetchDataFailed'),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return {};
    }
  }

  /**
   * 工程情報取得（プロジェクトID指定）
   * @param projectId プロジェクトID
   */
  const fetchUniqueProcessData = async (projectId: string): Promise<UniqueProcessType[]> => {
    const functionName = "getUniqueProcessByProjectId";
    try {
      const payload = {
        query: `
          query getUniqueProcessByProjectId($projectId: String, $reviewDate: String) {
            getUniqueProcessByProjectId(projectId: $projectId, reviewDate: $reviewDate) {
              uniqueProcessId
              uniqueProcessCycleTimeInSecondByPartNo
            }
          }`,
        variables: { projectId, ...(reviewDate && { reviewDate }) }
      };

      // DB情報取得
      const response = await WebAPI.request(payload);

      if (!response?.data[functionName]) {
        // DBデータ取得失敗
        console.error(`Failed to call API ${functionName}. errors = `, response?.errors);
        return [];
      }

      // uniqueProcessCycleTimeInSecondByPartNoListに変換
      const result: UniqueProcessType[] = response.data[functionName].map((process: any) => {
        const cycleTimeList = process.uniqueProcessCycleTimeInSecondByPartNo
          ? JSON.parse(process.uniqueProcessCycleTimeInSecondByPartNo)
          : [];
        return {
          ...process,
          uniqueProcessCycleTimeInSecondByPartNoList: cycleTimeList,
        };
      });

      return result;

    } catch (error) {
      console.error(`${functionName} ERROR:`, error);
      return [];
    }
  }

  // 材料費情報取得API（PartNo単位）
  const getMaterialCost = async (projectId: string, partNo: string, reviewDateOverride?: string | null, referencingProjectId?: string | null): Promise<{ materialCost?: string, materialCostWithInhouseProfit?: string } | null> => {
    const functionName = "getMaterialCost";
    try {
      const effectiveReviewDate = reviewDateOverride === undefined ? reviewDate : reviewDateOverride;
      const response = await WebAPI.request({
        query: `
          query getMaterialCost($projectId: String, $partNo: String, $reviewDate: String, $referencingProjectId: String) {
            getMaterialCost(projectId: $projectId, partNo: $partNo, reviewDate: $reviewDate, referencingProjectId: $referencingProjectId) {
              materialCost
              materialCostWithInhouseProfit
            }
          }`,
        variables: { projectId, partNo, ...(effectiveReviewDate && { reviewDate: effectiveReviewDate }), ...(referencingProjectId && { referencingProjectId }) }
      });

      if (!response?.data?.getMaterialCost) {
        console.log(`${functionName} データなし: partNo=${partNo}`);
        return null;
      }

      return response?.data?.getMaterialCost;
    } catch (error) {
      console.error(`${functionName} error: partNo=${partNo}`, error);
      return null;
    }
  };

  /**
   * 過去プロジェクト情報取得
   * @param projectId プロジェクトID
   * @param dataLabel データラベル
   */
  const fetchProject = async (projectId: string | null | undefined, dataLabel?: string, reviewDateOverride?: string | null, referencingProjectId?: string | null) => {
    try {
      const effectiveReviewDate = reviewDateOverride === undefined ? reviewDate : reviewDateOverride;
      const payload = {
        query: `
          query getProjectById($projectId: String!, $useRDSData: Boolean, $targets: [String!]!, $reviewDate: String, $referencingProjectId: String) {
            getProjectById(projectId: $projectId, useRDSData: $useRDSData, reviewDate: $reviewDate, referencingProjectId: $referencingProjectId) {
              projectId
              pastProjectId
              customerId
              customerName
              endUserName
              customerIndustry
              customerIndustryHierarchy
              customerNationality
              currencyId
              baseLaborCostIncreaseRate
              salesManagementRate
              otherEquipmentCost
              otherEquipmentCostCurrencyId
              devCost
              devCostCurrencyId
              otherCost
              otherCostCurrencyId
              monthlyExpenseData
              productionLaborCostCurrencyId
              overseasFactoryExpensesCurrencyId
              outsourcingProcessingCostCurrencyId
              pastEquipmentCostCurrencyId
              factoryBuildingDepreciationCurrencyId
              royaltyCurrencyId
              domesticLaborCostCurrencyId
              domesticSgaExpensesCurrencyId
              productionSgaExpensesCurrencyId
              domesticFactoryExpensesCurrencyId
              domesticInvestmentDepreciationCurrencyId
              domesticFactoryBuildingDepreciationCurrencyId
              domesticOtherDepreciationCurrencyId
              salesCompanySgaCurrencyId
              originalProfitAndLossByMonth
              currencyId
              companyPlantSnapshot
              downsideRisk
              downsideIndex
              downsideIndexEnable
              registrantDivisionId
              updateDate
              productionLineId
              pricingAgreement
              finalInvestmentReason
              moldSalesByProject
              developmentSalesByProject
              equipmentSalesByProject
              projectStartDate
              projectEndDate
              newProductStartDate
              selectedSimulationConfigIds
              pastProjectId
              mergedChartDataOriginal
              productionFactoryLaborUnitPrice
              productionFactoryExpenseUnitPrice
            }
            getLargeChartDataById(projectId: $projectId, targets: $targets, reviewDate: $reviewDate, referencingProjectId: $referencingProjectId) {
              simulationChartData
            }
          }`,
        variables: {
          projectId, useRDSData: false,
          ...(effectiveReviewDate && { reviewDate: effectiveReviewDate }),
          targets: ["simulationChartData"],
          ...(referencingProjectId && { referencingProjectId }),
        }
      };

      // プロジェクト情報取得（dynamodb、RDS）
      const response = await WebAPI.request(payload);

      const rdsSimulationChartData =
        response?.data?.getLargeChartDataById?.simulationChartData ? JSON.parse(response?.data?.getLargeChartDataById?.simulationChartData) : null;

      if (response?.data?.getProjectById?.projectId) {
        let projectData = response.data.getProjectById;
        projectData = rdsSimulationChartData ? { ...projectData, ...rdsSimulationChartData } : projectData;

        return projectData;
      } else {
        console.error(`Failed to call API getProjectById. response = `, response);
        // データ取得失敗の場合
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationNewProduct.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationNewProduct.message.projectInfo') }),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error(`Exception to call API getProjectById. errors = `, error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationNewProduct.message.projectInfo') }),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }

    // データ取得失敗時
    return {};
  }

  /**
   * 過去パーツ情報取得
   * @param projectId プロジェクトID
   * @param dataLabel データラベル
   */
  const fetchPartNo = async (projectId: string | null | undefined, dataLabel?: string, reviewDateOverride?: string | null, referencingProjectId?: string | null) => {
    try {
      const effectiveReviewDate = reviewDateOverride === undefined ? reviewDate : reviewDateOverride;
      const payload = {
        query: `
          query getPartNo($projectId: String, $reviewDate: String, $referencingProjectId: String) {
            getPartNo(projectId: $projectId, reviewDate: $reviewDate, referencingProjectId: $referencingProjectId) {
              partNo
              displayPartNo
              quantityAndPrice
              moldSalesByPartNo
              developmentSalesByPartNo
              inhousePart
              processes
              basicInfoRegistered
            }
          }`,
        variables: { projectId, ...(effectiveReviewDate && { reviewDate: effectiveReviewDate }), ...(referencingProjectId && { referencingProjectId }) }
      };

      const response = await WebAPI.request(payload);

      if (response?.data?.getPartNo) {
        const partNoList: PartNo[] = response.data.getPartNo;

        // 各PartNoのmaterialCostを取得してマージ
        const partNoWithMaterialCost = await Promise.all(
          partNoList.map(async (part) => {
            const materialCostData = await getMaterialCost(projectId!, part.partNo!, reviewDateOverride, referencingProjectId);
            return {
              ...part,
              materialCost: materialCostData?.materialCost,
              materialCostWithInhouseProfit: materialCostData?.materialCostWithInhouseProfit,
            };
          })
        );

        return partNoWithMaterialCost;
      } else {
        console.error(`Failed to call API getPartNo. response = `, response);
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationNewProduct.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationNewProduct.message.projectInfo') }),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error(`Exception to call API getPartNo. errors = `, error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationNewProduct.message.partNoInfo') }),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }

    return [];
  }

  /**
   * 過去通貨情報取得
   * @param projectId プロジェクトID
   * @param dataLabel データラベル
   */
  const fetchCurrency = async (projectId: string | null | undefined, dataLabel?: string, referencingProjectId?: string | null) => {
    try {
      const payload = {
        query: `
          query getCurrencyById($projectId: String, $referencingProjectId: String) {
            getCurrencyById(projectId: $projectId, referencingProjectId: $referencingProjectId) {
              currencyId
              currencyName
              exchangeRate
            }
          }`,
        variables: { projectId, ...(referencingProjectId && { referencingProjectId }) }
      };

      const response = await WebAPI.request(payload);

      if (response?.data?.getCurrencyById) {
        return response.data.getCurrencyById;
      } else {
        console.error(`Failed to call API getCurrencyById. response = `, response);
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationNewProduct.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationNewProduct.message.currencyInfo') }),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error(`Exception to call API getCurrencyById. errors = `, error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationNewProduct.message.currencyInfo') }),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }

    return {};
  }

  /**
   *
   * 設備情報取得
   * @param projectId プロジェクトID
   * @param dataLabel データラベル
   * @param currencyNameArg 表示通貨名
   * @param currencyDataArg 通貨情報
   * @returns 設備情報
   */
  const fetchEquipments = async (projectId: string | null | undefined, dataLabel?: string, currencyNameArg?: string, currencyDataArg?: Currency[], reviewDateOverride?: string | null, referencingProjectId?: string | null) => {
    try {
      const effectiveReviewDate = reviewDateOverride === undefined ? reviewDate : reviewDateOverride;
      const payload = {
        query: `
          query getEquipmentByProjectId($projectId: String, $reviewDate: String, $referencingProjectId: String) {
            getEquipmentByProjectId(projectId: $projectId, reviewDate: $reviewDate, referencingProjectId: $referencingProjectId) {
              equipmentId
              equipmentName
              unitPrice
              quantity
              amount
              currencyId
              numberOfPeopleRequiredForEquipment
              unskilledWorker
              multiSkilledWorker
              technician
              numberOfPeopleRequiredForWithoutEquipment
              depreciationPeriod
              depreciationStartMonth
              acceptanceMonth
              processId
            }
          }`,
        variables: { projectId, ...(effectiveReviewDate && { reviewDate: effectiveReviewDate }), ...(referencingProjectId && { referencingProjectId }) }
      };

      // 設備情報取得（dynamodb、RDS）
      const response = await WebAPI.request(payload);

      if (response?.data?.getEquipmentByProjectId) {
        const rawEquipmentData: EquipmentType[] = response.data.getEquipmentByProjectId;

        if (!(currencyNameArg || null)) {
          currencyNameArg = localCurrencyName;
        }
        if (!(currencyDataArg || null)) {
          currencyDataArg = currencyData;
        }

        // 設備の通貨変換
        const convertedData = convertEquipmentData(rawEquipmentData, currencyNameArg!, currencyDataArg!);
        // EquipmentType => EquipmentExtType へのマッピング
        const equipmentData: EquipmentExtType[] = convertedData.map((e: EquipmentType) => {

          let changeInQuantity = 0;
          if (e.unitPrice && e.unitPrice) {
            const amount = new Decimal(e.amount || 0);
            const quantity = amount.div(e.unitPrice!);
            // 数量(増減数)
            changeInQuantity = quantity.toNumber();
          }

          return {
            ...e,
            selected: true,
            changeInQuantity: changeInQuantity,
          }
        });

        return equipmentData;

      } else {
        console.error(`Failed to call API getEquipmentByProjectId. response = `, response);
        // データ取得失敗の場合
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationNewProduct.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationNewProduct.message.equipmentInfo') }),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error(`Exception to call API getEquipmentByProjectId. errors = `, error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationNewProduct.message.equipmentInfo') }),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }

    // データ取得失敗時
    return [];
  }

  // 共通関数
  const updateStateIfNeeded = (
    sourceArray: any[],
    targetArray: any[],
    index: number,
    compareFunc: (sourceItem: any, targetItem: any) => boolean,
    updateFunc: (updater: (prev: any[]) => any[]) => void,
    updatedFields: (sourceItem: any) => any
  ) => {
    const sourceItem = sourceArray[index];
    const targetItem = targetArray[index];

    if (targetItem && compareFunc(sourceItem, targetItem)) {
      // 差分がある場合のみ状態を更新
      updateFunc((prev) => {
        const updated = [...prev];
        updated[index] = updatedFields(sourceItem);
        return updated;
      });
    }
  };

  /**
   * 表示通貨情報を取得（初期値：JPY）
   */
  useEffect(() => {
    if (localCurrencyId && currencyData.length > 0) {
      const selected = currencyData.find(currency => currency.currencyName === CurrencyNameJPY);
      if (selected && selected.currencyId && selected.currencyName) {
        setSelectedCurrency({
          id: selected.currencyId,
          name: selected.currencyName
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currencyData]);

  /**
   * 振り返りモード時は calcXxx 関数がすでに表示通貨で計算済み。
   * convertChartDatasets の from に表示通貨を渡すことで from===to となり変換をスキップ（二重変換防止）。
   * 通常モードは従来どおり localCurrencyName から変換する。
   */
  const displayFromCurrency = reviewDate ? selectedCurrency.name : localCurrencyName;

  /**
   * シミュレーション設定「労務費」の自動算出ボタン押下
   * 生産工場労務費単価・経費単価、C/T、販売数量から生産工場労務費・償却費以外の工場経費（生産）を算出
   */
  const handleSimulationAutoCalculateLaborCost = useCallback(async () => {
    if (isLaborCostCalculating) {
      return;
    }

    try {
      setIsLaborCostCalculating(true);

      // 前提値チェック（シミュレーション設定の単価・ベースアップ率を使用）
      if (
        scenarioProductionFactoryLaborUnitPrice === null || scenarioProductionFactoryLaborUnitPrice === undefined ||
        scenarioProductionFactoryExpenseUnitPrice === null || scenarioProductionFactoryExpenseUnitPrice === undefined ||
        scenarioBaseLaborCostIncreaseRate === null || scenarioBaseLaborCostIncreaseRate === undefined
      ) {
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationNewProduct.message.laborCostAutoCalcRequiresUnitPrice'),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      const startDate = projectData?.projectStartDate || "";
      if (!startDate || !originalProfitAndLossByMonth?.labels || originalProfitAndLossByMonth.labels.length === 0) {
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationNewProduct.message.projectStartDateNotSet'),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      // 年月リストを取得（費用画面のfiscalMonthsLabelless相当）
      const yearMonthList = originalProfitAndLossByMonth.labels.map((label) => {
        const [year, month] = label.split("/").map(Number);
        return { year, month };
      });

      // 月別のC/T合計を計算
      const totalCycleTimeByMonth: Decimal[] = calcTotalCycleTimeByMonth(uniqueProcessData, yearMonthList);

      // PartNo別月別数量を取得
      const currentCapexPartNo = capexPartNo.map(part => {
        const matchedTable = quantityAndPriceTables.find(t => t.data.partNo === part.partNo);
        if (matchedTable) {
          return {
            ...part,
            quantityAndPrice: JSON.stringify(matchedTable.data)
          };
        }
        return part;
      });

      // 最新パーツデータから月別数量を取得
      const quantitiesByPartNoMonth = getQuantitiesByPartNoMonth(currentCapexPartNo, startDate);

      // 月別販売数量合計を計算
      const totalSalesQuantityByMonth: Decimal[] = calcTotalQuantityByMonth(
        quantitiesByPartNoMonth,
        yearMonthList.length
      );

      // 生産工場労務費の通貨情報を取得
      const laborCostCurrencyName = currencyData?.find(
        c => c.currencyId === projectData?.productionLaborCostCurrencyId
      )?.currencyName;
      const laborCostDecimalCurrency = laborCostCurrencyName !== CurrencyNameJPY;

      // 生産工場労務費を計算
      const laborCostByMonth = calcCycleTimeBasedCost(
        totalCycleTimeByMonth,
        new Decimal(scenarioProductionFactoryLaborUnitPrice ?? 0),
        laborCostCurrencyName,
        laborCostCurrencyName, // 同じ通貨（変換なし）
        currencyData,
        totalSalesQuantityByMonth,
        laborCostDecimalCurrency,
        "monthly",
        "calcSimulationProductionLaborCost"
      );

      // ベースアップ率を適用（シミュレーション設定値。単価からの新規算出なので二重適用の心配はない）
      applyBaseUpRateToLaborCost(laborCostByMonth, scenarioBaseLaborCostIncreaseRate, startDate);

      // 償却費以外の工場経費の通貨情報を取得
      const overseasExpensesCurrencyName = currencyData?.find(
        c => c.currencyId === projectData?.overseasFactoryExpensesCurrencyId
      )?.currencyName;
      const overseasExpensesDecimalCurrency = overseasExpensesCurrencyName !== CurrencyNameJPY;

      // 償却費以外の工場経費を計算
      const overseasExpensesByMonth = calcCycleTimeBasedCost(
        totalCycleTimeByMonth,
        new Decimal(scenarioProductionFactoryExpenseUnitPrice ?? 0),
        overseasExpensesCurrencyName,
        overseasExpensesCurrencyName, // 同じ通貨（変換なし）
        currencyData,
        totalSalesQuantityByMonth,
        overseasExpensesDecimalCurrency,
        "monthly",
        "calcSimulationOverseasFactoryExpenses"
      );

      setScenarioLaborCostByMonth(laborCostByMonth.map(d => d.toNumber()));
      setScenarioOverseasFactoryExpensesByMonth(overseasExpensesByMonth.map(d => d.toNumber()));

      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.laborCostAutoCalcSuccess'),
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    } catch (err: any) {
      console.error("handleSimulationAutoCalculateLaborCost error:", err);
      toast({
        title: TITLE,
        description: err.message || t('features.InvestmentScreening.SimulationNewProduct.message.laborCostAutoCalcFailed'),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLaborCostCalculating(false);
    }
  }, [
    isLaborCostCalculating,
    scenarioProductionFactoryLaborUnitPrice,
    scenarioProductionFactoryExpenseUnitPrice,
    scenarioBaseLaborCostIncreaseRate,
    projectData,
    originalProfitAndLossByMonth,
    uniqueProcessData,
    capexPartNo,
    quantityAndPriceTables,
    currencyData,
    t,
    toast,
    TITLE,
  ]);

  /**
   * 売上グラフデータの表示用設定（当初計画）
   * - 選択通貨に応じて適切なデータを選択
   *   1. 選択通貨 = 保存時の表示通貨 → displayVersionSalesChartData（変換不要）
   *   2. 選択通貨 = ローカル通貨 → salesChartData（変換不要）
   *   3. その他 → salesChartDataをローカル通貨→選択通貨に変換
   */
  useEffect(() => {
    if (!selectedCurrency?.id || !currencyData.length || !localCurrencyId) {
      return;
    }

    if (!salesChartData) {
      setDisplaySalesChartData(null);
      return;
    }

    // 選択通貨がJPYの場合はJPY版データを使用（二重通貨変換回避）
    // 振り返りモード時は月別レートで再計算済みのsalesChartDataを使用するためスキップ
    if (displayVersionSalesChartData && selectedCurrency.name === CurrencyNameJPY && !reviewDate) {
      setDisplaySalesChartData(displayVersionSalesChartData);
      return;
    }

    // 選択通貨がローカル通貨と一致する場合
    if (selectedCurrency.id === localCurrencyId) {
      setDisplaySalesChartData(salesChartData);
      return;
    }

    // その他：ローカル通貨→選択通貨に変換
    const convertedChartData = convertChartDatasets(
      salesChartData,
      displayFromCurrency,
      selectedCurrency.name,
      currencyData,
      undefined,  // decimalPlacesは自動判定
      ["profitRate"]  // 利益率は変換スキップ
    );

    setDisplaySalesChartData(convertedChartData);

  }, [selectedCurrency, salesChartData, displayVersionSalesChartData, localCurrencyId, localCurrencyName, currencyData, displayFromCurrency]);

  /**
   * 投資回収グラフデータの表示用設定（当初計画）
   * - 選択通貨に応じて適切なデータを選択
   */
  useEffect(() => {
    if (!selectedCurrency?.id || !currencyData.length || !localCurrencyId) {
      return;
    }

    if (!combinedChartData) {
      setDisplayCombinedChartData(null);
      return;
    }

    // 選択通貨がJPYの場合はJPY版データを使用（二重通貨変換回避）
    // 振り返りモード時は月別レートで再計算済みのcombinedChartDataを使用するためスキップ
    if (displayVersionCombinedChartData && selectedCurrency.name === CurrencyNameJPY && !reviewDate) {
      setDisplayCombinedChartData(displayVersionCombinedChartData);
      return;
    }

    // 選択通貨がローカル通貨と一致する場合
    if (selectedCurrency.id === localCurrencyId) {
      setDisplayCombinedChartData(combinedChartData);
      return;
    }

    // その他：ローカル通貨→選択通貨に変換
    const convertedChartData = convertChartDatasets(
      combinedChartData,
      displayFromCurrency,
      selectedCurrency.name,
      currencyData
    );

    setDisplayCombinedChartData(convertedChartData);

  }, [selectedCurrency, combinedChartData, displayVersionCombinedChartData, localCurrencyId, localCurrencyName, currencyData, displayFromCurrency]);

  /**
   * 投資回収グラフデータの表示用設定（プロジェクト全体投資回収）
   */
  const displayCombinedChartDataAll = useMemo(() => {
    if (!combinedChartDataAll) return null;
    return convertChartDatasets(combinedChartDataAll, displayFromCurrency, selectedCurrency.name, currencyData);
  }, [combinedChartDataAll, displayFromCurrency, selectedCurrency.name, currencyData]);

  /** 増分キャッシュフロー（当初投資・回収）表示用 */
  const displayCombinedChartDataPast = useMemo(() => {
    if (!combinedChartDataPast) return null;
    return convertChartDatasets(combinedChartDataPast, displayFromCurrency, selectedCurrency.name, currencyData);
  }, [combinedChartDataPast, displayFromCurrency, selectedCurrency.name, currencyData]);


  /**
   * 販売単価・材料単価グラフデータの表示用設定（当初計画）
   * - 選択通貨に応じて適切なデータを選択
   */
  useEffect(() => {
    if (!selectedCurrency?.id || !currencyData.length || !localCurrencyId) {
      return;
    }

    if (!mergedChartDataOriginal) {
      setDisplayMergedChartDataOriginal(null);
      return;
    }

    // 選択通貨がJPYの場合はJPY版データを使用（二重通貨変換回避）
    if (displayVersionMergedChartDataOriginal && selectedCurrency.name === CurrencyNameJPY) {
      setDisplayMergedChartDataOriginal(displayVersionMergedChartDataOriginal);
      return;
    }

    // 選択通貨がローカル通貨と一致する場合
    if (selectedCurrency.id === localCurrencyId) {
      setDisplayMergedChartDataOriginal(mergedChartDataOriginal);
      return;
    }

    // その他：ローカル通貨→選択通貨に変換（単価なので小数3桁）
    const convertedChartData = convertChartDatasets(
      mergedChartDataOriginal,
      localCurrencyName,
      selectedCurrency.name,
      currencyData,
      hasDecimal(selectedCurrency.name) ? 3 : 0
    );

    setDisplayMergedChartDataOriginal(convertedChartData);

  }, [selectedCurrency, mergedChartDataOriginal, displayVersionMergedChartDataOriginal, localCurrencyId, localCurrencyName, currencyData]);

  /**
   * 売上グラフデータの表示用設定（ダウンサイド）
   * - 選択通貨に応じて適切なデータを選択
   */
  useEffect(() => {
    if (!selectedCurrency?.id || !currencyData.length || !localCurrencyId) {
      return;
    }

    if (!salesChartDataModified) {
      setDisplaySalesChartDataModified(null);
      return;
    }

    // 選択通貨がJPYの場合はJPY版データを使用（二重通貨変換回避）
    // 振り返りモード時は月別レートで再計算済みのsalesChartDataModifiedを使用するためスキップ
    if (displayVersionSalesChartDataModified && selectedCurrency.name === CurrencyNameJPY && !reviewDate) {
      setDisplaySalesChartDataModified(displayVersionSalesChartDataModified);
      return;
    }

    // 選択通貨がローカル通貨と一致する場合
    if (selectedCurrency.id === localCurrencyId) {
      setDisplaySalesChartDataModified(salesChartDataModified);
      return;
    }

    // その他：ローカル通貨→選択通貨に変換
    const convertedChartData = convertChartDatasets(
      salesChartDataModified,
      displayFromCurrency,
      selectedCurrency.name,
      currencyData,
      undefined,
      ["profitRate"]
    );

    setDisplaySalesChartDataModified(convertedChartData);

  }, [selectedCurrency, salesChartDataModified, displayVersionSalesChartDataModified, localCurrencyId, localCurrencyName, currencyData, displayFromCurrency]);

  /**
   * 投資回収グラフデータの表示用設定（ダウンサイド）
   * - 選択通貨に応じて適切なデータを選択
   */
  useEffect(() => {
    if (!selectedCurrency?.id || !currencyData.length || !localCurrencyId) {
      return;
    }

    if (!combinedChartDataModified) {
      setDisplayCombinedChartDataModified(null);
      return;
    }

    // 選択通貨がJPYの場合はJPY版データを使用（二重通貨変換回避）
    // 振り返りモード時は月別レートで再計算済みのcombinedChartDataModifiedを使用するためスキップ
    if (displayVersionCombinedChartDataModified && selectedCurrency.name === CurrencyNameJPY && !reviewDate) {
      setDisplayCombinedChartDataModified(displayVersionCombinedChartDataModified);
      return;
    }

    // 選択通貨がローカル通貨と一致する場合
    if (selectedCurrency.id === localCurrencyId) {
      setDisplayCombinedChartDataModified(combinedChartDataModified);
      return;
    }

    // その他：ローカル通貨→選択通貨に変換
    const convertedChartData = convertChartDatasets(
      combinedChartDataModified,
      displayFromCurrency,
      selectedCurrency.name,
      currencyData
    );

    setDisplayCombinedChartDataModified(convertedChartData);

  }, [selectedCurrency, combinedChartDataModified, displayVersionCombinedChartDataModified, localCurrencyId, localCurrencyName, currencyData, displayFromCurrency]);

  /**
   * 販売単価・材料単価グラフデータの表示用設定（ダウンサイド）
   * - 選択通貨に応じて適切なデータを選択
   */
  useEffect(() => {
    if (!selectedCurrency?.id || !currencyData.length || !localCurrencyId) {
      return;
    }

    if (!mergedChartDataModified) {
      setDisplayMergedChartDataModified(null);
      return;
    }

    // 選択通貨がJPYの場合はJPY版データを使用（二重通貨変換回避）
    if (displayVersionMergedChartDataModified && selectedCurrency.name === CurrencyNameJPY) {
      setDisplayMergedChartDataModified(displayVersionMergedChartDataModified);
      return;
    }

    // 選択通貨がローカル通貨と一致する場合
    if (selectedCurrency.id === localCurrencyId) {
      setDisplayMergedChartDataModified(mergedChartDataModified);
      return;
    }

    // その他：ローカル通貨→選択通貨に変換（単価なので小数3桁）
    const convertedChartData = convertChartDatasets(
      mergedChartDataModified,
      localCurrencyName,
      selectedCurrency.name,
      currencyData,
      hasDecimal(selectedCurrency.name) ? 3 : 0
    );

    setDisplayMergedChartDataModified(convertedChartData);

  }, [selectedCurrency, mergedChartDataModified, displayVersionMergedChartDataModified, localCurrencyId, localCurrencyName, currencyData]);

  /**
   * 保存済み設定の売上グラフデータの通貨変換
   */
  useEffect(() => {
    if (!selectedCurrency?.id || !currencyData.length || !localCurrencyId) {
      return;
    }

    if (!salesChartDataForSavedConfig || salesChartDataForSavedConfig.length === 0) {
      setDisplaySalesChartDataForSavedConfig([]);
      return;
    }

    const localCurrency = currencyData.find(c => c.currencyId === localCurrencyId);
    if (!localCurrency) return;

    // 選択通貨がJPYの場合はJPY版データを使用（二重通貨変換回避・小数精度保持）
    // 振り返りモード時は JPY 版が月別レート未対応のため、通常パスに落として convertFn 適用版を使う。
    if (!reviewDate && displayVersionSalesChartDataForSavedConfig.length > 0 && selectedCurrency.name === CurrencyNameJPY) {
      setDisplaySalesChartDataForSavedConfig(displayVersionSalesChartDataForSavedConfig);
      return;
    }

    // 選択通貨がローカル通貨と一致する場合は変換不要（そのまま使用）
    if (selectedCurrency.id === localCurrencyId) {
      setDisplaySalesChartDataForSavedConfig(salesChartDataForSavedConfig);
      return;
    }

    // その他：ローカル通貨→選択通貨に変換（通常版と同じくconvertChartDatasetsを使用）
    const convertedDataArray = salesChartDataForSavedConfig.map(item => ({
      configId: item.configId,
      data: convertChartDatasets(
        item.data,
        displayFromCurrency,
        selectedCurrency.name,
        currencyData,
        undefined,  // decimalPlacesは自動判定
        ["profitRate"]  // 利益率は変換スキップ
      )
    }));

    setDisplaySalesChartDataForSavedConfig(convertedDataArray);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCurrency, salesChartDataForSavedConfig, displayVersionSalesChartDataForSavedConfig, currencyData, reviewDate]);

  /**
   * 保存済み設定の投資回収グラフデータの通貨変換
   */
  useEffect(() => {
    if (!selectedCurrency?.id || !currencyData.length || !localCurrencyId) {
      return;
    }

    if (!combinedChartDataForSavedConfig || combinedChartDataForSavedConfig.length === 0) {
      setDisplayCombinedChartDataForSavedConfig([]);
      return;
    }

    const localCurrency = currencyData.find(c => c.currencyId === localCurrencyId);
    if (!localCurrency) return;

    // 選択通貨がローカル通貨と一致する場合は変換不要（そのまま使用）
    if (selectedCurrency.id === localCurrencyId) {
      setDisplayCombinedChartDataForSavedConfig(combinedChartDataForSavedConfig);
      return;
    }

    // その他：ローカル通貨→選択通貨に変換（通常版と同じくconvertChartDatasetsを使用）
    const convertedDataArray = combinedChartDataForSavedConfig.map(item => ({
      configId: item.configId,
      data: convertChartDatasets(
        item.data,
        displayFromCurrency,
        selectedCurrency.name,
        currencyData
      )
    }));

    setDisplayCombinedChartDataForSavedConfig(convertedDataArray);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCurrency, combinedChartDataForSavedConfig, currencyData]);

  /**
   * 保存済み設定の価格・材料単価グラフデータの通貨変換
   */
  useEffect(() => {
    if (!selectedCurrency?.id || !currencyData.length || !localCurrencyId) {
      return;
    }

    if (!mergedChartDataForSavedConfig || mergedChartDataForSavedConfig.length === 0) {
      setDisplayMergedChartDataForSavedConfig([]);
      return;
    }

    const localCurrency = currencyData.find(c => c.currencyId === localCurrencyId);
    if (!localCurrency) return;

    // 選択通貨がJPYの場合はJPY版データを使用（二重通貨変換回避・小数精度保持）
    if (displayVersionMergedChartDataForSavedConfig.length > 0 && selectedCurrency.name === CurrencyNameJPY) {
      setDisplayMergedChartDataForSavedConfig(displayVersionMergedChartDataForSavedConfig);
      return;
    }

    // 選択通貨がローカル通貨と一致する場合は変換不要（そのまま使用）
    if (selectedCurrency.id === localCurrencyId) {
      setDisplayMergedChartDataForSavedConfig(mergedChartDataForSavedConfig);
      return;
    }

    // その他：ローカル通貨→選択通貨に変換（単価なので小数3桁、通常版と同じ設定）
    const convertedDataArray = mergedChartDataForSavedConfig.map(item => ({
      configId: item.configId,
      data: convertChartDatasets(
        item.data,
        localCurrency.currencyName!,
        selectedCurrency.name,
        currencyData,
        hasDecimal(selectedCurrency.name) ? 3 : 0
      )
    }));

    setDisplayMergedChartDataForSavedConfig(convertedDataArray);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCurrency, mergedChartDataForSavedConfig, displayVersionMergedChartDataForSavedConfig, currencyData]);

  /**
   * 改善後稼働日数更新
   */
  useEffect(() => {

    // 稼働日数入力チェック結果がTRUE(OK)の場合
    if (isValidWorkingDays) {

      // 改善後稼働日数の年度ごとに処理
      improvedWorkingDaysData.forEach((_, index) => {
        // 改善後月別稼働日数の更新
        updateStateIfNeeded(
          improvedWorkingDaysData,
          improvedWorkingDayByYear,
          index,
          (source, target) =>
            isSameFiscalYear(source.fiscalYear, target.fiscalYear) &&
            JSON.stringify(source.workingDaysData.workingDays) !== JSON.stringify(target.workingDay),
          setImprovedWorkingDayByYear,
          (source) => ({
            fiscalYear: source.fiscalYear,
            workingDay: source.workingDaysData.workingDays,
          })
        );
        // 改善後月別休日出勤日数の更新
        updateStateIfNeeded(
          improvedWorkingDaysData,
          improvedHolidayByYear,
          index,
          (source, target) =>
            isSameFiscalYear(source.fiscalYear, target.fiscalYear) &&
            JSON.stringify(source.workingDaysData.workOnWeekendAndHolidays) !== JSON.stringify(target.holiday),
          setImprovedHolidayByYear,
          (source) => ({
            fiscalYear: source.fiscalYear,
            holiday: source.workingDaysData.workOnWeekendAndHolidays,
          })
        );
        // 改善後月別ライン数の更新
        updateStateIfNeeded(
          improvedWorkingDaysData,
          improvedLineCountByYear,
          index,
          (source, target) =>
            isSameFiscalYear(source.fiscalYear, target.fiscalYear) &&
            JSON.stringify(source.workingDaysData.lineCount) !== JSON.stringify(target.lineCount),
          setImprovedLineCountByYear,
          (source) => ({
            fiscalYear: source.fiscalYear,
            lineCount: source.workingDaysData.lineCount || Array(12).fill(1),
          })
        );
      });

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isValidWorkingDays,
    improvedWorkingDaysData,
    // 以下は出力側の状態のため依存配列から除外（無限ループ防止）パフォーマンス改善
    // improvedWorkingDayByYear,
    // improvedHolidayByYear,
    // improvedLineCountByYear,
  ]);

  /**
   * 改善後非稼働時間更新時
   */
  useEffect(() => {

    // 算出した稼働率を参照（年度ごとの非稼働時間データ配列）
    const availabilityRates: {
      fiscalYear: string;
      availabilityRate: number[];
    }[] = [];

    // 各年度のデータを処理
    improvedWorkingDaysData.forEach(({ fiscalYear, workingDaysData }) => {
      // 各年度に対応する非稼働時間データを検索（会計年度文字列は表示言語で変わるため年数値で判定する）
      const matchingNonWorkingHoursData = improvedNonWorkingHoursData.find(
        (data) => isSameFiscalYear(data.fiscalYear, fiscalYear)
      );

      // 該当するデータがある場合のみ処理
      if (matchingNonWorkingHoursData) {
        const availabilityRateByMonth = workingDaysData.requiredOverTimes.map((_, index) => {
          // 該当月の availabilityRate を取得（存在しない場合は 0）
          return Number(
            matchingNonWorkingHoursData.nonWorkingHoursByMonth[index]?.availabilityRate ?? 0
          );
        });

        // 結果を配列に格納
        availabilityRates.push({
          fiscalYear,
          availabilityRate: availabilityRateByMonth,
        });
      } else {
        // 該当するデータがない場合は空の配列を追加 (もしくは別の処理)
        availabilityRates.push({
          fiscalYear,
          availabilityRate: Array(12).fill(0), // 仮に月ごとの稼働率が全て 0 の場合
        });
      }
    });

    // 差分確認および更新を行う
    availabilityRates.forEach((_, index) => {
      updateStateIfNeeded(
        availabilityRates,
        improvedAvailabilityRateByMonth,
        index,
        (sourceItem, targetItem) =>
          JSON.stringify(sourceItem) !== JSON.stringify(targetItem),
        setImprovedAvailabilityRateByMonth,
        (sourceItem) => sourceItem
      );
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    improvedNonWorkingHoursData,
    improvedWorkingDaysData,
    // 以下は出力側の状態のため依存配列から除外（無限ループ防止）
    // improvedAvailabilityRateByMonth,
  ]);

  /**
   * 権限情報
   */
  useEffect(() => {
    const pagePermissions = getPermissions(userPermissions, WorkflowId.SimulationNewProduct, projectData?.purpose, employeeId, divisionId, projectData?.registrantDivisionId);
    setPagePermissions(pagePermissions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userPermissions, employeeId, divisionId, projectData?.purpose, projectData?.registrantDivisionId]);

  /**
   * 別案件・別の振り返りを表示した際、過去Part No不整合の通知済みフラグをリセットする
   */
  useEffect(() => {
    pastPartNoToastShownRef.current = false;
    setMissingPastPartNoList([]);
  }, [projectId, reviewDate]);

  /**
   * 過去プロジェクトのPart No不整合をトーストで通知する（画面表示時に1回のみ）
   * pagePermissionsが未設定の間は承認完了かどうかを判定できないため待つ（権限判定の競合防止）
   */
  useEffect(() => {
    if (pastPartNoToastShownRef.current) return;
    if (missingPastPartNoList.length === 0) return;
    if ((userPermissions?.length || 0) <= 0) return;
    if (!pagePermissions) return;

    const partNos = missingPastPartNoList.join(", ");

    if (userPermissions[0].flowKb === FlowKb.Confirmation) {
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.pastPartNoMismatchForConfirmer', { partNos }),
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
    } else if (userPermissions[0].flowKb === FlowKb.Approval) {
      if (pagePermissions?.currentFlowId !== WorkflowId.ApproveComplete) {
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationNewProduct.message.pastPartNoMismatchForApprover', { partNos }),
          status: 'warning',
          duration: 5000,
          isClosable: true,
        });
      } else {
        console.warn(`For the approved request, the PartNo[${partNos}] of the Project linked to a past project does not match the PartNo of the current project.`);
      }
    }
    pastPartNoToastShownRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [missingPastPartNoList, userPermissions, pagePermissions]);

  /**
   * 初期表示時
   */
  useEffect(() => {
    if (projectId) {
      // ドラフトとテキストエリア（マウント中のみ）の両方を初期化し、表示とドラフトの不一致を防ぐ
      finalInvestmentReasonDraftRef.current = null;
      finalInvestmentReasonRef.current?.setValue(null);
      downsideRiskDraftRef.current = null;
      downsideRiskRef.current?.setValue(null);
      fetchData();
    }
  }, [projectId, toast, t]);

  /**
   * 初期表示時：シナリオデータを取得して保存済み設定一覧を更新
   */
  useEffect(() => {
    const loadScenarioConfigs = async () => {
      if (!projectId) return;

      // DB からシナリオデータを取得
      const scenarioData = await fetchScenarioData();

      // DB から取得したデータを SavedSimulationConfig 形式に変換
      const convertedConfigs = scenarioData.map(convertTScenarioToSavedConfig);

      // 保存済み設定一覧を更新
      setSavedConfigs(convertedConfigs);
    };

    loadScenarioConfigs();
  }, [projectId]);

  /**
   * 保存済み設定の選択状態を復元
   * savedConfigsとprojectDataが揃った後、一度だけ実行
   * 必要なグラフデータが生成されてから実行
   */
  useEffect(() => {
    // 既に復元済みの場合はスキップ
    if (hasRestoredSelection) return;

    // 必要なデータが揃っていない場合はスキップ
    if (!savedConfigs || savedConfigs.length === 0) return;
    if (!projectData || !projectData.selectedSimulationConfigIds) return;

    // 基本グラフデータが生成されるまで待機
    // （保存済み設定グラフ生成に必要なデータ）
    if (!quantitiesChartDataModified || !mergedChartDataModified) return;

    // DBから取得した選択状態を復元
    const savedSelectedIds = projectData.selectedSimulationConfigIds.split(",").filter(Boolean);

    // 存在する設定のみフィルタ
    const validSelectedIds = savedSelectedIds.filter(id =>
      savedConfigs.some(config => config.id === id)
    );

    // 有効な選択IDがある場合、選択状態を復元（グラフは自動的に生成される）
    if (validSelectedIds.length > 0) {
      setSelectedConfigIds(validSelectedIds);
    }

    // 復元完了フラグを立てる
    setHasRestoredSelection(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedConfigs, projectData?.selectedSimulationConfigIds, hasRestoredSelection, quantitiesChartDataModified, mergedChartDataModified]);

  /**
   * 必要情報をチェックし、ない場合は、トースト表示する。
   * @param projectData プロジェクト情報
   * @param capexPartNo パーツNo情報（数量・販売単価と材料費）
   * @param equipmentAmounts 設備情報
   * @param productionLine 製造ライン情報
   */
  const requiredDataNotice = (projectData: ProjectWithRdsData, capexPartNo: PartNo[], equipmentAmounts: EquipmentType[], productionLine: ProductionLineType) => {
    let displayName = null;

    if (!projectData.projectStartDate || !projectData.projectEndDate || !projectData.companyPlantId) {
      displayName = t('features.InvestmentScreening.SimulationNewProduct.validation.basicInfo');
    } else if (capexPartNo.some((p: PartNo) => !p.quantityAndPrice || !p.quantityAndPrice) || !projectData.currencyId) {
      displayName = labelQuantityAndPrice;
    } else if (!projectData.customerNationality || !projectData.pricingAgreement) {
      displayName = t('features.InvestmentScreening.SimulationNewProduct.validation.pricingAgreement');
    } else if (
      capexPartNo.some((p: PartNo) => !p.materialCost || !p.materialCostWithInhouseProfit) ||
      !projectData.productionLineId || !productionLine || !productionLine.workingDays || !productionLine.nonWorkingHours) {
      displayName = t('features.InvestmentScreening.SimulationNewProduct.validation.manufacturingProcess');
    } else if (!equipmentAmounts || equipmentAmounts.length === 0 || (!productionLine.cycleTime && productionLine.cycleTime !== 0) || (!productionLine.yieldRate && Number(productionLine.yieldRate) !== 0)) {
      displayName = t('features.InvestmentScreening.SimulationNewProduct.validation.equipment');
    } else if (!projectData.originalProfitAndLossByMonth) {
      displayName = t('features.InvestmentScreening.SimulationNewProduct.validation.profitAndLoss');
    }

    if (displayName) {
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.validation.registerFrom', { displayName }),
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
      return false;
    }

    return true;
  }

  /**
   * パーツNo情報の整合性をチェックする（保存時専用。不整合時はトースト表示の上、保存を中断させる）
   * @param capexPartNo パーツNo情報
   * @param pastCapexPartNo 過去プロジェクトのパーツNo情報
   */
  const validPartNo = (capexPartNo: PartNo[], pastCapexPartNo: PartNo[],) => {
    if ((userPermissions?.length || 0) <= 0) {
      return true;
    }

    // 過去プロジェクトのパーツNoが本プロジェクトのパーツNoにすべて含まれているかをチェック
    const missingPartNo = findMissingPastPartNos(capexPartNo, pastCapexPartNo);

    if (missingPartNo.length > 0) {
      const partNos = missingPartNo.join(", ");
      // 「確認」の場合
      if (userPermissions[0].flowKb === FlowKb.Confirmation) {
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationNewProduct.message.pastPartNoMismatchForConfirmer', { partNos }),
          status: 'warning',
          duration: 5000,
          isClosable: true,
        });
      }
      // 「承認」の場合
      if (userPermissions[0].flowKb === FlowKb.Approval) {
        // 「承認完了」以外の場合
        if (pagePermissions?.currentFlowId !== WorkflowId.ApproveComplete) {
          toast({
            title: TITLE,
            description: t('features.InvestmentScreening.SimulationNewProduct.message.pastPartNoMismatchForApprover', { partNos }),
            status: 'warning',
            duration: 5000,
            isClosable: true,
          });
        } else {
          console.warn(`For the approved request, the PartNo[${partNos}] of the Project linked to a past project does not match the PartNo of the current project.`);
        }
      }

      return false;
    }

    return true;
  }

  /**
  * エラー情報をユーザー通知する
  * @param dataName データ論理名
  * @param apiName API名称
  * @param responseErrors レスポンスエラー情報
  */
  const showApiError = (dataName: string, apiName: string, responseErrors: any) => {
    toast({
      title: t('features.InvestmentScreening.SimulationNewProduct.message.dataFetchError'),
      description: t('features.InvestmentScreening.SimulationNewProduct.message.dataFetchFailedFor', { dataName }),
      status: 'error',
      duration: 5000,
      isClosable: true,
    });

    console.error(`Failed to call API ${apiName}.errors = ${JSON.stringify(responseErrors)}`);
  }

  // 生産キャパグラフ（既存ライン含む）：要否・既存ライン生産数量・入力操作・保存・グラフデータ
  const elq = useExistingLineCapacity({
    projectId,
    reviewDate,
    labels: originalProfitAndLossByMonth?.labels ?? [],
    title: TITLE,
    googleAPI,
    source: existingLineCapacitySource,
    capexPartNo,
  });

  /**
   * 【数量 (当初計画 / ダウンサイド)】チャートデータ作成
   */
  useEffect(() => {
    if (
      originalProfitAndLossByMonth &&                         // オリジナル月別(当初損益月別)（「対象プロジェクトの利益試算」で登録）
      originalProfitAndLossByMonth.quantityByPartNo  // オリジナル月別(当初損益月別) パーツNo別の月別/数量
    ) {

      const quantitiesChartDataset = calcQuantitiesChartDataSet(originalProfitAndLossByMonth, downsideIndexGraph, capexPartNo);

      // Chart.js 用に 2種のデータを別々に作る
      // 数量（当初計画）[ラベル/データセット]設定
      setQuantitiesChartDataOriginal(quantitiesChartDataset.quantitiesChartDataOriginal);
      // 数量（ダウンサイド）[ラベル/データセット]設定
      setQuantitiesChartDataModified(quantitiesChartDataset.quantitiesChartDataModified);
    }
  }, [originalProfitAndLossByMonth, selectedCustomerProduct, downsideIndexGraph, originalImprovedWorkingDaysData, originalImprovedNonWorkingHoursData]);

  /**
   * 月別材料費単価を算出
   */
  useEffect(() => {
    if (!originalProfitAndLossByMonth?.labels || capexPartNo.length === 0) {
      return;
    }
    // ラベル（YYYY/MM形式）から年月リストを生成
    const yearMonthList = originalProfitAndLossByMonth.labels.map((label) => {
      const [year, month] = label.split("/").map(Number);
      return { year, month };
    });
    // 月別材料単価を取得（材料費は既に記帳通貨で保存されているため為替変換なし）
    const materialCostByPartNo = getMaterialCostByPartNoByMonth(
      capexPartNo,
      undefined,  // sourceCurrencyName (通貨変換なし)
      undefined,  // targetCurrencyName (通貨変換なし)
      undefined,  // currencyData (通貨変換なし)
      yearMonthList
    );
    // MapオブジェクトにconvertしてStateに設定
    const partNoToMonthlyMaterialCostMap = new Map<string, Record<string, Decimal>>();
    materialCostByPartNo.forEach((item) => {
      if (item.partNo) {
        partNoToMonthlyMaterialCostMap.set(item.partNo, item.materialCostByMonth);
      }
    });
    setPartNoToMonthlyMaterialCost(partNoToMonthlyMaterialCostMap);
  }, [originalProfitAndLossByMonth?.labels, capexPartNo]);

  /**
   * 【JPY版】月別材料費単価を算出
   * displayOriginalProfitAndLossByMonth（対象PJ画面で保存したJPY版）用
   * 選択通貨が保存時の表示通貨と一致する場合に使用（二重変換回避）
   */
  useEffect(() => {
    if (!displayOriginalProfitAndLossByMonth?.labels || !savedDisplayCurrencyName || !localCurrencyName || capexPartNo.length === 0 || !currencyData.length) {
      setDisplayVersionPartNoToMonthlyMaterialCost(null);
      return;
    }
    // ラベル（YYYY/MM形式）から年月リストを生成
    const yearMonthList = displayOriginalProfitAndLossByMonth.labels.map((label) => {
      const [year, month] = label.split("/").map(Number);
      return { year, month };
    });
    // 月別材料単価を取得（ローカル通貨→表示通貨に変換）
    // 材料費データは記帳通貨（ローカル通貨）で保存されているため、ローカル通貨から変換
    const materialCostByPartNo = getMaterialCostByPartNoByMonth(
      capexPartNo,
      localCurrencyName,  // sourceCurrencyName: ローカル通貨
      savedDisplayCurrencyName,  // targetCurrencyName: 表示通貨
      currencyData,
      yearMonthList
    );
    // MapオブジェクトにconvertしてStateに設定
    const displayVersionMaterialCostMap = new Map<string, Record<string, Decimal>>();
    materialCostByPartNo.forEach((item) => {
      if (item.partNo) {
        displayVersionMaterialCostMap.set(item.partNo, item.materialCostByMonth);
      }
    });
    setDisplayVersionPartNoToMonthlyMaterialCost(displayVersionMaterialCostMap);
  }, [displayOriginalProfitAndLossByMonth?.labels, savedDisplayCurrencyName, localCurrencyName, capexPartNo, currencyData]);

  /**
   * 【販売単価と材料単価 (当初計画 / ダウンサイド)】チャートデータ作成
   */
  useEffect(() => {
    if (
      originalProfitAndLossByMonth &&         // オリジナル月別(当初損益月別）（「対象プロジェクトの利益試算」で登録）
      originalProfitAndLossByMonth.labels &&  // オリジナル月別(当初損益月別）年月ラベル配列
      capexPartNo.length > 0 &&               // パーツNo情報（「数量・販売単価」と「材料費」）
      capexPartNo.every((p: PartNo) => p.quantityAndPrice) &&
      (partNoToMonthlyMaterialCost?.size || 0) > 0
    ) {
      // チャートデータ作成（ローカル通貨版を使用）
      // 振り返りモード: 対象PJの損益試算画面と同じく月別レートで販売単価をローカル通貨に変換
      const mergedChartDataSet = calcMergedChartDataSet(
        originalProfitAndLossByMonth, capexPartNo, partNoToMonthlyMaterialCost, downsideIndexGraph, localCurrencyName, currencyData,
        reviewDate ? convertWithRate : undefined,
      );

      // 販売単価と材料単価（当初計画）データ設定
      setMergedChartDataOriginal(mergedChartDataSet.mergedOriginal);

      // 販売単価と材料単価（ダウンサイド）データ設定
      setMergedChartDataModified(mergedChartDataSet.mergedModified);
    }
  }, [originalProfitAndLossByMonth, capexPartNo, selectedCustomerProduct, partNoToMonthlyMaterialCost, downsideIndexGraph, originalImprovedWorkingDaysData, originalImprovedNonWorkingHoursData, localCurrencyName, reviewDate, convertWithRate]);

  /**
   * 【JPY版】販売単価と材料単価チャートデータ作成
   * displayOriginalProfitAndLossByMonth（対象PJ画面で保存したJPY版）から直接計算
   * 選択通貨が保存時の表示通貨と一致する場合に使用（二重変換回避）
   */
  useEffect(() => {
    if (
      displayOriginalProfitAndLossByMonth &&
      displayOriginalProfitAndLossByMonth.labels &&
      savedDisplayCurrencyName &&
      capexPartNo.length > 0 &&
      capexPartNo.every((p: PartNo) => p.quantityAndPrice) &&
      (displayVersionPartNoToMonthlyMaterialCost?.size || 0) > 0  // JPY版の材料単価を使用
    ) {
      // チャートデータ作成（JPY版を使用）
      // 材料単価もJPY版（displayVersionPartNoToMonthlyMaterialCost）を使用
      const displayVersionMergedChartDataSet = calcMergedChartDataSet(
        displayOriginalProfitAndLossByMonth, capexPartNo, displayVersionPartNoToMonthlyMaterialCost, downsideIndexGraph, savedDisplayCurrencyName, currencyData
      );

      // 販売単価と材料単価（当初計画）JPY版データ設定
      setDisplayVersionMergedChartDataOriginal(displayVersionMergedChartDataSet.mergedOriginal);

      // 販売単価と材料単価（ダウンサイド）JPY版データ設定
      setDisplayVersionMergedChartDataModified(displayVersionMergedChartDataSet.mergedModified);
    }
  }, [displayOriginalProfitAndLossByMonth, savedDisplayCurrencyName, capexPartNo, selectedCustomerProduct, displayVersionPartNoToMonthlyMaterialCost, downsideIndexGraph]);

  /**
   * 【数量グラフ】保存済み設定用グラフ生成
   */
  useEffect(() => {
    if (quantitiesChartDataModified && selectedConfigIds.length > 0) {
      selectedConfigIds.forEach(configId => {
        const config = savedConfigs.find(c => c.id === configId);
        if (config) {
          const configApplyDownside = config.applyDownside !== false;
          const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;
          let chartData;

          if (!configApplyDownside) {
            // ストレスOFF: null で再計算し Modified パスのデータを使用（当初計画と同じ値になる）
            let sourceData: OriginalProfitAndLossByMonthTable;
            if (config.quantityAndPrice.length > 0) {
              // 変更PartNoのみ保存されるため、originalと結合して全PartNoを含める
              const converted = convertToOriginalProfitAndLossByMonthTable(config.quantityAndPrice);
              sourceData = {
                ...originalProfitAndLossByMonth!,
                quantityByPartNo: {
                  ...originalProfitAndLossByMonth!.quantityByPartNo,
                  ...converted.quantityByPartNo,
                },
              };
            } else {
              sourceData = originalProfitAndLossByMonth!;
            }
            const quantitiesChartDataset = calcQuantitiesChartDataSet(sourceData, null, capexPartNo);
            chartData = quantitiesChartDataset.quantitiesChartDataModified;
          } else if (config.quantityAndPrice.length > 0) {
            // ストレスON + カスタム設定あり: 再計算
            // 変更PartNoのみ保存されるため、originalと結合して全PartNoを含める
            const converted = convertToOriginalProfitAndLossByMonthTable(config.quantityAndPrice);
            const merged: OriginalProfitAndLossByMonthTable = {
              ...originalProfitAndLossByMonth!,
              quantityByPartNo: {
                ...originalProfitAndLossByMonth!.quantityByPartNo,
                ...converted.quantityByPartNo,
              },
            };
            const quantitiesChartDataset = calcQuantitiesChartDataSet(merged, configDownsideIndex, capexPartNo);
            chartData = quantitiesChartDataset.quantitiesChartDataModified;
          } else {
            // ストレスON + カスタム設定なし: プリ計算済みデータ使用
            chartData = quantitiesChartDataModified;
          }

          // 数量（保存済み設定）[ラベル/データセット]設定
          setQuantitiesChartDataForSavedConfig(prev => {
            const filtered = prev.filter(item => item.configId !== configId);
            return [...filtered, { configId, data: chartData }];
          });
        }
      });
    }
  }, [quantitiesChartDataModified, selectedConfigIds, neutralDownsideIndex, originalProfitAndLossByMonth, savedConfigs, downsideIndexGraph]);

  /**
   * 【販売単価・材料単価グラフ】保存済み設定用グラフ生成
   */
  useEffect(() => {
    if (mergedChartDataModified && selectedConfigIds.length > 0) {
      selectedConfigIds.forEach(configId => {
        const config = savedConfigs.find(c => c.id === configId);
        if (config) {
          const configApplyDownside = config.applyDownside !== false;
          const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;
          let chartData;

          if (!configApplyDownside) {
            // ストレスOFF: neutralDownsideIndex で再計算し Modified パスのデータを使用
            const partNo = config.quantityAndPrice.length !== 0
              ? capexPartNo.map(capexPartNo => {
                const matched = config.quantityAndPrice.find(q => q.partNo === capexPartNo.partNo);
                return matched
                  ? { ...capexPartNo, quantityAndPrice: JSON.stringify(matched) }
                  : capexPartNo;
              })
              : capexPartNo;
            const mergedChartDataSet = calcMergedChartDataSet(
              originalProfitAndLossByMonth!, partNo, partNoToMonthlyMaterialCost, neutralDownsideIndex, localCurrencyName, currencyData,
              reviewDate ? convertWithRate : undefined,
            );
            chartData = mergedChartDataSet.mergedModified;
          } else if (config.quantityAndPrice.length !== 0) {
            // ストレスON + カスタム設定あり: 再計算
            const partNo = capexPartNo.map(capexPartNo => {
              const matched = config.quantityAndPrice.find(q => q.partNo === capexPartNo.partNo);

              return matched
                ? { ...capexPartNo, quantityAndPrice: JSON.stringify(matched) }
                : capexPartNo;
            });

            const mergedChartDataSet = calcMergedChartDataSet(
              originalProfitAndLossByMonth!, partNo, partNoToMonthlyMaterialCost, configDownsideIndex, localCurrencyName, currencyData,
              reviewDate ? convertWithRate : undefined,
            );
            chartData = mergedChartDataSet.mergedModified;
          } else {
            // ストレスON + カスタム設定なし: プリ計算済みデータ使用
            chartData = mergedChartDataModified;
          }

          // 販売単価・材料単価（保存済み設定）[ラベル/データセット]設定
          setMergedChartDataForSavedConfig(prev => {
            const filtered = prev.filter(item => item.configId !== configId);
            return [...filtered, { configId, data: chartData }];
          });
        }
      });
    }
  }, [mergedChartDataModified, selectedConfigIds, neutralDownsideIndex, originalProfitAndLossByMonth, savedConfigs, downsideIndexGraph, capexPartNo, partNoToMonthlyMaterialCost, localCurrencyName, currencyData, reviewDate, convertWithRate]);

  /**
   * 【JPY版】販売単価・材料単価（保存済み設定用）チャートデータ作成
   * ダウンサイドと同じJPYネイティブのデータパスを使用し、営業利益合計の一致を保証
   */
  useEffect(() => {
    if (
      displayVersionMergedChartDataModified &&
      displayOriginalProfitAndLossByMonth &&
      displayVersionPartNoToMonthlyMaterialCost &&
      savedDisplayCurrencyName &&
      selectedConfigIds.length > 0
    ) {
      selectedConfigIds.forEach(configId => {
        const config = savedConfigs.find(c => c.id === configId);
        if (config) {
          const configApplyDownside = config.applyDownside !== false;
          const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;
          let chartData;

          if (!configApplyDownside) {
            // ストレスOFF: neutralDownsideIndex で再計算し Modified パスのデータを使用
            const configPartNo = config.quantityAndPrice.length !== 0
              ? capexPartNo.map(partNo => {
                const matched = config.quantityAndPrice.find(q => q.partNo === partNo.partNo);
                return matched
                  ? { ...partNo, quantityAndPrice: JSON.stringify(matched) }
                  : partNo;
              })
              : capexPartNo;
            const mergedResult = calcMergedChartDataSet(
              displayOriginalProfitAndLossByMonth, configPartNo, displayVersionPartNoToMonthlyMaterialCost,
              neutralDownsideIndex, savedDisplayCurrencyName, currencyData
            );
            chartData = mergedResult.mergedModified;
          } else if (config.quantityAndPrice.length !== 0) {
            // ストレスON + カスタム設定あり: 再計算
            const configPartNo = capexPartNo.map(partNo => {
              const matched = config.quantityAndPrice.find(q => q.partNo === partNo.partNo);
              return matched
                ? { ...partNo, quantityAndPrice: JSON.stringify(matched) }
                : partNo;
            });
            const mergedResult = calcMergedChartDataSet(
              displayOriginalProfitAndLossByMonth, configPartNo, displayVersionPartNoToMonthlyMaterialCost,
              configDownsideIndex, savedDisplayCurrencyName, currencyData
            );
            chartData = mergedResult.mergedModified;
          } else {
            // ストレスON + カスタム設定なし: プリ計算済みデータ使用
            chartData = displayVersionMergedChartDataModified;
          }

          setDisplayVersionMergedChartDataForSavedConfig(prev => {
            const filtered = prev.filter(item => item.configId !== configId);
            return [...filtered, { configId, data: chartData }];
          });
        }
      });
    }
  }, [displayVersionMergedChartDataModified, displayOriginalProfitAndLossByMonth, displayVersionPartNoToMonthlyMaterialCost, savedDisplayCurrencyName, selectedConfigIds, savedConfigs, capexPartNo, downsideIndexGraph, neutralDownsideIndex, currencyData]);

  /**
   * 【売上（当初計画）】チャートデータ作成 & 【投資回収（当初計画）】チャートデータ作成
   */
  useEffect(() => {
    if (!originalImprovedWorkingDaysData || !originalImprovedNonWorkingHoursData) {
      return;
    }

    // originalImprovedWorkingDaysDataとoriginalImprovedNonWorkingHoursDataが空でないことを確認
    if (originalImprovedWorkingDaysData.length === 0 || originalImprovedNonWorkingHoursData.length === 0) {
      return;
    }

    // 各要素にnonWorkingHoursByMonthが存在することを確認
    const hasValidNonWorkingHoursData = originalImprovedNonWorkingHoursData.every(
      item => item.nonWorkingHoursByMonth && item.nonWorkingHoursByMonth.length > 0
    );

    if (!hasValidNonWorkingHoursData) {
      console.warn('originalImprovedNonWorkingHoursData has invalid structure');
      return;
    }

    if (originalProfitAndLossByMonth && originalEquipmentAmounts.length > 0) {

      if (!mergedChartDataOriginal || !quantitiesChartDataOriginal) {
        console.log(`mergedChartDataOriginal or quantitiesChartDataOriginal not ready`);
        return;
      }

      // 【売上（当初計画）】チャートデータ作成
      // 振り返りモード: selectedCurrency.name を targetCurrencyName に渡し月別レートで変換
      // 通常モード: localCurrencyName を渡し従来パスを通す
      const originalSalesChartDataSet = calcOriginalSalesChartDataSet(
        originalProfitAndLossByMonth,
        quantitiesChartDataOriginal,
        mergedChartDataOriginal,
        capexPartNo,
        projectData,
        originalEquipmentAmounts,
        originalImprovedWorkingDaysData,
        originalImprovedNonWorkingHoursData,
        downsideIndexGraph,
        reviewDate ? selectedCurrency.name : localCurrencyName,
        currencyData,
        decimalCurrency,
        uniqueProcessData,
        bomData,
        undefined,
        reviewDate ? convertWithRate : undefined,
        reviewDate ? localCurrencyName : undefined,
      );

      // 売上（当初計画）データ設定
      setSalesChartData(originalSalesChartDataSet.charData);

      // 【投資回収（当初計画）】チャートデータ作成
      const originalCombinedChartDataSet = calcOriginalCombinedChartDataSet(
        originalSalesChartDataSet.profitByMonth,
        capexPartNo,
        projectData,
        originalEquipmentAmounts,
        originalProfitAndLossByMonth.labels,
        decimalCurrency,
        reviewDate ? selectedCurrency.name : localCurrencyName,
        currencyData,
        reviewDate ? convertWithRate : undefined,
      );

      // 回収額設定
      setMonthOfRecoveryOriginal(originalCombinedChartDataSet.monthOfRecoveryOriginal);

      // 投資回収（当初計画）データ設定
      setCombinedChartData(originalCombinedChartDataSet.chartData);

      // 増分キャッシュフロー Excel出力用データ保持
      setIncrementalCashFlowOriginal({
        labels: originalCombinedChartDataSet.chartData.labels,
        ...originalCombinedChartDataSet.incrementalCashFlowData,
        recoveryMonths: originalCombinedChartDataSet.monthOfRecoveryOriginal,
        costBreakdown: originalSalesChartDataSet.charData?.costBreakdown,
        equipmentDepreciationInputs: originalSalesChartDataSet.charData?.equipmentDepreciationInputs,
        scrapCostInputs: originalSalesChartDataSet.charData?.scrapCostInputs,
      });
    }
  }, [
    originalProfitAndLossByMonth,
    quantitiesChartDataOriginal,
    mergedChartDataOriginal,
    capexPartNo,
    originalEquipmentAmounts,
    productionLine,
    originalImprovedWorkingDaysData,
    originalImprovedNonWorkingHoursData,
    reviewDate,
    selectedCurrency.name,
    convertWithRate,
  ]);

  /**
   * 金型費/開発費の実績差し替え
   * 増産開始年月より前の期間は実績（現在PJ）で上書きする
   * @param periodYears 増産開始年
   * @param periodMonths 増産開始月
   * @param increasedProductionStartMonth 増産開始月
   * @param moldOrOrDevelopmentSalesJson 金型費または開発費JSON
   * @param pastMoldOrOrDevelopmentSalesJson 金型費または開発費JSON（過去）
   * @returns
   */
  const replaceMoldOrDevelopmentSales = (periodYears: number, periodMonths: number, increasedProductionStartMonth: number, moldOrOrDevelopmentSalesJson: string | null | undefined, pastMoldOrOrDevelopmentSalesJson: string | null | undefined) => {
    const moldOrDevelopmentSalesByProjectList: any[] = moldOrOrDevelopmentSalesJson ? JSON.parse(moldOrOrDevelopmentSalesJson) : undefined;
    const pastMoldOrDevelopmentSalesByProjectList: any[] = pastMoldOrOrDevelopmentSalesJson ? JSON.parse(pastMoldOrOrDevelopmentSalesJson) : undefined;

    if (pastMoldOrDevelopmentSalesByProjectList) {
      for (let i = 0; i < pastMoldOrDevelopmentSalesByProjectList.length; i++) {
        const moldOrDevelopmentSalesByPartNo = moldOrDevelopmentSalesByProjectList ? moldOrDevelopmentSalesByProjectList[i] : undefined;
        const pastMoldOrDevelopmentSalesByPartNo = pastMoldOrDevelopmentSalesByProjectList[i];

        if (!moldOrDevelopmentSalesByPartNo) {
          // 実績なし
          continue;
        }

        for (let years of pastMoldOrDevelopmentSalesByPartNo.years) {
          if (years < periodYears) {
            // 実績コピー(年単位)
            pastMoldOrDevelopmentSalesByPartNo.data[years] = moldOrDevelopmentSalesByPartNo.data[years];
          } else if (years === periodYears && increasedProductionStartMonth !== 4) {
            for (const [months, data] of Object.entries(pastMoldOrDevelopmentSalesByPartNo.data[years].months)) {
              if (Object(data).month > periodMonths) {
                break;
              }
              // 実績コピー(月単位)
              pastMoldOrDevelopmentSalesByPartNo.data[years].months[Number(months)] =
                moldOrDevelopmentSalesByPartNo.data[years].months[Number(months)];
            }
          }
        }
      }

      return JSON.stringify(pastMoldOrDevelopmentSalesByProjectList);
    }

    return null;
  }

  /**
   * 【投資回収（プロジェクト全体投資回収）】チャートデータ作成
   *
   * ■ 概要
   *   過去PJ（当初の試作投資）と現在PJ（追加投資）を統合した、プロジェクト全体の投資回収シミュレーション。
   *   「当初投資 + 追加投資の合算」でプロジェクト全体としての投資回収を評価する。
   *
   * ■ 対象データ
   *   - 数量・単価: 現在PJのデータを使用
   *   - 設備投資（CAPEXバー）: 過去PJ設備 + 現在PJ設備を統合（mergeEquipmentAmounts）
   *   - 減価償却費: 費用画面の値（monthlyExpenseData.pastEquipmentCost）を使用
   *
   * ■ 前提条件
   *   pastProjectIdがある場合のみ計算。
   */
  useEffect(() => {
    if (
      !originalProfitAndLossByMonth ||
      !mergedChartDataOriginal ||
      !quantitiesChartDataOriginal ||
      !capexPartNo || capexPartNo.length === 0 ||
      !projectData ||
      !pastEquipmentAmounts || pastEquipmentAmounts.length === 0 ||
      !originalEquipmentAmounts || originalEquipmentAmounts.length === 0 ||
      !originalImprovedWorkingDaysData || originalImprovedWorkingDaysData.length === 0 ||
      !originalImprovedNonWorkingHoursData || originalImprovedNonWorkingHoursData.length === 0
    ) {
      return;
    }

    // 過去PJ設備 + 現在PJ設備を統合（CAPEXバー表示用）
    const mergeEquipmentAmounts = [...pastEquipmentAmounts, ...originalEquipmentAmounts];

    // 【売上（プロジェクト全体投資回収）】チャートデータ作成
    // ※過去PJ設備の減価償却費は費用画面の値（monthlyExpenseData.pastEquipmentCost）を使用するため、
    //   設備データは当初設備のみ渡し、現在PJのmonthlyExpenseDataを渡して費用画面の値を合算
    const currentMonthlyExpenseData: MonthlyExpenseData[] = projectData.monthlyExpenseData
      ? JSON.parse(projectData.monthlyExpenseData) : [];
    const pastEquipmentCostCurrencyName = currencyData?.find(
      c => c.currencyId === projectData?.pastEquipmentCostCurrencyId
    )?.currencyName;
    const salesChartDataSet = calcOriginalSalesChartDataSet(
      originalProfitAndLossByMonth,
      quantitiesChartDataOriginal,
      mergedChartDataOriginal,
      capexPartNo,
      projectData,
      originalEquipmentAmounts,
      originalImprovedWorkingDaysData,
      originalImprovedNonWorkingHoursData,
      downsideIndexGraph,
      reviewDate ? selectedCurrency.name : localCurrencyName,
      currencyData,
      decimalCurrency,
      uniqueProcessData,
      bomData,
      { expenseData: currentMonthlyExpenseData, currencyName: pastEquipmentCostCurrencyName },
      reviewDate ? convertWithRate : undefined,
      reviewDate ? localCurrencyName : undefined,
    );

    setSalesChartDataAll(salesChartDataSet.charData);

    // 【投資回収（プロジェクト全体投資回収）】チャートデータ作成
    const combinedAllChartDataSet = calcOriginalCombinedChartDataSet(
      salesChartDataSet.profitByMonth,
      capexPartNo,
      projectData,
      mergeEquipmentAmounts,
      originalProfitAndLossByMonth.labels,
      decimalCurrency,
      reviewDate ? selectedCurrency.name : localCurrencyName,
      currencyData,
      reviewDate ? convertWithRate : undefined,
    );

    // 回収額設定（プロジェクト全体投資回収）
    setMonthOfRecoveryAll(combinedAllChartDataSet.monthOfRecoveryOriginal);

    // 投資回収（プロジェクト全体投資回収）データ設定
    setCombinedChartDataAll(combinedAllChartDataSet.chartData);

    // 増分キャッシュフロー Excel出力用データ保持
    const salesCostBreakdown = salesChartDataSet?.charData?.costBreakdown;
    const salesEquipDepInputs = salesChartDataSet?.charData?.equipmentDepreciationInputs;
    setIncrementalCashFlowAll({
      labels: combinedAllChartDataSet?.chartData?.labels,
      ...combinedAllChartDataSet?.incrementalCashFlowData,
      recoveryMonths: combinedAllChartDataSet?.monthOfRecoveryOriginal,
      costBreakdown: salesCostBreakdown ? {
        ...salesCostBreakdown,
        pastEquipmentCostSeparate: !!reviewDate,
      } : salesCostBreakdown,
      equipmentDepreciationInputs: salesEquipDepInputs ? {
        ...salesEquipDepInputs,
        equipments: [...pastEquipmentAmounts, ...(salesEquipDepInputs.equipments || [])],
        originalEquipments: salesEquipDepInputs.originalEquipments
          ? [...pastEquipmentAmounts, ...salesEquipDepInputs.originalEquipments]
          : undefined,
      } : salesEquipDepInputs,
      scrapCostInputs: salesChartDataSet?.charData?.scrapCostInputs,
    });

  }, [
    originalProfitAndLossByMonth,
    quantitiesChartDataOriginal,
    mergedChartDataOriginal,
    capexPartNo,
    projectData,
    pastEquipmentAmounts,
    originalEquipmentAmounts,
    originalImprovedWorkingDaysData,
    originalImprovedNonWorkingHoursData,
    downsideIndexGraph,
    localCurrencyName,
    currencyData,
    decimalCurrency,
    uniqueProcessData,
    bomData,
    reviewDate,
    selectedCurrency.name,
    convertWithRate,
  ]);

  /**
   * 【投資回収（当初投資・回収）】チャートデータ作成
   *
   * ■ 概要
   *   過去PJ（当初の試作投資）単体での投資回収シミュレーション。
   *   当初の投資申請時の計画が、実績を踏まえてどのように回収されるかを評価する。
   *   「プロジェクト全体投資回収」と対比して、当初投資分だけの回収状況を確認できる。
   *
   * ■ 対象データ
   *   - 数量・単価: 過去PJのデータを使用（量産開始年月より前は現在PJの実績で上書き）
   *   - 設備投資（CAPEXバー）: 過去PJ設備のみ（pastEquipmentAmounts）
   *   - 減価償却費: 費用画面の値（monthlyExpenseData.pastEquipmentCost）を使用
   *   - 金型費・開発費: 過去PJのデータ（量産開始年月より前は現在PJの実績で上書き）
   *
   * ■ 前提条件
   *   pastProjectIdがある場合のみ計算。
   */
  useEffect(() => {
    // 必要なデータの有無チェック
    if (
      !originalProfitAndLossByMonth ||
      !projectData ||
      !pastProjectData ||
      !pastCapexPartNo || pastCapexPartNo.length === 0 ||
      !capexPartNo || capexPartNo.length === 0 ||
      !pastCurrencyData || !Array.isArray(pastCurrencyData) || pastCurrencyData.length === 0 ||
      !pastEquipmentAmounts || pastEquipmentAmounts.length === 0 ||
      !currencyData || currencyData.length === 0 ||
      !originalImprovedWorkingDaysData || originalImprovedWorkingDaysData.length === 0 ||
      !originalImprovedNonWorkingHoursData || originalImprovedNonWorkingHoursData.length === 0
    ) {
      return;
    }

    // 新製品投資量産開始年月のインデックスを見つける
    const productionStartIndex = originalProfitAndLossByMonth.labels.indexOf(newProductStartYearMonth);

    // 過去プロジェクトのオリジナル(当初損益)
    if (!pastProjectData?.originalProfitAndLossByMonth || pastProjectData.originalProfitAndLossByMonth.trim() === '') {
      return;
    }
    const pastOriginalProfitAndLossByMonth: OriginalProfitAndLossByMonthTable = JSON.parse(pastProjectData.originalProfitAndLossByMonth);

    // EOL予定日までの月数でフィルタリング（現在プロジェクトと同様の処理）
    const pastVisibleMonths = calcMonthsBetweenDates(
      pastProjectData.projectStartDate,
      pastProjectData.projectEndDate
    );

    if (pastVisibleMonths > 0 && pastOriginalProfitAndLossByMonth.labels &&
      pastVisibleMonths < pastOriginalProfitAndLossByMonth.labels.length) {
      // labels をフィルタリング
      pastOriginalProfitAndLossByMonth.labels = pastOriginalProfitAndLossByMonth.labels.slice(0, pastVisibleMonths);
      // totalSales をフィルタリング
      if (pastOriginalProfitAndLossByMonth.totalSales) {
        pastOriginalProfitAndLossByMonth.totalSales = pastOriginalProfitAndLossByMonth.totalSales.slice(0, pastVisibleMonths);
      }
      // profit をフィルタリング
      if (pastOriginalProfitAndLossByMonth.profit) {
        pastOriginalProfitAndLossByMonth.profit = pastOriginalProfitAndLossByMonth.profit.slice(0, pastVisibleMonths);
      }
      // quantityByPartNo を各PartNo毎にフィルタリング
      if (pastOriginalProfitAndLossByMonth.quantityByPartNo) {
        Object.keys(pastOriginalProfitAndLossByMonth.quantityByPartNo).forEach(partNo => {
          pastOriginalProfitAndLossByMonth.quantityByPartNo[partNo] =
            pastOriginalProfitAndLossByMonth.quantityByPartNo[partNo].slice(0, pastVisibleMonths);
        });
      }
    }

    // 過去プロジェクトの終了インデックス
    const pastEndIndex = pastOriginalProfitAndLossByMonth.labels.length - 1;

    const localQuantityByPartNo: Record<string, string[]> = {};
    for (let [partNo, pastQuantities] of Object.entries(pastOriginalProfitAndLossByMonth.quantityByPartNo)) {
      let quantities = originalProfitAndLossByMonth.quantityByPartNo[partNo];

      if (!quantities) {
        // PartNo数の不整合の場合は例外発生しないようにする
        continue;
      }

      if (pastEndIndex < productionStartIndex) {
        // 過去プロジェクトの期間の方が、量産開始年月より短い場合、過去プロジェクトの期間で切り出し
        localQuantityByPartNo[partNo] = quantities.slice(0, pastEndIndex);
      } else {
        // 実績：先頭から量産開始年月より前まで切り出し
        quantities = quantities.slice(0, productionStartIndex);

        // 過去プロジェクトの数量：量産開始年月以降を切り出し
        pastQuantities = pastQuantities.slice(productionStartIndex);

        // 実績＋過去プロジェクトの数量
        localQuantityByPartNo[partNo] = [...quantities, ...pastQuantities];
      }
    }

    // 差し替え：実績＋過去プロジェクトの数量
    pastOriginalProfitAndLossByMonth.quantityByPartNo = localQuantityByPartNo;

    // 実績＋過去プロジェクト(数量)
    let [startYear, startMonth] = (pastProjectData.projectStartDate || "/").split(/-|\//).map(v => Number(v));
    if (startMonth < 4) {
      // 年度変換
      startYear = startYear - 1;
    }

    let [newProductStartYear, newProductStartMonth] = newProductStartYearMonth.split(/-|\//).map(v => Number(v));
    if (newProductStartMonth < 4) {
      // 年度変換
      newProductStartYear = newProductStartYear - 1;
    }

    // 量産開始年
    const periodYears = newProductStartYear - startYear + 1;
    // 量産開始月
    const periodMonths = newProductStartMonth;

    // プロジェクト単位（金型費、開発費、設備費）
    if (pastProjectData.moldSalesByProject) {
      pastProjectData.moldSalesByProject = replaceMoldOrDevelopmentSales(periodYears, periodMonths, newProductStartMonth, projectData.moldSalesByProject, pastProjectData.moldSalesByProject);
    }

    if (pastProjectData.developmentSalesByProject) {
      pastProjectData.developmentSalesByProject = replaceMoldOrDevelopmentSales(periodYears, periodMonths, newProductStartMonth, projectData.developmentSalesByProject, pastProjectData.developmentSalesByProject);
    }

    if (pastProjectData.equipmentSalesByProject) {
      pastProjectData.equipmentSalesByProject = replaceMoldOrDevelopmentSales(periodYears, periodMonths, newProductStartMonth, projectData.equipmentSalesByProject, pastProjectData.equipmentSalesByProject);
    }

    // パーツNoループ
    for (let partNoItem of pastCapexPartNo) {
      const capexPartNoItem = capexPartNo.find(p => p.partNo === partNoItem.partNo);

      if (!capexPartNoItem) {
        continue;
      }

      // 数量パース
      const quantityAndPrice: QuantityAndPriceMonthTable = JSON.parse(capexPartNoItem.quantityAndPrice!);
      const pastQuantityAndPrice: QuantityAndPriceMonthTable = JSON.parse(partNoItem.quantityAndPrice!);

      for (let years of pastQuantityAndPrice.years) {
        // 数量・単価
        if (years < periodYears) {
          // 実績コピー(年単位)
          pastQuantityAndPrice.data[years] = quantityAndPrice?.data[years] || 0;
        } else if (years === periodYears && newProductStartMonth !== 4) {
          for (const [months, data] of Object.entries(pastQuantityAndPrice.data[years].months)) {
            if (data.month >= periodMonths) {
              break;
            }
            // 実績コピー(月単位)
            pastQuantityAndPrice.data[years].months[Number(months)] =
              quantityAndPrice.data[years].months[Number(months)];
          }
        }
      }

      // 金型費の置き換え
      if (partNoItem.moldSalesByPartNo) {
        partNoItem.moldSalesByPartNo = replaceMoldOrDevelopmentSales(periodYears, periodMonths, newProductStartMonth, capexPartNoItem.moldSalesByPartNo, partNoItem.moldSalesByPartNo);
      }

      // 開発費の置き換え
      if (partNoItem.developmentSalesByPartNo) {
        partNoItem.developmentSalesByPartNo = replaceMoldOrDevelopmentSales(periodYears, periodMonths, newProductStartMonth, capexPartNoItem.developmentSalesByPartNo, partNoItem.developmentSalesByPartNo);
      }

      // 数量：実績コピーしたものを戻す
      partNoItem.quantityAndPrice = JSON.stringify(pastQuantityAndPrice);
    }

    // 数量チャートデータ生成
    const pastQuantitiesChartDataSets = calcQuantitiesChartDataSet(
      pastOriginalProfitAndLossByMonth,
      null,
      pastCapexPartNo
    );

    // 販売通貨（過去プロジェクト）
    const pastSalesCurrencyName = pastCurrencyData.find(c => c.currencyId === pastProjectData?.currencyId)?.currencyName;

    if (!(pastProjectData?.mergedChartDataOriginal || null)) {
      return;
    }

    // 価格と材料単価チャートデータ（過去プロジェクト）
    // ※DB保存済みJSONのlabelには実キーが焼き込まれている可能性があるため、displayPartNoに補正する
    const pastMergedChartDataOriginal = resolveChartDatasetLabels(
      JSON.parse(pastProjectData?.mergedChartDataOriginal!) as { labels?: string[]; datasets: any[] },
      pastCapexPartNo
    );

    // 過去PJのローカル通貨名を取得
    const pastLocalCurrencyName = pastCurrencyData.find(
      c => c.currencyId === getLocalCurrencyId(pastProjectData?.companyPlantSnapshot)
    )?.currencyName || "";

    // 過去PJのローカル通貨 → 現在PJのローカル通貨に変換（通貨が異なる場合のみ）
    const convertedPastMergedData = (pastLocalCurrencyName && pastLocalCurrencyName !== localCurrencyName)
      ? convertChartDatasets(pastMergedChartDataOriginal, pastLocalCurrencyName, localCurrencyName, currencyData)
      : pastMergedChartDataOriginal;

    // 【売上（当初投資・回収）】チャートデータ作成
    // ※過去PJ設備の減価償却費は費用画面の値（現在PJのmonthlyExpenseData.pastEquipmentCost）を使用するため、
    //   設備データは空配列を渡し、現在PJのmonthlyExpenseDataを渡して費用画面の値を合算
    const currentMonthlyExpenseDataForPast: MonthlyExpenseData[] = projectData?.monthlyExpenseData
      ? JSON.parse(projectData.monthlyExpenseData) : [];
    const pastEquipmentCostOverrideForPast = {
      expenseData: currentMonthlyExpenseDataForPast,
      currencyName: currencyData?.find(c => c.currencyId === projectData?.pastEquipmentCostCurrencyId)?.currencyName,
    };
    const salesChartDataSetPast = calcDownsideSalesChartDataSet(
      pastQuantitiesChartDataSets.quantitiesChartDataOriginal,
      convertedPastMergedData,
      pastCapexPartNo,
      pastProjectData,
      [],
      originalImprovedWorkingDaysData,
      originalImprovedNonWorkingHoursData,
      null,
      null,
      null,
      pastSalesCurrencyName || "",
      localCurrencyName,
      pastCurrencyData,
      pastOriginalProfitAndLossByMonth.labels,
      decimalCurrency,
      uniqueProcessData,
      bomData,
      undefined,
      true,
      pastEquipmentCostOverrideForPast,
    );

    // 売上
    setSalesChartDataPast(salesChartDataSetPast.chartData);

    // 【投資回収（当初投資・回収）】チャートデータ作成
    // ※pastEquipmentAmountsはCAPEXバー表示用に引き続き渡すが、
    //   減価償却費計算は費用画面の値を使用
    const combinedPastChartDataSet = calcDownsideCombinedChartDataSet(
      pastQuantitiesChartDataSets.quantitiesChartDataOriginal,
      convertedPastMergedData,
      pastCapexPartNo,
      pastProjectData,
      pastEquipmentAmounts,
      originalImprovedWorkingDaysData,
      originalImprovedNonWorkingHoursData,
      null,
      null,
      [],
      salesChartDataSetPast.chartData,
      salesChartDataSetPast.monthlySalesByPartNo,
      null,
      reviewDate ? selectedCurrency.name : localCurrencyName,
      pastCurrencyData,
      decimalCurrency,
      uniqueProcessData,
      bomData,
      undefined,
      true,
      pastEquipmentCostOverrideForPast,
      reviewDate ? convertWithRate : undefined,
      reviewDate ? localCurrencyName : undefined,
    );

    if (!combinedPastChartDataSet) {
      return;
    }

    combinedPastChartDataSet.recoveryDataset.label = combinedPastChartDataSet.recoveryDataset.label.replace("(Modified)", "");

    // 回収額設定（当初投資・回収）
    setMonthOfRecoveryPast(combinedPastChartDataSet?.recoveryMonths!);

    // 投資回収（当初投資・回収）データ設定
    setCombinedChartDataPast({
      labels: combinedPastChartDataSet.labels,
      datasets: [combinedPastChartDataSet.recoveryDataset, ...combinedPastChartDataSet.capexDatasets],
    });

    // 増分キャッシュフロー Excel出力用データ保持
    setIncrementalCashFlowPast({
      labels: combinedPastChartDataSet?.labels,
      ...combinedPastChartDataSet?.incrementalCashFlowData,
      recoveryMonths: combinedPastChartDataSet?.recoveryMonths,
    });

  }, [
    originalProfitAndLossByMonth,
    pastProjectData,
    pastCapexPartNo,
    capexPartNo,
    quantitiesChartDataOriginal,
    pastEquipmentAmounts,
    originalImprovedWorkingDaysData,
    originalImprovedNonWorkingHoursData,
    pastCurrencyData,
    decimalCurrency,
    uniqueProcessData,
    bomData,
  ]);

  /**
   * 【JPY版】売上・投資回収チャートデータ作成（当初計画）
   * displayOriginalProfitAndLossByMonth（対象PJ画面で保存したJPY版）から直接計算
   * 選択通貨が保存時の表示通貨と一致する場合に使用（二重変換回避）
   */
  useEffect(() => {
    if (!displayOriginalProfitAndLossByMonth ||
      !displayOriginalProfitAndLossByMonth.labels ||
      !savedDisplayCurrencyName ||
      !quantitiesChartDataOriginal ||
      !displayVersionMergedChartDataOriginal ||
      !originalEquipmentAmounts?.length) {
      setDisplayVersionSalesChartData(null);
      setDisplayVersionCombinedChartData(null);
      return;
    }

    // 表示通貨の小数点有無
    const displayCurrencyDecimal = hasDecimal(savedDisplayCurrencyName);

    // 【売上（当初計画）】チャートデータ作成（JPY版）
    const displayVersionSalesChartDataSet = calcOriginalSalesChartDataSet(
      displayOriginalProfitAndLossByMonth,
      quantitiesChartDataOriginal,
      displayVersionMergedChartDataOriginal,
      capexPartNo,
      projectData,
      originalEquipmentAmounts,
      originalImprovedWorkingDaysData,
      originalImprovedNonWorkingHoursData,
      downsideIndexGraph,
      savedDisplayCurrencyName,
      currencyData,
      displayCurrencyDecimal,
      uniqueProcessData,
      bomData,
    );

    // 売上（当初計画）JPY版データ設定
    setDisplayVersionSalesChartData(displayVersionSalesChartDataSet.charData);

    // 【投資回収（当初計画）】チャートデータ作成（JPY版）
    const displayVersionCombinedChartDataSet = calcOriginalCombinedChartDataSet(
      displayVersionSalesChartDataSet.profitByMonth,
      capexPartNo,
      projectData,
      originalEquipmentAmounts,
      displayOriginalProfitAndLossByMonth.labels,
      displayCurrencyDecimal,
      savedDisplayCurrencyName,
      currencyData,
    );

    // 投資回収（当初計画）JPY版データ設定
    setDisplayVersionCombinedChartData(displayVersionCombinedChartDataSet.chartData);

  }, [
    displayOriginalProfitAndLossByMonth,
    savedDisplayCurrencyName,
    quantitiesChartDataOriginal,
    displayVersionMergedChartDataOriginal,
    capexPartNo,
    originalEquipmentAmounts,
    originalImprovedWorkingDaysData,
    originalImprovedNonWorkingHoursData
  ]);

  // #region 「売上(ダウンサイド)」チャートデータ作成

  /**
   * 「売上(ダウンサイド)」チャートデータ作成
   */
  useEffect(() => {

    if (quantitiesChartDataModified && mergedChartDataModified && capexPartNo && originalProfitAndLossByMonth) {
      const downsideSalesChartDataSet = calcDownsideSalesChartDataSet(quantitiesChartDataModified, mergedChartDataModified, capexPartNo, projectData, originalEquipmentAmounts,
        originalImprovedWorkingDaysData, originalImprovedNonWorkingHoursData, null, null, downsideIndexGraph,
        salesCurrencyName, reviewDate ? selectedCurrency.name : localCurrencyName, currencyData, originalProfitAndLossByMonth.labels, decimalCurrency,
        uniqueProcessData,
        bomData,
        undefined, true, undefined,
        reviewDate ? convertWithRate : undefined,
        reviewDate ? localCurrencyName : undefined,
      );

      // パーツNo毎の月次売上（ダウンサイド）を保持
      setMonthlySalesModifiedByPartNo(downsideSalesChartDataSet.monthlySalesByPartNo);

      // ダウンサイドグラフを更新
      setSalesChartDataModified(downsideSalesChartDataSet.chartData);
    }
  }, [
    quantitiesChartDataModified,
    mergedChartDataModified,
    capexPartNo,
    projectData,
    originalImprovedWorkingDaysData,
    originalImprovedNonWorkingHoursData,
    originalEquipmentAmounts,
    originalProfitAndLossByMonth,
    downsideIndexGraph,
    reviewDate,
    selectedCurrency.name,
    convertWithRate,
  ]);

  /**
   * 【JPY版】売上（ダウンサイド）チャートデータ作成
   * displayOriginalProfitAndLossByMonth（対象PJ画面で保存したJPY版）から直接計算
   * 選択通貨が保存時の表示通貨と一致する場合に使用（二重変換回避）
   */
  useEffect(() => {
    if (!displayOriginalProfitAndLossByMonth ||
      !displayOriginalProfitAndLossByMonth.labels ||
      !savedDisplayCurrencyName ||
      !quantitiesChartDataModified ||
      !displayVersionMergedChartDataModified ||
      !originalEquipmentAmounts?.length) {
      setDisplayVersionSalesChartDataModified(null);
      return;
    }

    // 表示通貨の小数点有無
    const displayCurrencyDecimal = hasDecimal(savedDisplayCurrencyName);

    // 【売上（ダウンサイド）】チャートデータ作成（JPY版）
    const downsideSalesChartDataSet = calcDownsideSalesChartDataSet(
      quantitiesChartDataModified,
      displayVersionMergedChartDataModified,
      capexPartNo,
      projectData,
      originalEquipmentAmounts,
      originalImprovedWorkingDaysData,
      originalImprovedNonWorkingHoursData,
      null,
      null,
      downsideIndexGraph,
      salesCurrencyName,
      savedDisplayCurrencyName,  // ローカル通貨ではなく表示通貨を使用
      currencyData,
      displayOriginalProfitAndLossByMonth.labels,
      displayCurrencyDecimal,
      uniqueProcessData,
      bomData,
    );

    // 売上（ダウンサイド）JPY版データ設定
    setDisplayVersionSalesChartDataModified(downsideSalesChartDataSet.chartData);

  }, [
    displayOriginalProfitAndLossByMonth,
    savedDisplayCurrencyName,
    quantitiesChartDataModified,
    displayVersionMergedChartDataModified,
    capexPartNo,
    projectData,
    originalEquipmentAmounts,
    originalImprovedWorkingDaysData,
    originalImprovedNonWorkingHoursData,
    downsideIndexGraph,
    salesCurrencyName,
    currencyData,
    uniqueProcessData,
    bomData,
  ]);

  // #endregion

  /**
   * 【投資回収（ダウンサイド）】チャートデータ作成
   */
  useEffect(() => {

    // ダウンサイドグラフの計算
    const downsideCombinedChartDataSet = calcDownsideCombinedChartDataSet(
      quantitiesChartDataModified, mergedChartDataModified, capexPartNo, projectData, originalEquipmentAmounts,
      originalImprovedWorkingDaysData, originalImprovedNonWorkingHoursData, null,
      null, salesChartDataForSavedConfig, salesChartDataModified, monthlySalesModifiedByPartNo,
      downsideIndexGraph, reviewDate ? selectedCurrency.name : localCurrencyName, currencyData, decimalCurrency,
      uniqueProcessData,
      bomData,
      undefined, true, undefined,
      reviewDate ? convertWithRate : undefined,
      reviewDate ? localCurrencyName : undefined,
    );

    if (!downsideCombinedChartDataSet) {
      return;
    }

    // ダウンサイドグラフを更新
    setMonthOfRecoveryModified(downsideCombinedChartDataSet.recoveryMonths);
    setCombinedChartDataModified({
      labels: downsideCombinedChartDataSet.labels,
      datasets: [downsideCombinedChartDataSet.recoveryDataset, ...downsideCombinedChartDataSet.capexDatasets],
    });

    // 増分キャッシュフロー Excel出力用データ保持
    setIncrementalCashFlowDownside({
      labels: downsideCombinedChartDataSet.labels,
      ...downsideCombinedChartDataSet.incrementalCashFlowData,
      recoveryMonths: downsideCombinedChartDataSet.recoveryMonths,
    });

  }, [
    salesChartDataModified,
    quantitiesChartDataModified,
    mergedChartDataModified,
    originalEquipmentAmounts,
    originalImprovedWorkingDaysData,
    originalImprovedNonWorkingHoursData,
    selectedCustomerProduct,
    capexPartNo,
    monthlySalesModifiedByPartNo,
    downsideIndexGraph,
    reviewDate,
    selectedCurrency.name,
    convertWithRate,
  ]);

  /**
   * 【JPY版】投資回収（ダウンサイド）チャートデータ作成
   * displayOriginalProfitAndLossByMonth（対象PJ画面で保存したJPY版）から直接計算
   * 選択通貨が保存時の表示通貨と一致する場合に使用（二重変換回避）
   */
  useEffect(() => {
    if (!displayOriginalProfitAndLossByMonth ||
      !displayOriginalProfitAndLossByMonth.labels ||
      !savedDisplayCurrencyName ||
      !displayVersionSalesChartDataModified ||
      !quantitiesChartDataModified ||
      !displayVersionMergedChartDataModified ||
      !originalEquipmentAmounts?.length) {
      setDisplayVersionCombinedChartDataModified(null);
      return;
    }

    // 表示通貨の小数点有無
    const displayCurrencyDecimal = hasDecimal(savedDisplayCurrencyName);

    // パーツNo毎の月次売上（ダウンサイド）を計算
    // displayVersionSalesChartDataModifiedから抽出
    const salesDataset = displayVersionSalesChartDataModified?.datasets?.find((d: any) => d.id === "sales");
    if (!salesDataset) {
      setDisplayVersionCombinedChartDataModified(null);
      return;
    }

    // 【投資回収（ダウンサイド）】チャートデータ作成（JPY版）
    const downsideCombinedChartDataSet = calcDownsideCombinedChartDataSet(
      quantitiesChartDataModified,
      displayVersionMergedChartDataModified,
      capexPartNo,
      projectData,
      originalEquipmentAmounts,
      originalImprovedWorkingDaysData,
      originalImprovedNonWorkingHoursData,
      null,
      null,
      salesChartDataForSavedConfig,
      displayVersionSalesChartDataModified,
      {},  // monthlySalesModifiedByPartNoは使用しない（関数内で再計算される）
      downsideIndexGraph,
      savedDisplayCurrencyName,  // ローカル通貨ではなく表示通貨を使用
      currencyData,
      displayCurrencyDecimal,
      uniqueProcessData,
      bomData,
    );

    if (!downsideCombinedChartDataSet) {
      setDisplayVersionCombinedChartDataModified(null);
      return;
    }

    // 投資回収（ダウンサイド）JPY版データ設定
    setDisplayVersionCombinedChartDataModified({
      labels: downsideCombinedChartDataSet.labels,
      datasets: [downsideCombinedChartDataSet.recoveryDataset, ...downsideCombinedChartDataSet.capexDatasets],
    });

  }, [
    displayOriginalProfitAndLossByMonth,
    savedDisplayCurrencyName,
    displayVersionSalesChartDataModified,
    quantitiesChartDataModified,
    displayVersionMergedChartDataModified,
    capexPartNo,
    projectData,
    originalEquipmentAmounts,
    originalImprovedWorkingDaysData,
    originalImprovedNonWorkingHoursData,
    salesChartDataForSavedConfig,
    downsideIndexGraph,
    currencyData,
    uniqueProcessData,
    bomData,
  ]);

  /**
   * 【売上グラフ】保存済み設定用グラフ生成
   */
  useEffect(() => {
    if (selectedConfigIds.length > 0 && quantitiesChartDataForSavedConfig.length > 0 && mergedChartDataForSavedConfig.length > 0 && projectData && originalProfitAndLossByMonth) {
      selectedConfigIds.forEach(configId => {
        const config = savedConfigs.find(c => c.id === configId);

        const savedQuantitiesData = quantitiesChartDataForSavedConfig.find(q => q.configId === configId);
        const savedMergedData = mergedChartDataForSavedConfig.find(q => q.configId === configId);

        if (config && savedQuantitiesData && savedMergedData) {
          const configApplyDownside = config.applyDownside !== false;
          const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;

          // 保存済み設定の数量・単価変更がある場合、capexPartNoのquantityAndPriceを更新
          const savedConfigCapexPartNo = config.quantityAndPrice.length > 0
            ? capexPartNo.map(partNo => {
              const matched = config.quantityAndPrice.find(q => q.partNo === partNo.partNo);
              return matched
                ? { ...partNo, quantityAndPrice: JSON.stringify(matched) }
                : partNo;
            })
            : capexPartNo;

          const savedConfigSalesChartDataSet = calcDownsideSalesChartDataSet(
            savedQuantitiesData.data, savedMergedData.data, savedConfigCapexPartNo,
            applyScenarioLaborCostToProjectData(
              projectData!,
              config.scenarioLaborCostByMonth,
              config.scenarioOverseasFactoryExpensesByMonth,
              originalProfitAndLossByMonth.labels
            ), originalEquipmentAmounts,
            config.improvedWorkingDaysData, config.improvedNonWorkingHoursData, config, configId, configDownsideIndex,
            salesCurrencyName, reviewDate ? selectedCurrency.name : localCurrencyName, currencyData, originalProfitAndLossByMonth.labels, decimalCurrency,
            uniqueProcessData,
            bomData,
            undefined,
            configApplyDownside,
            undefined,
            reviewDate ? convertWithRate : undefined,
            reviewDate ? localCurrencyName : undefined,
          );

          // No.411追加対応: 申請書画面（ReportAndDraft.tsx）が投資回収用データ構造
          // （combinedChartDataForSavedConfig）に間借りせず自己完結で参照できるよう、
          // salesChartDataForSavedConfigのchartData自体にrealProfitRate/realProfitRateByMonthを付帯させる。
          const salesDataset = savedConfigSalesChartDataSet.chartData.datasets?.find((d: any) => d.id === "sales");
          const sales = salesDataset ? salesDataset.data.map((v: string | number) => new Decimal(v)) : [];
          const savedConfigLabels = originalProfitAndLossByMonth.labels.slice(0, sales.length);
          // 顧客指定部品の有無判断
          const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
          const { realProfitRate, realProfitRateByMonth } = a // 判定条件の sales.length > 0  を a にしてみた
            ? calcRealProfitRateCommon({
              salesData: sales,
              mergedData: savedMergedData.data,
              quantitiesData: savedQuantitiesData.data,
              labels: savedConfigLabels,
              capexPartNo: savedConfigCapexPartNo,
              equipments: originalEquipmentAmounts,
              projectData: applyScenarioLaborCostToProjectData(
                projectData!,
                config.scenarioLaborCostByMonth,
                config.scenarioOverseasFactoryExpensesByMonth,
                savedConfigLabels
              ),
              isDownside: configApplyDownside,
              localCurrencyName,
              currencyData,
              targetCurrencyName: reviewDate ? selectedCurrency.name : localCurrencyName,
              downsideIndexGraph: configDownsideIndex,
              decimalCurrency,
              processCodeData: uniqueProcessData,
              bomData,
              moldSales: projectData?.moldSalesByProject,
              developmentSales: projectData?.developmentSalesByProject,
              equipmentSales: projectData?.equipmentSalesByProject,
              convertFn: reviewDate ? convertWithRate : undefined,
            })
            : { realProfitRate: "", realProfitRateByMonth: [] as number[] };

          setSalesChartDataForSavedConfig(prev => {
            const filtered = prev.filter(item => item.configId !== configId);
            return [...filtered, {
              configId, data: {
                ...savedConfigSalesChartDataSet.chartData,
                realProfitRate,
                realProfitRateByMonth,
              }
            }];
          });
        }
      });
    }
  }, [selectedConfigIds, savedConfigs, quantitiesChartDataForSavedConfig, mergedChartDataForSavedConfig, capexPartNo, projectData, downsideIndexGraph, salesCurrencyName, localCurrencyName, currencyData, originalProfitAndLossByMonth, decimalCurrency, neutralDownsideIndex, reviewDate, selectedCurrency.name, convertWithRate]);

  /**
   * 【JPY版】売上グラフ 保存済み設定用グラフ生成
   * ダウンサイドと同じJPYネイティブのデータパスを使用し、営業利益合計の一致を保証
   * 選択通貨が保存時の表示通貨（JPY）と一致する場合にグラフ・Excel出力で使用
   */
  useEffect(() => {
    if (
      selectedConfigIds.length > 0 &&
      quantitiesChartDataForSavedConfig.length > 0 &&
      displayVersionMergedChartDataForSavedConfig.length > 0 &&
      displayOriginalProfitAndLossByMonth &&
      savedDisplayCurrencyName &&
      projectData
    ) {
      const displayCurrencyDecimal = hasDecimal(savedDisplayCurrencyName);

      selectedConfigIds.forEach(configId => {
        const config = savedConfigs.find(c => c.id === configId);
        const savedQuantitiesData = quantitiesChartDataForSavedConfig.find(q => q.configId === configId);
        const savedDisplayMergedData = displayVersionMergedChartDataForSavedConfig.find(m => m.configId === configId);

        if (config && savedQuantitiesData && savedDisplayMergedData) {
          const configApplyDownside = config.applyDownside !== false;
          const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;

          const savedConfigCapexPartNo = config.quantityAndPrice.length > 0
            ? capexPartNo.map(partNo => {
              const matched = config.quantityAndPrice.find(q => q.partNo === partNo.partNo);
              return matched
                ? { ...partNo, quantityAndPrice: JSON.stringify(matched) }
                : partNo;
            })
            : capexPartNo;

          const displaySalesChartDataSet = calcDownsideSalesChartDataSet(
            savedQuantitiesData.data, savedDisplayMergedData.data, savedConfigCapexPartNo,
            applyScenarioLaborCostToProjectData(
              projectData!,
              config.scenarioLaborCostByMonth,
              config.scenarioOverseasFactoryExpensesByMonth,
              displayOriginalProfitAndLossByMonth.labels
            ), originalEquipmentAmounts,
            config.improvedWorkingDaysData, config.improvedNonWorkingHoursData, config, configId, configDownsideIndex,
            salesCurrencyName, savedDisplayCurrencyName, currencyData, displayOriginalProfitAndLossByMonth.labels, displayCurrencyDecimal,
            uniqueProcessData,
            bomData,
            undefined,
            configApplyDownside,
          );

          setDisplayVersionSalesChartDataForSavedConfig(prev => {
            const filtered = prev.filter(item => item.configId !== configId);
            return [...filtered, { configId, data: displaySalesChartDataSet.chartData }];
          });
        }
      });
    }
  }, [selectedConfigIds, savedConfigs, quantitiesChartDataForSavedConfig, displayVersionMergedChartDataForSavedConfig, displayOriginalProfitAndLossByMonth, savedDisplayCurrencyName, capexPartNo, projectData, downsideIndexGraph, salesCurrencyName, currencyData, uniqueProcessData, bomData, neutralDownsideIndex]);

  /**
   * 【投資回収グラフ】保存済み設定用グラフ生成
   */
  useEffect(() => {
    if (selectedConfigIds.length > 0 && salesChartDataForSavedConfig.length > 0 && quantitiesChartDataForSavedConfig.length > 0 && mergedChartDataForSavedConfig.length > 0 && projectData) {
      selectedConfigIds.forEach(configId => {
        const config = savedConfigs.find(c => c.id === configId);
        const savedSalesData = salesChartDataForSavedConfig.find(item => item.configId === configId);
        const savedQuantitiesData = quantitiesChartDataForSavedConfig.find(q => q.configId === configId);
        const savedMergedData = mergedChartDataForSavedConfig.find(q => q.configId === configId);
        if (config && savedSalesData && savedQuantitiesData && savedMergedData) {
          const configApplyDownside = config.applyDownside !== false;
          const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;

          // 保存済み設定の数量・単価変更がある場合、capexPartNoのquantityAndPriceを更新
          const savedConfigCapexPartNo = config.quantityAndPrice.length > 0
            ? capexPartNo.map(partNo => {
              const matched = config.quantityAndPrice.find(q => q.partNo === partNo.partNo);
              return matched
                ? { ...partNo, quantityAndPrice: JSON.stringify(matched) }
                : partNo;
            })
            : capexPartNo;

          const savedCombinedDataSet = calcDownsideCombinedChartDataSet(
            savedQuantitiesData.data, savedMergedData.data, savedConfigCapexPartNo,
            applyScenarioLaborCostToProjectData(
              projectData!,
              config.scenarioLaborCostByMonth,
              config.scenarioOverseasFactoryExpensesByMonth,
              originalProfitAndLossByMonth?.labels ?? []
            ), originalEquipmentAmounts,
            config.improvedWorkingDaysData, config.improvedNonWorkingHoursData, config,
            configId, salesChartDataForSavedConfig, savedSalesData.data, monthlySalesModifiedByPartNo,
            configDownsideIndex, reviewDate ? selectedCurrency.name : localCurrencyName, currencyData, decimalCurrency,
            uniqueProcessData,
            bomData,
            undefined,
            configApplyDownside,
            undefined,
            reviewDate ? convertWithRate : undefined,
            reviewDate ? localCurrencyName : undefined,
          );

          if (savedCombinedDataSet) {
            setMonthOfRecoveryForSavedConfig(prev => {
              const filtered = prev.filter(item => item.configId !== configId);
              return [...filtered, { configId, data: savedCombinedDataSet.recoveryMonths }];
            });

            // 営業利益額と営業利益率を計算（保存済み設定用）
            const { totalProfit: configTotalProfit, profitRate: configProfitRate } = calcTotalProfitAndRate(savedSalesData.data);
            // 営業利益合計をcostBreakdown経由で計算（表示通貨 - ReportAndDraftとの一致用）
            const configDisplayTotalProfit = calcDisplayTotalProfit(savedSalesData.data);

            // 実質的営業利益率を計算（保存済み設定用）
            let configRealProfitRate = "";
            let configRealProfitRateByMonth: number[] = [];
            // 顧客指定部品の有無判断
            const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
            const configSalesDataset = savedSalesData.data?.datasets?.find((d: any) => d.id === "sales");
            if (configSalesDataset && originalProfitAndLossByMonth?.labels) {
              const configSales = configSalesDataset.data.map((v: number) => new Decimal(v));
              const configMaterialCosts = calcMaterialCost(
                savedMergedData.data,
                savedQuantitiesData.data,
                savedConfigCapexPartNo,
                originalProfitAndLossByMonth.labels,
                projectData?.projectId!,
                localCurrencyName,
                currencyData
              );
              // データの実期間に調整
              const labels = originalProfitAndLossByMonth.labels.slice(0, configSales.length);
              const configMonthlyData = calcMonthlyProfitAndLossDetails(
                configSales,
                configMaterialCosts || [],
                labels,
                configApplyDownside,
                originalEquipmentAmounts,
                applyScenarioLaborCostToProjectData(
                  projectData!,
                  config.scenarioLaborCostByMonth,
                  config.scenarioOverseasFactoryExpensesByMonth,
                  labels
                ),
                savedConfigCapexPartNo,
                // 振り返りモード: savedSalesDataは表示通貨(selectedCurrency)で月別レート変換済みのため、
                // 費用側も表示通貨+convertFnで揃えて通貨不一致を回避する。
                // 通常モード: 従来どおりローカル通貨で統一（比率なので通貨に依存しない）。
                reviewDate ? selectedCurrency.name : localCurrencyName,
                currencyData,
                configDownsideIndex,
                decimalCurrency,
                uniqueProcessData,
                bomData,
                projectData?.moldSalesByProject,
                projectData?.developmentSalesByProject,
                projectData?.equipmentSalesByProject,
                undefined,
                reviewDate ? convertWithRate : undefined,
              );
              if (configMonthlyData) {
                const configTotalSalesVal = configSalesDataset.data.reduce((sum: number, v: number) => sum + (v || 0), 0);
                // No.411追加対応: 表示期間外（生産終了後）に残る減価償却費を分子に加算し、系統A（画面表示用）と算出方式を統一する
                const configTotalProfitVal = (savedSalesData.data.datasets.find((d: any) => d.id === "profit")?.data?.reduce((sum: number, v: number) => sum + (v || 0), 0) || 0)
                  + (configMonthlyData.residualDepreciationTotal?.toNumber() ?? 0);
                const configTotalCustomerCost = configMonthlyData.customerSpecifiedPartsCost.reduce((sum: Decimal, v: Decimal) => sum.plus(v), new Decimal(0));
                if (a) {
                  configRealProfitRate = calcRealProfitRate(new Decimal(configTotalSalesVal), new Decimal(configTotalProfitVal), configTotalCustomerCost);
                  const configProfitDataset = savedSalesData.data.datasets.find((d: any) => d.id === "profit");
                  if (configProfitDataset) {
                    configRealProfitRateByMonth = calcRealProfitRateByMonth(
                      configSalesDataset.data as number[],
                      configProfitDataset.data as number[],
                      configMonthlyData.customerSpecifiedPartsCost
                    );
                  }
                }
              }
            }

            setCombinedChartDataForSavedConfig(prev => {
              const filtered = prev.filter(item => item.configId !== configId);
              return [...filtered, {
                configId, data: {
                  labels: savedCombinedDataSet.labels,
                  datasets: [savedCombinedDataSet.recoveryDataset, ...savedCombinedDataSet.capexDatasets],
                  totalProfit: configTotalProfit,
                  displayTotalProfit: configDisplayTotalProfit?.toString(),
                  profitRate: configProfitRate,
                  realProfitRate: configRealProfitRate,
                  realProfitRateByMonth: configRealProfitRateByMonth,
                }
              }];
            });

            // 増分キャッシュフロー Excel出力用データ保持
            setIncrementalCashFlowForSavedConfig(prev => {
              const filtered = prev.filter(item => item.configId !== configId);
              return [...filtered, {
                configId,
                data: {
                  labels: savedCombinedDataSet.labels,
                  ...savedCombinedDataSet.incrementalCashFlowData,
                  recoveryMonths: savedCombinedDataSet.recoveryMonths,
                },
              }];
            });
          }
        }
      });
    }
  }, [selectedConfigIds, savedConfigs, salesChartDataForSavedConfig, quantitiesChartDataForSavedConfig, mergedChartDataForSavedConfig, capexPartNo, projectData, monthlySalesModifiedByPartNo, downsideIndexGraph, localCurrencyName, currencyData, decimalCurrency, selectedCustomerProduct, neutralDownsideIndex, reviewDate, selectedCurrency.name, convertWithRate]);

  useEffect(() => {
    if (!quantityAndPriceTables.length || !projectData?.projectStartDate) return;

    const projectStartDate = projectData?.projectStartDate;
    const startMonth = projectStartDate ? parseInt(projectStartDate.split("-")[1], 10) : 4;

    const result = quantityAndPriceTables.map((table) => ({
      id: table.data.id,
      rows: generateRowsFromTable(table.data, startMonth),
    }));

    setPriceRows(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantityAndPriceTables, projectData?.projectStartDate]);

  /**
   * 年月度別配列から年月を引数に値を取得する
   * @param dataByYear 
   * @param year 
   * @param month 
   * @param targetKey 
   * @returns 
   */
  const getMonthlyDataByYearAndMonth = (
    dataByYear: {
      fiscalYear: string,
      workingDay?: number[],
      holiday?: number[],
      availabilityRate?: number[],
      lineCount?: number[],
    }[],
    year: number,
    month: number,
    targetKey: "workingDay" | "holiday" | "availabilityRate" | "lineCount" // 限定されたキー
  ): number => {
    // Fiscal Year のフォーマット: "{year}年3月期"
    // 例: 2025年4月 → 2026年3月期（2025年4月〜2026年3月）
    const targetFiscalYear = `${year + 1}年3月期`;

    // 該当する fiscalYear を検索（会計年度文字列は表示言語で変わるため年数値で判定する）
    const data = dataByYear.find((item) => isSameFiscalYear(item.fiscalYear, targetFiscalYear));

    if (!data) {
      // 該当する fiscalYear が存在しない場合
      // console.error(`Fiscal Year ${targetFiscalYear} が見つかりません`);
      return 0;
    }

    // 対象データが存在しない場合
    const targetData = data[targetKey];
    if (!targetData) {
      // console.error(`キー "${targetKey}" に対応するデータが存在しません`);
      return 0;
    }

    // 月のインデックスを計算（1月は 0 インデックス）
    const monthIndex = month - 1;

    if (monthIndex < 0 || monthIndex >= 12) {
      // 無効な月のチェック
      // console.error(`月 "${month}" は無効な月です（1～12 の範囲で指定してください）`);
      return 0;
    }

    // 該当する targetKey のデータを返す
    const monthlyData = targetData[monthIndex];

    if (monthlyData === undefined) {
      // console.error(`月 "${month}" のデータが見つかりません`);
      return 0;
    }

    return monthlyData;
  };

  /**
   * 【顧客需要と設備キャパシティ（当初計画 / ダウンサイド）】チャートデータ作成
   */
  useEffect(() => {

    if (
      originalProfitAndLossByMonth &&                         // オリジナル月別(当初損益月別）対象PJの損益試算画面で登録
      originalProfitAndLossByMonth.quantityByPartNo &&  // オリジナル月別(当初損益月別) PartNo別の月別/数量
      workingDayByYear.length > 0 &&                    // 稼働日数データが存在
      lineCountByYear.length > 0 &&                    // ライン数データが存在
      holidayByYear.length > 0 &&                       // 休日データが存在
      availabilityRateByMonth.length > 0                // 稼働率データが存在
    ) {

      // 「Chart.jsがnumber型を期待している」、「金額ではなく数量を求める」ことからDecimal型は使用しない

      // #region 初期処理

      // ベース計算用データソース（常に初期データを使用）
      const baseWorkingDayData = workingDayByYear;
      const baseLineCountByYear = lineCountByYear;
      const baseHolidayData = holidayByYear;
      const baseAvailabilityData = availabilityRateByMonth;

      // 変数宣言
      const quantityByPartNo = originalProfitAndLossByMonth.quantityByPartNo;  // PartNo別の月別/数量
      const originalLabels = [...originalProfitAndLossByMonth.labels];                  // 年月ラベル(当初計画)
      const baseAvailabilityRateByMonthLocal: { fiscalYear: string, availabilityRate: number[] }[] = [];  // 稼働率（ベース用ローカル）
      const baseQuantities: number[] = [];                                              // 販売個数(ベース)配列
      const baseCapacityQuantities: number[] = [];                                      // キャパ(ベース)配列
      const baseSurplusCapacityQuantities: number[] = [];                               // 販売個数(ベース)配列
      let modifiedLabels = [...originalProfitAndLossByMonth.labels];                    // 年月ラベル(ダウンサイド)
      let stressQuantities: number[] = [];                                              // 販売個数(ベース)配列
      let stressCapacityQuantities: number[] = [];                                      // キャパ(ストレス)配列
      let stressSurplusCapacityQuantities: number[] = [];                               // キャパ過剰分(ストレス)配列

      // 稼働率データをコピー（ベース用は初期データ）
      for (let i = 0; i < baseAvailabilityData.length; i++) {
        baseAvailabilityRateByMonthLocal.push({
          fiscalYear: baseAvailabilityData[i]?.fiscalYear || `Unknown Fiscal Year ${i}`,
          availabilityRate: baseAvailabilityData[i]?.availabilityRate || [],
        });
      }

      // #endregion

      // #region 顧客需要と設備キャパシティ（当初計画）

      // 販売個数(ベース)の計算(月別)
      Object.values(quantityByPartNo).forEach(part => {
        part.forEach((value, index) => {
          // 販売個数(個) = 販売個数(個)
          const baseQuantity = Number(value || 0);
          // 販売個数(ベース)配列に格納
          baseQuantities[index] = (baseQuantities[index] || 0) + baseQuantity;
        });
      });

      // キャパ(ベース)の計算(月別)
      for (let i = 0; i < originalLabels.length; i++) {
        // 処理中の年月を取得
        const { year, month } = getFiscalYearMonth(originalLabels, i);

        // 月別のC/Tと歩留をBOMデータから取得（なければ0）
        const cycleTimeToUse = getCycleTimeFromBom(originalLabels[i]) ?? 0;
        const yieldRateToUse = getYieldRateFromBom(originalLabels[i]) ?? 0;

        // 稼働日+休日出勤稼働時間(秒) = (稼働日数 + 休日出勤日数) * 24時間 * 3600秒
        const availabilityTime = (
          getMonthlyDataByYearAndMonth(baseWorkingDayData, year, month, "workingDay") +
          getMonthlyDataByYearAndMonth(baseHolidayData, year, month, "holiday"))
          * 24 * 3600;
        // 生産可能個数(個) = 稼働日+休日出勤稼働時間(秒) / サイクルタイム(秒)
        const productionQuantity = Math.round(availabilityTime / cycleTimeToUse);
        // キャパ(個) = 生産可能個数(個) * 稼働率(%) * 歩留(%) * ライン数
        const availabilityRateToUse = getMonthlyDataByYearAndMonth(baseAvailabilityData, year, month, "availabilityRate");
        const baseCapacityQuantity = Math.round(productionQuantity * availabilityRateToUse * yieldRateToUse * getMonthlyDataByYearAndMonth(baseLineCountByYear, year, month, "lineCount"));
        // キャパ(ベース)配列に格納
        baseCapacityQuantities[i] = Number.isNaN(baseCapacityQuantity) || baseCapacityQuantity === Infinity ? 0 : baseCapacityQuantity;;
      }

      // 24h稼働キャパ(ベース)の計算(月別) = 工場稼働日数 × 86400 / CT × 歩留 × ライン数
      const base24hCapacityQuantities: number[] = [];
      for (let i = 0; i < originalLabels.length; i++) {
        const { year, month } = getFiscalYearMonth(originalLabels, i);
        const ct = getCycleTimeFromBom(originalLabels[i]) ?? 0;
        const yr = getYieldRateFromBom(originalLabels[i]) ?? 0;
        const fwd = getMonthlyDataByYearAndMonth(factoryWorkingDayByYear, year, month, "workingDay");
        const rawQty = ct > 0 ? Math.round(fwd * 86400 / ct) : 0;
        const lc = getMonthlyDataByYearAndMonth(baseLineCountByYear, year, month, "lineCount");
        const cap = Math.round(rawQty * yr * getMonthlyDataByYearAndMonth(baseLineCountByYear, year, month, "lineCount"));
        base24hCapacityQuantities[i] = Number.isNaN(cap) || cap === Infinity ? 0 : cap;
      }

      // キャパ過剰分(ベース)の計算(月別)
      for (let i = 0; i < originalLabels.length; i++) {
        // キャパ過剰分(個) = キャパ(個) - 販売個数(個)
        const baseSurplusCapacityQuantity = baseCapacityQuantities[i] - baseQuantities[i];
        // キャパ過剰分(ベース)配列に格納
        baseSurplusCapacityQuantities[i] = baseSurplusCapacityQuantity;
      }

      // #endregion

      // #region 顧客需要と設備キャパシティ（ダウンサイド）

      // ストレスシナリオを常に適用
      // 関数宣言
      const parseYearMonth = (label: string) => {
        const [y, m] = label.split("/");
        return { year: parseInt(y), month: parseInt(m) };
      };

      // プロジェクト開始年度を取得
      const { year: firstYear, month: firstMonth } = parseYearMonth(modifiedLabels[0]);
      const projectFiscalYearStart = firstMonth >= 4 ? firstYear : firstYear - 1;

      // 販売個数(ストレス)の計算(月別)
      modifiedLabels.forEach((_, index: number) => {

        // 年月を取得 （例）{ 2025, 04 }
        const { year, month } = parseYearMonth(modifiedLabels[index]);
        // 年度を取得 （例）2025
        const fyStart = month >= 4 ? year : year - 1;
        // 年数を取得 （例）1
        const fiscalYearIndex = fyStart - projectFiscalYearStart + 1;

        // 数量をストレス指数分減少（月度単利）
        const downsindeIndex = (1 - getDownsideIndexToQuantity(fiscalYearIndex - 1, downsideIndexGraph));
        // 販売個数(個) = 販売個数(個) * ストレス指数
        const stressQuantity = (baseQuantities[index] || 0) * downsindeIndex;
        // 販売個数(ベース)配列に格納
        stressQuantities[index] = (stressQuantities[index] || 0) + stressQuantity;

      });

      // キャパ(ストレス)の設定（ダウンサイドグラフはベースと同じ）
      stressCapacityQuantities = baseCapacityQuantities;

      // AI分析
      setAdjustedOrders(stressQuantities);
      setProductionCapacityData(stressCapacityQuantities);

      // キャパ過剰分(ストレス)の計算(月別)
      for (let i = 0; i < originalLabels.length; i++) {
        // キャパ過剰分(個) = キャパ(個) - 販売個数(個)
        // stressCapacityQuantities は保存済み設定の場合、改善後データで計算されたものを使用
        const stressSurplusCapacityQuantity = stressCapacityQuantities[i] - stressQuantities[i];
        // キャパ過剰分(ストレス)配列に格納
        stressSurplusCapacityQuantities[i] = stressSurplusCapacityQuantity;
      }

      // 期間をストレス指数分短縮（データのみ、ラベルは短縮しない）
      const newLength = Math.floor(modifiedLabels.length * (1 - getDownsideIndexToPeriod(downsideIndexGraph)));
      // 期間を短縮した販売個数(ストレス)を取得
      stressQuantities = stressQuantities.slice(0, newLength);
      // 期間を短縮したキャパ(ストレス)を取得
      stressCapacityQuantities = stressCapacityQuantities.slice(0, newLength);
      // 期間を短縮したキャパ過剰分(ストレス)を取得
      stressSurplusCapacityQuantities = stressSurplusCapacityQuantities.slice(0, newLength);
      // 期間を短縮した24h稼働キャパを取得
      const stress24hCapacityQuantities = base24hCapacityQuantities.slice(0, newLength);

      // #endregion

      // #region 生産キャパグラフ用（案件品のPartNo別数量）

      // 月別のストレス係数（販売個数(ストレス)と同じ計算）
      const calcDownsideFactors = (downsideIndex: typeof downsideIndexGraph) => modifiedLabels.map(label => {
        const { year, month } = parseYearMonth(label);
        const fyStart = month >= 4 ? year : year - 1;
        const fiscalYearIndex = fyStart - projectFiscalYearStart + 1;
        return 1 - getDownsideIndexToQuantity(fiscalYearIndex - 1, downsideIndex);
      });
      // PartNo別の月別数量（数値化・係数適用・期間短縮）
      const toQuantityByPartNo = (source: Record<string, string[]>, factors: number[] | null, length: number) =>
        Object.fromEntries(Object.entries(source).map(([partNo, values]) => [
          partNo,
          originalLabels.slice(0, length).map((_, i) => Number(values[i] || 0) * (factors ? factors[i] : 1)),
        ]));
      const baseDownsideFactors = calcDownsideFactors(downsideIndexGraph);
      const existingLineCapacitySavedConfigs: TExistingLineCapacitySource["savedConfigs"] = [];

      // #endregion

      // #region グラフデータの設定

      // 当初計画グラフ
      const original = [
        {
          type: "line",
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.salesQuantityOriginal'),
          data: baseQuantities,
          borderColor: "red",
          backgroundColor: "red",
          fill: false,
          tension: 0.4,
        },
        {
          type: "line",
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.capacity'),
          data: baseCapacityQuantities,
          borderColor: "green",
          backgroundColor: "green",
          fill: false,
          tension: 0.4,
        },
        {
          type: "bar",
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.surplusCapacityOriginal'),
          data: baseSurplusCapacityQuantities,
          backgroundColor: "brown",
          tension: 0.4,
        },
        {
          type: "line",
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.full24hCapacity'),
          data: base24hCapacityQuantities,
          borderColor: "cornflowerblue",
          backgroundColor: "cornflowerblue",
          fill: false,
          tension: 0.4,
        },
      ];

      // ダウンサイドグラフ
      // ストレスシナリオを常に適用
      const modified = [
        {
          type: "line",
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.salesQuantityModified'),
          data: stressQuantities,
          borderColor: "blue",
          backgroundColor: "blue",
          fill: false,
          tension: 0.4,
        },
        {
          type: "line",
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.capacity'),
          data: stressCapacityQuantities,
          borderColor: "green",
          backgroundColor: "green",
          fill: false,
          tension: 0.4,
        },
        {
          type: "bar",
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.surplusCapacityModified'),
          data: stressSurplusCapacityQuantities,
          backgroundColor: "orange",
          tension: 0.4,
        },
        {
          type: "line",
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.full24hCapacity'),
          data: stress24hCapacityQuantities,
          borderColor: "cornflowerblue",
          backgroundColor: "cornflowerblue",
          fill: false,
          tension: 0.4,
        },
      ];

      // グラフデータの設定
      // ダウンサイドグラフを更新
      setGapChartDataOriginal({
        labels: originalLabels,
        datasets: original,
      });
      setGapChartDataModified({
        labels: originalLabels,  // 全期間のラベルを使用
        datasets: modified,
      });

      // 選択されている保存済み設定グラフも更新（各設定の改善データを使用）
      if (selectedConfigIds.length > 0) {
        selectedConfigIds.forEach(configId => {
          const config = savedConfigs.find(c => c.id === configId);
          if (config) {
            const configApplyDownside = config.applyDownside !== false;
            const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;
            let savedStressQuantities = configApplyDownside ? stressQuantities : baseQuantities;

            if (config.quantityAndPrice.length > 0) {
              // 販売個数を再設定
              savedStressQuantities = [];
              const converted = convertToOriginalProfitAndLossByMonthTable(config.quantityAndPrice);
              // 変更PartNoのみ保存されるため、originalと結合して全PartNoを含める
              const mergedQuantityByPartNo = {
                ...originalProfitAndLossByMonth!.quantityByPartNo,
                ...converted.quantityByPartNo,
              };

              const savedQuantities: number[] = [];

              // 販売個数(ベース)の計算(月別)
              Object.values(mergedQuantityByPartNo).forEach(part => {
                part.forEach((value, index) => {
                  // 販売個数(個) = 販売個数(個)
                  const baseQuantity = Number(value || 0);

                  // 販売個数(ベース)配列に格納
                  savedQuantities[index] = (savedQuantities[index] || 0) + baseQuantity;
                });
              });

              // 販売個数(ストレス)の計算(月別)
              modifiedLabels.forEach((_, index: number) => {

                // 年月を取得 （例）{ 2025, 04 }
                const { year, month } = parseYearMonth(modifiedLabels[index]);
                // 年度を取得 （例）2025
                const fyStart = month >= 4 ? year : year - 1;
                // 年数を取得 （例）1
                const fiscalYearIndex = fyStart - projectFiscalYearStart + 1;

                // 数量をストレス指数分減少（月度単利）
                const downsindeIndex = (1 - getDownsideIndexToQuantity(fiscalYearIndex - 1, configDownsideIndex));
                // 販売個数(個) = 販売個数(個) * ストレス指数
                const stressQuantity = (savedQuantities[index] || 0) * downsindeIndex;
                // 販売個数(ベース)配列に格納
                savedStressQuantities[index] = (savedStressQuantities[index] || 0) + stressQuantity;
              });
            }

            // この設定の改善データを使ってキャパを再計算
            const savedConfigWorkingDayData = config.improvedWorkingDayByYear;
            const savedConfigLineCountData = config.improvedLineCountByYear;
            const savedConfigHolidayData = config.improvedHolidayByYear;
            const savedConfigAvailabilityData = config.improvedAvailabilityRateByMonth;
            const savedConfigYieldRateList = config.improvedYieldRateList || [];
            const savedConfigCycleTimeList = config.improvedCycleTimeList || [];
            // 工場稼働日数（保存済み設定）
            const savedConfigFactoryWorkingDayData = (config.improvedWorkingDaysData || []).map(wd => ({
              fiscalYear: wd.fiscalYear,
              workingDay: wd.workingDaysData?.factoryWorkingDays || [],
            }));

            // 稼働率データをローカル変数にコピー
            const savedConfigAvailabilityRateByMonthLocal: { fiscalYear: string, availabilityRate: number[] }[] = [];
            for (let i = 0; i < savedConfigAvailabilityData.length; i++) {
              savedConfigAvailabilityRateByMonthLocal.push({
                fiscalYear: savedConfigAvailabilityData[i]?.fiscalYear || `Unknown Fiscal Year ${i}`,
                availabilityRate: savedConfigAvailabilityData[i]?.availabilityRate || [],
              });
            }

            // キャパ(保存済み設定)の計算
            const savedConfigCapacityQuantities: number[] = [];
            for (let i = 0; i < originalLabels.length; i++) {
              const { year, month } = getFiscalYearMonth(originalLabels, i);
              const availabilityTime = (
                getMonthlyDataByYearAndMonth(savedConfigWorkingDayData, year, month, "workingDay") +
                getMonthlyDataByYearAndMonth(savedConfigHolidayData, year, month, "holiday"))
                * 24 * 3600;
              const cycleTimeToUse = getApplicableCycleTime(originalLabels[i], savedConfigCycleTimeList, getCycleTimeFromBom);
              const productionQuantity = Math.round(availabilityTime / cycleTimeToUse);
              const availabilityRateToUse = getMonthlyDataByYearAndMonth(savedConfigAvailabilityRateByMonthLocal, year, month, "availabilityRate");
              const yieldRateToUse = getApplicableYieldRate(originalLabels[i], savedConfigYieldRateList, getYieldRateFromBom);
              const savedConfigCapacityQuantity = Math.round(productionQuantity * availabilityRateToUse * yieldRateToUse * getMonthlyDataByYearAndMonth(savedConfigLineCountData, year, month, "lineCount"));
              savedConfigCapacityQuantities[i] = Number.isNaN(savedConfigCapacityQuantity) || savedConfigCapacityQuantity === Infinity ? 0 : savedConfigCapacityQuantity;
            }

            // 設定ごとの期間短縮長を決定（ストレスOFF時は全期間）
            const configNewLength = configApplyDownside ? newLength : modifiedLabels.length;

            // 生産キャパグラフ用（販売個数(保存済み設定)と同じ数量をPartNo別に保持）
            existingLineCapacitySavedConfigs.push({
              configId,
              quantityByPartNo: toQuantityByPartNo(
                config.quantityAndPrice.length > 0
                  ? { ...originalProfitAndLossByMonth!.quantityByPartNo, ...convertToOriginalProfitAndLossByMonthTable(config.quantityAndPrice).quantityByPartNo }
                  : originalProfitAndLossByMonth!.quantityByPartNo,
                config.quantityAndPrice.length > 0 || configApplyDownside ? calcDownsideFactors(configDownsideIndex) : null,
                configNewLength
              ),
              capacity: savedConfigCapacityQuantities,
              length: configNewLength,
            });

            // キャパ過剰分(保存済み設定)の計算（期間短縮後のデータのみ）
            const savedConfigSurplusCapacityQuantities: number[] = [];
            for (let i = 0; i < configNewLength; i++) {
              savedConfigSurplusCapacityQuantities[i] = savedConfigCapacityQuantities[i] - savedStressQuantities[i];
            }

            // 24h稼働キャパ(保存済み設定)の計算 = 工場稼働日数 × 86400 / CT × 歩留 × ライン数
            const savedConfig24hCapacityQuantities: number[] = [];
            for (let i = 0; i < originalLabels.length; i++) {
              const { year, month } = getFiscalYearMonth(originalLabels, i);
              const ct = getApplicableCycleTime(originalLabels[i], savedConfigCycleTimeList, getCycleTimeFromBom);
              const yr = getApplicableYieldRate(originalLabels[i], savedConfigYieldRateList, getYieldRateFromBom);
              const fwd = savedConfigFactoryWorkingDayData.length > 0
                ? getMonthlyDataByYearAndMonth(savedConfigFactoryWorkingDayData, year, month, "workingDay")
                : getMonthlyDataByYearAndMonth(factoryWorkingDayByYear, year, month, "workingDay");
              const rawQty = ct > 0 ? Math.round(fwd * 86400 / ct) : 0;
              const cap = Math.round(rawQty * yr * getMonthlyDataByYearAndMonth(savedConfigLineCountData, year, month, "lineCount"));
              savedConfig24hCapacityQuantities[i] = Number.isNaN(cap) || cap === Infinity ? 0 : cap;
            }

            // 保存済み設定用グラフデータセット（データを期間短縮）
            const savedConfigModified = [
              {
                type: "line",
                label: t('features.InvestmentScreening.SimulationNewProduct.chart.salesQuantityModified'),
                data: savedStressQuantities.slice(0, configNewLength),  // 期間短縮
                borderColor: "blue",
                backgroundColor: "blue",
                fill: false,
                tension: 0.4,
              },
              {
                type: "line",
                label: t('features.InvestmentScreening.SimulationNewProduct.chart.capacity'),
                data: savedConfigCapacityQuantities.slice(0, configNewLength),  // 期間短縮
                borderColor: "green",
                backgroundColor: "green",
                fill: false,
                tension: 0.4,
              },
              {
                type: "bar",
                label: t('features.InvestmentScreening.SimulationNewProduct.chart.surplusCapacityModified'),
                data: savedConfigSurplusCapacityQuantities,  // 既に短縮済み
                backgroundColor: "orange",
                tension: 0.4,
              },
              {
                type: "line",
                label: t('features.InvestmentScreening.SimulationNewProduct.chart.full24hCapacity'),
                data: savedConfig24hCapacityQuantities.slice(0, configNewLength),  // 期間短縮
                borderColor: "cornflowerblue",
                backgroundColor: "cornflowerblue",
                fill: false,
                tension: 0.4,
              },
            ];

            setGapChartDataForSavedConfig(prev => {
              const filtered = prev.filter(item => item.configId !== configId);
              return [...filtered, {
                configId, data: {
                  labels: originalLabels,  // 全期間のラベルを使用
                  datasets: savedConfigModified,
                }
              }];
            });
          }
        });
      }

      // 生産キャパグラフ用データの設定（キャパの値はダウンサイドでも当初計画と同じ。期間は他グラフと同様に短縮）
      setExistingLineCapacitySource({
        labels: originalLabels,
        original: {
          quantityByPartNo: toQuantityByPartNo(quantityByPartNo, null, originalLabels.length),
          capacity: baseCapacityQuantities,
          length: originalLabels.length,
        },
        modified: {
          quantityByPartNo: toQuantityByPartNo(quantityByPartNo, baseDownsideFactors, newLength),
          capacity: baseCapacityQuantities,
          length: newLength,
        },
        savedConfigs: existingLineCapacitySavedConfigs,
      });

      // #endregion

    }

  }, [
    originalProfitAndLossByMonth,
    workingDayByYear,
    factoryWorkingDayByYear,
    holidayByYear,
    availabilityRateByMonth,
    selectedCustomerProduct,
    downsideIndexGraph,
    selectedConfigIds,
    savedConfigs,
    bomData,
    neutralDownsideIndex,
  ]);

  /**
   * 【設備生産数量からのギャップ（当初計画 / ダウンサイド）】チャートデータ作成
   */
  useEffect(() => {

    if (
      originalProfitAndLossByMonth &&                           // オリジナル月別(当初損益月別）対象PJの損益試算画面で登録
      originalProfitAndLossByMonth.quantityByPartNo && // オリジナル月別(当初損益月別) PartNo別の月別/数量
      workingDayByYear.length > 0 &&                   // 稼働日数データが存在
      lineCountByYear.length > 0 &&                   // ライン数データが存在
      holidayByYear.length > 0 &&                      // 休日データが存在
      availabilityRateByMonth.length !== 0             // 稼働率データが存在
    ) {

      // 「Chart.jsがnumber型を期待している」、「金額ではなく数量を求める」ことからDecimal型は使用しない

      // #region 初期処理

      // ベース計算用データソース（常に初期データを使用）
      const baseWorkingDayData = workingDayByYear;
      const baseLineCountByYear = lineCountByYear;
      const baseHolidayData = holidayByYear;
      const baseAvailabilityData = availabilityRateByMonth;

      // 変数宣言
      const quantityByPartNo: Record<string, string[]> = originalProfitAndLossByMonth.quantityByPartNo;                         // PartNo別の月別/数量
      const originalLabels: string[] = [...originalProfitAndLossByMonth.labels];                                                // 年月ラベル(当初計画)
      const baseAvailabilityRateByMonthLocal: { fiscalYear: string, availabilityRate: number[] }[] = [];                         // 稼働率（ベース用ローカル）
      const baseEstimatedQuantities: number[] = [];                                                                             // 出荷必要見込み数(ベース)配列
      const baseWorkingDayQuantities: number[] = [];                                                                            // 稼働日分生産個数(ベース)配列
      const baseHolidayQuantities: number[] = [];                                                                               // 休日分生産個数(ベース)配列
      const baseImprovedYieldQuantities: number[] = [];                                                                         // 歩留改善分生産個数(ベース)配列
      const baseImprovedAvailabilityQuantities: number[] = [];                                                                  // 稼働率改善分生産個数(ベース)配列
      const baseImprovedCycleTimeQuantities: number[] = [];                                                                     // サイクル短縮分生産個数(ベース)配列
      let modifiedLabels: string[] = [...originalProfitAndLossByMonth.labels];                                                  // 年月ラベル(ダウンサイド)
      let stressEstimatedQuantities: number[] = [];                                                                             // 出荷必要見込み数(ストレス)配列
      let stressWorkingDayQuantities: number[] = [];                                                                            // 稼働日分生産個数(ストレス)配列
      let stressHolidayQuantities: number[] = [];                                                                               // 休日分生産個数(ストレス)配列
      let stressImprovedYieldQuantities: number[] = [];                                                                         // 歩留改善分生産個数(ストレス)配列
      let stressImprovedAvailabilityQuantities: number[] = [];                                                                  // 稼働率改善分生産個数(ストレス)配列
      let stressImprovedCycleTimeQuantities: number[] = [];                                                                     // サイクル短縮分生産個数(ストレス)配列

      // 稼働率データをコピー（ベース用は初期データ）
      for (let i = 0; i < baseAvailabilityData.length; i++) {
        baseAvailabilityRateByMonthLocal.push({
          fiscalYear: baseAvailabilityData[i]?.fiscalYear || `Unknown Fiscal Year ${i}`,
          availabilityRate: baseAvailabilityData[i]?.availabilityRate || [],
        });
      }

      // #endregion

      // #region 設備生産数量からのギャップ（当初計画）

      // 出荷必要見込み数(ベース)の計算(月別)
      Object.values(quantityByPartNo).forEach(part => {
        part.forEach((value, index) => {
          // 出荷必要見込み数(個) = 出荷必要見込み数(個)
          const baseEstimatedQuantity = Number(value || 0);
          // 出荷必要見込み数(ベース)配列に格納
          baseEstimatedQuantities[index] = (baseEstimatedQuantities[index] || 0) + baseEstimatedQuantity;
        });
      });

      // 24h稼働キャパの計算(月別) = 工場稼働日数 × 86400 / CT × 歩留 × ライン数
      const base24hCapacityQuantities2: number[] = [];
      for (let i = 0; i < originalLabels.length; i++) {
        const { year, month } = getFiscalYearMonth(originalLabels, i);
        const ct = getCycleTimeFromBom(originalLabels[i]) ?? 0;
        const yr = getYieldRateFromBom(originalLabels[i]) ?? 0;
        const fwd = getMonthlyDataByYearAndMonth(factoryWorkingDayByYear, year, month, "workingDay");
        const rawQty = ct > 0 ? Math.round(fwd * 86400 / ct) : 0;
        const cap = Math.round(rawQty * yr * getMonthlyDataByYearAndMonth(baseLineCountByYear, year, month, "lineCount"));
        base24hCapacityQuantities2[i] = Number.isNaN(cap) || cap === Infinity ? 0 : cap;
      }

      // 稼働日分生産個数(ベース)の計算(月別)
      for (let i = 0; i < originalLabels.length; i++) {
        // 処理中の年月を取得
        const { year, month } = getFiscalYearMonth(originalLabels, i);

        // 月別のC/Tと歩留をBOMデータから取得（なければ0）
        const cycleTimeToUse = getCycleTimeFromBom(originalLabels[i]) ?? 0;
        const yieldRateToUse = getYieldRateFromBom(originalLabels[i]) ?? 0;

        // 稼働日稼働時間(秒) = 稼働日数 * 24時間 * 3600秒
        const availabilityTime = getMonthlyDataByYearAndMonth(baseWorkingDayData, year, month, "workingDay") * 24 * 3600;
        // 生産可能個数(個) = 稼働日稼働時間(秒) / サイクルタイム(秒)
        const workingDayQuantity = Math.round(availabilityTime / cycleTimeToUse);
        // 稼働日分生産個数(個) = 生産可能個数(個) * 稼働率(%) * 歩留(%) * ライン数
        const availabilityRateToUse = getMonthlyDataByYearAndMonth(baseAvailabilityRateByMonthLocal, year, month, "availabilityRate");
        const baseWorkingDayQuantity = Math.round(workingDayQuantity * availabilityRateToUse * yieldRateToUse * getMonthlyDataByYearAndMonth(baseLineCountByYear, year, month, "lineCount"));
        // 稼働日分生産個数(ベース)配列に格納
        baseWorkingDayQuantities[i] = Number.isNaN(baseWorkingDayQuantity) || baseWorkingDayQuantity === Infinity ? 0 : baseWorkingDayQuantity;
      }

      // 休日分生産個数(ベース)の計算(月別)
      for (let i = 0; i < originalLabels.length; i++) {
        // 処理中の年月を取得
        const { year, month } = getFiscalYearMonth(originalLabels, i);

        // 月別のC/Tと歩留をBOMデータから取得（なければ0）
        const cycleTimeToUse = getCycleTimeFromBom(originalLabels[i]) ?? 0;
        const yieldRateToUse = getYieldRateFromBom(originalLabels[i]) ?? 0;

        // 休日出勤稼働時間(秒) = 休日出勤日数 * 24時間 * 3600秒
        const availabilityTime = getMonthlyDataByYearAndMonth(baseHolidayData, year, month, "holiday") * 24 * 3600;
        // 生産可能個数(個) = 休日出勤稼働時間(秒) / サイクルタイム(秒)
        const holidayQuantity = Math.round(availabilityTime / cycleTimeToUse);
        // 休日分生産個数(個) = 生産可能個数(個) * 稼働率(%) * 歩留(%) * ライン数
        const availabilityRateToUse = getMonthlyDataByYearAndMonth(baseAvailabilityRateByMonthLocal, year, month, "availabilityRate");
        const baseHolidayQuantity = Math.round(holidayQuantity * availabilityRateToUse * yieldRateToUse * getMonthlyDataByYearAndMonth(baseLineCountByYear, year, month, "lineCount"));
        // 休日分生産個数(ベース)配列に格納
        baseHolidayQuantities[i] = Number.isNaN(baseHolidayQuantity) || baseHolidayQuantity === Infinity ? 0 : baseHolidayQuantity;
      }

      // 改善分生産個数(ベース)の計算(月別): 稼働率改善分・歩留改善分・サイクル短縮分
      // 各改善分は個別の基準月を持つ。基準月が未選択/無効/生産個数0の場合はその改善分を0にする。
      let baseMonthAvailabilityRate = 0;
      let baseMonthYieldRate = 0;
      let baseMonthCycleTime = 0;

      // --- 歩留の基準月 ---
      const yieldBaseMonth = productionLine?.improvementBaseMonthYield?.replace("-", "/") || null;
      let skipYieldImprovement = !yieldBaseMonth || !originalLabels.includes(yieldBaseMonth);
      let yieldBaseMonthIdx = -1;
      if (!skipYieldImprovement) {
        yieldBaseMonthIdx = originalLabels.indexOf(yieldBaseMonth ?? "");
        if ((baseWorkingDayQuantities[yieldBaseMonthIdx] || 0) + (baseHolidayQuantities[yieldBaseMonthIdx] || 0) === 0) {
          skipYieldImprovement = true;
        } else {
          baseMonthYieldRate = getYieldRateFromBom(originalLabels[yieldBaseMonthIdx]) ?? 0;
        }
      }

      // --- 稼働率の基準月 ---
      const availabilityBaseMonth = productionLine?.improvementBaseMonthAvailability?.replace("-", "/") || null;
      let skipAvailabilityImprovement = !availabilityBaseMonth || !originalLabels.includes(availabilityBaseMonth);
      let availabilityBaseMonthIdx = -1;
      if (!skipAvailabilityImprovement) {
        availabilityBaseMonthIdx = originalLabels.indexOf(availabilityBaseMonth ?? "");
        if ((baseWorkingDayQuantities[availabilityBaseMonthIdx] || 0) + (baseHolidayQuantities[availabilityBaseMonthIdx] || 0) === 0) {
          skipAvailabilityImprovement = true;
        } else {
          const { year, month } = getFiscalYearMonth(originalLabels, availabilityBaseMonthIdx);
          baseMonthAvailabilityRate = getMonthlyDataByYearAndMonth(baseAvailabilityRateByMonthLocal, year, month, "availabilityRate");
        }
      }

      // --- サイクルタイムの基準月 ---
      const cycleTimeBaseMonth = productionLine?.improvementBaseMonthCycleTime?.replace("-", "/") || null;
      let skipCycleTimeImprovement = !cycleTimeBaseMonth || !originalLabels.includes(cycleTimeBaseMonth);
      let cycleTimeBaseMonthIdx = -1;
      if (!skipCycleTimeImprovement) {
        cycleTimeBaseMonthIdx = originalLabels.indexOf(cycleTimeBaseMonth ?? "");
        if ((baseWorkingDayQuantities[cycleTimeBaseMonthIdx] || 0) + (baseHolidayQuantities[cycleTimeBaseMonthIdx] || 0) === 0) {
          skipCycleTimeImprovement = true;
        } else {
          baseMonthCycleTime = getCycleTimeFromBom(originalLabels[cycleTimeBaseMonthIdx]) ?? 0;
        }
      }

      for (let i = 0; i < originalLabels.length; i++) {
        // 処理中の年月を取得
        const { year, month } = getFiscalYearMonth(originalLabels, i);

        // 月別のC/Tと歩留をBOMデータから取得（なければ0）
        const currentCycleTime = getCycleTimeFromBom(originalLabels[i]) ?? 0;
        const currentYieldRate = getYieldRateFromBom(originalLabels[i]) ?? 0;
        const currentAvailabilityRate = getMonthlyDataByYearAndMonth(baseAvailabilityRateByMonthLocal, year, month, "availabilityRate");
        const lineCount = getMonthlyDataByYearAndMonth(baseLineCountByYear, year, month, "lineCount");

        // 稼働日+休日出勤稼働時間(秒) = (稼働日数 + 休日出勤日数) * 24時間 * 3600秒
        const availabilityTime = (
          getMonthlyDataByYearAndMonth(baseWorkingDayData, year, month, "workingDay") +
          getMonthlyDataByYearAndMonth(baseHolidayData, year, month, "holiday"))
          * 24 * 3600;

        // 各改善の有無を判定（各改善分は独立した基準月で判定）
        const availabilityRateDiff = Number((currentAvailabilityRate - baseMonthAvailabilityRate).toFixed(3));
        const yieldRateDiff = Number((currentYieldRate - baseMonthYieldRate).toFixed(3));
        const isRateImproved = !skipAvailabilityImprovement && i > availabilityBaseMonthIdx && availabilityRateDiff > 0;
        const isYieldImproved = !skipYieldImprovement && i > yieldBaseMonthIdx && yieldRateDiff > 0;
        const isCycleTimeImproved = !skipCycleTimeImprovement && i > cycleTimeBaseMonthIdx && currentCycleTime < baseMonthCycleTime && baseMonthCycleTime > 0;

        // 他の改善がある場合は基準月の値を使用（交差項の二重計上を防止）
        const availabilityRateToUse = isRateImproved ? baseMonthAvailabilityRate : currentAvailabilityRate;
        const yieldRateToUse = isYieldImproved ? baseMonthYieldRate : currentYieldRate;
        const cycleTimeToUse = isCycleTimeImproved ? baseMonthCycleTime : currentCycleTime;

        // 稼働率改善分生産個数
        if (isRateImproved) {
          const productionQuantityForRate = cycleTimeToUse > 0 ? Math.round(availabilityTime / cycleTimeToUse) : 0;
          const baseImprovedAvailabilityQuantity = Math.round(productionQuantityForRate * availabilityRateDiff * yieldRateToUse * lineCount);
          baseImprovedAvailabilityQuantities[i] = Number.isNaN(baseImprovedAvailabilityQuantity) || baseImprovedAvailabilityQuantity === Infinity ? 0 : baseImprovedAvailabilityQuantity;
        } else {
          baseImprovedAvailabilityQuantities[i] = 0;
        }

        // 歩留改善分生産個数
        if (isYieldImproved) {
          const productionQuantityForYield = cycleTimeToUse > 0 ? Math.round(availabilityTime / cycleTimeToUse) : 0;
          const baseImprovedYieldQuantity = Math.round(productionQuantityForYield * availabilityRateToUse * yieldRateDiff * lineCount);
          baseImprovedYieldQuantities[i] = Number.isNaN(baseImprovedYieldQuantity) || baseImprovedYieldQuantity === Infinity ? 0 : baseImprovedYieldQuantity;
        } else {
          baseImprovedYieldQuantities[i] = 0;
        }

        // サイクル短縮分生産個数
        if (isCycleTimeImproved) {
          const baseProdQuantity = baseMonthCycleTime > 0 ? Math.round(availabilityTime / baseMonthCycleTime) : 0;
          const currentProdQuantity = currentCycleTime > 0 ? Math.round(availabilityTime / currentCycleTime) : 0;
          const productionQuantityDiff = currentProdQuantity - baseProdQuantity;
          const baseImprovedCycleTimeQuantity = Math.round(productionQuantityDiff * availabilityRateToUse * yieldRateToUse * lineCount);
          baseImprovedCycleTimeQuantities[i] = Number.isNaN(baseImprovedCycleTimeQuantity) || baseImprovedCycleTimeQuantity === Infinity ? 0 : baseImprovedCycleTimeQuantity;
        } else {
          baseImprovedCycleTimeQuantities[i] = 0;
        }
      }

      // 稼働日分生産個数から改善分を差し引く（積み上げグラフで二重計上を防止）
      for (let i = 0; i < originalLabels.length; i++) {
        baseWorkingDayQuantities[i] = baseWorkingDayQuantities[i]
          - baseImprovedAvailabilityQuantities[i]
          - baseImprovedYieldQuantities[i]
          - baseImprovedCycleTimeQuantities[i];
      }

      // #endregion

      // #region 設備生産数量からのギャップ（ダウンサイド）

      // ストレスシナリオを常に適用
      // 関数宣言
      const parseYearMonth = (label: string) => {
        const [y, m] = label.split("/");
        return { year: parseInt(y), month: parseInt(m) };
      };

      // プロジェクト開始年度を取得
      const { year: firstYear, month: firstMonth } = parseYearMonth(modifiedLabels[0]);
      const projectFiscalYearStart = firstMonth >= 4 ? firstYear : firstYear - 1;

      // 出荷必要見込み数(ストレス)の計算(月別)
      modifiedLabels.forEach((_, index: number) => {

        // 年月を取得 （例）{ 2025, 04 }
        const { year, month } = parseYearMonth(modifiedLabels[index]);
        // 年度を取得 （例）2025
        const fyStart = month >= 4 ? year : year - 1;
        // 年数を取得 （例）1
        const fiscalYearIndex = fyStart - projectFiscalYearStart + 1;

        // 数量をストレス指数分減少（月度単利）
        const downsindeIndex = (1 - getDownsideIndexToQuantity(fiscalYearIndex - 1, downsideIndexGraph));
        // 出荷必要見込み数(個) = 出荷必要見込み数(個) * ストレス指数
        const stressEstimatedQuantity = (baseEstimatedQuantities[index] || 0) * downsindeIndex;
        // 出荷必要見込み数(ストレス)配列に格納
        stressEstimatedQuantities[index] = (stressEstimatedQuantities[index] || 0) + stressEstimatedQuantity;

      });

      // 稼働日分生産個数(ストレス)の設定
      stressWorkingDayQuantities = baseWorkingDayQuantities;
      // 休日分生産個数(ストレス)の設定
      stressHolidayQuantities = baseHolidayQuantities;
      // 歩留改善分生産個数(ストレス)の設定
      stressImprovedYieldQuantities = baseImprovedYieldQuantities;
      // 稼働率改善分生産個数(ストレス)の設定
      stressImprovedAvailabilityQuantities = baseImprovedAvailabilityQuantities;
      // サイクル短縮分生産個数(ストレス)の設定
      stressImprovedCycleTimeQuantities = baseImprovedCycleTimeQuantities;

      // 期間をストレス指数分短縮（データのみ、ラベルは短縮しない）
      const newLength = Math.floor(modifiedLabels.length * (1 - getDownsideIndexToPeriod(downsideIndexGraph)));
      // 期間を短縮した出荷必要見込み数(ストレス)を取得
      stressEstimatedQuantities = stressEstimatedQuantities.slice(0, newLength);
      // 期間を短縮した稼働日分生産個数(ストレス)を取得
      stressWorkingDayQuantities = stressWorkingDayQuantities.slice(0, newLength);
      // 期間を短縮した休日分生産個数(ストレス)を取得
      stressHolidayQuantities = stressHolidayQuantities.slice(0, newLength);
      // 期間を短縮した歩留改善分生産個数(ストレス)を取得
      stressImprovedYieldQuantities = stressImprovedYieldQuantities.slice(0, newLength);
      // 期間を短縮した稼働率改善分生産個数(ストレス)を取得
      stressImprovedAvailabilityQuantities = stressImprovedAvailabilityQuantities.slice(0, newLength);
      // 期間を短縮したサイクル短縮分生産個数(ストレス)を取得
      stressImprovedCycleTimeQuantities = stressImprovedCycleTimeQuantities.slice(0, newLength);
      // 期間を短縮した24h稼働キャパを取得
      const stress24hCapacityQuantities2 = base24hCapacityQuantities2.slice(0, newLength);

      // #endregion

      // #region グラフデータの設定

      // 当初計画グラフ
      const original = [
        {
          type: "line",
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.requiredShipmentOriginal'),
          data: baseEstimatedQuantities,
          borderColor: "red",
          backgroundColor: "red",
          fill: false,
          tension: 0.4,
        },
        {
          type: "bar",
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.workingDayProductionOriginal'),
          data: baseWorkingDayQuantities,
          borderColor: "orange",
          backgroundColor: "orange",
          fill: false,
          tension: 0.4,
        },
        {
          type: "bar",
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.holidayProductionOriginal'),
          data: baseHolidayQuantities,
          borderColor: "gray",
          backgroundColor: "gray",
          fill: false,
          tension: 0.4,
        },
        {
          type: "bar" as const,
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.yieldImprovedProductionOriginal'),
          data: baseImprovedYieldQuantities,
          borderColor: "darkturquoise",
          backgroundColor: "darkturquoise",
          fill: false,
          tension: 0.4,
        },
        {
          type: "bar" as const,
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.availabilityImprovedProductionOriginal'),
          data: baseImprovedAvailabilityQuantities,
          borderColor: "blue",
          backgroundColor: "blue",
          fill: false,
          tension: 0.4,
        },
        {
          type: "bar" as const,
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.cycleTimeReducedProductionOriginal'),
          data: baseImprovedCycleTimeQuantities,
          borderColor: "green",
          backgroundColor: "green",
          fill: false,
          tension: 0.4,
        },
        {
          type: "line" as const,
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.full24hCapacity'),
          data: base24hCapacityQuantities2,
          borderColor: "cornflowerblue",
          backgroundColor: "cornflowerblue",
          fill: false,
          tension: 0.4,
          stack: "capacity24h",
        },
      ];

      // ダウンサイドグラフ
      const modified = [
        {
          type: "line",
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.requiredShipmentModified'),
          data: stressEstimatedQuantities,
          borderColor: "red",
          backgroundColor: "red",
          fill: false,
          tension: 0.4,
        },
        {
          type: "bar",
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.workingDayProductionModified'),
          data: stressWorkingDayQuantities,
          borderColor: "orange",
          backgroundColor: "orange",
          fill: false,
          tension: 0.4,
        },
        {
          type: "bar",
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.holidayProductionModified'),
          data: stressHolidayQuantities,
          borderColor: "gray",
          backgroundColor: "gray",
          fill: false,
          tension: 0.4,
        },
        {
          type: "bar" as const,
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.yieldImprovedProductionModified'),
          data: stressImprovedYieldQuantities,
          borderColor: "darkturquoise",
          backgroundColor: "darkturquoise",
          fill: false,
          tension: 0.4,
        },
        {
          type: "bar" as const,
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.availabilityImprovedProductionModified'),
          data: stressImprovedAvailabilityQuantities,
          borderColor: "blue",
          backgroundColor: "blue",
          fill: false,
          tension: 0.4,
        },
        {
          type: "bar" as const,
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.cycleTimeReducedProductionModified'),
          data: stressImprovedCycleTimeQuantities,
          borderColor: "green",
          backgroundColor: "green",
          fill: false,
          tension: 0.4,
        },
        {
          type: "line" as const,
          label: t('features.InvestmentScreening.SimulationNewProduct.chart.full24hCapacity'),
          data: stress24hCapacityQuantities2,
          borderColor: "cornflowerblue",
          backgroundColor: "cornflowerblue",
          fill: false,
          tension: 0.4,
          stack: "capacity24h",
        },
      ];

      // グラフデータの設定
      // ダウンサイドグラフを更新
      setProductionQuantityChartDataOriginal({
        labels: originalLabels,
        datasets: original,
      });
      setProductionQuantityChartDataModified({
        labels: originalLabels,  // 全期間のラベルを使用
        datasets: modified,
      });

      // 選択されている保存済み設定グラフも更新（各設定の改善データを使用）
      if (selectedConfigIds.length > 0) {
        selectedConfigIds.forEach(configId => {
          const config = savedConfigs.find(c => c.id === configId);
          if (config) {
            const configApplyDownside = config.applyDownside !== false;
            const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;
            let savedStressQuantities = configApplyDownside ? stressEstimatedQuantities : baseEstimatedQuantities;

            if (config.quantityAndPrice.length > 0) {
              // 出荷必要見込み数を再設定
              savedStressQuantities = [];
              const converted = convertToOriginalProfitAndLossByMonthTable(config.quantityAndPrice);
              // 変更PartNoのみ保存されるため、originalと結合して全PartNoを含める
              const mergedQuantityByPartNo = {
                ...originalProfitAndLossByMonth!.quantityByPartNo,
                ...converted.quantityByPartNo,
              };

              const savedQuantities: number[] = [];

              // 出荷必要見込み数(ベース)の計算(月別)
              Object.values(mergedQuantityByPartNo).forEach(part => {
                part.forEach((value, index) => {
                  // 販売個数(個) = 販売個数(個)
                  const baseQuantity = Number(value || 0);

                  // 販売個数(ベース)配列に格納
                  savedQuantities[index] = (savedQuantities[index] || 0) + baseQuantity;
                });
              });

              // 出荷必要見込み数(ストレス)の計算(月別)
              modifiedLabels.forEach((_, index: number) => {

                // 年月を取得 （例）{ 2025, 04 }
                const { year, month } = parseYearMonth(modifiedLabels[index]);
                // 年度を取得 （例）2025
                const fyStart = month >= 4 ? year : year - 1;
                // 年数を取得 （例）1
                const fiscalYearIndex = fyStart - projectFiscalYearStart + 1;

                // 数量をストレス指数分減少（月度単利）
                const downsindeIndex = (1 - getDownsideIndexToQuantity(fiscalYearIndex - 1, configDownsideIndex));
                // 出荷必要見込み数(個) = 出荷必要見込み数(個) * ストレス指数
                const stressQuantity = (savedQuantities[index] || 0) * downsindeIndex;
                // 出荷必要見込み数(ベース)配列に格納
                savedStressQuantities[index] = (savedStressQuantities[index] || 0) + stressQuantity;
              });
            }

            // この設定の改善データを取得
            const savedConfigWorkingDayData = config.improvedWorkingDayByYear;
            const savedConfigLineCountData = config.improvedLineCountByYear;
            const savedConfigHolidayData = config.improvedHolidayByYear;
            const savedConfigAvailabilityData = config.improvedAvailabilityRateByMonth;
            const savedConfigYieldRateList = config.improvedYieldRateList || [];
            const savedConfigCycleTimeList = config.improvedCycleTimeList || [];
            // 工場稼働日数（保存済み設定）
            const savedConfigFactoryWorkingDayData = (config.improvedWorkingDaysData || []).map(wd => ({
              fiscalYear: wd.fiscalYear,
              workingDay: wd.workingDaysData?.factoryWorkingDays || [],
            }));

            // 稼働率データをローカル変数にコピー
            const savedConfigAvailabilityRateByMonthLocal: { fiscalYear: string, availabilityRate: number[] }[] = [];
            for (let i = 0; i < savedConfigAvailabilityData.length; i++) {
              savedConfigAvailabilityRateByMonthLocal.push({
                fiscalYear: savedConfigAvailabilityData[i]?.fiscalYear || `Unknown Fiscal Year ${i}`,
                availabilityRate: savedConfigAvailabilityData[i]?.availabilityRate || [],
              });
            }

            // 配列初期化
            const savedConfigWorkingDayQuantities: number[] = [];
            const savedConfigHolidayQuantities: number[] = [];
            const savedConfigImprovedYieldQuantities: number[] = [];
            const savedConfigImprovedAvailabilityQuantities: number[] = [];
            const savedConfigImprovedCycleTimeQuantities: number[] = [];

            // 稼働日分生産個数の計算
            for (let i = 0; i < originalLabels.length; i++) {
              const { year, month } = getFiscalYearMonth(originalLabels, i);
              const availabilityTime = getMonthlyDataByYearAndMonth(savedConfigWorkingDayData, year, month, "workingDay") * 24 * 3600;
              const lineCount = getMonthlyDataByYearAndMonth(savedConfigLineCountData, year, month, "lineCount");
              const applicableCycleTime = getApplicableCycleTime(originalLabels[i], savedConfigCycleTimeList, getCycleTimeFromBom);
              const applicableYieldRate = getApplicableYieldRate(originalLabels[i], savedConfigYieldRateList, getYieldRateFromBom);

              // 稼働率の差分を確認
              const savedConfigAvailabilityRate = getMonthlyDataByYearAndMonth(savedConfigAvailabilityRateByMonthLocal, year, month, "availabilityRate");
              const baseAvailabilityRate = getMonthlyDataByYearAndMonth(baseAvailabilityRateByMonthLocal, year, month, "availabilityRate");
              const availabilityRateDiff = savedConfigAvailabilityRate - baseAvailabilityRate;

              // 稼働率が増えた場合はbase稼働率を使用、減った場合は改善後稼働率を使用
              const availabilityRateToUse = availabilityRateDiff > 0 ? baseAvailabilityRate : savedConfigAvailabilityRate;

              // 歩留の差分を確認
              const bomYieldRate = getYieldRateFromBom(originalLabels[i]) ?? 0;
              const yieldRateDiff = applicableYieldRate - bomYieldRate;

              // 歩留が増えた場合はBOM歩留を使用、減った場合は改善後歩留を使用
              const yieldRateToUse = yieldRateDiff > 0 ? bomYieldRate : applicableYieldRate;

              // サイクルタイムの差分を確認（短縮=改善）
              const bomCycleTime = getCycleTimeFromBom(originalLabels[i]) ?? 0;
              const cycleTimeDiff = applicableCycleTime - bomCycleTime;

              // サイクルタイムが短縮（改善）した場合はBOM C/Tを使用、増加した場合は改善後C/Tを使用
              const cycleTimeToUse = cycleTimeDiff < 0 ? bomCycleTime : applicableCycleTime;

              const workingDayQuantity = Math.round(availabilityTime / cycleTimeToUse);
              const savedConfigWorkingDayQuantity = Math.round(workingDayQuantity * availabilityRateToUse * yieldRateToUse * lineCount);
              savedConfigWorkingDayQuantities[i] = Number.isNaN(savedConfigWorkingDayQuantity) || savedConfigWorkingDayQuantity === Infinity ? 0 : savedConfigWorkingDayQuantity;
            }

            // 休日分生産個数の計算
            for (let i = 0; i < originalLabels.length; i++) {
              const { year, month } = getFiscalYearMonth(originalLabels, i);
              const availabilityTime = getMonthlyDataByYearAndMonth(savedConfigHolidayData, year, month, "holiday") * 24 * 3600;
              const lineCount = getMonthlyDataByYearAndMonth(savedConfigLineCountData, year, month, "lineCount");
              const applicableCycleTime = getApplicableCycleTime(originalLabels[i], savedConfigCycleTimeList, getCycleTimeFromBom);
              const applicableYieldRate = getApplicableYieldRate(originalLabels[i], savedConfigYieldRateList, getYieldRateFromBom);

              // 稼働率の差分を確認
              const savedConfigAvailabilityRate = getMonthlyDataByYearAndMonth(savedConfigAvailabilityRateByMonthLocal, year, month, "availabilityRate");
              const baseAvailabilityRate = getMonthlyDataByYearAndMonth(baseAvailabilityRateByMonthLocal, year, month, "availabilityRate");
              const availabilityRateDiff = savedConfigAvailabilityRate - baseAvailabilityRate;

              // 稼働率が増えた場合はbase稼働率を使用、減った場合は改善後稼働率を使用
              const availabilityRateToUse = availabilityRateDiff > 0 ? baseAvailabilityRate : savedConfigAvailabilityRate;

              // 歩留の差分を確認
              const bomYieldRate = getYieldRateFromBom(originalLabels[i]) ?? 0;
              const yieldRateDiff = applicableYieldRate - bomYieldRate;

              // 歩留が増えた場合はBOM歩留を使用、減った場合は改善後歩留を使用
              const yieldRateToUse = yieldRateDiff > 0 ? bomYieldRate : applicableYieldRate;

              // サイクルタイムの差分を確認（短縮=改善）
              const bomCycleTime = getCycleTimeFromBom(originalLabels[i]) ?? 0;
              const cycleTimeDiff = applicableCycleTime - bomCycleTime;

              // サイクルタイムが短縮（改善）した場合はBOM C/Tを使用、増加した場合は改善後C/Tを使用
              const cycleTimeToUse = cycleTimeDiff < 0 ? bomCycleTime : applicableCycleTime;

              const holidayQuantity = Math.round(availabilityTime / cycleTimeToUse);
              const savedConfigHolidayQuantity = Math.round(holidayQuantity * availabilityRateToUse * yieldRateToUse * lineCount);
              savedConfigHolidayQuantities[i] = Number.isNaN(savedConfigHolidayQuantity) || savedConfigHolidayQuantity === Infinity ? 0 : savedConfigHolidayQuantity;
            }

            // 稼働率改善分生産個数の計算
            for (let i = 0; i < originalLabels.length; i++) {
              const { year, month } = getFiscalYearMonth(originalLabels, i);
              const applicableYieldRate = getApplicableYieldRate(originalLabels[i], savedConfigYieldRateList, getYieldRateFromBom);
              const applicableCycleTime = getApplicableCycleTime(originalLabels[i], savedConfigCycleTimeList, getCycleTimeFromBom);
              const lineCount = getMonthlyDataByYearAndMonth(savedConfigLineCountData, year, month, "lineCount");
              const availabilityTime = (
                getMonthlyDataByYearAndMonth(savedConfigWorkingDayData, year, month, "workingDay") +
                getMonthlyDataByYearAndMonth(savedConfigHolidayData, year, month, "holiday"))
                * 24 * 3600;

              // サイクルタイムの差分を確認（短縮=改善）
              const bomCycleTime = getCycleTimeFromBom(originalLabels[i]) ?? 0;
              const cycleTimeDiff = applicableCycleTime - bomCycleTime;

              // サイクルタイムが短縮（改善）した場合はBOM C/Tを使用、増加した場合は改善後C/Tを使用
              const cycleTimeToUse = cycleTimeDiff < 0 ? bomCycleTime : applicableCycleTime;

              const productionQuantity = Math.round(availabilityTime / cycleTimeToUse);
              const availabilityRateDiff = Number((
                getMonthlyDataByYearAndMonth(savedConfigAvailabilityRateByMonthLocal, year, month, "availabilityRate") -
                getMonthlyDataByYearAndMonth(baseAvailabilityRateByMonthLocal, year, month, "availabilityRate")
              ).toFixed(3));

              // 歩留の差分を確認
              const bomYieldRate = getYieldRateFromBom(originalLabels[i]) ?? 0;
              const yieldRateDiff = applicableYieldRate - bomYieldRate;

              // 歩留が増えた場合はBOM歩留を使用、減った場合は改善後歩留を使用
              const yieldRateToUse = yieldRateDiff > 0 ? bomYieldRate : applicableYieldRate;

              // 稼働率が増えた場合のみ稼働率改善分として計上、減った場合は0
              const savedConfigImprovedAvailabilityQuantity = availabilityRateDiff > 0
                ? Math.round(productionQuantity * availabilityRateDiff * yieldRateToUse * lineCount)
                : 0;
              savedConfigImprovedAvailabilityQuantities[i] = Number.isNaN(savedConfigImprovedAvailabilityQuantity) || savedConfigImprovedAvailabilityQuantity === Infinity ? 0 : savedConfigImprovedAvailabilityQuantity;
            }

            // 歩留改善分生産個数の計算
            for (let i = 0; i < originalLabels.length; i++) {
              const { year, month } = getFiscalYearMonth(originalLabels, i);
              const applicableYieldRate = getApplicableYieldRate(originalLabels[i], savedConfigYieldRateList, getYieldRateFromBom);
              const applicableCycleTime = getApplicableCycleTime(originalLabels[i], savedConfigCycleTimeList, getCycleTimeFromBom);
              const lineCount = getMonthlyDataByYearAndMonth(savedConfigLineCountData, year, month, "lineCount");
              const availabilityTime = (
                getMonthlyDataByYearAndMonth(savedConfigWorkingDayData, year, month, "workingDay") +
                getMonthlyDataByYearAndMonth(savedConfigHolidayData, year, month, "holiday"))
                * 24 * 3600;

              // 稼働率の差分を確認
              const savedConfigAvailabilityRate = getMonthlyDataByYearAndMonth(savedConfigAvailabilityRateByMonthLocal, year, month, "availabilityRate");
              const baseAvailabilityRate = getMonthlyDataByYearAndMonth(baseAvailabilityRateByMonthLocal, year, month, "availabilityRate");
              const availabilityRateDiff = savedConfigAvailabilityRate - baseAvailabilityRate;

              // 稼働率が増えた場合はbase稼働率を使用、減った場合は改善後稼働率を使用
              const availabilityRateToUse = availabilityRateDiff > 0 ? baseAvailabilityRate : savedConfigAvailabilityRate;

              // サイクルタイムの差分を確認（短縮=改善）
              const bomCycleTime = getCycleTimeFromBom(originalLabels[i]) ?? 0;
              const cycleTimeDiff = applicableCycleTime - bomCycleTime;

              // サイクルタイムが短縮（改善）した場合はBOM C/Tを使用、増加した場合は改善後C/Tを使用
              const cycleTimeToUse = cycleTimeDiff < 0 ? bomCycleTime : applicableCycleTime;

              const productionQuantity = Math.round(availabilityTime / cycleTimeToUse);

              // BOM歩留との差分を計算
              const bomYieldRate = getYieldRateFromBom(originalLabels[i]) ?? 0;
              const yieldRateDiff = Number((applicableYieldRate - bomYieldRate).toFixed(3));

              // 歩留が増えた場合のみ歩留改善分として計上、減った場合は0
              const hasImprovement = applicableYieldRate > bomYieldRate;
              const improvedYieldQuantity = hasImprovement
                ? Math.round(productionQuantity * availabilityRateToUse * yieldRateDiff * lineCount)
                : 0;
              savedConfigImprovedYieldQuantities[i] = Number.isNaN(improvedYieldQuantity) || improvedYieldQuantity === Infinity ? 0 : improvedYieldQuantity;
            }

            // サイクル短縮分生産個数の計算
            for (let i = 0; i < originalLabels.length; i++) {
              const { year, month } = getFiscalYearMonth(originalLabels, i);
              const applicableYieldRate = getApplicableYieldRate(originalLabels[i], savedConfigYieldRateList, getYieldRateFromBom);
              const applicableCycleTime = getApplicableCycleTime(originalLabels[i], savedConfigCycleTimeList, getCycleTimeFromBom);
              const lineCount = getMonthlyDataByYearAndMonth(savedConfigLineCountData, year, month, "lineCount");
              const availabilityTime = (
                getMonthlyDataByYearAndMonth(savedConfigWorkingDayData, year, month, "workingDay") +
                getMonthlyDataByYearAndMonth(savedConfigHolidayData, year, month, "holiday"))
                * 24 * 3600;

              // 稼働率の差分を確認
              const savedConfigAvailabilityRate = getMonthlyDataByYearAndMonth(savedConfigAvailabilityRateByMonthLocal, year, month, "availabilityRate");
              const baseAvailabilityRate = getMonthlyDataByYearAndMonth(baseAvailabilityRateByMonthLocal, year, month, "availabilityRate");
              const availabilityRateDiff = savedConfigAvailabilityRate - baseAvailabilityRate;

              // 稼働率が増えた場合はbase稼働率を使用、減った場合は改善後稼働率を使用
              const availabilityRateToUse = availabilityRateDiff > 0 ? baseAvailabilityRate : savedConfigAvailabilityRate;

              // BOMサイクルタイムとの差分を計算
              const bomCycleTime = getCycleTimeFromBom(originalLabels[i]) ?? 0;
              const productionQuantity = Math.round(availabilityTime / bomCycleTime);
              const improvedProductionQuantity = Math.round(availabilityTime / applicableCycleTime);
              const productionQuantityDiff = improvedProductionQuantity - productionQuantity;

              // 歩留の差分を確認
              const bomYieldRate = getYieldRateFromBom(originalLabels[i]) ?? 0;
              const yieldRateDiff = applicableYieldRate - bomYieldRate;

              // 歩留が増えた場合はBOM歩留を使用、減った場合は改善後歩留を使用
              const yieldRateToUse = yieldRateDiff > 0 ? bomYieldRate : applicableYieldRate;

              // サイクルタイムが短縮（改善）した場合のみサイクル短縮分として計上、増加した場合は0
              const hasCycleTimeImprovement = applicableCycleTime < bomCycleTime;
              const improvedCycleTimeQuantity = hasCycleTimeImprovement
                ? Math.round(productionQuantityDiff * availabilityRateToUse * yieldRateToUse * lineCount)
                : 0;
              savedConfigImprovedCycleTimeQuantities[i] = Number.isNaN(improvedCycleTimeQuantity) || improvedCycleTimeQuantity === Infinity ? 0 : improvedCycleTimeQuantity;
            }

            // 設定ごとの期間短縮長を決定（ストレスOFF時は全期間）
            const configNewLength = configApplyDownside ? newLength : modifiedLabels.length;

            // 24h稼働キャパ(保存済み設定)の計算 = 工場稼働日数 × 86400 / CT × 歩留 × ライン数
            const savedConfig24hCapacityQuantities2: number[] = [];
            for (let i = 0; i < originalLabels.length; i++) {
              const { year, month } = getFiscalYearMonth(originalLabels, i);
              const ct = getApplicableCycleTime(originalLabels[i], savedConfigCycleTimeList, getCycleTimeFromBom);
              const yr = getApplicableYieldRate(originalLabels[i], savedConfigYieldRateList, getYieldRateFromBom);
              const fwd = savedConfigFactoryWorkingDayData.length > 0
                ? getMonthlyDataByYearAndMonth(savedConfigFactoryWorkingDayData, year, month, "workingDay")
                : getMonthlyDataByYearAndMonth(factoryWorkingDayByYear, year, month, "workingDay");
              const rawQty = ct > 0 ? Math.round(fwd * 86400 / ct) : 0;
              const cap = Math.round(rawQty * yr * getMonthlyDataByYearAndMonth(savedConfigLineCountData, year, month, "lineCount"));
              savedConfig24hCapacityQuantities2[i] = Number.isNaN(cap) || cap === Infinity ? 0 : cap;
            }

            // 保存済み設定用グラフデータセット（改善分を含む、データを期間短縮）
            const savedConfigModified = [
              {
                type: "line",
                label: t('features.InvestmentScreening.SimulationNewProduct.chart.requiredShipmentModified'),
                data: savedStressQuantities.slice(0, configNewLength),  // 期間短縮
                borderColor: "red",
                backgroundColor: "red",
                fill: false,
                tension: 0.4,
              },
              {
                type: "bar",
                label: t('features.InvestmentScreening.SimulationNewProduct.chart.workingDayProductionModified'),
                data: savedConfigWorkingDayQuantities.slice(0, configNewLength),  // 期間短縮
                borderColor: "orange",
                backgroundColor: "orange",
                fill: false,
                tension: 0.4,
              },
              {
                type: "bar",
                label: t('features.InvestmentScreening.SimulationNewProduct.chart.holidayProductionModified'),
                data: savedConfigHolidayQuantities.slice(0, configNewLength),  // 期間短縮
                borderColor: "gray",
                backgroundColor: "gray",
                fill: false,
                tension: 0.4,
              },
              {
                type: "bar" as const,
                label: t('features.InvestmentScreening.SimulationNewProduct.chart.yieldImprovedProductionModified'),
                data: savedConfigImprovedYieldQuantities.slice(0, configNewLength),  // 期間短縮
                borderColor: "darkturquoise",
                backgroundColor: "darkturquoise",
                fill: false,
                tension: 0.4,
              },
              {
                type: "bar" as const,
                label: t('features.InvestmentScreening.SimulationNewProduct.chart.availabilityImprovedProductionModified'),
                data: savedConfigImprovedAvailabilityQuantities.slice(0, configNewLength),  // 期間短縮
                borderColor: "blue",
                backgroundColor: "blue",
                fill: false,
                tension: 0.4,
              },
              {
                type: "bar" as const,
                label: t('features.InvestmentScreening.SimulationNewProduct.chart.cycleTimeReducedProductionModified'),
                data: savedConfigImprovedCycleTimeQuantities.slice(0, configNewLength),  // 期間短縮
                borderColor: "green",
                backgroundColor: "green",
                fill: false,
                tension: 0.4,
              },
              {
                type: "line" as const,
                label: t('features.InvestmentScreening.SimulationNewProduct.chart.full24hCapacity'),
                data: savedConfig24hCapacityQuantities2.slice(0, configNewLength),  // 期間短縮
                borderColor: "cornflowerblue",
                backgroundColor: "cornflowerblue",
                fill: false,
                tension: 0.4,
                stack: "capacity24h",
              },
            ];

            setProductionQuantityChartDataForSavedConfig(prev => {
              const filtered = prev.filter(item => item.configId !== configId);
              return [...filtered, {
                configId, data: {
                  labels: originalLabels,  // 全期間のラベルを使用
                  datasets: savedConfigModified,
                }
              }];
            });
          }
        });
      }

      // #endregion

    }

  }, [
    originalProfitAndLossByMonth,
    workingDayByYear,
    holidayByYear,
    availabilityRateByMonth,
    selectedCustomerProduct,
    downsideIndexGraph,
    selectedConfigIds,
    savedConfigs,
    bomData,
    productionLine,
    factoryWorkingDayByYear,
    neutralDownsideIndex,
  ]);

  /**
   * ストレス指数（グラフ用）を更新
   * 注：downsideIndexまたはdownsideIndexEnableが更新されたとき（onChange/onBlur時を含む）に実行
   */
  useEffect(() => {
    // 初期化が完了していない場合は処理を抜ける
    if (!downsideIndex ||
      (Array.isArray(downsideIndex.quantityChangeOverTime) &&
        downsideIndex.quantityChangeOverTime.length === 0 &&
        Array.isArray(downsideIndex.quantityFluctuation) &&
        downsideIndex.quantityFluctuation.length === 0)) {
      return;
    }

    // ストレス指数（グラフ用）を更新
    setDownsideIndexGraph({
      // 数量経時変化
      quantityChangeOverTime: downsideIndexEnable.isEnabledQuantityChangeOverTime ? [...downsideIndex.quantityChangeOverTime] : [],
      // 数量上下変動
      quantityFluctuation: downsideIndexEnable.isEnabledFluctuationInQuantity ? [...downsideIndex.quantityFluctuation] : [],
      // 単価経時変化
      priceChangeOverTime: downsideIndexEnable.isEnabledPriceChangeOverTime ? [...downsideIndex.priceChangeOverTime] : [],
      // 顧客製品寿命（正の値は無視し、負の値のみ有効）
      customerProductLifecycle: downsideIndexEnable.isEnabledCustomerProductLifecycle && downsideIndex.customerProductLifecycle < 0
        ? downsideIndex.customerProductLifecycle
        : 0,
      // 為替変動（単価）
      exchangeRateFluctuationToPrice: downsideIndexEnable.isEnabledCurrencyFluctuationToPrice ? [...downsideIndex.exchangeRateFluctuationToPrice] : [],
      // 為替変動（原価）
      exchangeRateFluctuationToCost: downsideIndexEnable.isEnabledCurrencyFluctuationToCost ? [...downsideIndex.exchangeRateFluctuationToCost] : [],
      // 材料高騰
      materialCostIncrease: downsideIndexEnable.isEnabledRisingMaterialCosts ? [...downsideIndex.materialCostIncrease] : [],
      // 労務費高騰
      laborCostIncrease: downsideIndexEnable.isEnabledRisingLaborCosts ? [...downsideIndex.laborCostIncrease] : [],
      // 競合状態（数量）
      competitorStatusToQuantity: downsideIndexEnable.isEnabledCompetitorConditionToQuantity ? [...downsideIndex.competitorStatusToQuantity] : [],
      // 競合状態（単価）
      competitorStatusToPrice: downsideIndexEnable.isEnabledCompetitorConditionToPrice ? [...downsideIndex.competitorStatusToPrice] : [],
    });
  }, [downsideIndex, downsideIndexEnable]);

  // ❸ (任意) レンダリング部に「combinedChartDataModified」があればグラフを表示
  combinedChartDataModified && (
    <Box mt={4}>
      <Heading size="md" mb={2}>
        回収チャート (Modified)
      </Heading>
      <Chart
        type="bar"
        data={combinedChartDataModified}
        options={{
          plugins: {
            tooltip: { enabled: true },
          },
          scales: {
            x: { stacked: true },
            y: { stacked: true },
          },
        }}
      />
    </Box>
  )

  /**
   * スケール算出
   * @param data1 当初計画データ
   * @param data2 ダウンサイドデータ
   * @param isMinZero true：最小値を0とする。false：data1とdata2の最小値
   * @returns
   */
  const computeCommonScale = (data1: any, data2: any, isMinZero: boolean) => {
    const allData = [
      ...data1.datasets.flatMap((ds: any) => ds.data.filter((v: any) => v !== null)),
      ...data2.datasets.flatMap((ds: any) => ds.data.filter((v: any) => v !== null))
    ];
    const commonLabels = data1.labels.length >= data2.labels.length ? data1.labels : data2.labels;
    const { yMin, yMax } = calcYAxisRange(allData, isMinZero);
    return { yMin, yMax, commonLabels };
  };

  /**
   * タイプがlineのものを表示する。
   * @param chart チャート
   * @returns ラベル
   */
  const generateLabels = (chart: any): LegendItem[] => {
    return chart.data.datasets.filter((dataset: any) => dataset.type === "line").map((dataset: any, index: number) => {
      return {
        text: dataset.label,
        fillStyle: dataset.backgroundColor,
        strokeStyle: dataset.borderColor,
        hidden: !chart.isDatasetVisible(index),
        datasetIndex: index,
      }
    });
  }

  /**
   * ストレス指数の初期化（新規）
   * M_CEAS_DOWNSIDE_INDEXのitemIdに紐づくストレス指数値(stressIndex)を設定する
   * 
   * @param {DownsideIndexType[]} mDownsideIndex M_CEAS_DOWNSIDE_INDEX データ
   * @param {PricingAgreementFormType} agreement T_CEAS_PROJECT 顧客取り決め事項
   * @returns {void} なし
   */
  const setInitialDownsideIndexDisplayNew = (mDownsideIndex: DownsideIndexType[], agreement: PricingAgreementFormType): void => {

    // M_CEAS_DOWNSIDE_INDEX データが空の場合は処理を抜ける
    if (!mDownsideIndex || mDownsideIndex.length === 0) {
      return;
    }

    // 競合状態の判定
    let competitorStatusToQuantityDownsideId = "";
    let competitorStatusToPriceDownsideId = "";
    const competitor = agreement?.competitor;
    if (competitor?.competitorType === competitorType.Competitor.value) {
      // 競合ありの場合
      switch (competitor.competitiorCondition) {
        case competitiorCondition.TopRank.value:
          // 競合1番手の場合
          competitorStatusToQuantityDownsideId = DownsideItems.competitorStatus1stToQuantity.downsideId;
          competitorStatusToPriceDownsideId = DownsideItems.competitorStatus1stToPrice.downsideId;
          break;
        case competitiorCondition.LowerRank.value:
          // 競合2番手の場合
          competitorStatusToQuantityDownsideId = DownsideItems.competitorStatus2ndToQuantity.downsideId;
          competitorStatusToPriceDownsideId = DownsideItems.competitorStatus2ndToPrice.downsideId;
          break;
      }
    } else {
      // 競合なしの場合
      competitorStatusToQuantityDownsideId = DownsideItems.competitorStatusNoToQuantity.downsideId;
      competitorStatusToPriceDownsideId = DownsideItems.competitorStatusNoToToPrice.downsideId;
    }

    // 関数宣言
    const processDownsideIndex = (
      mDownsideIndex: DownsideIndexType[],
      itemId: string
    ): string => {

      // 関数宣言
      function formatStressIndex(index: number): string {
        return index > 0 ? `+${index}` : `${index}`;
      }

      // 変数宣言
      let downsideIndexString = t('features.InvestmentScreening.SimulationNewProduct.label.none');

      // itemIdが無効の場合は処理を抜ける
      if (!itemId) return downsideIndexString;

      // ストレス指数を取得
      const stressIndex = mDownsideIndex
        .filter(record => record.itemId === itemId)               // 項目IDが一致
        .sort((a, b) => (a.yearIndex || 0) - (b.yearIndex || 0))  // 年数昇順で並び替え
        .map(record => record.stressIndex ?? 0)[0];               // ストレス指数を返却

      // ストレス指数（画面表示用）を取得
      if (
        itemId === DownsideItems.quantityChangeOverTime.downsideId ||
        itemId === DownsideItems.customerProductLifecycle.downsideId
      ) {
        // 数量経時変化
        // 顧客製品寿命
        downsideIndexString = `当初計画比${formatStressIndex(stressIndex)}%`;
      } else if (
        itemId === DownsideItems.priceChangeOverTime.downsideId ||
        itemId === DownsideItems.materialCostIncrease.downsideId ||
        itemId === DownsideItems.laborCostIncrease.downsideId
      ) {
        // 単価経時変化
        // 材料高騰
        // 労務費高騰
        downsideIndexString = `年間${formatStressIndex(stressIndex)}%`;
      } else if (
        itemId === DownsideItems.competitorStatus1stToQuantity.downsideId ||
        itemId === DownsideItems.competitorStatus1stToPrice.downsideId ||
        itemId === DownsideItems.competitorStatus2ndToQuantity.downsideId ||
        itemId === DownsideItems.competitorStatus2ndToQuantity.downsideId
      ) {
        // 競合状態（数量）（1番手）
        // 競合状態（単価）（1番手）
        // 競合状態（数量）（2番手）
        // 競合状態（単価）（2番手）
        downsideIndexString = `${competitor.competitiorCondition === competitiorCondition.TopRank.value ? competitiorCondition.TopRank.name : competitiorCondition.LowerRank.name}${formatStressIndex(stressIndex)}%`;
      } else if (
        itemId === DownsideItems.competitorStatusNoToQuantity.downsideId ||
        itemId === DownsideItems.competitorStatusNoToToPrice.downsideId
      ) {
        // 競合状態（数量）（競合なし）
        // 競合状態（単価）（競合なし）
        downsideIndexString = `${competitorType.NoCompetitor.name}${formatStressIndex(stressIndex)}%`;
      } else {
        // 数量上下変動 TODO 2025/8/4の週に菅原様から情報提供あり
        // 為替変動（単価） TODO 保留
        // 為替変動（原価） TODO 保留
        downsideIndexString = `なし`;
      }

      // ストレス指数を返却
      return downsideIndexString;

    };

    // 変数宣言
    const itemsToProcess = [
      { key: "quantityChangeOverTimeString", id: DownsideItems.quantityChangeOverTime.downsideId },                         // 数量経時変化
      { key: "fluctuationInQuantityString", id: DownsideItems.quantityFluctuation.downsideId },                             // 数量上下変動 TODO 2025/8/4の週に菅原様から情報提供あり
      { key: "priceChangeOverTimeString", id: DownsideItems.priceChangeOverTime.downsideId },                               // 単価経時変化
      { key: "customerProductLifecycleString", id: DownsideItems.customerProductLifecycle.downsideId },                     // 顧客製品寿命
      { key: "currencyFluctuationString", id: DownsideItems.exchangeRateFluctuationToPrice.downsideId },                    // 為替変動（単価） TODO 保留
      { key: "", id: DownsideItems.exchangeRateFluctuationToCost.downsideId },                                              // 為替変動（原価） TODO 保留
      { key: "risingMaterialCostsString", id: DownsideItems.materialCostIncrease.downsideId },                              // 材料高騰
      { key: "risingLaborCostsString", id: DownsideItems.laborCostIncrease.downsideId },                                    // 労務費高騰
      { key: "competitorConditionString", id: competitorStatusToQuantityDownsideId || competitorType.NoCompetitor.value },  // 競合状態（数量）
      { key: "", id: competitorStatusToPriceDownsideId || competitorType.NoCompetitor.value },                              // 競合状態（単価）
    ];

    // ストレス指数（画面表示用）の初期化
    itemsToProcess.forEach(({ key, id }) => {
      const processedData = processDownsideIndex(mDownsideIndex, id);
      updateDownsideIndexDisplay(key, processedData);
    });

  }

  /**
   * ストレス指数の初期化（更新）
   * T_CEAS_PROJECTから取得したダウンサイド指数(downsideIndex)の
   * itemIdに紐づくストレス指数値(stressIndex)を設定する
   * 
   * @param {DownsideIndexType[]} mDownsideIndex T_CEAS_PROJECT ダウンサイド指数(downsideIndex)データ
   * @param {PricingAgreementFormType} agreement T_CEAS_PROJECT 顧客取り決め事項
   * @returns {void} なし
   */
  const setInitialDownsideIndexDisplay = (mDownsideIndex: DownsideIndexType[], agreement: PricingAgreementFormType): void => {

    // M_CEAS_DOWNSIDE_INDEX データが空の場合は処理を抜ける
    if (!mDownsideIndex || mDownsideIndex.length === 0) {
      return;
    }

    // 競合状態の判定
    let competitorStatusToQuantityId = "";
    let competitorStatusToPriceId = "";
    const competitor = agreement?.competitor;
    if (competitor?.competitorType === competitorType.Competitor.value) {
      // 競合ありの場合
      switch (competitor.competitiorCondition) {
        case competitiorCondition.TopRank.value:
          // 競合1番手の場合
          competitorStatusToQuantityId = DownsideItems.competitorStatus1stToQuantity.id;
          competitorStatusToPriceId = DownsideItems.competitorStatus1stToPrice.id;
          break;
        case competitiorCondition.LowerRank.value:
          // 競合2番手の場合
          competitorStatusToQuantityId = DownsideItems.competitorStatus2ndToQuantity.id;
          competitorStatusToPriceId = DownsideItems.competitorStatus2ndToPrice.id;
          break;
      }
    } else {
      // 競合なしの場合
      competitorStatusToQuantityId = DownsideItems.competitorStatusNoToQuantity.id;
      competitorStatusToPriceId = DownsideItems.competitorStatusNoToToPrice.id;
    }

    // 関数宣言
    const processDownsideIndex = (
      mDownsideIndex: DownsideIndexType[],
      itemId: string
    ): string => {

      // 関数宣言
      function formatStressIndex(index: number): string {
        return index > 0 ? `+${index}` : `${index}`;
      }

      // 変数宣言
      let downsideIndexString = t('features.InvestmentScreening.SimulationNewProduct.label.none');

      // itemIdが無効の場合は処理を抜ける
      if (!itemId) return downsideIndexString;

      // ストレス指数を取得
      const stressIndex = mDownsideIndex
        .filter(record => record.itemId === itemId)               // 項目IDが一致
        .sort((a, b) => (a.yearIndex || 0) - (b.yearIndex || 0))  // 年数昇順で並び替え
        .map(record => record.stressIndex ?? 0)[0];               // ストレス指数を返却

      // ストレス指数（画面表示用）を取得
      if (
        itemId === DownsideItems.quantityChangeOverTime.id ||
        itemId === DownsideItems.customerProductLifecycle.id
      ) {
        // 数量経時変化
        // 顧客製品寿命
        downsideIndexString = `当初計画比${formatStressIndex(stressIndex)}%`;
      } else if (
        itemId === DownsideItems.priceChangeOverTime.id ||
        itemId === DownsideItems.materialCostIncrease.id ||
        itemId === DownsideItems.laborCostIncrease.id
      ) {
        // 単価経時変化
        // 材料高騰
        // 労務費高騰
        downsideIndexString = `年間${formatStressIndex(stressIndex)}%`;
      } else if (
        itemId === competitorStatusToQuantityId ||
        itemId === competitorStatusToPriceId
      ) {
        // 競合状態（数量）
        // 競合状態（単価）
        if (competitor?.competitorType === competitorType.Competitor.value) {
          // 競合ありの場合
          downsideIndexString = `${competitor.competitiorCondition === competitiorCondition.TopRank.value ? competitiorCondition.TopRank.name : competitiorCondition.LowerRank.name}${formatStressIndex(stressIndex)}%`;
        } else {
          // 競合なしの場合
          downsideIndexString = `${competitorType.NoCompetitor.name}${formatStressIndex(stressIndex)}%`;
        }
      } else {
        // 数量上下変動 TODO 2025/8/4の週に菅原様から情報提供あり
        // 為替変動（単価） TODO 保留
        // 為替変動（原価） TODO 保留
        downsideIndexString = `なし`;
      }

      // ストレス指数を返却
      return downsideIndexString;

    };

    // 変数宣言
    const itemsToProcess = [
      { key: "quantityChangeOverTimeString", id: DownsideItems.quantityChangeOverTime.id },                         // 数量経時変化
      { key: "fluctuationInQuantityString", id: DownsideItems.quantityFluctuation.id },                             // 数量上下変動 TODO 2025/8/4の週に菅原様から情報提供あり
      { key: "priceChangeOverTimeString", id: DownsideItems.priceChangeOverTime.id },                               // 単価経時変化
      { key: "customerProductLifecycleString", id: DownsideItems.customerProductLifecycle.id },                     // 顧客製品寿命
      { key: "currencyFluctuationString", id: DownsideItems.exchangeRateFluctuationToPrice.id },                    // 為替変動（単価） TODO 保留
      { key: "", id: DownsideItems.exchangeRateFluctuationToCost.id },                                              // 為替変動（原価） TODO 保留
      { key: "risingMaterialCostsString", id: DownsideItems.materialCostIncrease.id },                              // 材料高騰
      { key: "risingLaborCostsString", id: DownsideItems.laborCostIncrease.id },                                    // 労務費高騰
      { key: "competitorConditionString", id: competitorStatusToQuantityId || competitorType.NoCompetitor.value },  // 競合状態（数量）
      { key: "", id: competitorStatusToPriceId || competitorType.NoCompetitor.value },                              // 競合状態（単価）
    ];

    // ストレス指数（画面表示用）の初期化
    itemsToProcess.forEach(({ key, id }) => {
      const processedData = processDownsideIndex(mDownsideIndex, id);
      updateDownsideIndexDisplay(key, processedData);
    });

  }

  /**
   * ストレス指数（画面表示用）の更新
   * 
   * @param {string} itemName 項目名
   * @param {number} downsideIndex ストレス指数（画面表示用）
   * @returns {void} なし
   */
  const updateDownsideIndexDisplay = (
    itemName: string,
    downsideIndex: string,
  ): void => {

    // ストレス指数（画面表示用）を更新
    setDownsideIndexDisplay((prevState) => ({
      ...prevState,
      [itemName]: downsideIndex,
    }));

  }

  /**
   * ストレス指数(表)の初期化（新規）
   * M_CEAS_DOWNSIDE_INDEXのitemIdに紐づくストレス指数値(stressIndex)を設定する
   * 
   * @param {DownsideIndexType[]} mDownsideIndex ストレス指数データ
   * @param {PricingAgreementFormType} agreement T_CEAS_PROJECT 顧客取り決め事項
   * @param {string[]} labels グラフ用ラベル
   * @returns {void} なし
   */
  const setInitialDownsideIndexTableDisplayNew = (
    mDownsideIndex: DownsideIndexType[],
    agreement: PricingAgreementFormType,
    labels: string[]
  ): void => {

    // ストレス指数データが空の場合は処理を抜ける
    if (!mDownsideIndex || mDownsideIndex.length === 0) {
      return;
    }

    // 競合状態の判定
    const competitor = agreement?.competitor ?? NO_COMPETITOR_DEFAULT;
    let competitorStatusToQuantityDownsideId = "";
    let competitorStatusToPriceDownsideId = "";
    if (competitor?.competitorType === competitorType.Competitor.value) {
      // 競合ありの場合
      switch (competitor.competitiorCondition) {
        case competitiorCondition.TopRank.value:
          // 競合1番手の場合
          competitorStatusToQuantityDownsideId = DownsideItems.competitorStatus1stToQuantity.downsideId;
          competitorStatusToPriceDownsideId = DownsideItems.competitorStatus1stToPrice.downsideId;
          break;
        case competitiorCondition.LowerRank.value:
          // 競合2番手の場合
          competitorStatusToQuantityDownsideId = DownsideItems.competitorStatus2ndToQuantity.downsideId;
          competitorStatusToPriceDownsideId = DownsideItems.competitorStatus2ndToPrice.downsideId;
          break;
      }
    } else {
      // 競合なしの場合
      competitorStatusToQuantityDownsideId = DownsideItems.competitorStatusNoToQuantity.downsideId;
      competitorStatusToPriceDownsideId = DownsideItems.competitorStatusNoToToPrice.downsideId;
    }

    const yearList =
      Array.from(new Set(labels.map((s) => s.split("/")[0])))
        .sort((a, b) => Number(a) - Number(b));

    // mDownsideIndexを年ごとにグルーピング
    type DownsideIndexList = {
      [key: string]: Record<string, DownsideIndexType>
    };
    let downsideIndexList: DownsideIndexList = {};
    for (let i = 0; i < mDownsideIndex.length; i++) {
      const yearIndex = mDownsideIndex[i].yearIndex;
      if (yearIndex == undefined || yearIndex == 0 || yearIndex > yearList.length) continue;
      const year = yearList[yearIndex - 1];
      if (!downsideIndexList.hasOwnProperty(year)) {
        downsideIndexList[year] = {};
      }
      const itemId = mDownsideIndex[i].itemId;
      if (itemId == undefined) continue;
      downsideIndexList[year][itemId] = mDownsideIndex[i];
    }

    function formatStressIndex(index: number): string {
      return index > 0 ? `+${index}` : `${index}`;
    }

    // ストレス指数(表)のデータを作成
    let rows: DownsideIndexTableRowDisplay[] = [];
    yearList.forEach((year, index) => {
      let row: DownsideIndexTableRowDisplay = {
        /** 年 */
        yearString: year,
        yearIndex: index,

        /** 数量経時変化 */
        quantityChangeOverTimeString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        quantityChangeOverTimeId: DownsideItems.quantityChangeOverTime.id,
        quantityChangeOverTime: 0,

        /** 数量上下変動 */
        fluctuationInQuantityString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        fluctuationInQuantityId: DownsideItems.quantityFluctuation.id,
        fluctuationInQuantity: 0,

        /** 単価経時変化 */
        priceChangeOverTimeString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        priceChangeOverTimeId: DownsideItems.priceChangeOverTime.id,
        priceChangeOverTime: 0,

        /** 顧客製品寿命 */
        customerProductLifecycleString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        customerProductLifecycleId: DownsideItems.customerProductLifecycle.id,
        customerProductLifecycle: 0,

        /** 為替変動（単価） */
        currencyFluctuationToPriceString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        currencyFluctuationToPriceId: DownsideItems.exchangeRateFluctuationToPrice.id,
        currencyFluctuationToPrice: 0,

        /** 為替変動（原価） */
        currencyFluctuationToCostString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        currencyFluctuationToCostId: DownsideItems.exchangeRateFluctuationToCost.id,
        currencyFluctuationToCost: 0,

        /** 材料高騰 */
        risingMaterialCostsString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        risingMaterialCostsId: DownsideItems.materialCostIncrease.id,
        risingMaterialCosts: 0,

        /** 労務費高騰 */
        risingLaborCostsString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        risingLaborCostsId: DownsideItems.laborCostIncrease.id,
        risingLaborCosts: 0,

        /** 競合状態（数量） */
        competitorConditionToQuantityString: t('features.InvestmentScreening.SimulationNewProduct.label.noCompetitor'),
        competitorConditionToQuantityStringPre: competitor.competitiorCondition === null ? t('features.InvestmentScreening.SimulationNewProduct.label.noCompetitor') : competitor.competitiorCondition,
        competitorConditionToQuantityId: DownsideItems.competitorStatusNoToQuantity.id,
        competitorConditionToQuantity: 0,

        /** 競合状態（単価） */
        competitorConditionToPriceString: t('features.InvestmentScreening.SimulationNewProduct.label.noCompetitor'),
        competitorConditionToPriceStringPre: competitor.competitiorCondition === null ? t('features.InvestmentScreening.SimulationNewProduct.label.noCompetitor') : competitor.competitiorCondition,
        competitorConditionToPriceId: DownsideItems.competitorStatusNoToToPrice.id,
        competitorConditionToPrice: 0,
      };

      let downsideIndex: DownsideIndexType = downsideIndexList[year];
      if (downsideIndex === undefined) downsideIndex = {};
      Object.keys(downsideIndex).forEach((key) => {
        const value = downsideIndex[key as keyof DownsideIndexType];
        if (value == undefined) return;
        if (!(typeof value === "object" && "stressIndex" in value)) return;
        switch (key) {
          // 数量経時変化
          case DownsideItems.quantityChangeOverTime.downsideId:
            row.quantityChangeOverTimeString = `当初計画比${formatStressIndex((value as any).stressIndex)}%`;
            row.quantityChangeOverTimeId = DownsideItems.quantityChangeOverTime.id;
            row.quantityChangeOverTime = (value as any).stressIndex;
            break;

          // 数量上下変動
          case DownsideItems.quantityFluctuation.downsideId:
            row.fluctuationInQuantityString = `当初計画比${formatStressIndex((value as any).stressIndex)}%`;
            row.fluctuationInQuantityId = DownsideItems.quantityFluctuation.id;
            row.fluctuationInQuantity = (value as any).stressIndex;
            break;

          // 単価経時変化
          case DownsideItems.priceChangeOverTime.downsideId:
            row.priceChangeOverTimeString = `年間${formatStressIndex((value as any).stressIndex)}%`;
            row.priceChangeOverTimeId = DownsideItems.priceChangeOverTime.id;
            row.priceChangeOverTime = (value as any).stressIndex;
            break;

          // 顧客製品寿命
          case DownsideItems.customerProductLifecycle.downsideId:
            row.customerProductLifecycleString = `当初計画比${formatStressIndex((value as any).stressIndex)}%`;
            row.customerProductLifecycleId = DownsideItems.customerProductLifecycle.id;
            row.customerProductLifecycle = (value as any).stressIndex;
            break;

          // 為替変動（単価）
          case DownsideItems.exchangeRateFluctuationToPrice.downsideId:
            row.currencyFluctuationToPriceString = `当初計画比${formatStressIndex((value as any).stressIndex)}%`;
            row.currencyFluctuationToPriceId = DownsideItems.exchangeRateFluctuationToPrice.id;
            row.currencyFluctuationToPrice = (value as any).stressIndex;
            break;

          // 為替変動（原価）
          case DownsideItems.exchangeRateFluctuationToCost.downsideId:
            row.currencyFluctuationToCostString = `当初計画比${formatStressIndex((value as any).stressIndex)}%`;
            row.currencyFluctuationToCostId = DownsideItems.exchangeRateFluctuationToCost.id;
            row.currencyFluctuationToCost = (value as any).stressIndex;
            break;

          // 材料高騰
          case DownsideItems.materialCostIncrease.downsideId:
            row.risingMaterialCostsString = `年間${formatStressIndex((value as any).stressIndex)}%`;
            row.risingMaterialCostsId = DownsideItems.materialCostIncrease.id;
            row.risingMaterialCosts = (value as any).stressIndex;
            break;

          // 労務費高騰
          case DownsideItems.laborCostIncrease.downsideId:
            row.risingLaborCostsString = `年間${formatStressIndex((value as any).stressIndex)}%`;
            row.risingLaborCostsId = DownsideItems.laborCostIncrease.id;
            row.risingLaborCosts = (value as any).stressIndex;
            break;

          // 競合状態（数量）
          case competitorStatusToQuantityDownsideId:
            row.competitorConditionToQuantityString = `${competitor.competitiorCondition === competitiorCondition.TopRank.value ? competitiorCondition.TopRank.name : competitiorCondition.LowerRank.name}${formatStressIndex((value as any).stressIndex)}%`;
            row.competitorConditionToQuantityStringPre = `${competitor.competitiorCondition === competitiorCondition.TopRank.value ? competitiorCondition.TopRank.name : competitiorCondition.LowerRank.name}`;
            // IDはdownsideIdでなく項目IDを設定
            row.competitorConditionToQuantityId = DownsideItems.competitorStatus1stToQuantity.id;
            row.competitorConditionToQuantity = (value as any).stressIndex;

            if (`${competitor.competitorType}` === competitorType.NoCompetitor.value) {
              // 競合なしの場合
              row.competitorConditionToQuantityString = `${competitorType.NoCompetitor.name}${formatStressIndex((value as any).stressIndex)}%`;
              row.competitorConditionToQuantityStringPre = `${competitorType.NoCompetitor.name}`;
            }
            break;

          // 競合状態（単価）
          case competitorStatusToPriceDownsideId:
            row.competitorConditionToPriceString = `${competitor.competitiorCondition === competitiorCondition.TopRank.value ? competitiorCondition.TopRank.name : competitiorCondition.LowerRank.name}${formatStressIndex((value as any).stressIndex)}%`;
            row.competitorConditionToPriceStringPre = `${competitor.competitiorCondition === competitiorCondition.TopRank.value ? competitiorCondition.TopRank.name : competitiorCondition.LowerRank.name}`;
            // IDはdownsideIdでなく項目IDを設定
            row.competitorConditionToPriceId = DownsideItems.competitorStatus1stToPrice.id;
            row.competitorConditionToPrice = (value as any).stressIndex;

            if (`${competitor.competitorType}` === competitorType.NoCompetitor.value) {
              // 競合なしの場合
              row.competitorConditionToPriceString = `${competitorType.NoCompetitor.name}${formatStressIndex((value as any).stressIndex)}%`;
              row.competitorConditionToPriceStringPre = `${competitorType.NoCompetitor.name}`;
            }
            break;
        }
      });
      rows.push(row);
    });

    updateDownsideIndexTableDisplay(rows);

    // リセット用にコピーを保持
    setDownsideIndexTableDisplayForReset(JSON.parse(JSON.stringify(rows)) as DownsideIndexTableRowDisplay[]);
  }

  /**
   * ストレス指数(表)の初期化（更新）
   * T_CEAS_PROJECTから取得したダウンサイド指数(downsideIndex)の
   * itemIdに紐づくストレス指数値(stressIndex)を設定する
   * 
   * @param {DownsideIndexType[]} mDownsideIndex T_CEAS_PROJECT ストレス指数データ
   * @param {PricingAgreementFormType} agreement T_CEAS_PROJECT 顧客取り決め事項
   * @param {string[]} labels グラフ用ラベル
   * @returns {void} なし
   */
  const setInitialDownsideIndexTableDisplay = (
    mDownsideIndex: DownsideIndexType[],
    agreement: PricingAgreementFormType,
    labels: string[]
  ): void => {

    // ストレス指数データが空の場合は処理を抜ける
    if (!mDownsideIndex || mDownsideIndex.length === 0) {
      return;
    }

    // 競合状態の判定
    let competitorStatusToQuantityId = "";
    let competitorStatusToPriceId = "";
    const competitor = agreement?.competitor ?? NO_COMPETITOR_DEFAULT;
    if (competitor?.competitorType === competitorType.Competitor.value) {
      // 競合ありの場合
      switch (competitor.competitiorCondition) {
        case competitiorCondition.TopRank.value:
          // 競合1番手の場合
          competitorStatusToQuantityId = DownsideItems.competitorStatus1stToQuantity.id;
          competitorStatusToPriceId = DownsideItems.competitorStatus1stToPrice.id;
          break;
        case competitiorCondition.LowerRank.value:
          // 競合2番手の場合
          competitorStatusToQuantityId = DownsideItems.competitorStatus2ndToQuantity.id;
          competitorStatusToPriceId = DownsideItems.competitorStatus2ndToPrice.id;
          break;
      }
    } else {
      // 競合なしの場合
      competitorStatusToQuantityId = DownsideItems.competitorStatusNoToQuantity.id;
      competitorStatusToPriceId = DownsideItems.competitorStatusNoToToPrice.id;
    }

    const yearList =
      Array.from(new Set(labels.map((s) => s.split("/")[0])))
        .sort((a, b) => Number(a) - Number(b));

    // mDownsideIndexを年ごとにグルーピング
    type DownsideIndexList = {
      [key: string]: Record<string, DownsideIndexType>
    };
    let downsideIndexList: DownsideIndexList = {};
    for (let i = 0; i < mDownsideIndex.length; i++) {
      const yearIndex = mDownsideIndex[i].yearIndex;
      if (yearIndex == undefined || yearIndex == 0 || yearIndex > yearList.length) continue;
      const year = yearList[yearIndex - 1];
      if (!downsideIndexList.hasOwnProperty(year)) {
        downsideIndexList[year] = {};
      }
      const itemId = mDownsideIndex[i].itemId;
      if (itemId == undefined) continue;
      downsideIndexList[year][itemId] = mDownsideIndex[i];
    }

    function formatStressIndex(index: number): string {
      return index > 0 ? `+${index}` : `${index}`;
    }

    // ストレス指数(表)のデータを作成
    let rows: DownsideIndexTableRowDisplay[] = [];
    yearList.forEach((year, index) => {
      let row: DownsideIndexTableRowDisplay = {
        /** 年 */
        yearString: year,
        yearIndex: index,

        /** 数量経時変化 */
        quantityChangeOverTimeString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        quantityChangeOverTimeId: DownsideItems.quantityChangeOverTime.id,
        quantityChangeOverTime: 0,

        /** 数量上下変動 */
        fluctuationInQuantityString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        fluctuationInQuantityId: DownsideItems.quantityFluctuation.id,
        fluctuationInQuantity: 0,

        /** 単価経時変化 */
        priceChangeOverTimeString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        priceChangeOverTimeId: DownsideItems.priceChangeOverTime.id,
        priceChangeOverTime: 0,

        /** 顧客製品寿命 */
        customerProductLifecycleString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        customerProductLifecycleId: DownsideItems.customerProductLifecycle.id,
        customerProductLifecycle: 0,

        /** 為替変動（単価） */
        currencyFluctuationToPriceString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        currencyFluctuationToPriceId: DownsideItems.exchangeRateFluctuationToPrice.id,
        currencyFluctuationToPrice: 0,

        /** 為替変動（原価） */
        currencyFluctuationToCostString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        currencyFluctuationToCostId: DownsideItems.exchangeRateFluctuationToCost.id,
        currencyFluctuationToCost: 0,

        /** 材料高騰 */
        risingMaterialCostsString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        risingMaterialCostsId: DownsideItems.materialCostIncrease.id,
        risingMaterialCosts: 0,

        /** 労務費高騰 */
        risingLaborCostsString: t('features.InvestmentScreening.SimulationNewProduct.label.none'),
        risingLaborCostsId: DownsideItems.laborCostIncrease.id,
        risingLaborCosts: 0,

        /** 競合状態（数量） */
        competitorConditionToQuantityString: t('features.InvestmentScreening.SimulationNewProduct.label.noCompetitor'),
        competitorConditionToQuantityStringPre: competitor.competitiorCondition === null ? t('features.InvestmentScreening.SimulationNewProduct.label.noCompetitor') : competitor.competitiorCondition,
        competitorConditionToQuantityId: DownsideItems.competitorStatusNoToQuantity.id,
        competitorConditionToQuantity: 0,

        /** 競合状態（単価） */
        competitorConditionToPriceString: t('features.InvestmentScreening.SimulationNewProduct.label.noCompetitor'),
        competitorConditionToPriceStringPre: competitor.competitiorCondition === null ? t('features.InvestmentScreening.SimulationNewProduct.label.noCompetitor') : competitor.competitiorCondition,
        competitorConditionToPriceId: DownsideItems.competitorStatusNoToToPrice.id,
        competitorConditionToPrice: 0,
      };

      let downsideIndex: DownsideIndexType = downsideIndexList[year];
      if (downsideIndex === undefined) downsideIndex = {};
      Object.keys(downsideIndex).forEach((key) => {
        const value = downsideIndex[key as keyof DownsideIndexType];
        if (value == undefined) return;
        if (!(typeof value === "object" && "stressIndex" in value)) return;
        switch (key) {
          // 数量経時変化
          case DownsideItems.quantityChangeOverTime.id:
            row.quantityChangeOverTimeString = `当初計画比${formatStressIndex((value as any).stressIndex)}%`;
            row.quantityChangeOverTimeId = (value as any).itemId;
            row.quantityChangeOverTime = (value as any).stressIndex;
            break;

          // 数量上下変動
          case DownsideItems.quantityFluctuation.id:
            row.fluctuationInQuantityString = `当初計画比${formatStressIndex((value as any).stressIndex)}%`;
            row.fluctuationInQuantityId = (value as any).itemId;
            row.fluctuationInQuantity = (value as any).stressIndex;
            break;

          // 単価経時変化
          case DownsideItems.priceChangeOverTime.id:
            row.priceChangeOverTimeString = `年間${formatStressIndex((value as any).stressIndex)}%`;
            row.priceChangeOverTimeId = (value as any).itemId;
            row.priceChangeOverTime = (value as any).stressIndex;
            break;

          // 顧客製品寿命
          case DownsideItems.customerProductLifecycle.id:
            row.customerProductLifecycleString = `当初計画比${formatStressIndex((value as any).stressIndex)}%`;
            row.customerProductLifecycleId = (value as any).itemId;
            row.customerProductLifecycle = (value as any).stressIndex;
            break;

          // 為替変動（単価）
          case DownsideItems.exchangeRateFluctuationToPrice.id:
            row.currencyFluctuationToPriceString = `当初計画比${formatStressIndex((value as any).stressIndex)}%`;
            row.currencyFluctuationToPriceId = (value as any).itemId;
            row.currencyFluctuationToPrice = (value as any).stressIndex;
            break;

          // 為替変動（原価）
          case DownsideItems.exchangeRateFluctuationToCost.id:
            row.currencyFluctuationToCostString = `当初計画比${formatStressIndex((value as any).stressIndex)}%`;
            row.currencyFluctuationToCostId = (value as any).itemId;
            row.currencyFluctuationToCost = (value as any).stressIndex;
            break;

          // 材料高騰
          case DownsideItems.materialCostIncrease.id:
            row.risingMaterialCostsString = `年間${formatStressIndex((value as any).stressIndex)}%`;
            row.risingMaterialCostsId = (value as any).itemId;
            row.risingMaterialCosts = (value as any).stressIndex;
            break;

          // 労務費高騰
          case DownsideItems.laborCostIncrease.id:
            row.risingLaborCostsString = `年間${formatStressIndex((value as any).stressIndex)}%`;
            row.risingLaborCostsId = (value as any).itemId;
            row.risingLaborCosts = (value as any).stressIndex;
            break;

          // 競合状態（数量）
          case competitorStatusToQuantityId:
            row.competitorConditionToQuantityString = `${competitor.competitiorCondition === competitiorCondition.TopRank.value ? competitiorCondition.TopRank.name : competitiorCondition.LowerRank.name}${formatStressIndex((value as any).stressIndex)}%`;
            row.competitorConditionToQuantityStringPre = `${competitor.competitiorCondition === competitiorCondition.TopRank.value ? competitiorCondition.TopRank.name : competitiorCondition.LowerRank.name}`;
            row.competitorConditionToQuantityId = (value as any).itemId;
            row.competitorConditionToQuantity = (value as any).stressIndex;

            if (`${competitor.competitorType}` === competitorType.NoCompetitor.value) {
              // 競合なしの場合
              row.competitorConditionToQuantityString = `${competitorType.NoCompetitor.name}${formatStressIndex((value as any).stressIndex)}%`;
              row.competitorConditionToQuantityStringPre = `${competitorType.NoCompetitor.name}`;
            }
            break;

          // 競合状態（単価）
          case competitorStatusToPriceId:
            row.competitorConditionToPriceString = `${competitor.competitiorCondition === competitiorCondition.TopRank.value ? competitiorCondition.TopRank.name : competitiorCondition.LowerRank.name}${formatStressIndex((value as any).stressIndex)}%`;
            row.competitorConditionToPriceStringPre = `${competitor.competitiorCondition === competitiorCondition.TopRank.value ? competitiorCondition.TopRank.name : competitiorCondition.LowerRank.name}`;
            row.competitorConditionToPriceId = (value as any).itemId;
            row.competitorConditionToPrice = (value as any).stressIndex;

            if (`${competitor.competitorType}` === competitorType.NoCompetitor.value) {
              // 競合なしの場合
              row.competitorConditionToPriceString = `${competitorType.NoCompetitor.name}${formatStressIndex((value as any).stressIndex)}%`;
              row.competitorConditionToPriceStringPre = `${competitorType.NoCompetitor.name}`;
            }
            break;
        }
      });
      rows.push(row);
    });

    updateDownsideIndexTableDisplay(rows);

    // リセット用にコピーを保持
    setDownsideIndexTableDisplayForReset(JSON.parse(JSON.stringify(rows)) as DownsideIndexTableRowDisplay[]);

  }

  /**
   * ストレス指数（画面表示用）の更新
   * 
   * @param {DownsideIndexTableRowDisplay[]} rows ストレス指数（表）
   * @returns {void} なし
   */
  const updateDownsideIndexTableDisplay = (
    rows: DownsideIndexTableRowDisplay[]
  ): void => {

    // ストレス指数(表)（画面表示用）を更新
    setDownsideIndexTableDisplay(rows);
  }

  /**
   * ストレス指数（画面表示用）の更新
   * 
   * @param {string} year 年
   * @param {string} name プロパティ名
   * @param {number} value ストレス指数
   * @param {boolean} comit 
   * @returns {void} なし
   */
  const updateDownsideIndexTableValue = <K extends keyof DownsideIndexTableRowDisplay>(
    year: string,
    name: K,
    value: DownsideIndexTableRowDisplay[K],
    commit: boolean = true
  ): void => {

    // 年を取得
    const index = downsideIndexTableDisplay.findIndex(row => row.yearString === year);
    if (index < 0) return;

    // 該当する年のストレス指数を取得
    const row = { ...downsideIndexTableDisplay[index] };
    // 項目の値を更新
    row[name] = value;
    setDownsideIndexTableDisplay(prevState => prevState.map((item, i) => i === index ? row : item));

    // ストレス指数に変更がない場合はここで終了。
    if (!commit) return;

    const keyMap = {

      /** 数量経時変化 */
      quantityChangeOverTime: "quantityChangeOverTime",

      /** 数量上下変動 */
      fluctuationInQuantity: "quantityFluctuation",

      /** 単価経時変化 */
      priceChangeOverTime: "priceChangeOverTime",

      /** 顧客製品寿命 */
      customerProductLifecycle: "customerProductLifecycle",

      /** 為替変動（単価） */
      currencyFluctuationToPrice: "exchangeRateFluctuationToPrice",

      /** 為替変動（原価） */
      currencyFluctuationToCost: "exchangeRateFluctuationToCost",

      /** 材料高騰 */
      risingMaterialCosts: "materialCostIncrease",

      /** 労務費高騰 */
      risingLaborCosts: "laborCostIncrease",

      /** 競合状態（数量） */
      competitorConditionToQuantity: "competitorStatusToQuantity",

      /** 競合状態（単価） */
      competitorConditionToPrice: "competitorStatusToPrice"
    };
    const itemName = keyMap[name as keyof typeof keyMap];

    // 顧客製品寿命
    if (name === "customerProductLifecycle") {
      // 大きいマイナス値を手入力された際のエラー回避用処理
      if (Number(value) < DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MIN) return;

      // 値が変わっていなければ親stateへのコミット（重い再計算カスケード）をスキップ
      if (Number(downsideIndex.customerProductLifecycle) === Number(value)) return;

      updateDownsideIndex(itemName, Number(value));
      return;
    }

    // 顧客製品寿命以外
    let processedData: number[] = [];
    for (let i = 0; i < downsideIndexTableDisplay.length; i++) {
      const item = downsideIndexTableDisplay[i];
      processedData.push(i === index ? Number(value) : Number(item[name]));
    }

    // 値が変わっていなければ親stateへのコミット（重い再計算カスケード）をスキップ
    // ・currentArrayが未初期化（空配列 or 短い配列）の場合でも、
    //   該当インデックスの値が未設定＝0として比較することで、誤って「変更あり」と判定しないようにする。
    const currentArray = (downsideIndex as any)[itemName] as number[] | undefined;
    const isUnchanged = processedData.every(
      (v, i) => Number(currentArray?.[i] ?? 0) === v
    );
    if (isUnchanged) return;

    updateDownsideIndex(itemName, processedData);
  }

  /**
   * ストレス指数の初期化
   * M_CEAS_DOWNSIDE_INDEXのitemIdに紐づくストレス指数値(stressIndex)を設定する
   * 
   * @param {DownsideIndexType[]} mDownsideIndex M_CEAS_DOWNSIDE_INDEX データ
   * @param {PricingAgreementFormType} agreement T_CEAS_PROJECT 顧客取り決め事項
   * @returns {void} なし
   */
  const setInitialDownsideIndexNew = (mDownsideIndex: DownsideIndexType[], agreement: PricingAgreementFormType): void => {

    // M_CEAS_DOWNSIDE_INDEX データが空の場合は処理を抜ける
    if (!mDownsideIndex || mDownsideIndex.length === 0) {
      return;
    }

    // 競合状態の判定
    let competitorStatusToQuantityDownsideId = "";
    let competitorStatusToPriceDownsideId = "";
    const competitor = agreement?.competitor;
    if (competitor?.competitorType === competitorType.Competitor.value) {
      // 競合ありの場合
      switch (competitor.competitiorCondition) {
        case competitiorCondition.TopRank.value:
          // 競合1番手の場合
          competitorStatusToQuantityDownsideId = DownsideItems.competitorStatus1stToQuantity.downsideId;
          competitorStatusToPriceDownsideId = DownsideItems.competitorStatus1stToPrice.downsideId;
          break;
        case competitiorCondition.LowerRank.value:
          // 競合2番手の場合
          competitorStatusToQuantityDownsideId = DownsideItems.competitorStatus2ndToQuantity.downsideId;
          competitorStatusToPriceDownsideId = DownsideItems.competitorStatus2ndToPrice.downsideId;
          break;
      }
    } else {
      // 競合なしの場合
      competitorStatusToQuantityDownsideId = DownsideItems.competitorStatusNoToQuantity.downsideId;
      competitorStatusToPriceDownsideId = DownsideItems.competitorStatusNoToToPrice.downsideId;
    }

    // 関数宣言
    const processDownsideIndex = (
      mDownsideIndex: DownsideIndexType[],
      itemId: string
    ): number[] => {
      if (!itemId) return []; // itemIdが無効の場合は処理を抜ける
      return mDownsideIndex
        .filter(record => record.itemId === itemId)               // 項目IDが一致
        .sort((a, b) => (a.yearIndex || 0) - (b.yearIndex || 0))  // 年数昇順で並び替え
        .map(record => record.stressIndex ?? 0);                  // ストレス指数を返却
    };

    // 変数宣言
    const itemsToProcess = [
      { key: "quantityChangeOverTime", id: DownsideItems.quantityChangeOverTime.downsideId },                 // 数量経時変化
      { key: "quantityFluctuation", id: DownsideItems.quantityFluctuation.downsideId },                       // 数量上下変動 TODO 2025/8/4の週に菅原様から情報提供あり
      { key: "priceChangeOverTime", id: DownsideItems.priceChangeOverTime.downsideId },                       // 単価経時変化
      { key: "customerProductLifecycle", id: DownsideItems.customerProductLifecycle.downsideId },             // 顧客製品寿命
      { key: "exchangeRateFluctuationToPrice", id: DownsideItems.exchangeRateFluctuationToPrice.downsideId }, // 為替変動（単価） TODO 保留
      { key: "exchangeRateFluctuationToCost", id: DownsideItems.exchangeRateFluctuationToCost.downsideId },   // 為替変動（原価） TODO 保留
      { key: "materialCostIncrease", id: DownsideItems.materialCostIncrease.downsideId },                     // 材料高騰
      { key: "laborCostIncrease", id: DownsideItems.laborCostIncrease.downsideId },                           // 労務費高騰
      { key: "competitorStatusToQuantity", id: competitorStatusToQuantityDownsideId || "" },                  // 競合状態（数量）
      { key: "competitorStatusToPrice", id: competitorStatusToPriceDownsideId || "" },                        // 競合状態（単価）
    ];

    // ストレス指数の初期化
    itemsToProcess.forEach(({ key, id }) => {
      const processedData = processDownsideIndex(mDownsideIndex, id);
      updateDownsideIndex(key, processedData);

      // リセット用にコピーを保持
      updateDownsideIndexForReset(key, JSON.parse(JSON.stringify(processedData)));

    });

  }

  /**
   * ストレス指数の初期化（更新）
   * T_CEAS_PROJECTから取得したダウンサイド指数(downsideIndex)の
   * itemIdに紐づくストレス指数値(stressIndex)を設定する
   * 
   * @param {DownsideIndexType[]} mDownsideIndex M_CEAS_DOWNSIDE_INDEX ストレス指数データ
   * @param {PricingAgreementFormType} agreement T_CEAS_PROJECT 顧客取り決め事項
   * @returns {void} なし
   */
  const setInitialDownsideIndex = (mDownsideIndex: DownsideIndexType[], agreement: PricingAgreementFormType): void => {

    // M_CEAS_DOWNSIDE_INDEX データが空の場合は処理を抜ける
    if (!mDownsideIndex || mDownsideIndex.length === 0) {
      return;
    }

    // 競合状態の判定
    let competitorStatusToQuantityId = "";
    let competitorStatusToPriceId = "";
    const competitor = agreement?.competitor;
    if (competitor?.competitorType === competitorType.Competitor.value) {
      // 競合ありの場合
      switch (competitor.competitiorCondition) {
        case competitiorCondition.TopRank.value:
          // 競合1番手の場合
          competitorStatusToQuantityId = DownsideItems.competitorStatus1stToQuantity.id;
          competitorStatusToPriceId = DownsideItems.competitorStatus1stToPrice.id;
          break;
        case competitiorCondition.LowerRank.value:
          // 競合2番手の場合
          competitorStatusToQuantityId = DownsideItems.competitorStatus2ndToQuantity.id;
          competitorStatusToPriceId = DownsideItems.competitorStatus2ndToPrice.id;
          break;
      }
    } else {
      // 競合なしの場合
      competitorStatusToQuantityId = DownsideItems.competitorStatusNoToQuantity.id;
      competitorStatusToPriceId = DownsideItems.competitorStatusNoToToPrice.id;
    }

    // 関数宣言
    const processDownsideIndex = (
      mDownsideIndex: DownsideIndexType[],
      itemId: string
    ): number[] => {
      if (!itemId) return []; // itemIdが無効の場合は処理を抜ける
      return mDownsideIndex
        .filter(record => record.itemId === itemId)               // 項目IDが一致
        .sort((a, b) => (a.yearIndex || 0) - (b.yearIndex || 0))  // 年数昇順で並び替え
        .map(record => record.stressIndex ?? 0);                  // ストレス指数を返却
    };

    // 変数宣言
    const itemsToProcess = [
      { key: "quantityChangeOverTime", id: DownsideItems.quantityChangeOverTime.id },                 // 数量経時変化
      { key: "quantityFluctuation", id: DownsideItems.quantityFluctuation.id },                       // 数量上下変動 TODO 2025/8/4の週に菅原様から情報提供あり
      { key: "priceChangeOverTime", id: DownsideItems.priceChangeOverTime.id },                       // 単価経時変化
      { key: "customerProductLifecycle", id: DownsideItems.customerProductLifecycle.id },             // 顧客製品寿命
      { key: "exchangeRateFluctuationToPrice", id: DownsideItems.exchangeRateFluctuationToPrice.id }, // 為替変動（単価） TODO 保留
      { key: "exchangeRateFluctuationToCost", id: DownsideItems.exchangeRateFluctuationToCost.id },   // 為替変動（原価） TODO 保留
      { key: "materialCostIncrease", id: DownsideItems.materialCostIncrease.id },                     // 材料高騰
      { key: "laborCostIncrease", id: DownsideItems.laborCostIncrease.id },                           // 労務費高騰
      { key: "competitorStatusToQuantity", id: competitorStatusToQuantityId || "" },                  // 競合状態（数量）
      { key: "competitorStatusToPrice", id: competitorStatusToPriceId || "" },                        // 競合状態（単価）
    ];

    // ストレス指数の初期化
    itemsToProcess.forEach(({ key, id }) => {
      const processedData = processDownsideIndex(mDownsideIndex, id);
      updateDownsideIndex(key, processedData);

      // リセット用にコピーを保持
      updateDownsideIndexForReset(key, JSON.parse(JSON.stringify(processedData)));

    });

  }

  /**
   * ストレス指数（有効・無効）更新
   * 
   * @param {enableDownsideIndexType[]} enDwnidx ストレス指数（有効・無効）情報
   * @returns {void} なし
   */
  const updateEnabledDownsideIndex = (dwnIdxEn: DownsideIndexEnableType[]): void => {

    // ストレス指数（有効・無効）情報が空の場合は処理を抜ける
    if (!dwnIdxEn || dwnIdxEn.length === 0) {
      return;
    }

    // ストレス指数(表)のヘッダー(有効・無効)を設定
    // 数量経時変化
    downsideIndexEnable.isEnabledQuantityChangeOverTime
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.quantityChangeOverTime.id)?.enable ?? true);
    // 数量上下変動
    downsideIndexEnable.isEnabledFluctuationInQuantity
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.quantityFluctuation.id)?.enable ?? true);
    // 単価経時変化
    downsideIndexEnable.isEnabledPriceChangeOverTime
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.priceChangeOverTime.id)?.enable ?? true);
    // 顧客製品寿命
    downsideIndexEnable.isEnabledCustomerProductLifecycle
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.customerProductLifecycle.id)?.enable ?? true);
    // 為替変動（単価）
    downsideIndexEnable.isEnabledCurrencyFluctuationToPrice
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.exchangeRateFluctuationToPrice.id)?.enable ?? true);
    // 為替変動（原価）
    downsideIndexEnable.isEnabledCurrencyFluctuationToCost
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.exchangeRateFluctuationToCost.id)?.enable ?? true);
    // 材料高騰
    downsideIndexEnable.isEnabledRisingMaterialCosts
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.materialCostIncrease.id)?.enable ?? true);
    // 労務費高騰
    downsideIndexEnable.isEnabledRisingLaborCosts
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.laborCostIncrease.id)?.enable ?? true);
    // 競合状態（数量）
    downsideIndexEnable.isEnabledCompetitorConditionToQuantity
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.competitorStatusToQuantity.id)?.enable ?? true);
    //  競合状態（単価）
    downsideIndexEnable.isEnabledCompetitorConditionToPrice
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.competitorStatusToPrice.id)?.enable ?? true);

  }

  /**
   * ストレス指数の更新
   * 
   * @param {string} itemName 項目名
   * @param {number} downsideIndex ストレス指数
   * @returns {void} なし
   */
  const updateDownsideIndex = (
    itemName: string,
    downsideIndex: number | number[],
  ): void => {

    // ストレス指数を更新
    setDownsideIndex((prevState) => ({
      ...prevState,
      [itemName]: downsideIndex,
    }));

  }

  /** AI要因(FactorDef.labelKey) → ストレス指数(表)の項目名 のマッピング */
  const FACTOR_KEY_TO_TABLE_FIELD: Partial<Record<string, keyof DownsideIndexTableRowDisplay>> = {
    quantityChangeOverTime: "quantityChangeOverTime",
    quantityFluctuation: "fluctuationInQuantity",
    priceChangeOverTime: "priceChangeOverTime",
    customerProductLifecycle: "customerProductLifecycle",
    exchangeRateFluctuationToPrice: "currencyFluctuationToPrice",
    exchangeRateFluctuationToCost: "currencyFluctuationToCost",
    materialCostIncrease: "risingMaterialCosts",
    laborCostIncrease: "risingLaborCosts",
    competitorStatusToQuantity: "competitorConditionToQuantity",
    competitorStatusToPrice: "competitorConditionToPrice",
  };

  /**
   * 営業データ連携のAI試算結果（要因別ストレス）をストレス指数（ダウンサイド指数）へ反映する
   * ・表示用テーブル（downsideIndexTableDisplay）と計算用state（downsideIndex）を
   *   1回のsetStateでまとめて更新する（ループ内でのstate参照による反映漏れを避けるため）。
   * ・保存（DB反映）は行わない。ユーザーが内容を確認し、既存の保存操作で確定する。
   * ・customerProductLifecycleのみスカラー値、他の項目は全年度に同じ値を設定する。
   *
   * @param {FactorDef[]} factors AI試算結果（要因別ストレス）
   * @returns {void} なし
   */
  const handleReflectSalesDataLinkageToDownsideIndex = (factors: FactorDef[]): void => {

    if (!factors || factors.length === 0) return;

    // ストレス指数（表）（画面表示用）：全年度の該当項目に同じ値を反映
    setDownsideIndexTableDisplay((prevState) => prevState.map((row) => {
      const nextRow = { ...row };
      factors.forEach(({ labelKey, v }) => {
        const fieldName = FACTOR_KEY_TO_TABLE_FIELD[labelKey];
        if (fieldName) {
          (nextRow[fieldName] as number) = v;
        }
      });
      return nextRow;
    }));

    // ストレス指数（計算用state）：customerProductLifecycleはスカラー、他は年度分の配列に同じ値を設定
    setDownsideIndex((prevState) => {
      const nextState = { ...prevState };
      factors.forEach(({ labelKey, v }) => {
        if (!(labelKey in nextState)) return;
        if (labelKey === "customerProductLifecycle") {
          (nextState as any)[labelKey] = v;
        } else {
          const length = (nextState as any)[labelKey]?.length ?? downsideIndexTableDisplay.length;
          (nextState as any)[labelKey] = Array.from({ length }, () => v);
        }
      });
      return nextState;
    });
  }

  /**
   * ストレス指数（リセット用）の更新
   * 
   * @param {string} itemName 項目名
   * @param {number} downsideIndex ストレス指数
   * @returns {void} なし
   */
  const updateDownsideIndexForReset = (
    itemName: string,
    downsideIndex: number | number[],
  ): void => {

    // ストレス指数を更新
    setDownsideIndexForReset((prevState) => ({
      ...prevState,
      [itemName]: downsideIndex,
    }));

  }

  /**
   * ストレス指数（有効・無効）（リセット用）の更新
   * 
   * @param {string} itemName 項目名
   * @param {number} downsideIndex ストレス指数
   * @returns {void} なし
   */
  const updateEnabledDownsideIndexForReset = (
    itemName: string,
    downsideIndex: number | number[],
  ): void => {

    // ストレス指数を更新
    setDownsideIndexForReset((prevState) => ({
      ...prevState,
      [itemName]: downsideIndex,
    }));

  }
  /**
   * 年次データ内の月次データに対する単価チェックを実行
   *
   * @param months 月次データ ({ month: price })
   * @param errorKeyPrefix エラーのキーのプレフィックス
   * @param decimalCurrency 整数入力のみ必要な場合のフラグ
   */
  const validateMonthsPrice = (
    months: { [key: number]: { price: number } },
    errorKeyPrefix: string,
    decimalCurrency: boolean
  ) => {
    let error = false;
    Object.values(months).forEach((monthData, monthIndex) => {
      const price = monthData?.price || 0;
      if (!decimalCurrency && price % 1 !== 0) {
        const monthKey = Object.keys(months).find(
          (key) => months[Number(key)] === monthData
        );

        changeErrors(`${errorKeyPrefix}-${monthKey}-price`, true, t('features.InvestmentScreening.SimulationNewProduct.message.selectedCurrencyIntegerOnly'));

        error = true;
      }
    });
    return error;
  };

  // バリデーションを行う
  // 必須入力チェック追加
  // isError true：入力エラー、false：入力正常
  const validate = () => {

    // 先頭と末尾の空白を除去し、未定義の場合は空文字として扱う。
    const required = (value: string | undefined) => value?.trim() ?? "" !== "";

    // エラー情報初期化
    setErrors(clearErrors);

    let isError = false;

    if (!required(finalInvestmentReasonDraftRef.current ?? "")) {
      changeErrors("finalInvestmentReason", true, t('features.InvestmentScreening.SimulationNewProduct.message.finalInvestmentReasonRequired'));
      isError = true;
    }
    return !isError;
  }

  /**
   * ストレス指数画面「保存」ボタン押下処理
   */
  const handleSaveDownsideIndex = async (e: React.MouseEvent<HTMLButtonElement>) => {
    // フォーカスを外す
    e.currentTarget.blur();

    if (isSaving) return;
    setIsSaving(true);

    // ダウンサイド指数保存
    const result = await saveDownsideIndex();

    setIsSaving(false);

  }

  /**
   * ダウンサイド指数(ストレス指数)データを保存する。
   * @returns true：処理成功、false：処理失敗
   */
  const saveDownsideIndex = async () => {
    const query = `
    mutation updateDownsideIndex($input: DownsideIndexInput!) {
      updateDownsideIndex(input: $input) {status}
    }
  `;

    // APIリクエスト実行
    const result = await WebAPI.request({
      query: query,
      variables: {
        input: {
          projectId: projectId,
          downsideIndex: convertDownsideIndexToDynamoFormat(),
          downsideIndexEnable: convertDownsideIndexEnableToDynamoFormat(),
          updateDate: projectData?.updateDate,
          ...(reviewDate && { reviewDate }),
        }
      }
    });

    // console.log(`response = `, result);

    if (result?.data?.updateDownsideIndex?.status === "success") {
      toast({
        title: t('features.InvestmentScreening.SimulationNewProduct.message.downsideIndexSaveSuccess'),
        description: t('features.InvestmentScreening.SimulationNewProduct.message.savedInputContent'),
        status: 'success',
        duration: 5000,
        isClosable: true,
      });

      // データ再取得（未保存のテキスト入力は上書きしない）
      await fetchData({ preserveTextDraft: true });

      return true;
    } else if (result?.data?.updateDownsideIndex.status === 'expired') {
      toast({
        title: TITLE,
        description: Messages.expiredMessage,
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
      console.warn(`Conflict error. updateDownsideIndex.`);
      onCloseConfirmModal();
    } else {
      toast({
        title: t('features.InvestmentScreening.SimulationNewProduct.message.downsideIndexSaveFailed'),
        description: t('features.InvestmentScreening.SimulationNewProduct.message.saveFailed'),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      console.error(`Failed to call API updateDownsideIndex.errors = `, result?.errors);
      return false;
    }
  }

  /**
   * シナリオデータを保存する。
   * @param {boolean} deleted 削除フラグ
   * @param {string} updateDate 更新日時
   * @returns {Promise<boolean>} TRUE: 処理成功, FALSE: 処理失敗
   */
  const saveScenarioData = async (deleted: boolean, updateDate?: string, scenarioId?: string): Promise<boolean> => {
    const functionName = "saveScenarioData";

    // GraphQLクエリ
    const query = `
    mutation putScenario($input: ScenarioInput!) {
      putScenario(input: $input) {
        status
      }
    }
  `;

    // improvedWorkingDaysDataから他の2つの配列を同期生成
    // WorkingDaysコンポーネントはimprovedWorkingDaysDataのみを更新するため、
    // 保存時にworkingDay/holidayも同期させる必要がある
    const syncedWorkingDayByYear = improvedWorkingDaysData.map((item) => ({
      fiscalYear: item.fiscalYear,
      workingDay: item.workingDaysData.workingDays,
    }));

    const syncedHolidayByYear = improvedWorkingDaysData.map((item) => ({
      fiscalYear: item.fiscalYear,
      holiday: item.workingDaysData.workOnWeekendAndHolidays,
    }));

    const syncedLineCountByYear = improvedWorkingDaysData.map((item) => ({
      fiscalYear: item.fiscalYear,
      lineCount: item.workingDaysData.lineCount || Array(12).fill(1),
    }));

    const workingDaysScenario = {
      workingDay: syncedWorkingDayByYear,           // 同期済みデータを使用
      holiday: syncedHolidayByYear,                 // 同期済みデータを使用
      lineCount: syncedLineCountByYear,             // 同期済みデータを使用
      workingDaysData: improvedWorkingDaysData,
    };

    // improvedNonWorkingHoursDataから他の2つの配列を同期生成
    // NonWorkingHoursコンポーネントもimprovedNonWorkingHoursDataのみを更新するため、
    // 保存時にoverTime/availabilityRateも同期させる必要がある
    const syncedOverTimeByYear = improvedNonWorkingHoursData.map((item) => ({
      fiscalYear: item.fiscalYear,
      overTime: item.nonWorkingHoursByMonth.map((monthData) => monthData.overTime !== "00:00"),
    }));

    const syncedAvailabilityRateByMonth = improvedNonWorkingHoursData.map((item) => ({
      fiscalYear: item.fiscalYear,
      availabilityRate: item.nonWorkingHoursByMonth.map((monthData) => Number(monthData?.availabilityRate ?? 0)),
    }));

    const nonWorkingHoursScenario = {
      overTime: syncedOverTimeByYear,                     // 同期済みデータを使用
      availabilityRate: syncedAvailabilityRateByMonth,    // 同期済みデータを使用
      nonWorkingHoursData: improvedNonWorkingHoursData,
    };

    const yieldRateScenario = {
      yieldRateData: JSON.stringify(improvedYieldRateList)
    };

    const cycleTimeScenario = {
      cycleTimeData: JSON.stringify(improvedCycleTimeList)
    };

    const equipmentScenario = {
      equipmentsData: JSON.stringify(
        equipmentAmounts.filter(e => e.selected).map(e => ({
          equipmentId: e.equipmentId!,
          changeInQuantity: e.changeInQuantity,
          changedAcceptanceMonth: e.changedAcceptanceMonth,
          changedDepreciationStartMonth: e.changedDepreciationStartMonth
        }))
      )
    };

    const quantityAndPriceScenario = {
      quantityAndPriceData: JSON.stringify(
        quantityAndPriceTables.filter(q => q.edited).map(q => q.data))
    };

    const laborCostScenario: LaborCostScenario = {
      productionLaborCostByMonth: scenarioLaborCostByMonth,
      overseasFactoryExpensesByMonth: scenarioOverseasFactoryExpensesByMonth,
      // 単価・ベースアップ率（シミュレーション設定値）もシナリオに保存
      productionFactoryLaborUnitPrice: scenarioProductionFactoryLaborUnitPrice,
      productionFactoryExpenseUnitPrice: scenarioProductionFactoryExpenseUnitPrice,
      baseLaborCostIncreaseRate: scenarioBaseLaborCostIncreaseRate,
    };

    try {
      // APIリクエストの実行
      const result = await WebAPI.request({
        query: query,
        variables: {
          input: {
            projectId: projectId,
            scenarioId: scenarioId || `scenario-${v4()}`,
            scenarioName: configNameInput,
            workingDays: JSON.stringify(workingDaysScenario),
            nonWorkingHours: JSON.stringify(nonWorkingHoursScenario),
            yieldRate: JSON.stringify(yieldRateScenario),
            cycleTime: JSON.stringify(cycleTimeScenario),
            equipment: JSON.stringify(equipmentScenario),
            quantityAndPrice: JSON.stringify(quantityAndPriceScenario),
            laborCost: JSON.stringify(laborCostScenario),
            applyDownside: applyDownsideInput,
            deleted: deleted,
            updateDate: updateDate,
            ...(reviewDate && { reviewDate }),
          },
        },
      });

      // console.log(`${functionName} result: `, JSON.stringify(result));

      // APIレスポンスのステータスチェック
      const status = result?.data?.putScenario?.status;

      if (status === "success") {
        toast({
          title: t('features.InvestmentScreening.SimulationNewProduct.message.saveSuccess'),
          description: t('features.InvestmentScreening.SimulationNewProduct.message.savedInputContent'),
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        console.log(`${functionName}: 保存成功`);
        return true;
      }

      if (status === "expired") {
        toast({
          title: TITLE,
          description: Messages.expiredMessage,
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
        console.warn(`${functionName}: Conflict error. データが期限切れです。`);
        return false;
      }

      // APIレスポンスが失敗である場合
      toast({
        title: t('features.InvestmentScreening.SimulationNewProduct.message.saveFailedShort'),
        description: t('features.InvestmentScreening.SimulationNewProduct.message.saveFailed'),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      console.error(`${functionName}: Failed to call API. Errors: `, result?.errors);
      return false;

    } catch (error) {
      toast({
        title: t('features.InvestmentScreening.SimulationNewProduct.message.systemError'),
        description: t('features.InvestmentScreening.SimulationNewProduct.message.dbSaveError'),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      console.error(`${functionName}: ERROR occurred while saving scenario data`, error);
      return false;
    }
  };

  /**
   * シナリオデータを取得する。
   * @returns {Promise<TScenario[]>} 取得したシナリオデータのリスト
   */
  const fetchScenarioData = async (): Promise<TScenario[]> => {
    const functionName = "fetchScenarioData";

    // GraphQLクエリ
    const query = {
      query: `
      query getScenarioByProjectId($projectId: String, $hasDeleted: Boolean, $reviewDate: String) {
        getScenarioByProjectId(projectId: $projectId, hasDeleted: $hasDeleted, reviewDate: $reviewDate) {
          projectId
          scenarioId
          scenarioName
          workingDays
          nonWorkingHours
          yieldRate
          cycleTime
          equipment
          quantityAndPrice
          laborCost
          applyDownside
          updateDate
        }
      }
    `,
      variables: { projectId, hasDeleted: false, ...(reviewDate && { reviewDate }) }
    };

    try {
      // APIリクエストの実行
      const response = await WebAPI.request(query);
      // console.log(`${functionName} response: `, JSON.stringify(response));

      // データ取得失敗時の処理
      if (!response?.data?.getScenarioByProjectId) {
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationNewProduct.message.scenarioFetchFailed'),
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        console.error(`${functionName} ERROR: Failed to fetch scenario data`, response?.errors);
        return [];
      }

      // データ取得成功時の処理
      console.log(`${functionName} SUCCESS: Data fetched successfully`);
      return response.data.getScenarioByProjectId;

    } catch (error) {
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.fetchError'),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      console.error(`${functionName} ERROR:`, error);
      return [];
    }
  };

  // #region Excel出力関連

  /**
   * Excelシート名のサニタイズ（禁止文字を置換し、31文字以内に制限）
   * suffixが指定された場合、suffixを必ず残して基本名を切り詰める
   */
  const sanitizeSheetName = (baseName: string, suffix: string = ''): string => {
    const sanitized = (baseName + suffix).replace(/[\\\/\?\*\[\]:]/g, '_');
    if (sanitized.length <= 31) return sanitized;
    // サフィックスを保持して基本名を切り詰め
    const sanitizedSuffix = suffix.replace(/[\\\/\?\*\[\]:]/g, '_');
    const maxBase = 31 - sanitizedSuffix.length;
    return baseName.replace(/[\\\/\?\*\[\]:]/g, '_').substring(0, maxBase) + sanitizedSuffix;
  };

  /**
   * 列幅自動計算
   */
  const getAutoColWidths = (data: (string | number)[][]): XLSX.ColInfo[] => {
    const maxLengths: number[] = [];
    data.forEach(row => {
      row.forEach((cell, idx) => {
        const len = String(cell ?? "").length * 1.2;
        maxLengths[idx] = Math.max(maxLengths[idx] || 0, len);
      });
    });
    return maxLengths.map(wch => ({ wch: Math.min(Math.max(wch, 10), 50) }));
  };

  /**
   * 月次損益データをExcel出力用の2次元配列に変換
   */
  const createMonthlyProfitLossSheet = (
    data: MonthlyProfitAndLossData,
    sheetTitle: string,
    skipConversion: boolean = false  // 既に選択通貨で計算済みの場合はtrue
  ): (string | number)[][] => {
    // 通貨変換用ヘルパー関数
    // skipConversion=trueの場合は変換をスキップ（calcMonthlyProfitAndLossDetails内で既に変換済み）
    const convertIfNeeded = (value: Decimal): Decimal => {
      if (skipConversion) {
        return value;
      }
      if (selectedCurrency.id !== localCurrencyId) {
        const localCurrency = currencyData.find(c => c.currencyId === localCurrencyId);
        if (localCurrency?.currencyName) {
          return convertCurrency(value, localCurrency.currencyName, selectedCurrency.name, currencyData);
        }
      }
      return value;
    };

    // 月次データ処理用ヘルパー関数
    const processMonthlyData = (values: Decimal[]): { values: number[], total: number } => {
      const converted = values.map(v => convertIfNeeded(v || new Decimal(0)));
      // 通貨ごとの小数有無を判定し、小数なし通貨（JPY等）の場合は整数に丸める
      const decimalPlaces = hasDecimal(selectedCurrency.name) ? 2 : 0;
      const nums = converted.map(v => v.toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
      const total = converted.reduce((sum, val) => sum.plus(val), new Decimal(0)).toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber();
      return { values: nums, total };
    };

    // 各データの取得と変換
    const totalSales = processMonthlyData(data.totalSales);
    const productSales = processMonthlyData(data.productSales);
    const moldSales = processMonthlyData(data.moldSales);
    const devSales = processMonthlyData(data.devSales);
    const equipmentSales = processMonthlyData(data.equipmentSales);
    const salesCost = processMonthlyData(data.salesCost);
    const materialCost = processMonthlyData(data.materialCost);
    const outsideCost = processMonthlyData(data.outsideCost);
    const laborCost = processMonthlyData(data.laborCost);
    const domesticLaborCost = processMonthlyData(data.domesticLaborCost);
    const factoryExpenses = processMonthlyData(data.factoryExpenses);
    const overHeadCost = processMonthlyData(data.overHeadCost);
    const depreciation = processMonthlyData(data.depreciation);
    const equipmentDepreciation = processMonthlyData(data.equipmentDepreciation);
    const pastEquipmentCostData = processMonthlyData(data.pastEquipmentCost || []);
    const factoryCost = processMonthlyData(data.factoryCost);
    const otherEquipmentCost = processMonthlyData(data.otherEquipmentCost);
    const domesticFactoryExpenses = processMonthlyData(data.domesticFactoryExpenses);
    const domesticOverHeadCost = processMonthlyData(data.domesticOverHeadCost || []);
    const domesticDepreciation = processMonthlyData(data.domesticDepreciation || []);
    const domesticInvestmentDepreciation = processMonthlyData(data.domesticInvestmentDepreciation || []);
    const domesticFactoryBuildingDepreciation = processMonthlyData(data.domesticFactoryBuildingDepreciation || []);
    const domesticOtherDepreciation = processMonthlyData(data.domesticOtherDepreciation || []);
    const scrapCost = processMonthlyData(data.scrapCost);
    const sGAExpenses = processMonthlyData(data.sGAExpenses);
    const appliedLaborCost = processMonthlyData(data.appliedLaborCost);
    const domesticSgaCost = processMonthlyData(data.domesticSgaCost);
    const salesManagementCost = processMonthlyData(data.salesManagementCost);
    const devCost = processMonthlyData(data.devCost);
    const royalty = processMonthlyData(data.royalty);
    const otherCost = processMonthlyData(data.otherCost);
    const profit = processMonthlyData(data.profit);

    // 営業利益率（月別）
    const profitRateValues = data.labels.map((_, index) => {
      const sales = data.totalSales[index] || new Decimal(0);
      const profitVal = data.profit[index] || new Decimal(0);
      return sales.isZero() ? 0 : profitVal.div(sales).times(100).toNumber();
    });
    const totalProfitRate = totalSales.total === 0 ? 0 : (profit.total / totalSales.total) * 100;

    // 客先指定部品材料費
    const customerSpecifiedPartsCost = processMonthlyData(data.customerSpecifiedPartsCost || []);

    // 実質的営業利益率（月別）= 営業利益 / (売上合計 - 客先指定部品材料費) × 100
    const realProfitRateValues = data.labels.map((_, index) => {
      const sales = data.totalSales[index] || new Decimal(0);
      const custPartsCost = data.customerSpecifiedPartsCost?.[index] || new Decimal(0);
      const realSales = sales.minus(custPartsCost);
      const profitVal = data.profit[index] || new Decimal(0);
      return realSales.isZero() ? 0 : profitVal.div(realSales).times(100).toNumber();
    });
    const totalRealSales = totalSales.total - customerSpecifiedPartsCost.total;
    const totalRealProfitRate = totalRealSales === 0 ? 0 : (profit.total / totalRealSales) * 100;

    const monthsRow = [sheetTitle, ...data.labels, t('common.total')];

    const rows = [
      [ProfitAndLossItems.totalSales.name, ...totalSales.values, totalSales.total],
      [ProfitAndLossItems.productSales.name, ...productSales.values, productSales.total],
      [ProfitAndLossItems.moldRecovery.name, ...moldSales.values, moldSales.total],
      [ProfitAndLossItems.devRecovery.name, ...devSales.values, devSales.total],
      [ProfitAndLossItems.equipmentRecovery.name, ...equipmentSales.values, equipmentSales.total],
      [ProfitAndLossItems.salesCost.name, ...salesCost.values, salesCost.total],
      [ProfitAndLossItems.materialCost.name, ...materialCost.values, materialCost.total],
      [ProfitAndLossItems.outsideCost.name, ...outsideCost.values, outsideCost.total],
      [ProfitAndLossItems.laborCost.name, ...laborCost.values, laborCost.total],
      [ProfitAndLossItems.domesticLaborCost.name, ...domesticLaborCost.values, domesticLaborCost.total],
      [ProfitAndLossItems.factoryExpenses.name, ...factoryExpenses.values, factoryExpenses.total],
      [ProfitAndLossItems.overHeadCost.name, ...overHeadCost.values, overHeadCost.total],
      [ProfitAndLossItems.depreciation.name, ...depreciation.values, depreciation.total],
      [ProfitAndLossItems.equipmentDepreciation.name, ...equipmentDepreciation.values, equipmentDepreciation.total],
      [ProfitAndLossItems.pastEquipmentCost.name, ...pastEquipmentCostData.values, pastEquipmentCostData.total],
      [ProfitAndLossItems.factoryCost.name, ...factoryCost.values, factoryCost.total],
      [ProfitAndLossItems.otherEquipmentCost.name, ...otherEquipmentCost.values, otherEquipmentCost.total],
      [ProfitAndLossItems.domesticFactoryExpenses.name, ...domesticFactoryExpenses.values, domesticFactoryExpenses.total],
      [ProfitAndLossItems.domesticOverHeadCost.name, ...domesticOverHeadCost.values, domesticOverHeadCost.total],
      [ProfitAndLossItems.domesticDepreciation.name, ...domesticDepreciation.values, domesticDepreciation.total],
      [ProfitAndLossItems.domesticInvestmentDepreciation.name, ...domesticInvestmentDepreciation.values, domesticInvestmentDepreciation.total],
      [ProfitAndLossItems.domesticFactoryBuildingDepreciation.name, ...domesticFactoryBuildingDepreciation.values, domesticFactoryBuildingDepreciation.total],
      [ProfitAndLossItems.domesticOtherDepreciation.name, ...domesticOtherDepreciation.values, domesticOtherDepreciation.total],
      [ProfitAndLossItems.scrapCost.name, ...scrapCost.values, scrapCost.total],
      [ProfitAndLossItems.sgaExpenses.name, ...sGAExpenses.values, sGAExpenses.total],
      [ProfitAndLossItems.appliedLaborCost.name, ...appliedLaborCost.values, appliedLaborCost.total],
      [ProfitAndLossItems.domesticSgaCost.name, ...domesticSgaCost.values, domesticSgaCost.total],
      [ProfitAndLossItems.salesManagementCost.name, ...salesManagementCost.values, salesManagementCost.total],
      [ProfitAndLossItems.devCost.name, ...devCost.values, devCost.total],
      [ProfitAndLossItems.royalty.name, ...royalty.values, royalty.total],
      [ProfitAndLossItems.otherCost.name, ...otherCost.values, otherCost.total],
      [ProfitAndLossItems.operatingProfit.name, ...profit.values, profit.total],
      [`${ProfitAndLossItems.operatingProfitRate.name}(%)`, ...profitRateValues, totalProfitRate],
      [`${ProfitAndLossItems.realOperatingProfitRate.name}(%)`, ...realProfitRateValues, totalRealProfitRate],
    ];

    return [
      [`unit: ${selectedCurrency.name}`],
      [],
      monthsRow,
      ...rows,
    ];
  };

  /**
   * 顧客需要と設備キャパシティの計算詳細を算出
   *
   * @param labels               年月ラベル（例: ["2024/4", "2024/5", ...]）
   * @param quantityByPartNo     PartNo別の月別数量（販売個数の計算元）
   * @param workingDayData       稼働日数（年度別月別）
   * @param holidayData          休日出勤日数（年度別月別）
   * @param availabilityRateData 稼働率（年度別月別）
   * @param lineCountData        ライン数（年度別月別）
   * @param isDownside           true: ダウンサイド（ストレス指数適用+期間短縮）/ false: {t('features.InvestmentScreening.SimulationNewProduct.heading.initialPlan')}
   * @param getCycleTimeFn       サイクルタイム取得関数（当初: getCycleTimeFromBom / 保存済み設定: getApplicableCycleTimeのラッパー）
   * @param getYieldRateFn       歩留率取得関数（当初: getYieldRateFromBom / 保存済み設定: getApplicableYieldRateのラッパー）
   * @returns CapacityDetailsData 全中間値を含む計算結果
   */
  const calcCapacityDetails = (
    labels: string[],
    quantityByPartNo: Record<string, string[]>,
    workingDayData: { fiscalYear: string, workingDay?: number[] }[],
    holidayData: { fiscalYear: string, holiday?: number[] }[],
    availabilityRateData: { fiscalYear: string, availabilityRate?: number[] }[],
    lineCountData: { fiscalYear: string, lineCount?: number[] }[],
    isDownside: boolean,
    getCycleTimeFn: (label: string) => number | null,
    getYieldRateFn: (label: string) => number | null,
  ): CapacityDetailsData => {

    // 販売個数(月別)の計算: PartNo別数量を月ごとに合算
    // quantityByPartNo = { "PartNo1": ["100", "200", ...], "PartNo2": ["50", "60", ...] }
    // → salesQuantities = [150, 260, ...] （各月のPartNo合計）
    const salesQuantities: number[] = [];
    Object.values(quantityByPartNo).forEach(part => {
      part.forEach((value, index) => {
        salesQuantities[index] = (salesQuantities[index] || 0) + Number(value || 0);
      });
    });

    // ダウンサイドの場合: ストレス指数による数量減少と期間短縮を適用
    let effectiveLabels = [...labels];
    let effectiveQuantities = [...salesQuantities];
    if (isDownside) {
      // ラベルから年月を解析するヘルパー（例: "2024/4" → { year: 2024, month: 4 }）
      const parseYM = (label: string) => {
        const [y, m] = label.split("/");
        return { year: parseInt(y), month: parseInt(m) };
      };
      // プロジェクト開始年度を取得（4月始まりの年度計算）
      const { year: firstYear, month: firstMonth } = parseYM(labels[0]);
      const projectFiscalYearStart = firstMonth >= 4 ? firstYear : firstYear - 1;

      // 販売個数にストレス指数を適用: 販売個数 × (1 - ストレス指数)
      effectiveQuantities = labels.map((_, index) => {
        const { year, month } = parseYM(labels[index]);
        const fyStart = month >= 4 ? year : year - 1;
        const fiscalYearIndex = fyStart - projectFiscalYearStart + 1;
        const downsindeIndex = (1 - getDownsideIndexToQuantity(fiscalYearIndex - 1, downsideIndexGraph));
        return (salesQuantities[index] || 0) * downsindeIndex;
      });

      // 期間短縮: 全月数 × (1 - 期間ストレス指数) に切り詰め
      const newLength = Math.floor(labels.length * (1 - getDownsideIndexToPeriod(downsideIndexGraph)));
      effectiveLabels = labels.slice(0, newLength);
      effectiveQuantities = effectiveQuantities.slice(0, newLength);
    }

    // 各月の中間値を格納する配列を初期化
    const workingDays: number[] = [];             // 稼働日数
    const holidays: number[] = [];                // 休日出勤日数
    const cycleTimes: number[] = [];              // サイクルタイム(秒)
    const productionCapacities: number[] = [];    // 生産可能個数
    const availabilityRates: number[] = [];       // 稼働率
    const yieldRates: number[] = [];              // 歩留率
    const lineCounts: number[] = [];              // ライン数
    const capacities: number[] = [];              // キャパ
    const surplusCapacities: number[] = [];       // キャパ過剰分

    // 月別ループ: 各月の中間値を取得し、キャパを計算
    for (let i = 0; i < effectiveLabels.length; i++) {
      // ラベルのインデックスから年度・月を取得
      const { year, month } = getFiscalYearMonth(labels, i);

      // 各月の入力データを取得
      const wd = getMonthlyDataByYearAndMonth(workingDayData, year, month, "workingDay");       // 稼働日数
      const hd = getMonthlyDataByYearAndMonth(holidayData, year, month, "holiday");              // 休日出勤日数
      const ct = getCycleTimeFn(labels[i]) ?? 0;                                                 // サイクルタイム(秒)
      const yr = getYieldRateFn(labels[i]) ?? 0;                                                 // 歩留率(小数)
      const ar = getMonthlyDataByYearAndMonth(availabilityRateData, year, month, "availabilityRate"); // 稼働率(小数)
      const lc = getMonthlyDataByYearAndMonth(lineCountData, year, month, "lineCount");          // ライン数

      // 稼働時間(秒) = (稼働日数 + 休日出勤日数) × 24時間 × 3600秒
      const availabilityTime = (wd + hd) * 24 * 3600;
      // 生産可能個数(個) = 稼働時間(秒) / サイクルタイム(秒)
      const prodQty = ct > 0 ? Math.round(availabilityTime / ct) : 0;
      // キャパ(個) = 生産可能個数 × 稼働率 × 歩留率 × ライン数
      const capacity = Math.round(prodQty * ar * yr * lc);
      // NaN/Infinity対策
      const safeCapacity = Number.isNaN(capacity) || capacity === Infinity ? 0 : capacity;

      // 中間値を配列に格納
      workingDays[i] = wd;
      holidays[i] = hd;
      cycleTimes[i] = ct;
      productionCapacities[i] = prodQty;
      availabilityRates[i] = ar;
      yieldRates[i] = yr;
      lineCounts[i] = lc;
      capacities[i] = safeCapacity;
      // キャパ過剰分(個) = キャパ − 販売個数
      surplusCapacities[i] = safeCapacity - (effectiveQuantities[i] || 0);
    }

    return {
      labels: effectiveLabels,
      salesQuantities: effectiveQuantities.slice(0, effectiveLabels.length),
      workingDays,
      holidays,
      cycleTimes,
      productionCapacities,
      availabilityRates,
      yieldRates,
      lineCounts,
      capacities,
      surplusCapacities,
    };
  };

  /**
   * 設備生産数量からのギャップの計算詳細を算出
   *
   * @param labels               年月ラベル（例: ["2024/4", "2024/5", ...]）
   * @param quantityByPartNo     PartNo別の月別数量（出荷必要見込み数の計算元）
   * @param workingDayData       稼働日数（年度別月別）
   * @param holidayData          休日出勤日数（年度別月別）
   * @param availabilityRateData 稼働率（年度別月別）※保存済み設定の場合は改善後の値
   * @param lineCountData        ライン数（年度別月別）
   * @param isDownside           true: ダウンサイド（ストレス指数適用+期間短縮）/ false: {t('features.InvestmentScreening.SimulationNewProduct.heading.initialPlan')}
   * @param getCycleTimeFn       サイクルタイム取得関数（当初: getCycleTimeFromBom / 保存済み設定: getApplicableCycleTimeのラッパー）
   * @param getYieldRateFn       歩留率取得関数（当初: getYieldRateFromBom / 保存済み設定: getApplicableYieldRateのラッパー）
   * @param baseAvailabilityRateData 【保存済み設定のみ】ベース稼働率（改善分の差分計算用）
   * @param baseCycleTimeFn          【保存済み設定のみ】BOMサイクルタイム取得関数（改善分の差分計算用）
   * @param baseYieldRateFn          【保存済み設定のみ】BOM歩留率取得関数（改善分の差分計算用）
   * @returns ProductionQuantityDetailsData 全中間値を含む計算結果
   */
  const calcProductionQuantityDetails = (
    labels: string[],
    quantityByPartNo: Record<string, string[]>,
    workingDayData: { fiscalYear: string, workingDay?: number[] }[],
    holidayData: { fiscalYear: string, holiday?: number[] }[],
    availabilityRateData: { fiscalYear: string, availabilityRate?: number[] }[],
    lineCountData: { fiscalYear: string, lineCount?: number[] }[],
    isDownside: boolean,
    getCycleTimeFn: (label: string) => number | null,
    getYieldRateFn: (label: string) => number | null,
    baseAvailabilityRateData?: { fiscalYear: string, availabilityRate?: number[] }[],
    baseCycleTimeFn?: (label: string) => number | null,
    baseYieldRateFn?: (label: string) => number | null,
  ): ProductionQuantityDetailsData => {

    // 出荷必要見込み数(月別)の計算: PartNo別数量を月ごとに合算
    const estimatedQuantities: number[] = [];
    Object.values(quantityByPartNo).forEach(part => {
      part.forEach((value, index) => {
        estimatedQuantities[index] = (estimatedQuantities[index] || 0) + Number(value || 0);
      });
    });

    // ダウンサイドの場合: ストレス指数による数量減少と期間短縮を適用
    // （calcCapacityDetailsと同じロジック）
    let effectiveLabels = [...labels];
    let effectiveQuantities = [...estimatedQuantities];
    if (isDownside) {
      const parseYM = (label: string) => {
        const [y, m] = label.split("/");
        return { year: parseInt(y), month: parseInt(m) };
      };
      const { year: firstYear, month: firstMonth } = parseYM(labels[0]);
      const projectFiscalYearStart = firstMonth >= 4 ? firstYear : firstYear - 1;

      // 出荷必要見込み数にストレス指数を適用
      effectiveQuantities = labels.map((_, index) => {
        const { year, month } = parseYM(labels[index]);
        const fyStart = month >= 4 ? year : year - 1;
        const fiscalYearIndex = fyStart - projectFiscalYearStart + 1;
        const downsindeIndex = (1 - getDownsideIndexToQuantity(fiscalYearIndex - 1, downsideIndexGraph));
        return (estimatedQuantities[index] || 0) * downsindeIndex;
      });

      // 期間短縮
      const newLength = Math.floor(labels.length * (1 - getDownsideIndexToPeriod(downsideIndexGraph)));
      effectiveLabels = labels.slice(0, newLength);
      effectiveQuantities = effectiveQuantities.slice(0, newLength);
    }

    // 保存済み設定かどうかの判定
    // baseAvailabilityRateData が渡されている場合 = 保存済み設定 → ベースとの差分から改善分を分離計算
    const isSavedConfig = !!baseAvailabilityRateData;

    // 各月の中間値を格納する配列を初期化
    const workingDays: number[] = [];                   // 稼働日数
    const holidays: number[] = [];                      // 休日出勤日数
    const cycleTimes: number[] = [];                    // サイクルタイム(秒)
    const availabilityRates: number[] = [];             // 稼働率
    const yieldRates: number[] = [];                    // 歩留率
    const lineCounts: number[] = [];                    // ライン数
    const workingDayQuantities: number[] = [];          // 稼働日分生産個数
    const holidayQuantities: number[] = [];             // 休日分生産個数
    const improvedYieldQuantities: number[] = [];       // 歩留改善分生産個数
    const improvedAvailabilityQuantities: number[] = []; // 稼働率改善分生産個数
    const improvedCycleTimeQuantities: number[] = [];   // サイクル短縮分生産個数

    // 月別ループ: 各月の中間値を取得し、生産個数を計算
    for (let i = 0; i < effectiveLabels.length; i++) {
      const { year, month } = getFiscalYearMonth(labels, i);

      // 各月の入力データを取得
      const wd = getMonthlyDataByYearAndMonth(workingDayData, year, month, "workingDay");       // 稼働日数
      const hd = getMonthlyDataByYearAndMonth(holidayData, year, month, "holiday");              // 休日出勤日数
      const ct = getCycleTimeFn(labels[i]) ?? 0;                                                 // サイクルタイム(秒) ※保存済み設定では改善後の値
      const yr = getYieldRateFn(labels[i]) ?? 0;                                                 // 歩留率 ※保存済み設定では改善後の値
      const ar = getMonthlyDataByYearAndMonth(availabilityRateData, year, month, "availabilityRate"); // 稼働率 ※保存済み設定では改善後の値
      const lc = getMonthlyDataByYearAndMonth(lineCountData, year, month, "lineCount");          // ライン数

      // 中間値を配列に格納
      workingDays[i] = wd;
      holidays[i] = hd;
      cycleTimes[i] = ct;
      availabilityRates[i] = ar;
      yieldRates[i] = yr;
      lineCounts[i] = lc;

      if (isSavedConfig && baseAvailabilityRateData && baseCycleTimeFn && baseYieldRateFn) {
        // ===== 保存済み設定の場合: 改善分を分離して計算 =====

        // ベース値（改善前の値）を取得
        const baseAr = getMonthlyDataByYearAndMonth(baseAvailabilityRateData, year, month, "availabilityRate"); // ベース稼働率
        const bomCt = baseCycleTimeFn(labels[i]) ?? 0;  // BOMサイクルタイム
        const bomYr = baseYieldRateFn(labels[i]) ?? 0;  // BOM歩留率

        // 改善後の値とベース値の差分を計算
        const arDiff = ar - baseAr;   // 稼働率の差分（正=改善、負=悪化）
        const yrDiff = yr - bomYr;    // 歩留率の差分（正=改善、負=悪化）
        const ctDiff = ct - bomCt;    // サイクルタイムの差分（負=改善（短縮）、正=悪化）

        // 稼働日分・休日分の計算で使用する値を決定:
        // 改善があった項目はベース値を使用（改善分は別行で計上するため）
        // 悪化した項目は改善後の値をそのまま使用
        const arForBase = arDiff > 0 ? baseAr : ar;     // 稼働率が改善 → ベース稼働率を使用
        const yrForBase = yrDiff > 0 ? bomYr : yr;      // 歩留が改善 → BOM歩留を使用
        const ctForBase = ctDiff < 0 ? bomCt : ct;      // CTが短縮 → BOM CTを使用

        // 稼働日分生産個数 = (稼働日数 × 24 × 3600 / CT) × 稼働率 × 歩留率 × ライン数
        const wdTime = wd * 24 * 3600;
        const wdQty = ctForBase > 0 ? Math.round(wdTime / ctForBase) : 0;
        const wdResult = Math.round(wdQty * arForBase * yrForBase * lc);
        workingDayQuantities[i] = Number.isNaN(wdResult) || wdResult === Infinity ? 0 : wdResult;

        // 休日分生産個数 = (休日出勤日数 × 24 × 3600 / CT) × 稼働率 × 歩留率 × ライン数
        const hdTime = hd * 24 * 3600;
        const hdQty = ctForBase > 0 ? Math.round(hdTime / ctForBase) : 0;
        const hdResult = Math.round(hdQty * arForBase * yrForBase * lc);
        holidayQuantities[i] = Number.isNaN(hdResult) || hdResult === Infinity ? 0 : hdResult;

        // 稼働率改善分生産個数（稼働率が増えた場合のみ計上、減った場合は0）
        // = 生産可能個数(稼働日+休日合算) × 稼働率差分 × 歩留率(ベース) × ライン数
        const totalTime = (wd + hd) * 24 * 3600;
        const prodQtyForImprovement = ctForBase > 0 ? Math.round(totalTime / ctForBase) : 0;
        const arDiffRounded = Number(arDiff.toFixed(3));
        const improvedArQty = arDiff > 0 ? Math.round(prodQtyForImprovement * arDiffRounded * yrForBase * lc) : 0;
        improvedAvailabilityQuantities[i] = Number.isNaN(improvedArQty) || improvedArQty === Infinity ? 0 : improvedArQty;

        // 歩留改善分生産個数（歩留が増えた場合のみ計上、減った場合は0）
        // = 生産可能個数 × 稼働率(ベース) × 歩留差分 × ライン数
        const yrDiffRounded = Number(yrDiff.toFixed(3));
        const hasYieldImprovement = yr > bomYr;
        const improvedYrQty = hasYieldImprovement ? Math.round(prodQtyForImprovement * arForBase * yrDiffRounded * lc) : 0;
        improvedYieldQuantities[i] = Number.isNaN(improvedYrQty) || improvedYrQty === Infinity ? 0 : improvedYrQty;

        // サイクル短縮分生産個数（CTが短縮した場合のみ計上、増加した場合は0）
        // = (改善後生産可能個数 - BOM生産可能個数) × 稼働率(ベース) × 歩留率(ベース) × ライン数
        const prodQtyBom = bomCt > 0 ? Math.round(totalTime / bomCt) : 0;
        const prodQtyImproved = ct > 0 ? Math.round(totalTime / ct) : 0;
        const prodQtyDiff = prodQtyImproved - prodQtyBom;
        const hasCycleTimeImprovement = ct < bomCt;
        const improvedCtQty = hasCycleTimeImprovement ? Math.round(prodQtyDiff * arForBase * yrForBase * lc) : 0;
        improvedCycleTimeQuantities[i] = Number.isNaN(improvedCtQty) || improvedCtQty === Infinity ? 0 : improvedCtQty;
      } else {
        // ===== 当初計画 / ダウンサイドの場合: ベース値のみで計算（改善分は0） =====

        // 稼働日分生産個数 = (稼働日数 × 24 × 3600 / CT) × 稼働率 × 歩留率 × ライン数
        const wdTime = wd * 24 * 3600;
        const wdQty = ct > 0 ? Math.round(wdTime / ct) : 0;
        const wdResult = Math.round(wdQty * ar * yr * lc);
        workingDayQuantities[i] = Number.isNaN(wdResult) || wdResult === Infinity ? 0 : wdResult;

        // 休日分生産個数 = (休日出勤日数 × 24 × 3600 / CT) × 稼働率 × 歩留率 × ライン数
        const hdTime = hd * 24 * 3600;
        const hdQty = ct > 0 ? Math.round(hdTime / ct) : 0;
        const hdResult = Math.round(hdQty * ar * yr * lc);
        holidayQuantities[i] = Number.isNaN(hdResult) || hdResult === Infinity ? 0 : hdResult;

        // 当初計画・ダウンサイドでは改善分は0（シート構成統一のため行は出力する）
        improvedYieldQuantities[i] = 0;
        improvedAvailabilityQuantities[i] = 0;
        improvedCycleTimeQuantities[i] = 0;
      }
    }

    return {
      labels: effectiveLabels,
      estimatedQuantities: effectiveQuantities.slice(0, effectiveLabels.length),
      workingDays,
      holidays,
      cycleTimes,
      availabilityRates,
      yieldRates,
      lineCounts,
      workingDayQuantities,
      holidayQuantities,
      improvedYieldQuantities,
      improvedAvailabilityQuantities,
      improvedCycleTimeQuantities,
    };
  };

  /**
   * 増分キャッシュフローデータをExcel出力用の2次元配列に変換
   *
   * @param data           増分キャッシュフローデータ（state保持済み）
   * @param sheetTitle     シートタイトル（例: "当初計画", "ダウンサイド", "設定A"）
   * @param skipConversion 通貨変換をスキップするか（displayVersion + JPY時にtrue）
   * @param extendedLabels No.411対応（8章）: ダウンサイドケースのみ指定。当初計画側と同じ年月ラベルまで
   *   年月列を延長する。延長部分は稼働連動費0・減価償却費系のみ計算続行した値になる
   * @returns 2次元配列（XLSX.utils.aoa_to_sheetに渡す形式）
   */
  const createIncrementalCashFlowSheet = (
    data: any,
    sheetTitle: string,
    skipConversion: boolean = false,
    extendedLabels?: string[],
  ): (string | number)[][] => {
    const currencyName = selectedCurrency.name || '';

    // 月次データ処理用ヘルパー関数（通貨変換 → 丸め → 合計は各月の単純合算）
    const processMonthlyData = (values: Decimal[]): { values: number[], total: number } => {
      const decimalPlaces = hasDecimal(currencyName) ? 2 : 0;
      if (skipConversion) {
        const nums = values.map(v => (v || new Decimal(0)).toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
        const total = nums.reduce((sum, val) => sum + val, 0);
        return { values: nums, total };
      }
      const converted = values.map(v => new Decimal(convertCurrency(v || new Decimal(0), localCurrencyName, currencyName, currencyData)));
      const nums = converted.map(v => v.toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
      const total = nums.reduce((sum, val) => sum + val, 0);
      return { values: nums, total };
    };

    // 回収額（累積値）の処理 - 合計列は「-」
    const processRecoveryData = (values: Decimal[]): { values: number[] } => {
      const decimalPlaces = hasDecimal(currencyName) ? 2 : 0;
      if (skipConversion) {
        const nums = values.map(v => (v || new Decimal(0)).toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
        return { values: nums };
      }
      const nums = values.map(v =>
        new Decimal(convertCurrency(v || new Decimal(0), localCurrencyName, currencyName, currencyData))
          .toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber()
      );
      return { values: nums };
    };

    // No.411対応（8章）: ダウンサイド・通常モード時のみ、当初計画側と同じ長さまで年月列を延長する
    const isExtended = !reviewDate && !!extendedLabels && extendedLabels.length > (data.labels || []).length;
    const outputLabels = isExtended ? extendedLabels! : (data.labels || []);

    // データ配列をラベル数に合わせる（長い場合は切り詰め、短い場合は0でパディング）
    const labelCount = outputLabels.length;
    const fitToLabels = (arr: Decimal[]) => {
      const trimmed = arr.slice(0, labelCount);
      while (trimmed.length < labelCount) {
        trimmed.push(new Decimal(0));
      }
      return trimmed;
    };

    // 振り返りモード: capexByMonthは既にtargetCurrencyName（=表示通貨）で計算済みのため変換不要
    // 通常モード: ローカル通貨→表示通貨に変換
    const capex = reviewDate
      ? (() => {
        const decimalPlaces = hasDecimal(currencyName) ? 2 : 0;
        const nums = fitToLabels(data.capexByMonth || []).map((v: Decimal) =>
          (v || new Decimal(0)).toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
        return { values: nums, total: nums.reduce((s: number, v: number) => s + v, 0) };
      })()
      : processMonthlyData(fitToLabels(data.capexByMonth || []));

    const hasCostBreakdown = !!data.costBreakdown;
    let profit: { values: number[], total: number };
    let equipmentDepreciation: { values: number[], total: number };
    let recoverySources: { values: number[], total: number };
    let uncollected: { values: number[] };

    if (hasCostBreakdown) {
      const recalc = calcMonthlyProfitInDisplayCurrency(
        data.costBreakdown,
        localCurrencyName,
        currencyName,
        currencyData,
        data.equipmentDepreciationInputs,
        data.scrapCostInputs,
        reviewDate ? convertWithRate : undefined,
        reviewDate ? data.labels : undefined,
        isExtended ? labelCount : undefined,
      );
      const decimalPlaces = hasDecimal(currencyName) ? 2 : 0;
      const toNumbers = (arr: any[]) => {
        const nums = arr.slice(0, labelCount).map(v =>
          (v || new Decimal(0)).toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber()
        );
        return { values: nums, total: nums.reduce((s, v) => s + v, 0) };
      };
      profit = toNumbers(recalc.profitByMonth);
      equipmentDepreciation = toNumbers(recalc.equipmentDepreciationByMonth);
      // 回収原資 = 営業利益 + 投資対象設備の減価償却費（表示通貨で再計算）
      const recoverySourceNums = profit.values.map((p, i) => p + equipmentDepreciation.values[i]);
      recoverySources = { values: recoverySourceNums, total: recoverySourceNums.reduce((s, v) => s + v, 0) };
      // 未回収額: data.recoveryByMonth（calcRecoverySimulationの結果、検収月CAPEX計上済み）を使用
      // 振り返りモード: 既に表示通貨に変換済み → 丸めのみ
      // 通常モード: ローカル通貨 → processRecoveryData で表示通貨に変換
      if (reviewDate) {
        const recoveryNums = fitToLabels(data.recoveryByMonth || []).map((v: Decimal) =>
          (v || new Decimal(0)).toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
        uncollected = { values: recoveryNums };
      } else if (isExtended) {
        // No.411対応（8章）: ダウンサイドの生産期間短縮時、延長期間まで未回収額を再計算する。
        // 回収原資（表示通貨で再計算済み）と設備投資額（延長部分は0埋め）を
        // calcRecoverySimulationに渡し、延長後の期間で検算可能な未回収額を得る。
        const recoverySourceDecimals = recoverySources.values.map(v => new Decimal(v));
        const capexDecimals = fitToLabels(data.capexByMonth || []).map((v: Decimal) =>
          new Decimal(convertCurrency(v || new Decimal(0), localCurrencyName, currencyName, currencyData))
            .toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP));
        const extendedRecovery = calcRecoverySimulation(recoverySourceDecimals, capexDecimals, hasDecimal(currencyName), false);
        uncollected = { values: extendedRecovery.map(v => v.toNumber()) };
      } else {
        uncollected = processRecoveryData(fitToLabels(data.recoveryByMonth || []));
      }
    } else {
      profit = processMonthlyData(fitToLabels(data.profitByMonth || []));
      equipmentDepreciation = processMonthlyData(fitToLabels(data.equipmentDepreciationByMonth || []));
      recoverySources = processMonthlyData(fitToLabels(data.recoverySourcesByMonth || []));
      uncollected = processRecoveryData(fitToLabels(data.recoveryByMonth || []));
    }

    // 回収時点の表示（チャートのアノテーションと同じ formatRecoveryMonths を使用）
    const recoveryMonthStr = data.recoveryMonths?.length > 0
      ? data.recoveryMonths.map((m: number) => `${formatRecoveryMonths(m)}目`).join(", ")
      : "-";
    const recoveryPeriod = outputLabels.map(() => "");

    const monthsRow = [sheetTitle, ...outputLabels, t('common.total')];

    const rows = [
      [RecoverySimulationItems.capexAmount.name, ...capex.values, capex.total],
      [RecoverySimulationItems.recoveredResources.name, ...recoverySources.values, recoverySources.total],
      [RecoverySimulationItems.operatingProfit.name, ...profit.values, profit.total],
      [RecoverySimulationItems.equipmentDepreciation.name, ...equipmentDepreciation.values, equipmentDepreciation.total],
      [RecoverySimulationItems.uncollectedAmount.name, ...uncollected.values, "-"],
      [RecoverySimulationItems.collectionPeriod.name, ...recoveryPeriod, recoveryMonthStr],
    ];

    return [
      [`unit: ${currencyName}`],
      [],
      monthsRow,
      ...rows,
    ];
  };

  /**
   * ギャップ詳細データをExcel出力用の2次元配列に変換
   *
   * @param capacityData   calcCapacityDetailsの計算結果
   * @param productionData calcProductionQuantityDetailsの計算結果
   * @param sheetTitle     シートタイトル（例: "当初計画", "ダウンサイド", "設定A"）
   * @returns 2次元配列（XLSX.utils.aoa_to_sheetに渡す形式）
   */
  const createGapDetailsSheet = (
    capacityData: CapacityDetailsData,
    productionData: ProductionQuantityDetailsData,
    sheetTitle: string,
    capacity24h: number[],            // 24h稼働キャパ（工場稼働日数×86400/CT×歩留×ライン数）
    factoryWorkingDays: number[],     // 工場稼働日数（カレンダー上の稼働日数）
  ): (string | number)[][] => {
    const labels = capacityData.labels;

    // セクション1: 顧客需要と設備キャパシティ
    // ヘッダー行: セクション名 + 月別ラベル
    const capacityHeaderRow = [t('features.InvestmentScreening.SimulationNewProduct.excel.demandAndCapacitySection', { title: sheetTitle }), ...labels];
    // データ行: 各項目名 + 月別値
    const capacityRows = [
      [t('features.InvestmentScreening.SimulationNewProduct.excel.salesQuantity'), ...capacityData.salesQuantities],              // PartNo合計の販売個数
      [t('features.InvestmentScreening.SimulationNewProduct.excel.workingDays'), ...capacityData.workingDays],                  // 月別稼働日数
      [t('features.InvestmentScreening.SimulationNewProduct.excel.holidayWorkDays'), ...capacityData.holidays],                 // 月別休日出勤日数
      [t('features.InvestmentScreening.SimulationNewProduct.excel.cycleTimeSeconds'), ...capacityData.cycleTimes],         // BOM or 改善後CT
      [t('features.InvestmentScreening.SimulationNewProduct.excel.productionCapacity'), ...capacityData.productionCapacities],     // (稼働日数+休日)×24×3600/CT
      [t('features.InvestmentScreening.SimulationNewProduct.excel.availabilityRatePct'), ...capacityData.availabilityRates],           // 月別稼働率
      [t('features.InvestmentScreening.SimulationNewProduct.excel.yieldRatePct'), ...capacityData.yieldRates],                  // BOM or 改善後歩留率
      [t('features.InvestmentScreening.SimulationNewProduct.excel.lineCount'), ...capacityData.lineCounts],                   // 月別ライン数
      [t('features.InvestmentScreening.SimulationNewProduct.excel.capacity'), ...capacityData.capacities],                     // 生産可能個数×稼働率×歩留率×ライン数
      [t('features.InvestmentScreening.SimulationNewProduct.excel.surplusCapacity'), ...capacityData.surplusCapacities],       // キャパ−販売個数
      [t('features.InvestmentScreening.SimulationNewProduct.excel.factoryWorkingDays'), ...factoryWorkingDays],                    // カレンダー上の稼働日数
      [t('features.InvestmentScreening.SimulationNewProduct.excel.full24hCapacity'), ...capacity24h],                          // 工場稼働日数×86400/CT×歩留×ライン数
    ];

    // セクション2: 設備生産数量からのギャップ
    const productionHeaderRow = [t('features.InvestmentScreening.SimulationNewProduct.excel.productionQuantityGapSection', { title: sheetTitle }), ...productionData.labels];
    const productionRows: (string | number)[][] = [
      [t('features.InvestmentScreening.SimulationNewProduct.excel.requiredShipment'), ...productionData.estimatedQuantities],     // PartNo合計の出荷必要見込み数
      [t('features.InvestmentScreening.SimulationNewProduct.excel.workingDays'), ...productionData.workingDays],                     // 月別稼働日数
      [t('features.InvestmentScreening.SimulationNewProduct.excel.holidayWorkDays'), ...productionData.holidays],                    // 月別休日出勤日数
      [t('features.InvestmentScreening.SimulationNewProduct.excel.cycleTimeSeconds'), ...productionData.cycleTimes],            // BOM or 改善後CT
      [t('features.InvestmentScreening.SimulationNewProduct.excel.availabilityRatePct'), ...productionData.availabilityRates],              // 月別稼働率
      [t('features.InvestmentScreening.SimulationNewProduct.excel.yieldRatePct'), ...productionData.yieldRates],                     // BOM or 改善後歩留率
      [t('features.InvestmentScreening.SimulationNewProduct.excel.lineCount'), ...productionData.lineCounts],                      // 月別ライン数
      [t('features.InvestmentScreening.SimulationNewProduct.excel.workingDayProduction'), ...productionData.workingDayQuantities],    // 稼働日のみの生産個数
      [t('features.InvestmentScreening.SimulationNewProduct.excel.holidayProduction'), ...productionData.holidayQuantities],         // 休日出勤分の生産個数
    ];

    // 改善分生産個数（全シート共通で出力。当初計画・ダウンサイドでは値は0）
    productionRows.push([t('features.InvestmentScreening.SimulationNewProduct.excel.yieldImprovedProduction'), ...(productionData.improvedYieldQuantities || [])]);       // 歩留改善による増加分
    productionRows.push([t('features.InvestmentScreening.SimulationNewProduct.excel.availabilityImprovedProduction'), ...(productionData.improvedAvailabilityQuantities || [])]); // 稼働率改善による増加分
    productionRows.push([t('features.InvestmentScreening.SimulationNewProduct.excel.cycleTimeReducedProduction'), ...(productionData.improvedCycleTimeQuantities || [])]); // CT短縮による増加分
    productionRows.push([t('features.InvestmentScreening.SimulationNewProduct.excel.full24hCapacity'), ...capacity24h]);  // 工場稼働日数×86400/CT×歩留×ライン数

    return [
      ["unit: pcs"], // 単位行
      [],                  // 空行
      capacityHeaderRow,   // セクション1ヘッダー
      ...capacityRows,     // セクション1データ（10行）
      [],                  // セクション間の空行
      productionHeaderRow, // セクション2ヘッダー
      ...productionRows,   // セクション2データ（12行）
    ];
  };

  /**
   * 月次損益Excel出力
   */
  const exportMonthlyProfitLossToExcel = async () => {
    const functionName = "exportMonthlyProfitLossToExcel";
    console.log(`${functionName} START`);

    try {
      if (!projectData || !originalProfitAndLossByMonth || !capexPartNo || capexPartNo.length === 0) {
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationNewProduct.message.dataInsufficient'),
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const workbook = XLSX.utils.book_new();

      // 日付シート追加
      const today = new Date();
      const downloadTimeData = [[`${today.getUTCFullYear()}-${String(today.getUTCMonth() + 1).padStart(2, '0')}-${String(today.getUTCDate()).padStart(2, '0')} ${String(today.getUTCHours()).padStart(2, '0')}:${String(today.getUTCMinutes()).padStart(2, '0')}:${String(today.getUTCSeconds()).padStart(2, '0')}`]];
      const downloadTimeSheet = XLSX.utils.aoa_to_sheet(downloadTimeData);
      XLSX.utils.book_append_sheet(workbook, downloadTimeSheet, "downloadTime");

      // Excel出力：通貨変換はcalcMonthlyProfitAndLossDetails内で行われるため、
      // 適切なソースデータと通貨名を選択する
      // ※displayXxxChartData（表示用変換済み）を使用すると二重変換になるため使用しない
      const useDisplayVersionForExport = displayVersionSalesChartData &&
        selectedCurrency?.name === CurrencyNameJPY;

      let exportCurrencyName: string;
      let salesChartDataForExport: any;
      let salesChartDataModifiedForExport: any;
      let mergedChartDataOriginalForExport: any;
      let mergedChartDataModifiedForExport: any;

      if (reviewDate) {
        // 振り返りモード: salesChartDataは既にselectedCurrencyで月別レート変換済み。
        // calcMonthlyProfitAndLossDetailsにconvertWithRateを渡しコスト計算も月別レート対応。
        exportCurrencyName = selectedCurrency.name;
        salesChartDataForExport = salesChartData;
        salesChartDataModifiedForExport = salesChartDataModified;
        mergedChartDataOriginalForExport = mergedChartDataOriginal;
        mergedChartDataModifiedForExport = mergedChartDataModified;
      } else if (useDisplayVersionForExport) {
        // 保存時の表示通貨と一致 → JPY版を使用（変換不要）
        exportCurrencyName = savedDisplayCurrencyName;
        salesChartDataForExport = displayVersionSalesChartData;
        salesChartDataModifiedForExport = displayVersionSalesChartDataModified;
        mergedChartDataOriginalForExport = displayVersionMergedChartDataOriginal;
        mergedChartDataModifiedForExport = displayVersionMergedChartDataModified;
      } else {
        // ローカル通貨版を使用（calcMonthlyProfitAndLossDetails内で変換）
        exportCurrencyName = localCurrencyName;
        salesChartDataForExport = salesChartData;
        salesChartDataModifiedForExport = salesChartDataModified;
        mergedChartDataOriginalForExport = mergedChartDataOriginal;
        mergedChartDataModifiedForExport = mergedChartDataModified;
      }

      const exportDecimalCurrency = hasDecimal(exportCurrencyName);
      // labelsはoriginalProfitAndLossByMonthから取得（通貨に依存しない）
      const profitAndLossDataForExport = originalProfitAndLossByMonth;
      // 振り返りモード: materialCostsはローカル通貨で計算し、calcMonthlyProfitAndLossDetails内で月別レート変換する。
      // 通常モード: exportCurrencyNameで計算（calcMonthlyProfitAndLossDetailsはそのまま使用）。
      const materialCostCurrencyForExport = reviewDate ? localCurrencyName : exportCurrencyName;

      if (salesChartDataForExport?.datasets) {
        const salesDataset = salesChartDataForExport.datasets.find((d: any) => d.id === "sales");
        if (salesDataset) {
          const sales = salesDataset.data.map((v: number) => new Decimal(v));
          const materialCosts = calcMaterialCost(
            mergedChartDataOriginalForExport,
            quantitiesChartDataOriginal,
            capexPartNo,
            profitAndLossDataForExport.labels,
            projectData.projectId!,
            materialCostCurrencyForExport,
            currencyData
          );

          const originalData = calcMonthlyProfitAndLossDetails(
            sales,
            materialCosts || [],
            profitAndLossDataForExport.labels,
            false,
            originalEquipmentAmounts,
            projectData,
            capexPartNo,
            exportCurrencyName,
            currencyData,
            downsideIndexGraph,
            exportDecimalCurrency,
            uniqueProcessData,
            bomData,
            projectData.moldSalesByProject,
            projectData.developmentSalesByProject,
            projectData.equipmentSalesByProject,
            undefined,
            reviewDate ? convertWithRate : undefined,
          );

          if (originalData) {
            // calcMonthlyProfitAndLossDetails内で既に選択通貨に変換済みなのでskipConversion=true
            const sheetData = createMonthlyProfitLossSheet(originalData, t('features.InvestmentScreening.SimulationNewProduct.excel.monthlyProfitLossOriginal'), true);
            const sheet = XLSX.utils.aoa_to_sheet(sheetData);
            sheet["!cols"] = getAutoColWidths(sheetData);
            XLSX.utils.book_append_sheet(workbook, sheet, t('features.InvestmentScreening.SimulationNewProduct.excel.originalMonthlyProfitLossSheetName'));
          }
        }
      }

      // ダウンサイドシートを作成
      // salesChartDataModifiedForExport, mergedChartDataModifiedForExportは上記で設定済み

      if (salesChartDataModifiedForExport?.datasets) {
        const salesDataset = salesChartDataModifiedForExport.datasets.find((d: any) => d.id === "sales");
        if (salesDataset) {
          const sales = salesDataset.data.map((v: number) => new Decimal(v));
          // ダウンサイドチャートデータは既に期間短縮されているため、labelsもそれに合わせる
          const downsideLabels = profitAndLossDataForExport.labels.slice(0, sales.length);
          const materialCosts = calcMaterialCost(
            mergedChartDataModifiedForExport,
            quantitiesChartDataModified,
            capexPartNo,
            downsideLabels,
            projectData.projectId!,
            materialCostCurrencyForExport,
            currencyData
          );

          const downsideData = calcMonthlyProfitAndLossDetails(
            sales,
            materialCosts || [],
            downsideLabels,
            true,
            originalEquipmentAmounts,
            projectData,
            capexPartNo,
            exportCurrencyName,
            currencyData,
            downsideIndexGraph,
            exportDecimalCurrency,
            uniqueProcessData,
            bomData,
            projectData.moldSalesByProject,
            projectData.developmentSalesByProject,
            projectData.equipmentSalesByProject,
            undefined,
            reviewDate ? convertWithRate : undefined,
            // No.411対応（9章）: 当初計画側と同じラベルまで年月列を延長する
            !reviewDate ? incrementalCashFlowOriginal?.labels : undefined,
          );

          if (downsideData) {
            // calcMonthlyProfitAndLossDetails内で既に選択通貨に変換済みなのでskipConversion=true
            const sheetData = createMonthlyProfitLossSheet(downsideData, t('features.InvestmentScreening.SimulationNewProduct.excel.monthlyProfitLossDownside'), true);
            const sheet = XLSX.utils.aoa_to_sheet(sheetData);
            sheet["!cols"] = getAutoColWidths(sheetData);
            XLSX.utils.book_append_sheet(workbook, sheet, t('features.InvestmentScreening.SimulationNewProduct.excel.downsideMonthlyProfitLossSheetName'));
          }
        }
      }

      // 保存済み設定シートを作成
      // JPYネイティブデータが利用可能な場合はダウンサイドと同じデータパスで計算（1円ずれ防止）
      const savedConfigExportCurrencyName = selectedCurrency?.name || localCurrencyName;
      const savedConfigExportDecimalCurrency = hasDecimal(savedConfigExportCurrencyName);

      // JPYネイティブパス判定：出力通貨が保存時の表示通貨と一致する場合
      // 振り返りモード時は JPY 版が月別レート未対応のため、ローカル通貨パス（convertFn 適用版）を使う
      const useJpyNativeForExport = !reviewDate && savedConfigExportCurrencyName === savedDisplayCurrencyName;
      const jpySalesSourceForExport = useJpyNativeForExport ? displayVersionSalesChartDataForSavedConfig : null;
      const jpyMergedSourceForExport = useJpyNativeForExport ? displayVersionMergedChartDataForSavedConfig : null;
      const salesChartDataForSavedConfigExport = salesChartDataForSavedConfig;

      for (const chartDataItem of salesChartDataForSavedConfigExport) {
        const config = savedConfigs.find(c => c.id === chartDataItem.configId);
        if (!config) continue;

        // JPYネイティブデータを検索
        const jpySalesItem = jpySalesSourceForExport?.find(item => item.configId === chartDataItem.configId);
        const jpySalesDataset = jpySalesItem?.data?.datasets?.find((d: any) => d.id === "sales");
        const jpyMergedItem = jpyMergedSourceForExport?.find(m => m.configId === chartDataItem.configId);

        // JPYネイティブ版を優先、なければローカル通貨版を使用
        const useJpySales = jpySalesDataset && jpyMergedItem?.data;
        const salesDataset = useJpySales ? jpySalesDataset : chartDataItem.data?.datasets?.find((d: any) => d.id === "sales");
        if (salesDataset) {
          let sales: Decimal[];
          let effectiveCurrencyName: string;
          let effectiveDecimalCurrency: boolean;

          if (useJpySales) {
            // JPYネイティブパス：変換不要
            sales = salesDataset.data.map((v: number) => new Decimal(v));
            effectiveCurrencyName = savedDisplayCurrencyName;
            effectiveDecimalCurrency = hasDecimal(savedDisplayCurrencyName);
          } else {
            // ローカル通貨パス：変換あり
            const salesLocal = salesDataset.data.map((v: number) => new Decimal(v));
            // 振り返りモード: salesは calcDownsideSalesChartDataSet 内で既に表示通貨(convertFn月別レート)に変換済みのため、事前変換しない
            // 通常モード: 従来どおり単一レートで表示通貨へ事前変換
            sales = reviewDate
              ? salesLocal
              : (localCurrencyName !== savedConfigExportCurrencyName
                ? salesLocal.map((v: Decimal) => convertCurrency(v, localCurrencyName, savedConfigExportCurrencyName, currencyData))
                : salesLocal);
            effectiveCurrencyName = savedConfigExportCurrencyName;
            effectiveDecimalCurrency = savedConfigExportDecimalCurrency;
          }

          // 保存済み設定のチャートデータは既に期間短縮されているため、labelsもそれに合わせる
          const savedConfigLabels = profitAndLossDataForExport.labels.slice(0, sales.length);

          // 保存済み設定の数量データを取得
          const savedQuantitiesChartData = quantitiesChartDataForSavedConfig.find(
            q => q.configId === chartDataItem.configId
          );

          if (savedQuantitiesChartData) {
            // 保存済み設定の数量・単価変更がある場合、capexPartNoのquantityAndPriceを更新
            const savedConfigCapexPartNo = config.quantityAndPrice.length > 0
              ? capexPartNo.map(partNo => {
                const matched = config.quantityAndPrice.find(q => q.partNo === partNo.partNo);
                return matched
                  ? { ...partNo, quantityAndPrice: JSON.stringify(matched) }
                  : partNo;
              })
              : capexPartNo;

            let materialCosts: Decimal[] | null;
            if (useJpySales && jpyMergedItem?.data) {
              // JPYネイティブパス：JPY版のmergedChartDataで材料費を計算
              materialCosts = calcMaterialCost(
                jpyMergedItem.data,
                savedQuantitiesChartData.data,
                savedConfigCapexPartNo,
                savedConfigLabels,
                projectData.projectId!,
                savedDisplayCurrencyName,
                currencyData
              );
            } else {
              // ローカル通貨パス：ローカルで計算して変換
              const savedMergedChartData = mergedChartDataForSavedConfig.find(
                m => m.configId === chartDataItem.configId
              );
              const materialCostsLocal = savedMergedChartData ? calcMaterialCost(
                savedMergedChartData.data,
                savedQuantitiesChartData.data,
                savedConfigCapexPartNo,
                savedConfigLabels,
                projectData.projectId!,
                localCurrencyName,
                currencyData
              ) : null;
              // 振り返りモード: material はローカル通貨のまま関数に渡す（関数内で convertFn 月別レート変換）
              // 通常モード: 従来どおり単一レートで表示通貨へ事前変換
              materialCosts = reviewDate
                ? materialCostsLocal
                : (localCurrencyName !== savedConfigExportCurrencyName && materialCostsLocal
                  ? materialCostsLocal.map(v => convertCurrency(v, localCurrencyName, savedConfigExportCurrencyName, currencyData))
                  : materialCostsLocal);
            }

            // 保存済み設定の設備情報を取得
            const savedEquipmentConfig = config.equipmentAmounts || [];
            const configEquipments = originalEquipmentAmounts
              .map(eq => {
                const savedEq = savedEquipmentConfig.find(se => se.equipmentId === eq.equipmentId);
                return savedEq ? { ...eq, selected: true } : null;
              })
              .filter((eq): eq is EquipmentExtType => eq !== null);

            const configApplyDownside = config.applyDownside !== false;
            const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;
            const savedConfigData = calcMonthlyProfitAndLossDetails(
              sales,
              materialCosts || [],
              savedConfigLabels,
              configApplyDownside,
              configEquipments,
              applyScenarioLaborCostToProjectData(
                projectData,
                config.scenarioLaborCostByMonth,
                config.scenarioOverseasFactoryExpensesByMonth,
                savedConfigLabels
              ),
              savedConfigCapexPartNo,
              effectiveCurrencyName,
              currencyData,
              configDownsideIndex,
              effectiveDecimalCurrency,
              uniqueProcessData,
              bomData,
              projectData.moldSalesByProject,
              projectData.developmentSalesByProject,
              projectData.equipmentSalesByProject,
              undefined,
              reviewDate ? convertWithRate : undefined,
              // No.411対応（9章）: 保存済み設定もダウンサイド（ストレス指数）の一種のため同様に延長
              !reviewDate ? incrementalCashFlowOriginal?.labels : undefined,
            );

            if (savedConfigData) {
              const sheetName = sanitizeSheetName(config.name || `保存済み${config.id}`, '（月別損益）');
              // calcMonthlyProfitAndLossDetails内で既に選択通貨に変換済みなのでskipConversion=true
              const sheetData = createMonthlyProfitLossSheet(savedConfigData, `月別損益（${config.name || '保存済み設定'}）`, true);
              const sheet = XLSX.utils.aoa_to_sheet(sheetData);
              sheet["!cols"] = getAutoColWidths(sheetData);
              XLSX.utils.book_append_sheet(workbook, sheet, sheetName);
            }
          }
        }
      }

      // PJ全体シートを作成（過去PJ設備 + 現PJ設備のmerge）
      if (projectData?.pastProjectId && pastEquipmentAmounts.length > 0 && salesChartDataForExport?.datasets) {
        const salesDataset = salesChartDataForExport.datasets.find((d: any) => d.id === "sales");
        if (salesDataset) {
          const sales = salesDataset.data.map((v: string | number) => new Decimal(v));
          const materialCosts = calcMaterialCost(
            mergedChartDataOriginalForExport,
            quantitiesChartDataOriginal,
            capexPartNo,
            profitAndLossDataForExport.labels,
            projectData.projectId!,
            exportCurrencyName,
            currencyData
          );

          // mergeEquipmentAmounts: 過去PJ設備 + 現PJ設備
          const mergeEquipmentAmounts = [...pastEquipmentAmounts, ...originalEquipmentAmounts];

          const allData = calcMonthlyProfitAndLossDetails(
            sales,
            materialCosts || [],
            profitAndLossDataForExport.labels,
            false,
            mergeEquipmentAmounts,
            projectData,
            capexPartNo,
            exportCurrencyName,
            currencyData,
            downsideIndexGraph,
            exportDecimalCurrency,
            uniqueProcessData,
            bomData,
            projectData.moldSalesByProject,
            projectData.developmentSalesByProject,
            projectData.equipmentSalesByProject
          );

          if (allData) {
            // 現PJ設備のみで投資対象設備の減価償却費を再計算（過去PJ分を含まない正確な値）
            const currentEquipDepRaw = calcEquipmentDepreciationByYearMonth(
              getTotalFiscalYearsByPartNo(capexPartNo),
              convertEquipmentData(originalEquipmentAmounts, exportCurrencyName, currencyData, reviewDate ? convertWithRate : undefined),
              exportDecimalCurrency,
              projectData.projectStartDate || "",
              false
            );
            allData.equipmentDepreciation = currentEquipDepRaw
              .slice(0, allData.labels.length)
              .map(e => e.value);
            // 減価償却費・工場経費・売上原価・営業利益を再計算（equipmentDepreciation変更に伴い）
            const pastEquipCost = allData.pastEquipmentCost || [];
            allData.depreciation = allData.equipmentDepreciation.map((val, i) =>
              val.plus(pastEquipCost[i] || new Decimal(0))
                .plus(allData.factoryCost[i] || new Decimal(0))
                .plus(allData.otherEquipmentCost[i] || new Decimal(0))
            );
            allData.factoryExpenses = allData.depreciation.map((val, i) =>
              val.plus(allData.overHeadCost[i] || new Decimal(0))
            );
            allData.salesCost = allData.materialCost.map((val, i) =>
              val.plus(allData.outsideCost[i] || new Decimal(0))
                .plus(allData.laborCost[i] || new Decimal(0))
                .plus(allData.domesticLaborCost[i] || new Decimal(0))
                .plus(allData.factoryExpenses[i] || new Decimal(0))
                .plus(allData.domesticFactoryExpenses[i] || new Decimal(0))
                .plus(allData.scrapCost[i] || new Decimal(0))
            );
            allData.profit = allData.totalSales.map((val, i) =>
              val.minus(allData.salesCost[i] || new Decimal(0))
                .minus(allData.sGAExpenses[i] || new Decimal(0))
                .minus(allData.otherCost[i] || new Decimal(0))
            );
            const sheetData = createMonthlyProfitLossSheet(allData, t('features.InvestmentScreening.SimulationNewProduct.excel.monthlyProfitLossWholeProject'), true);
            const sheet = XLSX.utils.aoa_to_sheet(sheetData);
            sheet["!cols"] = getAutoColWidths(sheetData);
            XLSX.utils.book_append_sheet(workbook, sheet, t('features.InvestmentScreening.SimulationNewProduct.excel.wholeProjectMonthlyProfitLossSheetName'));
          }
        }
      }

      // 増分キャッシュフロー（PJ全体）シート追加
      if (incrementalCashFlowAll) {
        const cfSheetData = createIncrementalCashFlowSheet(incrementalCashFlowAll, t('features.InvestmentScreening.SimulationNewProduct.excel.incrementalCashFlowWholeProject'));
        const cfSheet = XLSX.utils.aoa_to_sheet(cfSheetData);
        cfSheet["!cols"] = getAutoColWidths(cfSheetData);
        XLSX.utils.book_append_sheet(workbook, cfSheet, t('features.InvestmentScreening.SimulationNewProduct.excel.incrementalCashFlowWholeProject'));
      }

      // 増分キャッシュフロー（当初投資）シート追加
      if (incrementalCashFlowPast) {
        const cfSheetData = createIncrementalCashFlowSheet(incrementalCashFlowPast, t('features.InvestmentScreening.SimulationNewProduct.excel.incrementalCashFlowPastInvestment'));
        const cfSheet = XLSX.utils.aoa_to_sheet(cfSheetData);
        cfSheet["!cols"] = getAutoColWidths(cfSheetData);
        XLSX.utils.book_append_sheet(workbook, cfSheet, t('features.InvestmentScreening.SimulationNewProduct.excel.incrementalCashFlowPastInvestment'));
      }

      // 増分キャッシュフローシートの追加
      // 注意: 増分CFデータは常にローカル通貨なので skipConversion は常に false
      if (incrementalCashFlowOriginal) {
        const sheetData = createIncrementalCashFlowSheet(incrementalCashFlowOriginal, t('features.InvestmentScreening.SimulationNewProduct.excel.incrementalCashFlowOriginal'));
        const sheet = XLSX.utils.aoa_to_sheet(sheetData);
        sheet["!cols"] = getAutoColWidths(sheetData);
        XLSX.utils.book_append_sheet(workbook, sheet, t('features.InvestmentScreening.SimulationNewProduct.excel.incrementalCashFlowOriginal'));
      }
      if (incrementalCashFlowDownside) {
        // No.411対応（8章）: 当初計画側と同じラベルまで年月列を延長する
        const sheetData = createIncrementalCashFlowSheet(incrementalCashFlowDownside, t('features.InvestmentScreening.SimulationNewProduct.excel.incrementalCashFlowDownside'), false, incrementalCashFlowOriginal?.labels);
        const sheet = XLSX.utils.aoa_to_sheet(sheetData);
        sheet["!cols"] = getAutoColWidths(sheetData);
        XLSX.utils.book_append_sheet(workbook, sheet, t('features.InvestmentScreening.SimulationNewProduct.excel.incrementalCashFlowDownside'));
      }
      if (incrementalCashFlowForSavedConfig.length > 0 && savedConfigs.length > 0) {
        for (const savedItem of incrementalCashFlowForSavedConfig) {
          const config = savedConfigs.find(c => c.id === savedItem.configId);
          if (config && savedItem.data) {
            const configName = config.name || `保存済み${config.id}`;
            const sheetName = sanitizeSheetName(configName, '（増分CF）');
            // No.411対応（8章）: 保存済み設定もダウンサイド（ストレス指数）の一種のため同様に延長
            const sheetData = createIncrementalCashFlowSheet(savedItem.data, `増分CF（${configName}）`, false, incrementalCashFlowOriginal?.labels);
            const sheet = XLSX.utils.aoa_to_sheet(sheetData);
            sheet["!cols"] = getAutoColWidths(sheetData);
            XLSX.utils.book_append_sheet(workbook, sheet, sheetName);
          }
        }
      }

      // ギャップシートの追加（顧客需要と設備キャパシティ + 設備生産数量からのギャップ）
      // グラフ描画に必要なデータが全て存在する場合のみシートを追加
      if (
        originalProfitAndLossByMonth?.quantityByPartNo &&
        workingDayByYear.length > 0 &&
        lineCountByYear.length > 0 &&
        holidayByYear.length > 0 &&
        availabilityRateByMonth.length > 0
      ) {
        // ベースデータ（全シート共通の元データ）
        const baseLabels = originalProfitAndLossByMonth.labels;                // 年月ラベル
        const baseQuantityByPartNo = originalProfitAndLossByMonth.quantityByPartNo; // PartNo別数量

        // 24h稼働キャパ（当初計画・ダウンサイド用：BOM CT/歩留 + 工場稼働日数 + ベースライン数で計算）
        const full24hCapacity: number[] = [];
        const fullFactoryWorkingDays: number[] = [];
        for (let i = 0; i < baseLabels.length; i++) {
          const { year, month } = getFiscalYearMonth(baseLabels, i);
          const ct = getCycleTimeFromBom(baseLabels[i]) ?? 0;
          const yr = getYieldRateFromBom(baseLabels[i]) ?? 0;
          const fwd = getMonthlyDataByYearAndMonth(factoryWorkingDayByYear, year, month, "workingDay");
          const lc = getMonthlyDataByYearAndMonth(lineCountByYear, year, month, "lineCount");
          const rawQty = ct > 0 ? Math.round(fwd * 86400 / ct) : 0;
          const cap = Math.round(rawQty * yr * lc);
          full24hCapacity[i] = Number.isNaN(cap) || cap === Infinity ? 0 : cap;
          fullFactoryWorkingDays[i] = fwd;
        }

        // 生産キャパグラフ（既存ライン含む）のセクションをギャップシートの末尾に追加する
        // 生産キャパグラフOFF（不要）のときは出力しない（申請書と同じ扱い）
        const elqSource = elq.show ? existingLineCapacitySource : null;
        const appendExistingLineCapacitySection = (
          sheetData: (string | number)[][],
          source: TExistingLineCapacityVersion | undefined,
          sheetTitle: string,
        ): (string | number)[][] => {
          if (!elqSource || !source) return sheetData;
          return [...sheetData, [], ...createExistingLineCapacitySectionRows(t, elq.data, source, elqSource.labels, sheetTitle, capexPartNo)];
        };

        // --- 当初計画（ギャップ）シート ---
        // isDownside=false: ストレス指数なし、期間短縮なし
        // CT/歩留: BOMデータをそのまま使用（getCycleTimeFromBom / getYieldRateFromBom）
        const originalCapacity = calcCapacityDetails(
          baseLabels, baseQuantityByPartNo,
          workingDayByYear, holidayByYear, availabilityRateByMonth, lineCountByYear,
          false, getCycleTimeFromBom, getYieldRateFromBom
        );
        const originalProduction = calcProductionQuantityDetails(
          baseLabels, baseQuantityByPartNo,
          workingDayByYear, holidayByYear, availabilityRateByMonth, lineCountByYear,
          false, getCycleTimeFromBom, getYieldRateFromBom
        );
        // 2つの計算結果を1シートにまとめてワークブックに追加
        const originalGapSheetData = appendExistingLineCapacitySection(
          createGapDetailsSheet(originalCapacity, originalProduction, t('features.InvestmentScreening.SimulationNewProduct.excel.gapDetailsOriginal'), full24hCapacity, fullFactoryWorkingDays),
          elqSource?.original,
          t('features.InvestmentScreening.SimulationNewProduct.excel.gapDetailsOriginal'),
        );
        const originalGapSheet = XLSX.utils.aoa_to_sheet(originalGapSheetData);
        originalGapSheet["!cols"] = getAutoColWidths(originalGapSheetData);
        XLSX.utils.book_append_sheet(workbook, originalGapSheet, t('features.InvestmentScreening.SimulationNewProduct.excel.originalGapSheetName'));

        // --- ダウンサイド（ギャップ）シート ---
        // isDownside=true: 販売個数にストレス指数適用 + 期間短縮
        // キャパの計算自体はベースと同じ（ストレスの影響を受けるのは販売個数/出荷見込み数のみ）
        const downsideCapacity = calcCapacityDetails(
          baseLabels, baseQuantityByPartNo,
          workingDayByYear, holidayByYear, availabilityRateByMonth, lineCountByYear,
          true, getCycleTimeFromBom, getYieldRateFromBom
        );
        const downsideProduction = calcProductionQuantityDetails(
          baseLabels, baseQuantityByPartNo,
          workingDayByYear, holidayByYear, availabilityRateByMonth, lineCountByYear,
          true, getCycleTimeFromBom, getYieldRateFromBom
        );
        const dsLen = downsideCapacity.labels.length;
        const downsideGapSheetData = appendExistingLineCapacitySection(
          createGapDetailsSheet(downsideCapacity, downsideProduction, t('features.InvestmentScreening.SimulationNewProduct.excel.gapDetailsDownside'), full24hCapacity.slice(0, dsLen), fullFactoryWorkingDays.slice(0, dsLen)),
          elqSource?.modified,
          t('features.InvestmentScreening.SimulationNewProduct.excel.gapDetailsDownside'),
        );
        const downsideGapSheet = XLSX.utils.aoa_to_sheet(downsideGapSheetData);
        downsideGapSheet["!cols"] = getAutoColWidths(downsideGapSheetData);
        XLSX.utils.book_append_sheet(workbook, downsideGapSheet, t('features.InvestmentScreening.SimulationNewProduct.excel.downsideGapSheetName'));

        // --- 保存済み設定（ギャップ）シート ---
        // 選択中の保存済み設定ごとにシートを追加
        for (const chartDataItem of salesChartDataForSavedConfig) {
          const config = savedConfigs.find(c => c.id === chartDataItem.configId);
          if (!config) continue;

          // 保存済み設定の改善後データを取得
          const savedConfigWorkingDayData = config.improvedWorkingDayByYear;        // 改善後稼働日数
          const savedConfigLineCountData = config.improvedLineCountByYear;          // 改善後ライン数
          const savedConfigHolidayData = config.improvedHolidayByYear;              // 改善後休日出勤日数
          const savedConfigAvailabilityData = config.improvedAvailabilityRateByMonth; // 改善後稼働率
          const savedConfigYieldRateList = config.improvedYieldRateList || [];       // 改善後歩留率リスト
          const savedConfigCycleTimeList = config.improvedCycleTimeList || [];       // 改善後サイクルタイムリスト

          // 保存済み設定の数量データ（設定に数量変更があればそちらを使用、なければベースデータ）
          let savedQuantityByPartNo = baseQuantityByPartNo;
          if (config.quantityAndPrice.length > 0) {
            const converted = convertToOriginalProfitAndLossByMonthTable(config.quantityAndPrice);
            // 変更PartNoのみ保存されるため、originalと結合して全PartNoを含める
            savedQuantityByPartNo = {
              ...baseQuantityByPartNo,
              ...converted.quantityByPartNo,
            };
          }

          // CT/歩留の取得関数をラップ: 改善後データを優先し、なければBOMデータにフォールバック
          const savedCycleTimeFn = (label: string) => getApplicableCycleTime(label, savedConfigCycleTimeList, getCycleTimeFromBom);
          const savedYieldRateFn = (label: string) => getApplicableYieldRate(label, savedConfigYieldRateList, getYieldRateFromBom);

          // キャパシティ計算: 改善後データで計算（config.applyDownsideに応じてストレス適用）
          const configApplyDownside = config.applyDownside !== false;
          const savedCapacity = calcCapacityDetails(
            baseLabels, savedQuantityByPartNo,
            savedConfigWorkingDayData, savedConfigHolidayData, savedConfigAvailabilityData, savedConfigLineCountData,
            configApplyDownside, savedCycleTimeFn, savedYieldRateFn
          );
          // 生産数量計算: 改善後データで計算 + ベースデータ（末尾3引数）で改善分を分離計算
          const savedProduction = calcProductionQuantityDetails(
            baseLabels, savedQuantityByPartNo,
            savedConfigWorkingDayData, savedConfigHolidayData, savedConfigAvailabilityData, savedConfigLineCountData,
            configApplyDownside, savedCycleTimeFn, savedYieldRateFn,
            availabilityRateByMonth, getCycleTimeFromBom, getYieldRateFromBom  // ベースデータ（改善分の差分計算用）
          );

          // 工場稼働日数・24h稼働キャパ（保存済み設定用：改善後データで計算）
          const savedConfigFactoryWorkingDayData = (config.improvedWorkingDaysData || []).map(wd => ({
            fiscalYear: wd.fiscalYear,
            workingDay: wd.workingDaysData?.factoryWorkingDays || [],
          }));
          const saved24hCapacity: number[] = [];
          const savedFactoryWorkingDays: number[] = [];
          for (let i = 0; i < baseLabels.length; i++) {
            const { year, month } = getFiscalYearMonth(baseLabels, i);
            const ct = savedCycleTimeFn(baseLabels[i]) ?? 0;
            const yr = savedYieldRateFn(baseLabels[i]) ?? 0;
            const fwd = savedConfigFactoryWorkingDayData.length > 0
              ? getMonthlyDataByYearAndMonth(savedConfigFactoryWorkingDayData, year, month, "workingDay")
              : getMonthlyDataByYearAndMonth(factoryWorkingDayByYear, year, month, "workingDay");
            const lc = getMonthlyDataByYearAndMonth(savedConfigLineCountData, year, month, "lineCount");
            const rawQty = ct > 0 ? Math.round(fwd * 86400 / ct) : 0;
            const cap = Math.round(rawQty * yr * lc);
            saved24hCapacity[i] = Number.isNaN(cap) || cap === Infinity ? 0 : cap;
            savedFactoryWorkingDays[i] = fwd;
          }

          const configName = config.name || `保存済み${config.id}`;
          const gapSheetName = sanitizeSheetName(configName, '（ギャップ）');
          const scLen = savedCapacity.labels.length;
          const savedGapSheetData = appendExistingLineCapacitySection(
            createGapDetailsSheet(savedCapacity, savedProduction, configName, saved24hCapacity.slice(0, scLen), savedFactoryWorkingDays.slice(0, scLen)),
            elqSource?.savedConfigs.find(item => item.configId === chartDataItem.configId),
            configName,
          );
          const savedGapSheet = XLSX.utils.aoa_to_sheet(savedGapSheetData);
          savedGapSheet["!cols"] = getAutoColWidths(savedGapSheetData);
          XLSX.utils.book_append_sheet(workbook, savedGapSheet, gapSheetName);
        }
      }

      // ファイル出力
      const formatted = today.toISOString().split("T")[0].replace(/-/g, "");
      const fileNamePrefix = t('features.InvestmentScreening.SimulationNewProduct.excel.monthlyProfitLossFileNamePrefix');
      XLSX.writeFile(workbook, `${fileNamePrefix}_${projectId}_${formatted}.xlsx`);

      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.monthlyExcelExportSuccess'),
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      console.log(`${functionName} SUCCESS`);
    } catch (error) {
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.excelExportFailed'),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      console.error(`${functionName} ERROR:`, error);
    }
  };

  // #endregion Excel出力関連

  /**
   * 「確認」ボタン押下処理
   */
  const handleModalOpen: React.MouseEventHandler<HTMLButtonElement> = (event) => {

    // フォーカスを外す
    event.currentTarget.blur();

    // どの部署からの確認かを保持
    const { name } = event.target as HTMLButtonElement;
    setConfirmSource(name);

    if (!projectData) {
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.registerFromBasicInfo'),
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    if (!requiredDataNotice(projectData, capexPartNo, equipmentAmounts, productionLine)) {
      return;
    }

    if (projectData?.pastProjectId) {
      if (!validPartNo(capexPartNo, pastCapexPartNo)) {
        return;
      }
    }

    if (validate() === false) {
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationNewProduct.message.inputError'),
        status: 'warning',
        duration: 2000,
        isClosable: true,
      });
      return;
    }

    setSelectedCustomerProduct(conditionTable?.customerIndustryName || "");

    // 確認モーダル表示
    onOpenConfirmModal();
  }

  /**
   * 確認モーダルで「保存」ボタン押下
   */
  const handleConfirm = async (e: React.MouseEvent<HTMLButtonElement>) => {
    // フォーカスを外す
    e.currentTarget.blur();

    if (isSaving) return;
    setIsSaving(true);

    // 既存ライン生産数量（生産キャパグラフ）→ チャートデータの順に保存
    // 生産キャパグラフOFF＝不要として、既存ライン生産数量は null で保存する（次回表示時もOFF）
    // 既存ライン生産数量の保存に失敗した場合は、チャート保存・確認登録を行わない
    const result = await elq.save() && await saveChartData();

    if (result) {
      try {
        // ワークフローテーブルを更新
        await updateConfirm(
          WebAPI,
          projectId,
          WorkflowId.SimulationNewProduct,
          employeeId,
          confirmSource,
          "true",
          reviewDate,
        );
        // 確認担当者JSONを取得
        const confirmor = await getConfirmor(
          WebAPI,
          projectId,
          reviewDate,
        );
        setConfirmor(confirmor);

        // 確認モーダルを閉じる
        onCloseConfirmModal();
      } catch (error) {
        // TODO 処理失敗時は暫定でスルーする
      }
    }

    setIsSaving(false);
  }

  /**
   * チャートデータを保存する。
   * @returns true：処理成功、false：処理失敗
   */
  const saveChartData = async () => {
    const query = `
    mutation updateChartData($input: ChartDataInput!) {
      updateChartData(input: $input) {status}
    }
  `;

    // APIリクエスト実行
    const result = await WebAPI.request({
      query: query,
      variables: {
        input: {
          projectId: projectId,
          applyDownside: (selectedCustomerProduct === CustomerIndustry.InVehicle.name),
          quantitiesChartDataOriginal: JSON.stringify(quantitiesChartDataOriginal),
          quantitiesChartDataModified: JSON.stringify(quantitiesChartDataModified),
          quantitiesChartDataForSavedConfig: JSON.stringify(quantitiesChartDataForSavedConfig),
          mergedChartDataOriginal: JSON.stringify(mergedChartDataOriginal),
          mergedChartDataModified: JSON.stringify(mergedChartDataModified),
          mergedChartDataForSavedConfig: JSON.stringify(mergedChartDataForSavedConfig),
          salesChartData: JSON.stringify(MovingAverageRate),
          salesChartDataModified: JSON.stringify(MovingAverageRateModified),
          salesChartDataAll: JSON.stringify(salesChartDataAll),
          salesChartDataPast: JSON.stringify(salesChartDataPast),
          salesChartDataForSavedConfig: JSON.stringify(salesChartDataForSavedConfig),
          combinedChartData: JSON.stringify({
            ...combinedChartData,
            // ※生産性向上シミュレーション都合で営業利益額と営業利益率を保存
            totalProfit: totalProfitOriginal ? convertCurrency(totalProfitOriginal, selectedCurrency.name, localCurrencyName, currencyData)?.toDecimalPlaces(4).toString() : "0",
            displayTotalProfit: calcDisplayTotalProfit(salesChartData)?.toString(),
            profitRate: profitRateOriginal,
            realProfitRate: realProfitRateOriginal,
            realProfitRateByMonth: realProfitRateByMonthOriginal,
          }),
          combinedChartDataModified: JSON.stringify({
            ...combinedChartDataModified,
            // ※生産性向上シミュレーション都合で営業利益額と営業利益率を保存
            totalProfit: totalProfitModified ? convertCurrency(totalProfitModified, selectedCurrency.name, localCurrencyName, currencyData)?.toDecimalPlaces(4).toString() : "0",
            displayTotalProfit: calcDisplayTotalProfit(salesChartDataModified)?.toString(),
            profitRate: profitRateModified,
            realProfitRate: realProfitRateModified,
            realProfitRateByMonth: realProfitRateByMonthModified,
          }),
          combinedChartDataAll: JSON.stringify(combinedChartDataAll),
          combinedChartDataPast: JSON.stringify(combinedChartDataPast),
          combinedChartDataForSavedConfig: JSON.stringify(combinedChartDataForSavedConfig),
          monthOfRecoveryOriginal: monthOfRecoveryOriginal.join(","),
          monthOfRecoveryModified: monthOfRecoveryModified.join(","),
          monthOfRecoveryAll: monthOfRecoveryAll.join(","),
          monthOfRecoveryPast: monthOfRecoveryPast.join(","),
          monthOfRecoveryForSavedConfig: JSON.stringify(monthOfRecoveryForSavedConfig),
          gapChartDataOriginal: JSON.stringify(gapChartDataOriginal),
          gapChartDataModified: JSON.stringify(gapChartDataModified),
          gapChartDataForSavedConfig: JSON.stringify(gapChartDataForSavedConfig),
          productionQuantityChartDataOriginal: JSON.stringify(productionQuantityChartDataOriginal),
          productionQuantityChartDataModified: JSON.stringify(productionQuantityChartDataModified),
          productionQuantityChartDataForSavedConfig: JSON.stringify(productionQuantityChartDataForSavedConfig),
          // 生産キャパグラフ：OFF（不要）のときは null で保存し、申請書に表示しない
          existingLineCapacityChartDataOriginal: elq.show ? JSON.stringify(elq.chartDataOriginal) : null,
          existingLineCapacityChartDataModified: elq.show ? JSON.stringify(elq.chartDataModified) : null,
          existingLineCapacityChartDataForSavedConfig: elq.show ? JSON.stringify(elq.chartDataForSavedConfig) : null,
          productionCapacityChartData: null,                            // 生産性向上シミュレーションでのみ保存
          productionCapacityChartDataModified: null,                    // 生産性向上シミュレーションでのみ保存
          productionCapacityChartDataForSavedConfig: null,              // 生産性向上シミュレーションでのみ保存
          productionCapacityProcessChartDataList: null,                 // 生産性向上シミュレーションでのみ保存
          productionCapacityProcessChartDataForSavedConfig: null,       // 生産性向上シミュレーションでのみ保存
          rationalizationSummaryChartData: null,                        // 生産性向上シミュレーションでのみ保存
          selectedSimulationConfigIds: selectedConfigIds.join(","),
          downsideRisk: (downsideRiskDraftRef.current ?? "").trim(),
          downsideIndex: convertDownsideIndexToDynamoFormat(),
          updateDate: projectData?.updateDate,
          finalInvestmentReason: (finalInvestmentReasonDraftRef.current ?? "").trim(),
          ...(reviewDate && { reviewDate }),
        }
      }
    });

    // console.log(`response = `, result);

    if (result?.data?.updateChartData?.status === "success") {
      toast({
        title: t('features.InvestmentScreening.SimulationNewProduct.message.saveSuccess'),
        description: t('features.InvestmentScreening.SimulationNewProduct.message.savedInputContent'),
        status: 'success',
        duration: 5000,
        isClosable: true,
      });

      // データ再取得
      await fetchData();

      return true;
    } else if (result?.data?.updateChartData.status === 'expired') {
      toast({
        title: TITLE,
        description: Messages.expiredMessage,
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
      console.warn(`Conflict error. updateChartData.`);
      onCloseConfirmModal();
    } else {
      toast({
        title: t('features.InvestmentScreening.SimulationNewProduct.message.saveFailedShort'),
        description: t('features.InvestmentScreening.SimulationNewProduct.message.saveFailed'),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      console.error(`Failed to call API updateChartData.errors = `, result?.errors);
      return false;
    }
  }

  /**
   * downsideIndexEnable(有効・無効情報)をDB保存用に変換する。
   * @returns DB保存用json文字列
   */
  const convertDownsideIndexEnableToDynamoFormat = (): string => {
    let data = [];

    // 数量経時変化
    data.push({
      id: DownsideItemsTitle.quantityChangeOverTime.id,
      enable: downsideIndexEnable.isEnabledQuantityChangeOverTime
    });

    // 数量上下変動
    data.push({
      id: DownsideItemsTitle.quantityFluctuation.id,
      enable: downsideIndexEnable.isEnabledFluctuationInQuantity
    });

    // 単価経時変化
    data.push({
      id: DownsideItemsTitle.priceChangeOverTime.id,
      enable: downsideIndexEnable.isEnabledPriceChangeOverTime
    });

    // 顧客製品寿命
    data.push({
      id: DownsideItemsTitle.customerProductLifecycle.id,
      enable: downsideIndexEnable.isEnabledCustomerProductLifecycle
    });

    // 為替変動（単価）
    data.push({
      id: DownsideItemsTitle.exchangeRateFluctuationToPrice.id,
      enable: downsideIndexEnable.isEnabledCurrencyFluctuationToPrice
    });

    // 為替変動（原価）
    data.push({
      id: DownsideItemsTitle.exchangeRateFluctuationToCost.id,
      enable: downsideIndexEnable.isEnabledCurrencyFluctuationToCost
    });

    // 材料高騰
    data.push({
      id: DownsideItemsTitle.materialCostIncrease.id,
      enable: downsideIndexEnable.isEnabledRisingMaterialCosts
    });

    // 労務費高騰
    data.push({
      id: DownsideItemsTitle.laborCostIncrease.id,
      enable: downsideIndexEnable.isEnabledRisingLaborCosts
    });

    // 競合状態（数量）
    data.push({
      id: DownsideItemsTitle.competitorStatusToQuantity.id,
      enable: downsideIndexEnable.isEnabledCompetitorConditionToQuantity
    });

    // 競合状態（単価）
    data.push({
      id: DownsideItemsTitle.competitorStatusToPrice.id,
      enable: downsideIndexEnable.isEnabledCompetitorConditionToPrice
    });

    return JSON.stringify(data);
  }

  /**
   * downsideIndexTableDisplayをDB保存用に変換する。
   * @returns DB保存用json文字列
   */
  const convertDownsideIndexToDynamoFormat = (): string => {
    let data = [];
    for (let i = 0; i < downsideIndexTableDisplay.length; i++) {
      let row: DownsideIndexTableRowDisplay = downsideIndexTableDisplay[i];
      // if (row.yearIndex === 0) continue;
      let stIdxValue: number = 0;

      // 数量経時変化
      stIdxValue = row.quantityChangeOverTime;
      if (!downsideIndexEnable.isEnabledQuantityChangeOverTime) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.quantityChangeOverTimeId,
        stressIndex: stIdxValue
      });

      // 数量上下変動
      stIdxValue = row.fluctuationInQuantity;
      if (!downsideIndexEnable.isEnabledFluctuationInQuantity) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.fluctuationInQuantityId,
        stressIndex: stIdxValue
      });

      // 単価経時変化
      stIdxValue = row.priceChangeOverTime;
      if (!downsideIndexEnable.isEnabledPriceChangeOverTime) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.priceChangeOverTimeId,
        stressIndex: stIdxValue
      });

      // 顧客製品寿命
      if (row.yearIndex === 0) {
        stIdxValue = row.customerProductLifecycle;
        if (!downsideIndexEnable.isEnabledCustomerProductLifecycle) {
          // 無効の場合、値をクリア
          stIdxValue = 0;
        }
        data.push({
          yearIndex: row.yearIndex + 1,
          itemId: row.customerProductLifecycleId,
          stressIndex: stIdxValue
        });
      }

      // 為替変動（単価）
      stIdxValue = row.currencyFluctuationToPrice;
      if (!downsideIndexEnable.isEnabledCurrencyFluctuationToPrice) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.currencyFluctuationToPriceId,
        stressIndex: stIdxValue
      });

      // 為替変動（原価）
      stIdxValue = row.currencyFluctuationToCost;
      if (!downsideIndexEnable.isEnabledCurrencyFluctuationToCost) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.currencyFluctuationToCostId,
        stressIndex: stIdxValue
      });

      // 材料高騰
      stIdxValue = row.risingMaterialCosts;
      if (!downsideIndexEnable.isEnabledRisingMaterialCosts) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.risingMaterialCostsId,
        stressIndex: stIdxValue
      });

      // 労務費高騰
      stIdxValue = row.risingLaborCosts;
      if (!downsideIndexEnable.isEnabledRisingLaborCosts) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.risingLaborCostsId,
        stressIndex: stIdxValue
      });

      // 競合状態（数量）
      stIdxValue = DownsideItems.competitorStatus1stToQuantity.id === row.competitorConditionToQuantityId ? row.competitorConditionToQuantity : 0;
      if (!downsideIndexEnable.isEnabledCompetitorConditionToQuantity) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.competitorConditionToQuantityId,
        stressIndex: stIdxValue
      });

      // 競合状態（単価）
      stIdxValue = DownsideItems.competitorStatus1stToPrice.id === row.competitorConditionToPriceId ? row.competitorConditionToPrice : 0;
      if (!downsideIndexEnable.isEnabledCompetitorConditionToPrice) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.competitorConditionToPriceId,
        stressIndex: stIdxValue
      });
    }

    return JSON.stringify(data);
  }

  useEffect(() => {
    const widths: Record<string, number> = Object.keys(refs).reduce((acc, key) => {
      acc[key] = refs[key]?.current?.offsetWidth || 0;
      return acc;
    }, {} as Record<string, number>);
    setButtonWidths(widths);
  }, []);

  useEffect(() => {
    const fetchConfirmor = async () => {
      try {
        // 確認担当者JSONを取得
        const confirmorData = await getConfirmor(
          WebAPI,
          projectId,
          reviewDate,
        );
        setConfirmor(confirmorData);
      } catch (error) {
        // TODO 処理失敗時は暫定でスルーする
      }
    };
    if (projectId) {
      fetchConfirmor();
    }
  }, [projectId, reviewDate]);

  useEffect(() => {
    if (confirmor?.simulationNewProduct) {
      const updatedNames = Object.keys(names).reduce((acc, division) => {
        const divisionData = confirmor.simulationNewProduct?.[division as keyof Confirmor['simulationNewProduct']];
        if (Array.isArray(divisionData)) {
          acc[division] = divisionData;
        } else {
          acc[division] = [];
        }
        return acc;
      }, {} as Record<string, ConfirmorInfo[]>);
      setNames(updatedNames);
    }
  }, [confirmor]);

  /**
   * 指定した値でプロジェクト情報を変更する。
   * @param name 変更先プロパティ名
   * @param value 入力項目
   */
  const changeProjectData = (name: string, value: any) => {
    setProjectData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  /**
   * 指定した値でストレス指数の有効/無効を変更する。
   * @param name 変更先プロパティ名
   * @param value 入力項目
   */
  const changeDownsideIndexEnable = (name: string, value: any) => {
    setDownsideIndexEnable((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  /**
   * 設備情報変更
   * @param equipmentId 設備ID
   * @param propertyName プロパティ名
   * @param value 値
   */
  const changeEquipmentAmounts = useCallback((equipmentId: string, propertyName: keyof EquipmentExtType, value: EquipmentExtType[typeof propertyName]) => {
    setEquipmentAmounts((prevState) =>
      prevState.map(
        (e) => e.equipmentId === equipmentId ?
          { ...e, [propertyName]: value } : e
      )
    );
  }, []);

  /**
   * 設備数量変更（金額も再計算）
   * @param equipmentId 設備ID
   * @param newQuantity 新しい数量
   */
  const changeEquipmentQuantity = useCallback((equipmentId: string, newQuantity: number) => {
    setEquipmentAmounts((prevState) =>
      prevState.map((e) => {
        if (e.equipmentId === equipmentId) {
          // 金額 = 単価 × 数量
          const newAmount = new Decimal(e.unitPrice || 0).mul(newQuantity).toString();
          return {
            ...e,
            changeInQuantity: newQuantity,
            amount: newAmount
          };
        }
        return e;
      })
    );
  }, []);

  // ▼ 営業利益率に移動平均反映
  /**移動平均反映後のsalesChartData（当初計画） */
  const [MovingAverageRate, setMovingAverageRate] = useState<any>(null);
  /**移動平均反映後のsalesChartData（ダウンサイド） */
  const [MovingAverageRateModified, setMovingAverageRateModified] = useState<any>(null);
  /**移動平均反映後のdisplaySalesChartData（当初計画・表示用） */
  const [displayMovingAverageRate, setDisplayMovingAverageRate] = useState<any>(null);
  /**移動平均反映後のdisplaySalesChartData（ダウンサイド・表示用） */
  const [displayMovingAverageRateModified, setDisplayMovingAverageRateModified] = useState<any>(null);

  /**
  * 営業利益率のチャートデータを作成（移動平均算出）
  * 
  * @param {Decimal[]} dataArray - 元のデータ配列
  * @param {number} windowSize - 移動平均のウィンドウサイズ
  * @returns {Decimal[]} 移動平均後のデータ配列
  */
  const calculateMovingAverage = (dataArray: Decimal[], windowSize: number): Decimal[] => {
    const movingAverageArray: Decimal[] = [];
    for (let i = 0; i < dataArray.length; i++) {
      const start = Math.max(0, i - windowSize + 1); // ウィンドウの開始点
      const end = i + 1; // ウィンドウの終了点
      const window = dataArray.slice(start, end);
      const sum = window.reduce((acc: Decimal, value: Decimal) => acc.plus(value), new Decimal(0));
      movingAverageArray.push(sum.div(window.length));
    }
    return movingAverageArray;
  };

  // MovingAverageに移動平均反映後のデータをセット
  useEffect(() => {
    if (!salesChartData && !salesChartDataModified) return;
    if (salesChartData) {
      const updated = processData(salesChartData);
      setMovingAverageRate(updated);
    }

    if (salesChartDataModified) {
      const updatedModified = processData(salesChartDataModified);
      setMovingAverageRateModified(updatedModified);
    }
  }, [salesChartData, salesChartDataModified]);

  // displayMovingAverageに移動平均反映後のデータをセット（表示用）
  useEffect(() => {
    if (!displaySalesChartData && !displaySalesChartDataModified) return;
    if (displaySalesChartData) {
      const updated = processData(displaySalesChartData);
      setDisplayMovingAverageRate(updated);
    }

    if (displaySalesChartDataModified) {
      const updatedModified = processData(displaySalesChartDataModified);
      setDisplayMovingAverageRateModified(updatedModified);
    }
  }, [displaySalesChartData, displaySalesChartDataModified]);

  /**
   * 営業利益合計と営業利益率を計算（当初計画）
   */
  useEffect(() => {
    if (!displaySalesChartData) return;

    const { totalProfit, profitRate } = calcTotalProfitAndRate(displaySalesChartData);

    setTotalProfitOriginal(totalProfit);
    setProfitRateOriginal(profitRate);
  }, [displaySalesChartData]);

  /**
   * 営業利益合計と営業利益率を計算（ダウンサイド）
   */
  useEffect(() => {
    if (!displaySalesChartDataModified) return;

    const { totalProfit, profitRate } = calcTotalProfitAndRate(displaySalesChartDataModified);
    setTotalProfitModified(totalProfit);
    setProfitRateModified(profitRate);
  }, [displaySalesChartDataModified]);

  /**
   * 実質的営業利益率を計算（当初計画）- DB保存用
   */
  useEffect(() => {
    if (!salesChartData?.datasets || !originalProfitAndLossByMonth?.labels || !capexPartNo || capexPartNo.length === 0) {
      setRealProfitRateOriginal(null);
      setRealProfitRateByMonthOriginal([]);
      return;
    }
    const salesDataset = salesChartData.datasets.find((d: any) => d.id === "sales");
    const profitDataset = salesChartData.datasets.find((d: any) => d.id === "profit");
    if (!salesDataset || !profitDataset) {
      setRealProfitRateOriginal(null);
      setRealProfitRateByMonthOriginal([]);
      return;
    }
    const sales = salesDataset.data.map((v: number) => new Decimal(v));
    const materialCosts = calcMaterialCost(
      mergedChartDataOriginal,
      quantitiesChartDataOriginal,
      capexPartNo,
      originalProfitAndLossByMonth.labels,
      projectData?.projectId!,
      localCurrencyName,
      currencyData
    );
    const monthlyData = calcMonthlyProfitAndLossDetails(
      sales,
      materialCosts || [],
      originalProfitAndLossByMonth.labels,
      false,
      originalEquipmentAmounts,
      projectData!,
      capexPartNo,
      // 振り返りモード: salesChartDataは表示通貨(selectedCurrency)で月別レート変換済みのため、
      // 費用側も表示通貨+convertFnで揃えて通貨不一致を回避する。
      // 通常モード: 従来どおりローカル通貨で統一（比率なので通貨に依存しない）。
      reviewDate ? selectedCurrency.name : localCurrencyName,
      currencyData,
      downsideIndexGraph,
      decimalCurrency,
      uniqueProcessData,
      bomData,
      projectData?.moldSalesByProject,
      projectData?.developmentSalesByProject,
      projectData?.equipmentSalesByProject,
      undefined,
      reviewDate ? convertWithRate : undefined,
    );
    if (!monthlyData) {
      setRealProfitRateOriginal(null);
      setRealProfitRateByMonthOriginal([]);
      return;
    }
    const salesData = salesDataset.data as number[];
    const profitData = profitDataset.data as number[];
    const totalSales = salesData.reduce((sum: number, v: number) => sum + (v || 0), 0);
    // No.411追加対応: 表示期間外（生産終了後）に残る減価償却費を分子に加算し、系統A（画面表示用）と算出方式を統一する
    const totalProfitVal = profitData.reduce((sum: number, v: number) => sum + (v || 0), 0)
      + (monthlyData.residualDepreciationTotal?.toNumber() ?? 0);
    const totalCustomerCost = monthlyData.customerSpecifiedPartsCost.reduce((sum: Decimal, v: Decimal) => sum.plus(v), new Decimal(0));
    const rate = calcRealProfitRate(new Decimal(totalSales), new Decimal(totalProfitVal), totalCustomerCost);
    const byMonth = calcRealProfitRateByMonth(salesData, profitData, monthlyData.customerSpecifiedPartsCost);
    // 顧客指定部品の有無判断
    const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
    if (a) {
      setRealProfitRateOriginal(rate);
      setRealProfitRateByMonthOriginal(byMonth);
    } else {
      setRealProfitRateOriginal(null);
      setRealProfitRateByMonthOriginal([]);
    }
  }, [salesChartData, mergedChartDataOriginal, quantitiesChartDataOriginal, originalProfitAndLossByMonth, capexPartNo, projectData, localCurrencyName, currencyData, originalEquipmentAmounts, downsideIndexGraph, decimalCurrency, uniqueProcessData, bomData, reviewDate, selectedCurrency.name, convertWithRate]);

  /**
   * 実質的営業利益率を計算（ダウンサイド）- DB保存用
   */
  useEffect(() => {
    if (!salesChartDataModified?.datasets || !originalProfitAndLossByMonth?.labels || !capexPartNo || capexPartNo.length === 0) {
      setRealProfitRateModified(null);
      setRealProfitRateByMonthModified([]);
      return;
    }
    const salesDataset = salesChartDataModified.datasets.find((d: any) => d.id === "sales");
    const profitDataset = salesChartDataModified.datasets.find((d: any) => d.id === "profit");
    if (!salesDataset || !profitDataset) {
      setRealProfitRateModified(null);
      setRealProfitRateByMonthModified([]);
      return;
    }
    const sales = salesDataset.data.map((v: number) => new Decimal(v));
    const materialCosts = calcMaterialCost(
      mergedChartDataModified,
      quantitiesChartDataModified,
      capexPartNo,
      originalProfitAndLossByMonth.labels,
      projectData?.projectId!,
      localCurrencyName,
      currencyData
    );

    // データの実期間に調整
    const labels = (originalProfitAndLossByMonth.labels).slice(0, sales.length);

    const monthlyData = calcMonthlyProfitAndLossDetails(
      sales,
      materialCosts || [],
      labels,
      true,
      originalEquipmentAmounts,
      projectData!,
      capexPartNo,
      // 振り返りモード: salesChartDataModifiedは表示通貨(selectedCurrency)で月別レート変換済みのため、
      // 費用側も表示通貨+convertFnで揃えて通貨不一致を回避する。
      // 通常モード: 従来どおりローカル通貨で統一（比率なので通貨に依存しない）。
      reviewDate ? selectedCurrency.name : localCurrencyName,
      currencyData,
      downsideIndexGraph,
      decimalCurrency,
      uniqueProcessData,
      bomData,
      projectData?.moldSalesByProject,
      projectData?.developmentSalesByProject,
      projectData?.equipmentSalesByProject,
      undefined,
      reviewDate ? convertWithRate : undefined,
    );
    if (!monthlyData) {
      setRealProfitRateModified(null);
      setRealProfitRateByMonthModified([]);
      return;
    }
    const salesData = salesDataset.data as number[];
    const profitData = profitDataset.data as number[];
    const totalSales = salesData.reduce((sum: number, v: number) => sum + (v || 0), 0);
    // No.411追加対応: 表示期間外（生産終了後）に残る減価償却費を分子に加算し、系統A（画面表示用）と算出方式を統一する
    const totalProfitVal = profitData.reduce((sum: number, v: number) => sum + (v || 0), 0)
      + (monthlyData.residualDepreciationTotal?.toNumber() ?? 0);
    const totalCustomerCost = monthlyData.customerSpecifiedPartsCost.reduce((sum: Decimal, v: Decimal) => sum.plus(v), new Decimal(0));
    const rate = calcRealProfitRate(new Decimal(totalSales), new Decimal(totalProfitVal), totalCustomerCost);
    const byMonth = calcRealProfitRateByMonth(salesData, profitData, monthlyData.customerSpecifiedPartsCost);
    // 顧客指定部品の有無判断
    const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
    if (a) {
      setRealProfitRateModified(rate);
      setRealProfitRateByMonthModified(byMonth);
    } else {
      setRealProfitRateModified(null);
      setRealProfitRateByMonthModified([]);
    }
  }, [salesChartDataModified, mergedChartDataModified, quantitiesChartDataModified, originalProfitAndLossByMonth, capexPartNo, projectData, localCurrencyName, currencyData, originalEquipmentAmounts, downsideIndexGraph, decimalCurrency, uniqueProcessData, bomData, reviewDate, selectedCurrency.name, convertWithRate]);

  // salesChartDataをコピーした後移動平均反映
  // ※移動平均を無効化（当月実績を表示）
  const processData = (data: any): any => {
    const copied = structuredClone(data);
    // 移動平均を適用せず、当月実績をそのまま使用
    return copied;
  };

  // 数量・販売単価情報をもとに、年月ラベル&数量（PartNo別）への変換を行う処理
  function convertToOriginalProfitAndLossByMonthTable(dataList: QuantityAndPriceMonthTable[]): OriginalProfitAndLossByMonthTable {
    const labels: string[] = [];
    const quantityByPartNo: Record<string, string[]> = {};

    if (!projectData?.projectStartDate) return { labels, quantityByPartNo } as OriginalProfitAndLossByMonthTable;

    const startDate = new Date(projectData?.projectStartDate);
    const year = startDate.getFullYear();
    const month = startDate.getMonth() + 1;
    const fiscalYear = month >= 4 ? year : year - 1;

    dataList.forEach((item, idx) => {
      const quantities: string[] = [];

      Object.entries(item.data).forEach(([yearOffset, yearData]) => {
        Object.values(yearData.months).forEach(m => {
          const year = fiscalYear + (m.month >= 4 ? Number(yearOffset) - 1 : Number(yearOffset));
          if (year <= fiscalYear && month > m.month) return;
          const label = `${year}/${String(m.month).padStart(2, "0")}`;

          // 1件目のpartNoのときのみ、labelsに年月を登録
          if (idx === 0) {
            labels.push(label);
          }

          quantities.push(String(m.quantity));
        });
      });

      quantityByPartNo[item.partNo] = quantities;
    });

    return { labels, quantityByPartNo } as OriginalProfitAndLossByMonthTable;
  }

  // 行情報生成処理
  const generateRowsFromTable = (table: any, startMonth: number) => {
    const rows: PriceRows[] = [];
    let id = 1;
    let prevValue: number | null = null;
    let start: { y: number; m: number } | null = null;

    table.years.forEach((y: number) => {
      const months = table.data[y].months ? Object.values(table.data[y].months) : [];
      months.forEach((m: any) => {

        // 年度表示の計算ロジック
        const fiscalYear =
          m.month >= 4 && m.month <= 12
            ? baseStartYear + y - 1
            : baseStartYear + y;

        const startYear =
          startMonth >= 4 && startMonth <= 12
            ? baseStartYear
            : baseStartYear + 1;

        if (fiscalYear < startYear ||
          fiscalYear === startYear && m.month < startMonth) {
          return;
        }

        const value = m["price"];

        if (prevValue === null) {
          start = { y: fiscalYear, m: m.month };
          prevValue = value;
        } else if (value !== prevValue) {
          rows.push({
            id: id++,
            displayStartMonth: `${start!.y}-${String(start!.m).padStart(2, "0")}`,
            displayEndMonth: `${m.month === 1 ? fiscalYear - 1 : fiscalYear}-${String(m.month === 1 ? 12 : m.month - 1).padStart(2, "0")}`,
            startMonth: `${start!.y}-${String(start!.m).padStart(2, "0")}`,
            endMonth: `${m.month === 1 ? fiscalYear - 1 : fiscalYear}-${String(m.month === 1 ? 12 : m.month - 1).padStart(2, "0")}`,
            value: prevValue,
          });
          start = { y: fiscalYear, m: m.month };
          prevValue = value;
        }

        // 最後の月の処理
        if (y === table.years[table.years.length - 1] && m.month === 3) {
          if (id === 1 || value !== 0) {
            rows.push({
              id: id++,
              displayStartMonth: `${start!.y}-${String(start!.m).padStart(2, "0")}`,
              displayEndMonth: `${fiscalYear}-${String(m.month).padStart(2, "0")}`,
              startMonth: `${start!.y}-${String(start!.m).padStart(2, "0")}`,
              endMonth: `${fiscalYear}-${String(m.month).padStart(2, "0")}`,
              value,
            });
          }
        }
      });
    });

    return rows;
  };

  // 基準通貨設定処理
  const updateSelectedCurrency = (tableId: string, partNo: string, currencyAndRatio: { id: string; ratio: number }[], currencyData: Currency[]) => {
    const maxRatio = Math.max(...currencyAndRatio.map((c) => c.ratio));
    const firstMaxIndex = currencyAndRatio.findIndex(
      (c) => c.ratio === maxRatio
    );

    const selected = currencyData.find(currency => currency.currencyId === currencyAndRatio[firstMaxIndex].id);
    const [id, name] = [selected ? selected.currencyId : "", selected ? selected.currencyName : ""]
    setSelectedCurrencyByPartNo((prev) => {
      const index = prev.findIndex((item) => item.tableId === tableId);

      if (index !== -1) {
        const updated = [...prev];
        updated[index] = {
          tableId,
          partNo,
          id: id!,
          name: name!,
        };
        return updated;
      }

      return [
        ...prev,
        { tableId, partNo, id: id!, name: name! },
      ];
    });
  };
  /**
   * PartNoごとの月次数量 (quantity) の合計計算
   * @param years 年度の配列 (例: [1, 2, 3])
   * @param data 年度ごとのデータ構造 ({ year: YearData })
   * @returns Decimal型の数量合計
   * 
   */
  const calculateTotalQuantity = (years: number[], data: { [key: number]: YearData }): Decimal => {
    return years.reduce((total, year) => {
      const yearMonths = data[year]?.months || {};
      const yearQuantity = Object.values(yearMonths).reduce(
        (sum, monthData) => sum.plus(monthData.quantity || 0),
        new Decimal(0)
      );
      return total.plus(yearQuantity);
    }, new Decimal(0));
  };

  /**
   * PartNoごとの売上金額 (quantity * price) の合計計算と加重平均販売単価計算
   * @param years 年度の配列 (例: [1, 2, 3])
   * @param data 年度ごとのデータ構造 ({ year: YearData })
   * @returns 売上合計金額 (`totalSales`) と加重平均販売単価 (`weightedAveragePrice`)
   */
  const calculateTotalSales = (years: number[], data: { [key: number]: YearData }): { totalSales: Decimal; weightedAveragePrice: Decimal } => {
    let totalQuantity = new Decimal(0); // 全年度の数量合計
    let weightedSum = new Decimal(0);   // 数量 * 販売単価の合計

    // 年度ごとの売上合計を計算
    const totalSales = years.reduce((total, year) => {
      const yearMonths = data[year]?.months || {};
      return Object.values(yearMonths).reduce(
        (sum, monthData) => {
          const quantity = new Decimal(monthData.quantity || 0);
          const price = new Decimal(monthData.price || 0);
          const monthlySales = quantity.times(price);

          // 加重平均計算用の値を集計
          // 数量合計
          totalQuantity = totalQuantity.plus(quantity);
          // 数量*販売単価合計
          weightedSum = weightedSum.plus(quantity.times(price));

          // 売上合計の累積
          return sum.plus(monthlySales);
        },
        total
      );
    }, new Decimal(0));

    // 売上合計を小数点以下3桁に丸める
    const roundedTotalSales = totalSales.toDecimalPlaces(3);

    // 加重平均販売単価の計算（総数量が0の場合は販売単価を0とする）
    const weightedAveragePrice = totalQuantity.equals(0)
      ? new Decimal(0)
      : weightedSum.dividedBy(totalQuantity).toDecimalPlaces(3);

    return { totalSales: roundedTotalSales, weightedAveragePrice };
  };

  /**
   * PartNo単位の合計計算（数量合計・売上合計・加重平均販売単価）のキャッシュ
   * 直前に計算した結果を`table.data`（テーブルデータ本体）の参照単位で保持し、
   * 編集されていないPartNoについては再計算せず前回結果を再利用する。
   * （handleInputChangeでは編集対象PartNo以外のテーブルオブジェクト参照は変化しないため成立する）
   */
  const tableTotalsCacheRef = useRef<Map<QuantityAndPriceMonthTable, { totalQuantity: Decimal; totalSales: Decimal; weightedAveragePrice: Decimal }>>(new Map());

  /**
   * quantityAndPriceTablesが変化した場合のみ、変更のあったPartNo分だけ合計計算を再実行する
   * @returns table.data（QuantityAndPriceMonthTable）をキーとした合計計算結果のMap
   */
  const tableTotalsMap = useMemo(() => {
    const nextCache = new Map<QuantityAndPriceMonthTable, { totalQuantity: Decimal; totalSales: Decimal; weightedAveragePrice: Decimal }>();

    quantityAndPriceTables.forEach((tableItem) => {
      const tableData = tableItem.data;
      // 前回計算結果があり、かつテーブルデータの参照が変わっていない場合は再利用
      const cached = tableTotalsCacheRef.current.get(tableData);
      if (cached) {
        nextCache.set(tableData, cached);
        return;
      }

      // 変更があったPartNo（または初回）のみ再計算
      const totalQuantity = calculateTotalQuantity(tableData.years, tableData.data);
      const { totalSales, weightedAveragePrice } = calculateTotalSales(tableData.years, tableData.data);
      nextCache.set(tableData, { totalQuantity, totalSales, weightedAveragePrice });
    });

    tableTotalsCacheRef.current = nextCache;
    return nextCache;
  }, [quantityAndPriceTables]);

  /**
   * 深い階層のフィールドをイミュータブルに更新する
   *
   * @param obj 更新対象のオブジェクト
   * @param path 更新する階層のパス（例: ['data', year, 'months', month, field]）
   * @param value 更新する値
   */
  const updateNestedField = (obj: any, path: (string | number)[], value: any): any => {
    if (path.length === 0) return value;

    const [key, ...restPath] = path;

    if (Array.isArray(obj)) {
      // IDに基づいて更新対象を特定
      return obj.map((item) =>
        item.id === key ? updateNestedField(item, restPath, value) : item
      );
    }

    return {
      ...obj,
      [key]: updateNestedField(obj[key] || {}, restPath, value),
    };
  };

  /**
   * ストレス指数　"-", backspaceを押したときの処理
   * @param row 操作対象の行データ
   * @param fieldName 更新対象となる行データのプロパティ名
   */
  const handleKeyDown = (
    row: DownsideIndexTableRowDisplay,
    fieldName: keyof DownsideIndexTableRowDisplay
  ) => (e: React.KeyboardEvent<HTMLInputElement>) => {
    const currentVal = Number(row?.[fieldName] || 0);
    const input = e.currentTarget;
    const cursorPos = input.selectionStart ?? -1;

    // 1. 0の状態で "-" が押されたら "-0" を設定
    if (currentVal === 0 && e.key === "-") {
      // 入力途中の中間状態のため、親state（downsideIndex）への重いコミットはスキップする
      updateDownsideIndexTableValue(row.yearString, fieldName, "-0", false);
      return;
    }

    // 2. Backspace の場合の特殊制御
    if (e.key === "Backspace") {
      // 1桁の負の数（-1 〜 -9）の末尾で Backspace を押した場合
      if (currentVal < 0 && currentVal >= -9 && cursorPos === 2) {
        e.preventDefault();
        // 入力途中の中間状態のため、親state（downsideIndex）への重いコミットはスキップする
        updateDownsideIndexTableValue(row.yearString, fieldName, "-0", false);
      }
      // 表示が "-0" の状態（または Object.is で -0 判定）で Backspace を押した場合
      else if (input.value === "-0" || Object.is(currentVal, -0)) {
        e.preventDefault();
        // 入力途中の中間状態のため、親state（downsideIndex）への重いコミットはスキップする
        updateDownsideIndexTableValue(row.yearString, fieldName, 0, false);
      }
    }
  };

  /**
   * レイアウト
   */
  return (
    <Box>
      <Box
        position="fixed"
        top="10vh"
        ml="2vw"
        mr="2vw"
        left="250px"
        width="calc(96vw - 250px)"
        height="85vh"
        p={6}
        paddingTop={0}
        overflowY="auto"
        bg="white"
      >
        {/* 表示切替ボタン */}
        <HStack spacing={4} p={4} bg="gray.100" justify="flex-start" position="sticky" top="0" zIndex={101}>
          <Button
            colorScheme="blue"
            onClick={() => requestModeChange("view")}
            isDisabled={mode === "view"}
          >
            {t('features.InvestmentScreening.SimulationNewProduct.button.simulationView')}
          </Button>
          <Button
            colorScheme="blue"
            onClick={() => requestModeChange("settings")}
            isDisabled={mode === "settings"}
          >
            {t('features.InvestmentScreening.SimulationNewProduct.button.simulationSettings')}
          </Button>
          <Button
            colorScheme="blue"
            onClick={() => requestModeChange("selection")}
            isDisabled={mode === "selection"}
          >
            {t('features.InvestmentScreening.SimulationNewProduct.button.displayTargetSelection')}
          </Button>
          <Button
            colorScheme="blue"
            onClick={() => requestModeChange("salesDataLinkage")}
            isDisabled={mode === "salesDataLinkage"}
          >
            {t('features.InvestmentScreening.SimulationNewProduct.button.salesDataLinkage')}
          </Button>
        </HStack>

        {/* タブ切替時の未保存入力破棄確認ダイアログ */}
        <ConfirmDialog
          isOpen={isTabSwitchConfirmOpen}
          title={t('features.InvestmentScreening.SimulationNewProduct.label.confirmDialogTitle')}
          message={t('features.InvestmentScreening.SimulationNewProduct.message.confirmDialogMessage')}
          confirmLabel={t('features.InvestmentScreening.SimulationNewProduct.label.confirmLabel')}
          cancelLabel={t('features.InvestmentScreening.SimulationNewProduct.label.cancelLabel')}
          confirmColorScheme="red"
          onConfirm={() => {
            if (pendingModeRef.current) setMode(pendingModeRef.current);
          }}
          onClose={() => {
            pendingModeRef.current = null;
            onCloseTabSwitchConfirm();
          }}
        />

        {/* 条件分岐による表示 */}
        {mode === "salesDataLinkage" && (
          <Box mt={4}>
            <SalesDataLinkage
              isEditable={!!pagePermissions?.isEditable}
              namespace="SimulationNewProduct"
              projectId={projectId}
              onReflect={handleReflectSalesDataLinkageToDownsideIndex}
              onDirtyChange={setIsSalesDataLinkageDirty}
            />
          </Box>
        )}

        {mode === "view" && (
          <Box mt={4}>
            <Heading textColor="blue" fontSize="28px" size="md">
              {t('features.InvestmentScreening.SimulationNewProduct.heading.newProductSimulation')}
            </Heading>

            {/* 表示通貨選択 */}
            <Box mt={4}>
              <Flex align="center" mb={2}>
                <Text alignItems="center" mr={4}>{t('features.InvestmentScreening.SimulationNewProduct.label.displayCurrency')}</Text>
                <Select
                  value={selectedCurrency.id}
                  onChange={(e) => {
                    const selectedOption = currencyOptions.find(option => option.value === e.target.value);
                    if (selectedOption && selectedOption.value && selectedOption.label) {
                      setSelectedCurrency({
                        id: selectedOption.value,
                        name: selectedOption.label
                      });
                    }
                  }}
                  width="200px"
                >
                  {currencyOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Select>
              </Flex>
            </Box>

            <fieldset disabled={!pagePermissions?.isEditable}>
              <Box mt={4}>
                <Heading size="md" mb={2} mt={2}>
                  {t('features.InvestmentScreening.SimulationNewProduct.heading.conditionTable')}
                </Heading>
                <Table
                  variant="simple"
                  width="80%"
                  minWidth="1000px"
                  sx={{
                    borderCollapse: "collapse",
                    tableLayout: "fixed",
                    "& th, & td": {
                      border: "1px solid",
                      borderColor: "gray.200",
                      whiteSpace: "normal",
                      minHeight: "2em",
                      overflowWrap: "break-word",
                      padding: "0.5em",
                    },
                  }}
                >
                  <Thead>
                    <Tr>
                      <Th style={thStyle}>{t('features.InvestmentScreening.SimulationNewProduct.tableHeader.customerIndustry')}</Th>
                      <Th style={thStyle}>{t('features.InvestmentScreening.SimulationNewProduct.tableHeader.customerNationality')}</Th>
                      <Th style={thStyle}>{t('features.InvestmentScreening.SimulationNewProduct.tableHeader.customerName')}</Th>
                      <Th style={thStyle}>{t('features.InvestmentScreening.SimulationNewProduct.tableHeader.endUserName')}</Th>
                      <Th style={thStyle}>{t('features.InvestmentScreening.SimulationNewProduct.tableHeader.factoryExchangeToSales')}</Th>
                      <Th style={thStyle}>{t('features.InvestmentScreening.SimulationNewProduct.tableHeader.factoryLocationCountry')}</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td style={tdStyle}>{conditionTable?.customerIndustryName}</Td>
                      <Td style={tdStyle}>{conditionTable?.customerNationality}</Td>
                      <Td style={tdStyle}>{conditionTable?.customerName}</Td>
                      <Td style={{ ...tdStyle, whiteSpace: "pre-line" }}>{splitEscapedList(conditionTable?.endUserName).join('\n')}</Td>
                      <Td style={tdStyle}>{`${conditionTable?.factoryExchange?.currencyName || t('features.InvestmentScreening.SimulationNewProduct.label.notRegistered')} -${conditionTable?.salesExchange?.currencyName || t('features.InvestmentScreening.SimulationNewProduct.label.notRegistered')} `}</Td>
                      <Td style={tdStyle}>{conditionTable?.factoryLocationCountry?.map(f => (<Text>{f}</Text>))}</Td>
                    </Tr>
                  </Tbody>
                </Table>
              </Box>

              <>
                {/* TODO 暫定でコメント化、後で削除
                  <Box mt={4}>
                    <Heading size="md" mb={2}>
                      ストレス指数
                    </Heading>
                    <Table
                      variant="simple"
                      width="80%"
                      minWidth="1400px"
                      sx={{
                        borderCollapse: "collapse",
                        tableLayout: "fixed",
                        "& th, & td": {
                          border: "1px solid",
                          borderColor: "gray.200",
                          whiteSpace: "normal",
                          minHeight: "2em",
                          overflowWrap: "break-word",
                          padding: "0.5em",
                        },
                      }}
                    >
                      <Thead>
                        <Tr>
                          <Th style={thStyle} bgColor={enableDownsideIndex.isEnabledQuantityChangeOverTime ? "transparent" : "#eee"}>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.quantityChangeOverTime')}
                            <Switch ml={2} isChecked={enableDownsideIndex.isEnabledQuantityChangeOverTime} onChange={(event) => {
                              changeEnableDownsideIndex("isEnabledQuantityChangeOverTime", event.target.checked);
                            }} />
                          </Th>
                          <Th style={thStyle} bgColor={enableDownsideIndex.isEnabledFluctuationInQuantity ? "transparent" : "#eee"}>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.quantityFluctuation')}
                            <Switch ml={2} isChecked={enableDownsideIndex.isEnabledFluctuationInQuantity} onChange={(event) => {
                              changeEnableDownsideIndex("isEnabledFluctuationInQuantity", event.target.checked);
                            }} />
                          </Th>
                          <Th style={thStyle} bgColor={enableDownsideIndex.isEnabledPriceChangeOverTime ? "transparent" : "#eee"}>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.priceChangeOverTime')}
                            <Switch ml={2} isChecked={enableDownsideIndex.isEnabledPriceChangeOverTime} onChange={(event) => {
                              changeEnableDownsideIndex("isEnabledPriceChangeOverTime", event.target.checked);
                            }} />
                          </Th>
                          <Th style={thStyle} bgColor={enableDownsideIndex.isEnabledCustomerProductLifecycle ? "transparent" : "#eee"}>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.customerProductLifecycle')}
                            <Switch ml={2} isChecked={enableDownsideIndex.isEnabledCustomerProductLifecycle} onChange={(event) => {
                              changeEnableDownsideIndex("isEnabledCustomerProductLifecycle", event.target.checked);
                            }} />
                          </Th>
                          <Th style={thStyle} bgColor={enableDownsideIndex.isEnabledCurrencyFluctuation ? "transparent" : "#eee"}>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.exchangeRateFluctuation')}
                            <Switch ml={2} isChecked={enableDownsideIndex.isEnabledCurrencyFluctuation} onChange={(event) => {
                              changeEnableDownsideIndex("isEnabledCurrencyFluctuation", event.target.checked);
                            }} />
                          </Th>
                          <Th style={thStyle} bgColor={enableDownsideIndex.isEnabledRisingMaterialCosts ? "transparent" : "#eee"}>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.materialCostIncrease')}
                            <Switch ml={2} isChecked={enableDownsideIndex.isEnabledRisingMaterialCosts} onChange={(event) => {
                              changeEnableDownsideIndex("isEnabledRisingMaterialCosts", event.target.checked);
                            }} />
                          </Th>
                          <Th style={thStyle} bgColor={enableDownsideIndex.isEnabledRisingLaborCosts ? "transparent" : "#eee"}>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.laborCostIncrease')}
                            <Switch ml={2} isChecked={enableDownsideIndex.isEnabledRisingLaborCosts} onChange={(event) => {
                              changeEnableDownsideIndex("isEnabledRisingLaborCosts", event.target.checked);
                            }} />
                          </Th>
                          <Th style={thStyle} bgColor={enableDownsideIndex.isEnabledCompetitorCondition ? "transparent" : "#eee"}>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.competitorStatus')}
                            <Switch ml={2} isChecked={enableDownsideIndex.isEnabledCompetitorCondition} onChange={(event) => {
                              changeEnableDownsideIndex("isEnabledCompetitorCondition", event.target.checked);
                            }} />
                          </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        <Tr>
                          <Td
                            style={tdStyle}
                            bgColor={enableDownsideIndex.isEnabledQuantityChangeOverTime ? "transparent" : "#eee"}
                          >{downsideIndexDisplay?.quantityChangeOverTimeString}</Td>
                          <Td
                            style={tdStyle}
                            bgColor={enableDownsideIndex.isEnabledFluctuationInQuantity ? "transparent" : "#eee"}
                          >
                            {downsideIndexDisplay?.fluctuationInQuantityString}
                          </Td>
                          <Td
                            style={tdStyle}
                            bgColor={enableDownsideIndex.isEnabledPriceChangeOverTime ? "transparent" : "#eee"}
                          >
                            {downsideIndexDisplay?.priceChangeOverTimeString}
                          </Td>
                          <Td
                            style={tdStyle}
                            bgColor={enableDownsideIndex.isEnabledCustomerProductLifecycle ? "transparent" : "#eee"}
                          >
                            {downsideIndexDisplay?.customerProductLifecycleString}
                          </Td>
                          <Td
                            style={tdStyle}
                            bgColor={enableDownsideIndex.isEnabledCurrencyFluctuation ? "transparent" : "#eee"}
                          >
                            {downsideIndexDisplay?.currencyFluctuationString}
                          </Td>
                          <Td
                            style={tdStyle}
                            bgColor={enableDownsideIndex.isEnabledRisingMaterialCosts ? "transparent" : "#eee"}
                          >
                            {downsideIndexDisplay?.risingMaterialCostsString}
                          </Td>
                          <Td
                            style={tdStyle}
                            bgColor={enableDownsideIndex.isEnabledRisingLaborCosts ? "transparent" : "#eee"}
                          >
                            {downsideIndexDisplay?.risingLaborCostsString}
                          </Td>
                          <Td
                            style={tdStyle}
                            bgColor={enableDownsideIndex.isEnabledCompetitorCondition ? "transparent" : "#eee"}
                          >
                            {downsideIndexDisplay?.competitorConditionString}
                          </Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </Box>
                  */}

                <DownsideRiskTextarea
                  ref={downsideRiskRef}
                  initialValue={downsideRiskDraftRef.current}
                  onValueChange={(v) => { downsideRiskDraftRef.current = v; }}
                />
              </>
            </fieldset>

            <Box mt="5vh">
              <Text color="red" fontWeight="bold" mb="1vh" whiteSpace="pre-line">
                {t('features.InvestmentScreening.SimulationNewProduct.label.recommendationMessage')}
              </Text>
              <HStack>

                {isAIEnabled && !isAIRestricted && (
                  <Button
                    onClick={() => {
                      setIsAIModalOpen(true);
                    }}
                    leftIcon={<RiSparklingFill />}
                    variant="solid"
                    colorScheme="purple"
                  >
                    {t('features.InvestmentScreening.SimulationNewProduct.button.aiAnalysis')}
                  </Button>
                )}

                <AIAnalysisModal
                  isAIModalOpen={isAIModalOpen}
                  setIsAIModalOpen={setIsAIModalOpen}
                  title={AI_ANALYSIS_TITLES.SIMULATION_NEW_PRODUCT}
                  projectId={projectId}
                  initialPrompt={generateSimulationNewProductPrompt({
                    adjustedOrders,
                    productionCapacityData
                  })}
                />

                <Button onClick={(event) => {
                  // フォーカスを外す
                  event.currentTarget.blur();

                  // 画面中央の座標を計算
                  const centerX = (window.innerWidth / 2) - (DOWNSIDE_INDEX_POPUP_WIDTH / 2);
                  const height = 1 + 16 + 27 + 8 + 33 + 57 * downsideIndexTableDisplay.length + 8 + 40 + 16 + 1;
                  const centerY = (window.innerHeight / 2) - (height / 2);
                  setPosition({ x: centerX, y: centerY });
                  setIsOpenDownsideIndex(true);
                }}>{t('features.InvestmentScreening.SimulationNewProduct.button.downsideIndex')}</Button>

              </HStack>
            </Box>

            <fieldset disabled={!pagePermissions?.isEditable} style={{ minWidth: 0 }}>
              {/* 数量（Quantities Chart） */}
              {quantitiesChartDataOriginal && quantitiesChartDataModified && (() => {
                // 選択された設定がある場合は、それらも含めてスケールを計算
                const allDataSets = [quantitiesChartDataOriginal, quantitiesChartDataModified];
                selectedConfigIds.forEach(configId => {
                  const chartData = quantitiesChartDataForSavedConfig.find(item => item.configId === configId);
                  if (chartData?.data) {
                    allDataSets.push(chartData.data);
                  }
                });

                // すべてのデータセットを考慮してスケールを計算
                const allData = allDataSets.flatMap(ds =>
                  ds?.datasets?.flatMap((dataset: any) => dataset?.data?.filter((v: any) => v !== null)) || []
                );
                const { yMin, yMax } = calcYAxisRange(allData);
                const commonLabels = quantitiesChartDataOriginal.labels.length >= quantitiesChartDataModified.labels.length
                  ? quantitiesChartDataOriginal.labels
                  : quantitiesChartDataModified.labels;
                return (
                  <Box mt="8vh">
                    <Heading size="md" mb={2}>
                      {labelQuantity}
                    </Heading>
                    <Text>
                      unit:pcs
                    </Text>
                    <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4}>
                      <Box textAlign="center">
                        <Heading size="sm" mb={1}>
                          {t('features.InvestmentScreening.SimulationNewProduct.heading.initialPlan')}
                        </Heading>
                        <Box width="30vw" height="calc(30vw * 0.5625)">
                          <Line
                            data={{ ...quantitiesChartDataOriginal, labels: commonLabels }}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              spanGaps: false,
                              elements: { point: { radius: 2 } },
                              scales: {
                                x: {
                                  offset: true,
                                  ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                },
                                y: {
                                  min: yMin,
                                  max: yMax,
                                  ticks: {
                                    format: {
                                      notation: "standard"
                                    }
                                  }
                                },
                              },
                              plugins: {
                                annotation: {
                                  annotations: {
                                    ...generateAnnotationStarLabels(newProductStartYearMonth, projectData?.purpose),
                                  }
                                },
                                datalabels: {
                                  display: false
                                }
                              },
                            }}
                          />
                        </Box>
                      </Box>
                      <Box textAlign="center">
                        <Heading size="sm" mb={1}>
                          {t('features.InvestmentScreening.SimulationNewProduct.heading.downside')}
                        </Heading>
                        <Box width="30vw" height="calc(30vw * 0.5625)">
                          <Line
                            data={{ ...quantitiesChartDataModified, labels: commonLabels }}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              spanGaps: false,
                              elements: { point: { radius: 2 } },
                              scales: {
                                x: {
                                  offset: true,
                                  ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                },
                                y: {
                                  min: yMin,
                                  max: yMax,
                                  ticks: {
                                    format: {
                                      notation: "standard"
                                    }
                                  }
                                },
                              },
                              plugins: {
                                annotation: {
                                  annotations: {
                                    ...generateAnnotationStarLabels(newProductStartYearMonth, projectData?.purpose),
                                  }
                                },
                                datalabels: {
                                  display: false
                                }
                              },
                            }}
                          />
                        </Box>
                      </Box>
                      {selectedConfigIds.map((configId) => {
                        const config = savedConfigs.find(c => c.id === configId);
                        const chartData = quantitiesChartDataForSavedConfig.find(item => item.configId === configId);
                        if (!config || !chartData?.data) return null;
                        return (
                          <Box key={config.id} textAlign="center">
                            <Heading size="sm" mb={1}>
                              {config.name}
                            </Heading>
                            <Box width="30vw" height="calc(30vw * 0.5625)">
                              <Line
                                data={{ ...chartData.data, labels: commonLabels }}
                                options={{
                                  responsive: true,
                                  maintainAspectRatio: false,
                                  spanGaps: false,
                                  elements: { point: { radius: 2 } },
                                  scales: {
                                    x: {
                                      offset: true,
                                      ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                    },
                                    y: {
                                      min: yMin,
                                      max: yMax,
                                      ticks: {
                                        format: {
                                          notation: "standard"
                                        }
                                      }
                                    },
                                  },
                                  plugins: {
                                    datalabels: {
                                      display: false
                                    }
                                  },
                                }}
                              />
                            </Box>
                          </Box>
                        );
                      })}
                    </Flex>
                  </Box>
                );
              })()}

              {/* 価格と材料単価（Price & Material Chart） */}
              {(displayMergedChartDataOriginal || mergedChartDataOriginal) && (displayMergedChartDataModified || mergedChartDataModified) && (() => {
                // 表示用データを優先、なければ元データを使用
                const mergedDataLeft = displayMergedChartDataOriginal || mergedChartDataOriginal;
                const mergedDataRight = displayMergedChartDataModified || mergedChartDataModified;

                // 選択された設定がある場合は、それらも含めてスケールを計算（表示用データを優先）
                const mergedSavedConfigDataSource = displayMergedChartDataForSavedConfig.length > 0
                  ? displayMergedChartDataForSavedConfig
                  : mergedChartDataForSavedConfig;
                const allDataSets = [mergedDataLeft, mergedDataRight];
                selectedConfigIds.forEach(configId => {
                  const chartData = mergedSavedConfigDataSource.find(item => item.configId === configId);
                  if (chartData?.data) {
                    allDataSets.push(chartData.data);
                  }
                });

                // すべてのデータセットを考慮してスケールを計算
                const allData = allDataSets.flatMap(ds =>
                  ds?.datasets?.flatMap((dataset: any) => dataset?.data?.filter((v: any) => v !== null)) || []
                );
                const { yMin, yMax } = calcYAxisRange(allData);
                const commonLabels = mergedDataLeft.labels.length >= mergedDataRight.labels.length
                  ? mergedDataLeft.labels
                  : mergedDataRight.labels;

                return (
                  <Box mt={4}>
                    <Heading size="md" mb={2}>
                      {isGeneralPurpose
                        ? t('features.InvestmentScreening.SimulationNewProduct.heading.estimatedPriceAndMaterialUnitPrice')
                        : t('features.InvestmentScreening.SimulationNewProduct.heading.salesPriceAndMaterialUnitPrice')}
                    </Heading>
                    <Text>
                      unit:{selectedCurrency.name}
                    </Text>
                    <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4}>
                      <Box textAlign="center">
                        <Heading size="sm" mb={1}>
                          {t('features.InvestmentScreening.SimulationNewProduct.heading.initialPlan')}
                        </Heading>
                        <Box width="30vw" height="calc(30vw * 0.5625)">
                          <Line
                            data={{ ...mergedDataLeft, labels: commonLabels }}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              spanGaps: false,
                              elements: { point: { radius: 2 } },
                              scales: {
                                x: {
                                  offset: true,
                                  ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                },
                                y: {
                                  min: yMin,
                                  max: yMax,
                                  ticks: {
                                    format: {
                                      notation: "standard"
                                    }
                                  }
                                },
                              },
                              plugins: {
                                annotation: {
                                  annotations: {
                                    ...generateAnnotationStarLabels(newProductStartYearMonth, projectData?.purpose),
                                  }
                                },
                                datalabels: {
                                  display: false
                                }
                              },
                            }}
                          />
                        </Box>
                      </Box>
                      <Box textAlign="center">
                        <Heading size="sm" mb={1}>
                          {t('features.InvestmentScreening.SimulationNewProduct.heading.downside')}
                        </Heading>
                        <Box width="30vw" height="calc(30vw * 0.5625)">
                          <Line
                            data={{ ...mergedDataRight, labels: commonLabels }}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              spanGaps: false,
                              elements: { point: { radius: 2 } },
                              scales: {
                                x: {
                                  offset: true,
                                  ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                },
                                y: {
                                  min: yMin,
                                  max: yMax,
                                  ticks: {
                                    format: {
                                      notation: "standard"
                                    }
                                  }
                                },
                              },
                              plugins: {
                                annotation: {
                                  annotations: {
                                    ...generateAnnotationStarLabels(newProductStartYearMonth, projectData?.purpose),
                                  }
                                },
                                datalabels: {
                                  display: false
                                }
                              },
                            }}
                          />
                        </Box>
                      </Box>
                      {selectedConfigIds.map((configId) => {
                        const config = savedConfigs.find(c => c.id === configId);
                        const chartData = mergedSavedConfigDataSource.find(item => item.configId === configId);
                        if (!config || !chartData?.data) return null;
                        return (
                          <Box key={config.id} textAlign="center">
                            <Heading size="sm" mb={1}>
                              {config.name}
                            </Heading>
                            <Box width="30vw" height="calc(30vw * 0.5625)">
                              <Line
                                data={{ ...chartData.data, labels: commonLabels }}
                                options={{
                                  responsive: true,
                                  maintainAspectRatio: false,
                                  spanGaps: false,
                                  elements: { point: { radius: 2 } },
                                  scales: {
                                    x: {
                                      offset: true,
                                      ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                    },
                                    y: {
                                      min: yMin,
                                      max: yMax,
                                      ticks: {
                                        format: {
                                          notation: "standard"
                                        }
                                      }
                                    },
                                  },
                                  plugins: {
                                    datalabels: {
                                      display: false
                                    }
                                  },
                                }}
                              />
                            </Box>
                          </Box>
                        );
                      })}
                    </Flex>
                  </Box>
                );
              })()}

              {/* 売上・利益グラフ */}
              {(displayMovingAverageRate || MovingAverageRate) && (
                <Box mt={4}>
                  <Heading size="md" mb={1}>
                    {t('features.InvestmentScreening.SimulationNewProduct.heading.salesAndProfit')}
                  </Heading>
                  <Text>
                    unit:{selectedCurrency.name}
                  </Text>
                  {(() => {

                    // 変数宣言（表示用データを優先、なければ元データ）
                    const dataLeft = displayMovingAverageRate || MovingAverageRate;
                    const dataRight = displayMovingAverageRateModified || MovingAverageRateModified;

                    // 売上合計（当初計画）の合計金額を算出（costBreakdown経由の年度丸め方式）
                    const totalProfit = calcDisplayTotalProfit(salesChartData);
                    const { profitRate } = calcTotalProfitAndRate(displaySalesChartData);

                    // 売上合計（ダウンサイド）の合計金額を算出（costBreakdown経由の年度丸め方式）
                    const totalProfitModified = calcDisplayTotalProfit(salesChartDataModified);
                    const { profitRate: profitRateModified } = calcTotalProfitAndRate(displaySalesChartDataModified);

                    // 実質的営業利益率を計算
                    // 注意: calcMonthlyProfitAndLossDetailsは記帳通貨（localCurrencyName）でデータを計算するため、
                    // salesChartData（通貨変換前）を使用し、結果を表示通貨に変換する
                    // 当初計画の実質的営業利益率（トップレベルのuseMemoで計算済み）
                    const { realProfitRate, realProfitRateByMonth } = realProfitRateDataMemo;
                    // ダウンサイドの実質的営業利益率（トップレベルのuseMemoで計算済み）
                    const { realProfitRate: realProfitRateModified, realProfitRateByMonth: realProfitRateByMonthModified } = realProfitRateDataModifiedMemo;

                    // 実質的営業利益率のデータセットを追加する関数
                    const addRealProfitRateDataset = (chartData: any, realProfitRateData: number[], label: string) => {
                      if (!chartData || realProfitRateData.length === 0) return chartData;
                      return {
                        ...chartData,
                        datasets: [
                          ...chartData.datasets,
                          {
                            label: label,
                            id: "realProfitRate",
                            yAxisID: "profitRate",
                            data: realProfitRateData,
                            borderColor: "orange",
                            backgroundColor: "orange",
                            fill: false,
                            tension: 0.4,
                            type: "line" as const,
                          }
                        ]
                      };
                    };

                    // 実質的営業利益率データセットを追加したグラフデータ
                    const dataLeftWithRealProfitRate = addRealProfitRateDataset(dataLeft, realProfitRateByMonth, t('features.InvestmentScreening.SimulationNewProduct.chart.realOperatingProfitRate'));
                    const dataRightWithRealProfitRate = addRealProfitRateDataset(dataRight, realProfitRateByMonthModified, t('features.InvestmentScreening.SimulationNewProduct.chart.realOperatingProfitRate'));

                    // 当初計画（売上/営業利益額）データをフィルタリング
                    const leftSalesData = {
                      datasets: dataLeft.datasets.filter((ds: { yAxisID: string; }) => ds.yAxisID === "sales"),
                      labels: dataLeft.labels
                    };

                    // 当初計画（営業利益率）データをフィルタリング
                    const leftProfitData = {
                      datasets: dataLeft.datasets.filter((ds: { yAxisID: string; }) => ds.yAxisID === "profitRate"),
                      labels: dataLeft.labels
                    };

                    // ダウンサイド（売上/営業利益額）データをフィルタリング
                    const rightSalesData = {
                      datasets: dataRight.datasets.filter((ds: { yAxisID: string; }) => ds.yAxisID === "sales"),
                      labels: dataRight.labels
                    };

                    // ダウンサイド（営業利益率）データをフィルタリング
                    const rightProfitData = {
                      datasets: dataRight.datasets.filter((ds: { yAxisID: string; }) => ds.yAxisID === "profitRate"),
                      labels: dataRight.labels
                    };

                    // 売上/営業利益額のスケールを算出
                    const { yMin: yMinLeft, yMax: yMaxLeft, commonLabels: commonLabelsLeft } = computeCommonScaleSalesChart(
                      leftSalesData,
                      rightSalesData,
                      false
                    );

                    // 営業利益率のスケールを算出
                    const { yMin: yMinRight, yMax: yMaxRight, commonLabels: commonLabelsRight } = computeCommonScaleSalesChart(
                      leftProfitData,
                      rightProfitData,
                      false
                    );

                    // 年月ラベルを取得
                    const commonLabels = commonLabelsLeft || commonLabelsRight;

                    // 選択されたシミュレーション設定のグラフデータを準備（表示用データを優先）
                    const savedConfigDataSource = displaySalesChartDataForSavedConfig.length > 0
                      ? displaySalesChartDataForSavedConfig
                      : salesChartDataForSavedConfig;
                    const selectedConfigsData = selectedConfigIds.map(configId => {
                      const config = savedConfigs.find(c => c.id === configId);
                      const salesData = savedConfigDataSource.find(item => item.configId === configId);
                      if (!config || !salesData?.data) return null;
                      return {
                        config,
                        movingAverageData: processData(salesData.data)
                      };
                    }).filter((item): item is { config: SavedSimulationConfig; movingAverageData: any } => item !== null);

                    return (
                      <Flex direction="row" justify="center" align="center" wrap="wrap">
                        <Box textAlign="center" mr="4">
                          <Heading size="sm" mb={1}>
                            {t('features.InvestmentScreening.SimulationNewProduct.heading.initialPlan')}
                          </Heading>
                          <Text fontSize={"sm"} align="right">
                            {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                              totalProfit,
                              selectedCurrency.name
                            )} {selectedCurrency.name}
                          </Text>
                          <Text fontSize={"sm"} align="right">
                            {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitRate')}: {profitRate} %
                          </Text>
                          {realProfitRate && (
                            <Text fontSize={"sm"} align="right">
                              {t('features.InvestmentScreening.SimulationNewProduct.label.realOperatingProfitRate')}: {realProfitRate} %
                            </Text>
                          )}
                          <Box width="30vw" height="calc(30vw * 0.5625)">
                            <Line
                              data={{ ...dataLeftWithRealProfitRate, labels: commonLabels }}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                scales: {
                                  x: {
                                    offset: true,
                                    ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                  },
                                  sales: {
                                    position: "left",
                                    min: yMinLeft,
                                    max: yMaxLeft,
                                    ticks: {
                                      callback: (value) =>
                                        new Intl.NumberFormat("en-US", { notation: "standard" }).format(Number(value)),
                                    },
                                  },
                                  profitRate: {
                                    position: "right",
                                    min: ProfitRateChartYAxisMin,
                                    max: ProfitRateChartYAxisMax,
                                    ticks: {
                                      callback: (value) => `${value}%`,
                                    },
                                    grid: {
                                      drawOnChartArea: false,
                                    },
                                  },
                                },
                                spanGaps: true,
                                elements: { point: { radius: 2 } },
                                plugins: {
                                  annotation: {
                                    annotations: {
                                      ...generateAnnotationStarLabels(newProductStartYearMonth, projectData?.purpose),
                                    }
                                  },
                                  datalabels: {
                                    display: false
                                  }
                                },
                              }}
                            />
                          </Box>
                        </Box>
                        <Box textAlign="center" mr="4">
                          <Heading size="sm" mb={1}>
                            {t('features.InvestmentScreening.SimulationNewProduct.heading.downside')}
                          </Heading>
                          <Text fontSize={"sm"} align="right">
                            {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                              totalProfitModified,
                              selectedCurrency.name
                            )} {selectedCurrency.name}
                          </Text>
                          <Text fontSize={"sm"} align="right">
                            {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitRate')}: {profitRateModified} %
                          </Text>
                          {realProfitRateModified && (
                            <Text fontSize={"sm"} align="right">
                              {t('features.InvestmentScreening.SimulationNewProduct.label.realOperatingProfitRate')}: {realProfitRateModified} %
                            </Text>
                          )}
                          <Box width="30vw" height="calc(30vw * 0.5625)">
                            <Line
                              data={{ ...dataRightWithRealProfitRate, labels: commonLabels }}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                scales: {
                                  x: {
                                    offset: true,
                                    ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                  },
                                  sales: {
                                    position: "left",
                                    min: yMinLeft,
                                    max: yMaxLeft,
                                    ticks: {
                                      callback: (value) =>
                                        new Intl.NumberFormat("en-US", { notation: "standard" }).format(Number(value)),
                                    },
                                  },
                                  profitRate: {
                                    position: "right",
                                    min: ProfitRateChartYAxisMin,
                                    max: ProfitRateChartYAxisMax,
                                    ticks: {
                                      callback: (value) => `${value}%`,
                                    },
                                    grid: {
                                      drawOnChartArea: false,
                                    },
                                  },
                                },
                                spanGaps: true,
                                elements: { point: { radius: 2 } },
                                plugins: {
                                  annotation: {
                                    annotations: {
                                      ...generateAnnotationStarLabels(newProductStartYearMonth, projectData?.purpose),
                                    }
                                  },
                                  datalabels: {
                                    display: false
                                  }
                                },
                              }}
                            />
                          </Box>
                        </Box>

                        {/* 選択されたシミュレーション設定のグラフを追加 */}
                        {selectedConfigsData.map(({ config, movingAverageData }, index) => {
                          const dataForGraph = movingAverageData;

                          if (!dataForGraph || !dataForGraph.datasets || !dataForGraph.labels) {
                            return null;
                          }

                          // 売上合計の合計金額を算出
                          const totalSalesConfig: Decimal = dataForGraph.datasets
                            .filter((ds: { id: string }) => ds.id === "sales")
                            .flatMap((ds: { data: any }) => ds.data)
                            .reduce((sum: Decimal, value: number) => sum.plus(value != null ? new Decimal(value) : new Decimal(0)), new Decimal(0));

                          // 営業利益額の合計金額を算出（costBreakdown経由の年度丸め方式 - 申請書画面と同一）
                          const rawSalesDataForConfig = salesChartDataForSavedConfig.find(s => s.configId === config.id);
                          const totalProfitConfig = calcDisplayTotalProfit(rawSalesDataForConfig?.data);

                          // monthlyPLDataForConfigは実質的営業利益率の計算に再利用
                          let totalProfitConfigLegacy: Decimal;
                          let monthlyPLDataForConfig: MonthlyProfitAndLossData | null = null;

                          const configQuantitiesData = quantitiesChartDataForSavedConfig.find(q => q.configId === config.id);

                          // JPYネイティブデータパス判定：選択通貨が保存時の表示通貨と一致する場合
                          // 振り返りモード時は JPY版が月別レート未対応のため、ローカル通貨パス（convertFn適用版）を使う
                          const jpySalesDataForConfig = !reviewDate && selectedCurrency?.name === savedDisplayCurrencyName
                            ? displayVersionSalesChartDataForSavedConfig.find(item => item.configId === config.id) : null;
                          const jpySalesDatasetForConfig = jpySalesDataForConfig?.data?.datasets?.find((d: any) => d.id === "sales");
                          const jpyMergedDataForConfig = !reviewDate && selectedCurrency?.name === savedDisplayCurrencyName
                            ? displayVersionMergedChartDataForSavedConfig.find(m => m.configId === config.id) : null;

                          if (jpySalesDatasetForConfig && jpyMergedDataForConfig?.data && configQuantitiesData?.data &&
                            displayOriginalProfitAndLossByMonth?.labels && savedDisplayCurrencyName && currencyData?.length && capexPartNo?.length) {
                            // JPYネイティブパス：ダウンサイドと同じデータソースを使用
                            const salesForPL = jpySalesDatasetForConfig.data.map((v: number) => new Decimal(v));
                            const labelsForPL = displayOriginalProfitAndLossByMonth.labels.slice(0, salesForPL.length);
                            const capexForPL = config.quantityAndPrice.length > 0
                              ? capexPartNo.map(partNo => {
                                const matched = config.quantityAndPrice.find(q => q.partNo === partNo.partNo);
                                return matched ? { ...partNo, quantityAndPrice: JSON.stringify(matched) } : partNo;
                              })
                              : capexPartNo;
                            const matForPL = calcMaterialCost(
                              jpyMergedDataForConfig.data, configQuantitiesData.data, capexForPL, labelsForPL,
                              projectData?.projectId!, savedDisplayCurrencyName, currencyData
                            );
                            const eqCfg = config.equipmentAmounts || [];
                            const eqForPL = originalEquipmentAmounts
                              .map(eq => eqCfg.find(se => se.equipmentId === eq.equipmentId) ? { ...eq, selected: true } : null)
                              .filter((eq): eq is EquipmentExtType => eq !== null);

                            const configApplyDownside = config.applyDownside !== false;
                            const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;
                            monthlyPLDataForConfig = calcMonthlyProfitAndLossDetails(
                              salesForPL, matForPL || [], labelsForPL, configApplyDownside, eqForPL,
                              applyScenarioLaborCostToProjectData(
                                projectData!,
                                config.scenarioLaborCostByMonth,
                                config.scenarioOverseasFactoryExpensesByMonth,
                                labelsForPL
                              ), capexForPL, savedDisplayCurrencyName, currencyData,
                              configDownsideIndex, hasDecimal(savedDisplayCurrencyName),
                              uniqueProcessData, bomData,
                              projectData?.moldSalesByProject, projectData?.developmentSalesByProject, projectData?.equipmentSalesByProject
                            );

                            totalProfitConfigLegacy = monthlyPLDataForConfig
                              ? monthlyPLDataForConfig.profit.reduce((sum, v) => sum.plus(v), new Decimal(0))
                              : dataForGraph.datasets.filter((ds: { id: string }) => ds.id === "profit")
                                .flatMap((ds: { data: any }) => ds.data)
                                .reduce((sum: Decimal, value: number) => sum.plus(value != null ? new Decimal(value) : new Decimal(0)), new Decimal(0));
                          } else {
                            // ローカル通貨パス（JPYネイティブデータが利用できない場合のフォールバック）
                            const configSalesData = salesChartDataForSavedConfig.find(item => item.configId === config.id);
                            const configSalesDataset = configSalesData?.data?.datasets?.find((d: any) => d.id === "sales");
                            const configMergedData = mergedChartDataForSavedConfig.find(m => m.configId === config.id);

                            if (configSalesDataset && configQuantitiesData?.data && configMergedData?.data &&
                              originalProfitAndLossByMonth?.labels && localCurrencyName && selectedCurrency?.name && currencyData?.length && capexPartNo?.length) {
                              const salesLocalForPL = configSalesDataset.data.map((v: number) => new Decimal(v));
                              // 振り返りモード: 事前変換せずローカル通貨のまま関数に渡す（関数内で月別レート変換）
                              // 通常モード: 従来どおり単一レートで表示通貨へ事前変換
                              const salesForPL = reviewDate
                                ? salesLocalForPL
                                : (localCurrencyName !== selectedCurrency.name
                                  ? salesLocalForPL.map((v: Decimal) => convertCurrency(v, localCurrencyName, selectedCurrency.name, currencyData))
                                  : salesLocalForPL);
                              const labelsForPL = originalProfitAndLossByMonth.labels.slice(0, salesLocalForPL.length);
                              const capexForPL = config.quantityAndPrice.length > 0
                                ? capexPartNo.map(partNo => {
                                  const matched = config.quantityAndPrice.find(q => q.partNo === partNo.partNo);
                                  return matched ? { ...partNo, quantityAndPrice: JSON.stringify(matched) } : partNo;
                                })
                                : capexPartNo;
                              const matLocalForPL = calcMaterialCost(
                                configMergedData.data, configQuantitiesData.data, capexForPL, labelsForPL,
                                projectData?.projectId!, localCurrencyName, currencyData
                              );
                              // 振り返りモード: 材料費はローカル通貨のまま関数に渡す
                              // 通常モード: 従来どおり単一レートで表示通貨へ事前変換
                              const matForPL = reviewDate
                                ? matLocalForPL
                                : (localCurrencyName !== selectedCurrency.name && matLocalForPL
                                  ? matLocalForPL.map(v => convertCurrency(v, localCurrencyName, selectedCurrency.name, currencyData))
                                  : matLocalForPL);
                              const eqCfg = config.equipmentAmounts || [];
                              const eqForPL = originalEquipmentAmounts
                                .map(eq => eqCfg.find(se => se.equipmentId === eq.equipmentId) ? { ...eq, selected: true } : null)
                                .filter((eq): eq is EquipmentExtType => eq !== null);

                              const configApplyDownside = config.applyDownside !== false;
                              const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;
                              monthlyPLDataForConfig = calcMonthlyProfitAndLossDetails(
                                salesForPL, matForPL || [], labelsForPL, configApplyDownside, eqForPL,
                                applyScenarioLaborCostToProjectData(
                                  projectData!,
                                  config.scenarioLaborCostByMonth,
                                  config.scenarioOverseasFactoryExpensesByMonth,
                                  labelsForPL
                                ), capexForPL, selectedCurrency.name, currencyData,
                                configDownsideIndex, hasDecimal(selectedCurrency.name),
                                uniqueProcessData, bomData,
                                projectData?.moldSalesByProject, projectData?.developmentSalesByProject, projectData?.equipmentSalesByProject,
                                undefined,
                                reviewDate ? convertWithRate : undefined,
                              );

                              totalProfitConfigLegacy = monthlyPLDataForConfig
                                ? monthlyPLDataForConfig.profit.reduce((sum, v) => sum.plus(v), new Decimal(0))
                                : dataForGraph.datasets.filter((ds: { id: string }) => ds.id === "profit")
                                  .flatMap((ds: { data: any }) => ds.data)
                                  .reduce((sum: Decimal, value: number) => sum.plus(value != null ? new Decimal(value) : new Decimal(0)), new Decimal(0));
                            } else {
                              totalProfitConfigLegacy = dataForGraph.datasets
                                .filter((ds: { id: string }) => ds.id === "profit")
                                .flatMap((ds: { data: any }) => ds.data)
                                .reduce((sum: Decimal, value: number) => sum.plus(value != null ? new Decimal(value) : new Decimal(0)), new Decimal(0));
                            }
                          }

                          // 営業利益率を算出
                          const profitRateConfig = (calcProfitRate(totalSalesConfig, totalProfitConfig))?.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                          const commonLabelsConfig = dataForGraph.labels;

                          // 実質的営業利益率を計算（保存済み設定用）
                          // monthlyPLDataForConfigが算出済みの場合はそれを再利用（calcMonthlyProfitAndLossDetailsの重複呼び出しを回避）
                          const calcRealProfitRateForConfig = () => {
                            if (!monthlyPLDataForConfig) {
                              return { realProfitRate: "", realProfitRateByMonth: [] as number[] };
                            }
                            // 顧客指定部品の有無判断
                            const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
                            if (!a) return { realProfitRate: "", realProfitRateByMonth: [] as number[] };

                            const displaySalesDataset = dataForGraph.datasets.find((d: any) => d.id === "sales");
                            const displayProfitDataset = dataForGraph.datasets.find((d: any) => d.id === "profit");
                            if (!displaySalesDataset || !displayProfitDataset) {
                              return { realProfitRate: "", realProfitRateByMonth: [] as number[] };
                            }
                            const displaySalesData = displaySalesDataset.data as number[];
                            const displayProfitData = displayProfitDataset.data as number[];

                            // customerSpecifiedPartsCostは既にselectedCurrencyで算出済み（calcMonthlyProfitAndLossDetailsのtargetCurrency=selectedCurrency）
                            const customerSpecifiedPartsCostConverted = monthlyPLDataForConfig.customerSpecifiedPartsCost;

                            const totalSalesVal = displaySalesData.reduce((sum, v) => sum + (v || 0), 0);
                            // No.411追加対応: 表示期間外（生産終了後）に残る減価償却費を分子に加算し、系統A（画面表示用）と算出方式を統一する
                            const totalProfitVal = displayProfitData.reduce((sum, v) => sum + (v || 0), 0)
                              + (monthlyPLDataForConfig.residualDepreciationTotal?.toNumber() ?? 0);
                            const totalCustomerCost = customerSpecifiedPartsCostConverted.reduce((sum, v) => sum.plus(v), new Decimal(0));
                            const realProfitRateVal = calcRealProfitRate(new Decimal(totalSalesVal), new Decimal(totalProfitVal), totalCustomerCost);

                            const realProfitRateByMonth = calcRealProfitRateByMonth(
                              displaySalesData,
                              displayProfitData,
                              customerSpecifiedPartsCostConverted
                            );

                            return { realProfitRate: realProfitRateVal, realProfitRateByMonth };
                          };

                          const { realProfitRate: realProfitRateConfig, realProfitRateByMonth: realProfitRateByMonthConfig } = calcRealProfitRateForConfig();

                          const dataForGraphWithRealProfitRate = realProfitRateByMonthConfig.length > 0
                            ? {
                              ...dataForGraph,
                              datasets: [
                                ...dataForGraph.datasets,
                                {
                                  label: t('features.InvestmentScreening.SimulationNewProduct.chart.realOperatingProfitRate'),
                                  id: "realProfitRate",
                                  yAxisID: "profitRate",
                                  data: realProfitRateByMonthConfig,
                                  borderColor: "orange",
                                  backgroundColor: "orange",
                                  fill: false,
                                  tension: 0.4,
                                  type: "line" as const,
                                }
                              ]
                            }
                            : dataForGraph;

                          return (
                            <Box key={config.id} textAlign="center" mr={index < selectedConfigsData.length - 1 ? "4" : "0"} mb={4}>
                              <Heading size="sm" mb={1}>
                                {config.name}
                              </Heading>
                              <Text fontSize={"sm"} align="right">
                                {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                                  totalProfitConfig,
                                  selectedCurrency.name
                                )} {selectedCurrency.name}
                              </Text>
                              <Text fontSize={"sm"} align="right">
                                {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitRate')}: {profitRateConfig} %
                              </Text>
                              {realProfitRateConfig && (
                                <Text fontSize={"sm"} align="right">
                                  {t('features.InvestmentScreening.SimulationNewProduct.label.realOperatingProfitRate')}: {realProfitRateConfig} %
                                </Text>
                              )}
                              <Box width="30vw" height="calc(30vw * 0.5625)">
                                <Line
                                  data={{ ...dataForGraphWithRealProfitRate, labels: commonLabelsConfig }}
                                  options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    scales: {
                                      x: {
                                        offset: true,
                                        ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabelsConfig[index]) },
                                      },
                                      sales: {
                                        position: "left",
                                        min: yMinLeft,
                                        max: yMaxLeft,
                                        ticks: {
                                          callback: (value) =>
                                            new Intl.NumberFormat("en-US", { notation: "standard" }).format(Number(value)),
                                        },
                                      },
                                      profitRate: {
                                        position: "right",
                                        min: ProfitRateChartYAxisMin,
                                        max: ProfitRateChartYAxisMax,
                                        ticks: {
                                          callback: (value) => `${value}%`,
                                        },
                                        grid: {
                                          drawOnChartArea: false,
                                        },
                                      },
                                    },
                                    spanGaps: true,
                                    elements: { point: { radius: 2 } },
                                    plugins: {
                                      datalabels: {
                                        display: false
                                      }
                                    },
                                  }}
                                />
                              </Box>
                            </Box>
                          );
                        })}
                      </Flex>
                    );
                  })()}
                </Box>
              )}

              {/* 投資回収（Combined Chart） */}
              {(displayCombinedChartData || combinedChartData) && (displayCombinedChartDataModified || combinedChartDataModified) && (() => {
                // 表示用データを優先、なければ元データを使用
                const combinedDataLeft = displayCombinedChartData || combinedChartData;
                const combinedDataRight = displayCombinedChartDataModified || combinedChartDataModified;

                // 選択された設定がある場合は、それらも含めてスケールを計算（表示用データを優先）
                const combinedSavedConfigDataSource = displayCombinedChartDataForSavedConfig.length > 0
                  ? displayCombinedChartDataForSavedConfig
                  : combinedChartDataForSavedConfig;
                const allDataSets = [combinedDataLeft, combinedDataRight];
                selectedConfigIds.forEach(configId => {
                  const chartData = combinedSavedConfigDataSource.find(item => item.configId === configId);
                  if (chartData?.data) {
                    allDataSets.push(chartData.data);
                  }
                });

                // すべてのデータセットを考慮してスケールを計算
                const allData = allDataSets.flatMap(ds =>
                  ds?.datasets?.flatMap((dataset: any) => dataset?.data?.filter((v: any) => v !== null)) || []
                );
                const { yMin, yMax } = calcYAxisRange(allData, false);
                const commonLabels = combinedDataLeft.labels.length >= combinedDataRight.labels.length
                  ? combinedDataLeft.labels
                  : combinedDataRight.labels;

                // 営業利益合計と営業利益率を計算（当初計画）（costBreakdown経由の年度丸め方式）
                const totalProfitOriginal = calcDisplayTotalProfit(salesChartData);
                const { profitRate: profitRateOriginal } = calcTotalProfitAndRate(displaySalesChartData);

                // 営業利益合計と営業利益率を計算（ダウンサイド）（costBreakdown経由の年度丸め方式）
                const totalProfitModified = calcDisplayTotalProfit(salesChartDataModified);
                const { profitRate: profitRateModified } = calcTotalProfitAndRate(displaySalesChartDataModified);

                // 実質的営業利益率を計算
                // 実質的営業利益率（当初計画・投資回収Combined、トップレベルのuseMemoで計算済み）
                const realProfitRateOriginal = realProfitRateForCombinedMemo;
                // 実質的営業利益率（ダウンサイド・投資回収Combined、トップレベルのuseMemoで計算済み）
                const realProfitRateModifiedCombined = realProfitRateForCombinedModifiedMemo;

                // 動的に「回収○ヶ月目」ラベル表示のアノテーションを生成
                const annotations = generateRecoveryPointAnnotationOptions(monthOfRecoveryOriginal, commonLabels);

                // 動的に「回収○ヶ月目」ラベル表示のアノテーションを生成（ダウンサイド）
                const annotationsModified = generateRecoveryPointAnnotationOptions(monthOfRecoveryModified, commonLabels);

                return (
                  <Box mt={4}>
                    <Heading size="md" mb={2}>
                      {t('features.InvestmentScreening.SimulationNewProduct.heading.incrementalCashFlow')}
                    </Heading>
                    <Text>
                      unit:{selectedCurrency.name}
                    </Text>
                    {/* プロジェクト全体投資回収　当初投資・回収 */}
                    {combinedChartDataAll && (() => {
                      const chartDataAll = displayCombinedChartDataAll || combinedChartDataAll;
                      const chartDataPast = displayCombinedChartDataPast || combinedChartDataPast;

                      // スケール計算（当初投資・回収がある場合は共通Y軸スケール）
                      const allDataSets = [chartDataAll, ...(chartDataPast ? [chartDataPast] : [])];
                      const allData = allDataSets.flatMap(ds =>
                        ds?.datasets?.flatMap((dataset: any) => dataset?.data?.filter((v: any) => v !== null)) || []
                      );
                      const { yMin, yMax } = calcYAxisRange(allData, false);

                      // 営業利益合計と営業利益率を計算（プロジェクト全体投資回収）
                      const { profitRate: profitRateAll } = calcTotalProfitAndRate(salesChartDataAll);

                      // 営業利益合計と営業利益率を計算（当初投資・回収）
                      const { profitRate: profitRatePast } = combinedChartDataPast ? calcTotalProfitAndRate(salesChartDataPast) : { profitRate: null };

                      // 動的に「回収○ヶ月目」ラベル表示のアノテーションを生成
                      const annotationsAllRecovery = generateRecoveryPointAnnotationOptions(monthOfRecoveryAll, chartDataAll.labels);

                      // 動的に「回収○ヶ月目」ラベル表示のアノテーションを生成（当初投資・回収）
                      const annotationsPast = chartDataPast ? generateRecoveryPointAnnotationOptions(monthOfRecoveryPast, chartDataPast.labels) : {};

                      return (
                        <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4}>
                          <Box textAlign="center">
                            <Heading size="sm" mb={1}>
                              {t('features.InvestmentScreening.SimulationNewProduct.heading.projectTotalRecovery')}
                            </Heading>
                            <Text fontSize={"sm"} align="right">
                              {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                                calcDisplayTotalProfit(salesChartDataAll),
                                selectedCurrency.name
                              )} {selectedCurrency.name}
                            </Text>
                            <Text fontSize={"sm"} align="right">
                              {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitRate')}: {profitRateAll} %
                            </Text>
                            <Box width="30vw" height="calc(30vw * 0.5625)">
                              <Chart
                                type="bar"
                                data={chartDataAll}
                                options={{
                                  responsive: true,
                                  maintainAspectRatio: false,
                                  plugins: {
                                    tooltip: {
                                      enabled: true,
                                      callbacks: {
                                        label: (context: any) => {
                                          let label = context.dataset.label || '';
                                          if (label) label += ': ';
                                          if (context.parsed.y !== null) {
                                            const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
                                            label += context.parsed.y.toLocaleString(undefined, {
                                              minimumFractionDigits: dp,
                                              maximumFractionDigits: dp,
                                            }) + ' ' + selectedCurrency.name;
                                          }
                                          return label;
                                        }
                                      }
                                    },
                                    legend: {
                                      labels: {
                                        // 凡例のカスタマイズ
                                        generateLabels: generateLabels,
                                      }
                                    },
                                    annotation: {
                                      annotations: {
                                        zeroLine: {
                                          type: "line",
                                          yMin: 0,
                                          yMax: 0,
                                          borderColor: "red",
                                          borderDash: [4, 4],
                                          borderWidth: 2,
                                        },
                                        ...annotationsAllRecovery,
                                        ...generateAnnotationStarLabels(newProductStartYearMonth, projectData?.purpose, Object.entries(annotationsAllRecovery).length),
                                      }
                                    },
                                    datalabels: {
                                      display: false
                                    },
                                  },
                                  scales: {
                                    x: {
                                      offset: true,
                                      ticks: { callback: (index: any) => formatYearMonthByLocale(chartDataAll.labels[index]) },
                                    },
                                    y: {
                                      min: yMin,
                                      max: yMax,
                                      ticks: {
                                        format: {
                                          notation: "standard",
                                          minimumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                          maximumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                        }
                                      }
                                    },
                                  },
                                }}
                              />
                            </Box>
                          </Box>
                          {combinedChartDataPast && chartDataPast && (
                            <Box textAlign="center">
                              <Heading size="sm" mb={1}>
                                {t('features.InvestmentScreening.SimulationNewProduct.heading.initialInvestmentRecovery')}
                              </Heading>
                              <Text fontSize={"sm"} align="right">
                                {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                                  calcDisplayTotalProfit(salesChartDataPast),
                                  selectedCurrency.name
                                )} {selectedCurrency.name}
                              </Text>
                              <Text fontSize={"sm"} align="right">
                                {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitRate')}: {profitRatePast} %
                              </Text>
                              <Box width="30vw" height="calc(30vw * 0.5625)">
                                <Chart
                                  type="bar"
                                  data={chartDataPast}
                                  options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                      tooltip: {
                                        enabled: true,
                                        callbacks: {
                                          label: (context: any) => {
                                            let label = context.dataset.label || '';
                                            if (label) label += ': ';
                                            if (context.parsed.y !== null) {
                                              const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
                                              label += context.parsed.y.toLocaleString(undefined, {
                                                minimumFractionDigits: dp,
                                                maximumFractionDigits: dp,
                                              }) + ' ' + selectedCurrency.name;
                                            }
                                            return label;
                                          }
                                        }
                                      },
                                      legend: {
                                        labels: {
                                          generateLabels: generateLabels,
                                        }
                                      },
                                      annotation: {
                                        annotations: {
                                          zeroLine: {
                                            type: "line",
                                            yMin: 0,
                                            yMax: 0,
                                            borderColor: "red",
                                            borderDash: [4, 4],
                                            borderWidth: 2,
                                          },
                                          ...annotationsPast,
                                          ...generateAnnotationStarLabels(newProductStartYearMonth, projectData?.purpose, Object.entries(annotationsPast).length),
                                        }
                                      },
                                      datalabels: {
                                        display: false
                                      },
                                    },
                                    scales: {
                                      x: {
                                        offset: true,
                                        ticks: { callback: (index: any) => formatYearMonthByLocale(chartDataPast.labels[index]) },
                                      },
                                      y: {
                                        min: yMin,
                                        max: yMax,
                                        ticks: {
                                          format: {
                                            notation: "standard",
                                            minimumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                            maximumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                          }
                                        }
                                      },
                                    },
                                  }}
                                />
                              </Box>
                            </Box>
                          )}
                        </Flex>
                      );
                    })()}

                    <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4}>
                      <Box textAlign="center">
                        <Heading size="sm" mb={1}>
                          {t('features.InvestmentScreening.SimulationNewProduct.heading.initialPlan')}
                        </Heading>
                        <Text fontSize={"sm"} align="right">
                          {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                            totalProfitOriginal,
                            selectedCurrency.name
                          )} {selectedCurrency.name}
                        </Text>
                        <Text fontSize={"sm"} align="right">
                          {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitRate')}: {profitRateOriginal} %
                        </Text>
                        {realProfitRateOriginal && (
                          <Text fontSize={"sm"} align="right">
                            {t('features.InvestmentScreening.SimulationNewProduct.label.realOperatingProfitRate')}: {realProfitRateOriginal} %
                          </Text>
                        )}
                        <Box width="30vw" height="calc(30vw * 0.5625)">
                          <Chart
                            type="bar"
                            data={{ ...combinedDataLeft, labels: commonLabels }}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              plugins: {
                                tooltip: { enabled: true },
                                legend: {
                                  labels: {
                                    // 凡例のカスタマイズ
                                    generateLabels: generateLabels,
                                  }
                                },
                                annotation: {
                                  annotations: {
                                    zeroLine: {
                                      type: "line",
                                      yMin: 0,
                                      yMax: 0,
                                      borderColor: "red",
                                      borderDash: [4, 4],
                                      borderWidth: 2,
                                    },
                                    ...annotations, // 動的に生成したアノテーションをここで展開
                                    ...generateAnnotationStarLabels(newProductStartYearMonth, projectData?.purpose, Object.entries(annotations).length),
                                  }
                                },
                                datalabels: {
                                  display: false
                                },
                              },
                              scales: {
                                x: {
                                  offset: true,
                                  ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                },
                                y: {
                                  min: yMin,
                                  max: yMax,
                                  ticks: {
                                    format: {
                                      notation: "standard"
                                    }
                                  }
                                },
                              },
                            }}
                          />
                        </Box>
                      </Box>
                      <Box textAlign="center">
                        <Heading size="sm" mb={1}>
                          {t('features.InvestmentScreening.SimulationNewProduct.heading.downside')}
                        </Heading>
                        <Text fontSize={"sm"} align="right">
                          {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                            totalProfitModified,
                            selectedCurrency.name
                          )} {selectedCurrency.name}
                        </Text>
                        <Text fontSize={"sm"} align="right">
                          {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitRate')}: {profitRateModified} %
                        </Text>
                        {realProfitRateModifiedCombined && (
                          <Text fontSize={"sm"} align="right">
                            {t('features.InvestmentScreening.SimulationNewProduct.label.realOperatingProfitRate')}: {realProfitRateModifiedCombined} %
                          </Text>
                        )}
                        <Box width="30vw" height="calc(30vw * 0.5625)">
                          <Chart
                            type="bar"
                            data={{ ...combinedDataRight, labels: commonLabels }}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              plugins: {
                                tooltip: { enabled: true },
                                legend: {
                                  labels: {
                                    // 凡例のカスタマイズ
                                    generateLabels: generateLabels,
                                  }
                                },
                                annotation: {
                                  annotations: {
                                    zeroLine: {
                                      type: "line",
                                      yMin: 0,
                                      yMax: 0,
                                      borderColor: "red",
                                      borderDash: [4, 4],
                                      borderWidth: 2,
                                    },
                                    ...annotationsModified, // 動的に生成したアノテーションをここで展開
                                    ...generateAnnotationStarLabels(newProductStartYearMonth, projectData?.purpose, Object.entries(annotationsModified).length),
                                  }
                                },
                                datalabels: {
                                  display: false
                                },
                              },
                              scales: {
                                x: {
                                  offset: true,
                                  ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                },
                                y: {
                                  min: yMin,
                                  max: yMax,
                                  ticks: {
                                    format: {
                                      notation: "standard"
                                    }
                                  }
                                },
                              },
                            }}
                          />
                        </Box>
                      </Box>
                      {selectedConfigIds.map((configId) => {
                        const config = savedConfigs.find(c => c.id === configId);
                        // 表示用データを優先
                        const salesSavedConfigDataSource = displaySalesChartDataForSavedConfig.length > 0
                          ? displaySalesChartDataForSavedConfig
                          : salesChartDataForSavedConfig;
                        const combinedData = combinedSavedConfigDataSource.find(item => item.configId === configId);
                        const monthOfRecoveryData = monthOfRecoveryForSavedConfig.find(item => item.configId === configId);
                        const salesData = salesSavedConfigDataSource.find(item => item.configId === configId);

                        if (!config || !combinedData?.data) return null;

                        // 選択された設定のアノテーションを生成
                        const configAnnotations = generateRecoveryPointAnnotationOptions(monthOfRecoveryData?.data, commonLabels);

                        // 営業利益合計と営業利益率を計算
                        const movingAverageData = salesData ? processData(salesData.data) : null;
                        // 営業利益合計をcostBreakdown経由で計算（申請書画面と同一方式）
                        const rawSalesDataForCombinedConfig = salesChartDataForSavedConfig.find(s => s.configId === configId);
                        const configTotalProfit = calcDisplayTotalProfit(rawSalesDataForCombinedConfig?.data);
                        const totalSalesForProfitRate = movingAverageData?.datasets
                          ?.filter((ds: { id: string }) => ds.id === "sales")
                          ?.flatMap((ds: { data: any }) => ds.data)
                          ?.reduce((sum: Decimal, value: number) => sum.plus(value != null ? new Decimal(value) : new Decimal(0)), new Decimal(0)) || new Decimal(0);
                        const configProfitRate = (calcProfitRate(totalSalesForProfitRate, configTotalProfit))?.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

                        // monthlyPLDataForCombinedConfigは実質的営業利益率の計算に再利用
                        let configTotalProfitLegacy: Decimal;
                        let configProfitRateLegacy: string;
                        let monthlyPLDataForCombinedConfig: MonthlyProfitAndLossData | null = null;

                        const combinedConfigQuantitiesData = quantitiesChartDataForSavedConfig.find(q => q.configId === config.id);

                        // JPYネイティブデータパス判定
                        // 振り返りモード時は JPY版が月別レート未対応のため、ローカル通貨パスを使う
                        const jpySalesDataForCombined = !reviewDate && selectedCurrency?.name === savedDisplayCurrencyName
                          ? displayVersionSalesChartDataForSavedConfig.find(item => item.configId === configId) : null;
                        const jpySalesDatasetForCombined = jpySalesDataForCombined?.data?.datasets?.find((d: any) => d.id === "sales");
                        const jpyMergedDataForCombined = !reviewDate && selectedCurrency?.name === savedDisplayCurrencyName
                          ? displayVersionMergedChartDataForSavedConfig.find(m => m.configId === config.id) : null;

                        if (jpySalesDatasetForCombined && jpyMergedDataForCombined?.data && combinedConfigQuantitiesData?.data &&
                          displayOriginalProfitAndLossByMonth?.labels && savedDisplayCurrencyName && currencyData?.length && capexPartNo?.length) {
                          // JPYネイティブパス
                          const salesForCombinedPL = jpySalesDatasetForCombined.data.map((v: number) => new Decimal(v));
                          const labelsForCombinedPL = displayOriginalProfitAndLossByMonth.labels.slice(0, salesForCombinedPL.length);
                          const capexForCombinedPL = config.quantityAndPrice.length > 0
                            ? capexPartNo.map(partNo => {
                              const matched = config.quantityAndPrice.find(q => q.partNo === partNo.partNo);
                              return matched ? { ...partNo, quantityAndPrice: JSON.stringify(matched) } : partNo;
                            })
                            : capexPartNo;
                          const matForCombinedPL = calcMaterialCost(
                            jpyMergedDataForCombined.data, combinedConfigQuantitiesData.data, capexForCombinedPL, labelsForCombinedPL,
                            projectData?.projectId!, savedDisplayCurrencyName, currencyData
                          );
                          const eqCfgCombined = config.equipmentAmounts || [];
                          const eqForCombinedPL = originalEquipmentAmounts
                            .map(eq => eqCfgCombined.find(se => se.equipmentId === eq.equipmentId) ? { ...eq, selected: true } : null)
                            .filter((eq): eq is EquipmentExtType => eq !== null);

                          const configApplyDownside = config.applyDownside !== false;
                          const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;
                          monthlyPLDataForCombinedConfig = calcMonthlyProfitAndLossDetails(
                            salesForCombinedPL, matForCombinedPL || [], labelsForCombinedPL, configApplyDownside, eqForCombinedPL,
                            applyScenarioLaborCostToProjectData(
                              projectData!,
                              config.scenarioLaborCostByMonth,
                              config.scenarioOverseasFactoryExpensesByMonth,
                              labelsForCombinedPL
                            ), capexForCombinedPL, savedDisplayCurrencyName, currencyData,
                            configDownsideIndex, hasDecimal(savedDisplayCurrencyName),
                            uniqueProcessData, bomData,
                            projectData?.moldSalesByProject, projectData?.developmentSalesByProject, projectData?.equipmentSalesByProject
                          );

                          if (monthlyPLDataForCombinedConfig) {
                            configTotalProfitLegacy = monthlyPLDataForCombinedConfig.profit.reduce((sum, v) => sum.plus(v), new Decimal(0));
                            const totalSales = movingAverageData?.datasets
                              ?.filter((ds: { id: string }) => ds.id === "sales")
                              ?.flatMap((ds: { data: any }) => ds.data)
                              ?.reduce((sum: Decimal, value: number) => sum.plus(value != null ? new Decimal(value) : new Decimal(0)), new Decimal(0)) || new Decimal(0);
                            configProfitRateLegacy = (calcProfitRate(totalSales, configTotalProfitLegacy))?.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                          } else {
                            const result = calcTotalProfitAndRate(movingAverageData);
                            configTotalProfitLegacy = result.totalProfit;
                            configProfitRateLegacy = result.profitRate;
                          }
                        } else {
                          // ローカル通貨パス（フォールバック）
                          const combinedConfigSalesData = salesChartDataForSavedConfig.find(item => item.configId === configId);
                          const combinedConfigSalesDataset = combinedConfigSalesData?.data?.datasets?.find((d: any) => d.id === "sales");
                          const combinedConfigMergedData = mergedChartDataForSavedConfig.find(m => m.configId === config.id);

                          if (combinedConfigSalesDataset && combinedConfigQuantitiesData?.data && combinedConfigMergedData?.data &&
                            originalProfitAndLossByMonth?.labels && localCurrencyName && selectedCurrency?.name && currencyData?.length && capexPartNo?.length) {
                            const salesLocalForCombined = combinedConfigSalesDataset.data.map((v: number) => new Decimal(v));
                            const salesForCombinedPL = localCurrencyName !== selectedCurrency.name
                              ? salesLocalForCombined.map((v: Decimal) => convertCurrency(v, localCurrencyName, selectedCurrency.name, currencyData))
                              : salesLocalForCombined;
                            const labelsForCombinedPL = originalProfitAndLossByMonth.labels.slice(0, salesLocalForCombined.length);
                            const capexForCombinedPL = config.quantityAndPrice.length > 0
                              ? capexPartNo.map(partNo => {
                                const matched = config.quantityAndPrice.find(q => q.partNo === partNo.partNo);
                                return matched ? { ...partNo, quantityAndPrice: JSON.stringify(matched) } : partNo;
                              })
                              : capexPartNo;
                            const matLocalForCombined = calcMaterialCost(
                              combinedConfigMergedData.data, combinedConfigQuantitiesData.data, capexForCombinedPL, labelsForCombinedPL,
                              projectData?.projectId!, localCurrencyName, currencyData
                            );
                            const matForCombinedPL = localCurrencyName !== selectedCurrency.name && matLocalForCombined
                              ? matLocalForCombined.map(v => convertCurrency(v, localCurrencyName, selectedCurrency.name, currencyData))
                              : matLocalForCombined;
                            const eqCfgCombined = config.equipmentAmounts || [];
                            const eqForCombinedPL = originalEquipmentAmounts
                              .map(eq => eqCfgCombined.find(se => se.equipmentId === eq.equipmentId) ? { ...eq, selected: true } : null)
                              .filter((eq): eq is EquipmentExtType => eq !== null);

                            const configApplyDownside = config.applyDownside !== false;
                            const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;
                            monthlyPLDataForCombinedConfig = calcMonthlyProfitAndLossDetails(
                              salesForCombinedPL, matForCombinedPL || [], labelsForCombinedPL, configApplyDownside, eqForCombinedPL,
                              applyScenarioLaborCostToProjectData(
                                projectData!,
                                config.scenarioLaborCostByMonth,
                                config.scenarioOverseasFactoryExpensesByMonth,
                                labelsForCombinedPL
                              ), capexForCombinedPL, selectedCurrency.name, currencyData,
                              configDownsideIndex, hasDecimal(selectedCurrency.name),
                              uniqueProcessData, bomData,
                              projectData?.moldSalesByProject, projectData?.developmentSalesByProject, projectData?.equipmentSalesByProject
                            );

                            if (monthlyPLDataForCombinedConfig) {
                              configTotalProfitLegacy = monthlyPLDataForCombinedConfig.profit.reduce((sum, v) => sum.plus(v), new Decimal(0));
                              const totalSales = movingAverageData?.datasets
                                ?.filter((ds: { id: string }) => ds.id === "sales")
                                ?.flatMap((ds: { data: any }) => ds.data)
                                ?.reduce((sum: Decimal, value: number) => sum.plus(value != null ? new Decimal(value) : new Decimal(0)), new Decimal(0)) || new Decimal(0);
                              configProfitRateLegacy = (calcProfitRate(totalSales, configTotalProfitLegacy))?.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                            } else {
                              const result = calcTotalProfitAndRate(movingAverageData);
                              configTotalProfitLegacy = result.totalProfit;
                              configProfitRateLegacy = result.profitRate;
                            }
                          } else {
                            const result = calcTotalProfitAndRate(movingAverageData);
                            configTotalProfitLegacy = result.totalProfit;
                            configProfitRateLegacy = result.profitRate;
                          }
                        }

                        // 実質的営業利益率を計算（保存済み設定用）
                        // monthlyPLDataForCombinedConfigが算出済みの場合はそれを再利用
                        const calcRealProfitRateForCombinedConfig = () => {
                          if (!monthlyPLDataForCombinedConfig || !movingAverageData?.datasets) {
                            return "";
                          }
                          // 顧客指定部品の有無判断
                          const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
                          if (!a) return "";

                          // customerSpecifiedPartsCostは既にselectedCurrencyで算出済み
                          const totalCustomerCost = monthlyPLDataForCombinedConfig.customerSpecifiedPartsCost.reduce((sum, v) => sum.plus(v), new Decimal(0));

                          const displaySalesDataset = movingAverageData.datasets.find((d: any) => d.id === "sales");
                          const displayProfitDataset = movingAverageData.datasets.find((d: any) => d.id === "profit");
                          if (!displaySalesDataset || !displayProfitDataset) {
                            return "";
                          }
                          const totalSalesVal = (displaySalesDataset.data as number[]).reduce((sum, v) => sum + (v || 0), 0);
                          // No.411追加対応: 表示期間外（生産終了後）に残る減価償却費を分子に加算し、系統A（画面表示用）と算出方式を統一する
                          const totalProfitVal = (displayProfitDataset.data as number[]).reduce((sum, v) => sum + (v || 0), 0)
                            + (monthlyPLDataForCombinedConfig.residualDepreciationTotal?.toNumber() ?? 0);
                          return calcRealProfitRate(new Decimal(totalSalesVal), new Decimal(totalProfitVal), totalCustomerCost);
                        };
                        const realProfitRateConfig = calcRealProfitRateForCombinedConfig();

                        return (
                          <Box key={config.id} textAlign="center">
                            <Heading size="sm" mb={1}>
                              {config.name}
                            </Heading>
                            <Text fontSize={"sm"} align="right">
                              {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                                configTotalProfit,
                                selectedCurrency.name
                              )} {selectedCurrency.name}
                            </Text>
                            <Text fontSize={"sm"} align="right">
                              {t('features.InvestmentScreening.SimulationNewProduct.label.operatingProfitRate')}: {configProfitRate} %
                            </Text>
                            {realProfitRateConfig && (
                              <Text fontSize={"sm"} align="right">
                                {t('features.InvestmentScreening.SimulationNewProduct.label.realOperatingProfitRate')}: {realProfitRateConfig} %
                              </Text>
                            )}
                            <Box width="30vw" height="calc(30vw * 0.5625)">
                              <Chart
                                type="bar"
                                data={{ ...combinedData.data, labels: commonLabels }}
                                options={{
                                  responsive: true,
                                  maintainAspectRatio: false,
                                  plugins: {
                                    tooltip: { enabled: true },
                                    legend: {
                                      labels: {
                                        // 凡例のカスタマイズ
                                        generateLabels: generateLabels,
                                      }
                                    },
                                    annotation: {
                                      annotations: {
                                        zeroLine: {
                                          type: "line",
                                          yMin: 0,
                                          yMax: 0,
                                          borderColor: "red",
                                          borderDash: [4, 4],
                                          borderWidth: 2,
                                        },
                                        ...configAnnotations, // 動的に生成したアノテーションをここで展開
                                      }
                                    },
                                    datalabels: {
                                      display: false
                                    },
                                  },
                                  scales: {
                                    x: {
                                      offset: true,
                                      ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                    },
                                    y: {
                                      min: yMin,
                                      max: yMax,
                                      ticks: {
                                        format: {
                                          notation: "standard"
                                        }
                                      }
                                    },
                                  },
                                }}
                              />
                            </Box>
                          </Box>
                        );
                      })}
                    </Flex>
                  </Box>
                );
              })()}

              {/* 顧客需要と設備キャパシティ (Demand & Capacity Chart) */}
              {gapChartDataOriginal && (
                <Box mt={4}>
                  <Heading size="md" mb={2}>
                    {t('features.InvestmentScreening.SimulationNewProduct.heading.demandAndCapacity')}
                  </Heading>
                  <Text>
                    unit:pcs
                  </Text>
                  {(() => {
                    const dataLeft = gapChartDataOriginal;
                    const dataRight = gapChartDataModified ? gapChartDataModified : gapChartDataOriginal;

                    // 選択された設定がある場合は、それらも含めてスケールを計算
                    const allDataSets = [dataLeft, dataRight];
                    selectedConfigIds.forEach(configId => {
                      const chartData = gapChartDataForSavedConfig.find(item => item.configId === configId);
                      if (chartData?.data) {
                        allDataSets.push(chartData.data);
                      }
                    });

                    // すべてのデータセットを考慮してスケールを計算
                    const allData = allDataSets.flatMap(ds =>
                      ds?.datasets?.flatMap((dataset: any) => dataset?.data?.filter((v: any) => v !== null)) || []
                    );
                    const { yMin, yMax } = calcYAxisRange(allData, false);
                    const commonLabels = dataLeft.labels;

                    return (
                      <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4}>
                        <Box textAlign="center">
                          <Heading size="sm" mb={1}>
                            {t('features.InvestmentScreening.SimulationNewProduct.heading.initialPlan')}
                          </Heading>
                          <Box width="30vw" height="calc(30vw * 0.5625)">
                            <Line
                              data={{ ...dataLeft, labels: commonLabels }}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                scales: {
                                  x: {
                                    offset: true,
                                    ticks: { callback: (index) => formatYearMonthByLocale(commonLabels[index]) },
                                  },
                                  y: {
                                    min: yMin,
                                    max: yMax,
                                    ticks: {
                                      format: {
                                        notation: "standard"
                                      },
                                    },
                                  },
                                },
                                spanGaps: true,
                                elements: { point: { radius: 2 } },
                                plugins: {
                                  annotation: {
                                    annotations: {
                                      ...generateAnnotationStarLabels(newProductStartYearMonth, projectData?.purpose),
                                    }
                                  },
                                  datalabels: {
                                    display: false
                                  },
                                },
                              }}
                            />
                          </Box>
                        </Box>
                        <Box textAlign="center">
                          <Heading size="sm" mb={1}>
                            {t('features.InvestmentScreening.SimulationNewProduct.heading.downside')}
                          </Heading>
                          <Box width="30vw" height="calc(30vw * 0.5625)">
                            <Line
                              data={{ ...dataRight, labels: commonLabels }}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                scales: {
                                  x: {
                                    offset: true,
                                    ticks: { callback: (index) => formatYearMonthByLocale(commonLabels[index]) },
                                  },
                                  y: {
                                    min: yMin,
                                    max: yMax,
                                    ticks: {
                                      format: {
                                        notation: "standard"
                                      },
                                    },
                                  },
                                },
                                spanGaps: true,
                                elements: { point: { radius: 2 } },
                                plugins: {
                                  annotation: {
                                    annotations: {
                                      ...generateAnnotationStarLabels(newProductStartYearMonth, projectData?.purpose),
                                    }
                                  },
                                  datalabels: {
                                    display: false
                                  }
                                },
                              }}
                            />
                          </Box>
                        </Box>
                        {selectedConfigIds.map((configId) => {
                          const config = savedConfigs.find(c => c.id === configId);
                          const chartData = gapChartDataForSavedConfig.find(item => item.configId === configId);
                          if (!config || !chartData?.data) return null;
                          return (
                            <Box key={config.id} textAlign="center">
                              <Heading size="sm" mb={1}>
                                {config.name}
                              </Heading>
                              <Box width="30vw" height="calc(30vw * 0.5625)">
                                <Line
                                  data={{ ...chartData.data, labels: commonLabels }}
                                  options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    scales: {
                                      x: {
                                        offset: true,
                                        ticks: { callback: (index) => formatYearMonthByLocale(commonLabels[index]) },
                                      },
                                      y: {
                                        min: yMin,
                                        max: yMax,
                                        ticks: {
                                          format: {
                                            notation: "standard"
                                          },
                                        },
                                      },
                                    },
                                    spanGaps: true,
                                    elements: { point: { radius: 2 } },
                                    plugins: {
                                      datalabels: {
                                        display: false
                                      }
                                    },
                                  }}
                                />
                              </Box>
                            </Box>
                          );
                        })}
                      </Flex>
                    );
                  })()}
                </Box>
              )}

              {/* 設備生産数量からのギャップ (Production Quantity & Gap Chart) */}
              {productionQuantityChartDataOriginal && (
                <Box mt={4}>
                  <Heading size="md" mb={2}>
                    {t('features.InvestmentScreening.SimulationNewProduct.heading.productionQuantityGap')}
                  </Heading>
                  <Text>
                    unit:pcs
                  </Text>
                  {(() => {
                    const dataLeft = productionQuantityChartDataOriginal;
                    const dataRight = productionQuantityChartDataModified ? productionQuantityChartDataModified : productionQuantityChartDataOriginal;

                    // 選択された設定がある場合は、それらも含めてスケールを計算
                    const allDataSets = [dataLeft, dataRight];
                    selectedConfigIds.forEach(configId => {
                      const chartData = productionQuantityChartDataForSavedConfig.find(item => item.configId === configId);
                      if (chartData?.data) {
                        allDataSets.push(chartData.data);
                      }
                    });

                    // すべてのデータセットを考慮してスケールを計算
                    const allData = allDataSets.flatMap(ds =>
                      ds?.datasets?.flatMap((dataset: any) => dataset?.data?.filter((v: any) => v !== null)) || []
                    );
                    const { yMin, yMax } = calcYAxisRange(allData);
                    const commonLabels = dataLeft.labels.length >= dataRight.labels.length
                      ? dataLeft.labels
                      : dataRight.labels;

                    return (
                      <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4}>
                        <Box textAlign="center">
                          <Heading size="sm" mb={1}>
                            {t('features.InvestmentScreening.SimulationNewProduct.heading.initialPlan')}
                          </Heading>
                          <Box width="30vw" height="calc(30vw * 0.5625)">
                            <Chart
                              type="bar"
                              data={{
                                ...dataLeft,
                                labels: commonLabels,
                                datasets: dataLeft.datasets.map((ds: any) =>
                                  ds.type === 'line' ? { ...ds, yAxisID: 'y1' } : ds
                                ),
                              }}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                scales: {
                                  x: {
                                    offset: true,
                                    stacked: true,
                                    ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                  },
                                  y: {
                                    stacked: true,
                                    min: yMin,
                                    max: yMax,
                                    ticks: {
                                      format: {
                                        notation: "standard"
                                      }
                                    }
                                  },
                                  y1: {
                                    display: false,
                                    stacked: false,
                                    min: yMin,
                                    max: yMax,
                                  },
                                },
                                elements: { point: { radius: 2 } },
                                plugins: {
                                  annotation: {
                                    annotations: {
                                      ...generateAnnotationStarLabels(newProductStartYearMonth, projectData?.purpose),
                                    }
                                  },
                                  datalabels: {
                                    display: false,
                                  },
                                },
                              }}
                            />
                          </Box>
                        </Box>
                        <Box textAlign="center">
                          <Heading size="sm" mb={1}>
                            {t('features.InvestmentScreening.SimulationNewProduct.heading.downside')}
                          </Heading>
                          <Box width="30vw" height="calc(30vw * 0.5625)">
                            <Chart
                              type="bar"
                              data={{
                                ...dataRight,
                                labels: commonLabels,
                                datasets: dataRight.datasets.map((ds: any) =>
                                  ds.type === 'line' ? { ...ds, yAxisID: 'y1' } : ds
                                ),
                              }}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                scales: {
                                  x: {
                                    offset: true,
                                    stacked: true,
                                    ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                  },
                                  y: {
                                    stacked: true,
                                    min: yMin,
                                    max: yMax,
                                    ticks: {
                                      format: {
                                        notation: "standard"
                                      }
                                    }
                                  },
                                  y1: {
                                    display: false,
                                    stacked: false,
                                    min: yMin,
                                    max: yMax,
                                  },
                                },
                                elements: { point: { radius: 2 } },
                                plugins: {
                                  annotation: {
                                    annotations: {
                                      ...generateAnnotationStarLabels(newProductStartYearMonth, projectData?.purpose),
                                    }
                                  },
                                  datalabels: {
                                    display: false,
                                  },
                                },
                              }}
                            />
                          </Box>
                        </Box>
                        {selectedConfigIds.map((configId) => {
                          const config = savedConfigs.find(c => c.id === configId);
                          const chartData = productionQuantityChartDataForSavedConfig.find(item => item.configId === configId);
                          if (!config || !chartData?.data) return null;
                          return (
                            <Box key={config.id} textAlign="center">
                              <Heading size="sm" mb={1}>
                                {config.name}
                              </Heading>
                              <Box width="30vw" height="calc(30vw * 0.5625)">
                                <Chart
                                  type="bar"
                                  data={{
                                    ...chartData.data,
                                    labels: commonLabels,
                                    datasets: chartData.data.datasets.map((ds: any) =>
                                      ds.type === 'line' ? { ...ds, yAxisID: 'y1' } : ds
                                    ),
                                  }}
                                  options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    scales: {
                                      x: {
                                        offset: true,
                                        stacked: true,
                                        ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                      },
                                      y: {
                                        stacked: true,
                                        min: yMin,
                                        max: yMax,
                                        ticks: {
                                          format: {
                                            notation: "standard"
                                          }
                                        }
                                      },
                                      y1: {
                                        display: false,
                                        stacked: false,
                                        min: yMin,
                                        max: yMax,
                                      },
                                    },
                                    elements: { point: { radius: 2 } },
                                    plugins: {
                                      datalabels: {
                                        display: false,
                                      },
                                    },
                                  }}
                                />
                              </Box>
                            </Box>
                          );
                        })}
                      </Flex>
                    );
                  })()}
                </Box>
              )}

              {/* 生産キャパグラフ（既存ライン含む） (Existing Line Capacity Chart) */}
              <ExistingLineCapacityPanel
                elq={elq}
                labels={originalProfitAndLossByMonth?.labels ?? []}
                selectedConfigIds={selectedConfigIds}
                savedConfigs={savedConfigs}
                annotationStartYearMonth={newProductStartYearMonth}
                purpose={projectData?.purpose}
                isEditable={!!pagePermissions?.isEditable}
              />

              {/** 最終的な投資判断の理由 **/}
              <FinalInvestmentReasonTextarea
                ref={finalInvestmentReasonRef}
                initialValue={finalInvestmentReasonDraftRef.current}
                onValueChange={(v) => { finalInvestmentReasonDraftRef.current = v; }}
                error={errors.finalInvestmentReason}
              />
            </fieldset >

            {/* Excel出力・確認ボタン */}
            <Flex justify="space-between" mt="20px">
              <Box>
                <Button
                  colorScheme="green"
                  onClick={exportMonthlyProfitLossToExcel}
                  isDisabled={!projectData || !originalProfitAndLossByMonth}
                >
                  {t('features.InvestmentScreening.SimulationNewProduct.button.excelExport')}
                </Button>
              </Box>
              <Flex>
                <Box>
                  <Button
                    colorScheme="blue"
                    name="companyDivision"
                    onClick={handleModalOpen}
                    isDisabled={!pagePermissions?.eabledCompanyDivision}
                    ref={refs["companyDivision"]}
                  >
                    {t('features.InvestmentScreening.SimulationNewProduct.button.divisionConfirm')}
                  </Button>
                  <ConfirmorList confirmorInfo={names["companyDivision"]} width={buttonWidths["companyDivision"]} />
                </Box>
                <Box>
                  <Button
                    ml="10px"
                    colorScheme="blue"
                    name="companyHeadDivision"
                    onClick={handleModalOpen}
                    isDisabled={!pagePermissions?.eabledCompanyHeadDivision}
                    ref={refs["companyHeadDivision"]}
                  >
                    {t('features.InvestmentScreening.SimulationNewProduct.button.headDivisionConfirm')}
                  </Button>
                  <ConfirmorList confirmorInfo={names["companyHeadDivision"]} width={buttonWidths["companyHeadDivision"]} />
                </Box>
              </Flex>
            </Flex>
          </Box>
        )}

        {/* シミュレーション設定 */}
        {mode === "settings" && (
          <>
            <fieldset disabled={!pagePermissions?.isEditable} style={{ minWidth: 0 }}>
              <HStack spacing={4} pt="16px" pb="16px" position="sticky" top="72px" zIndex={101} bgColor="white">
                <Heading size="md">{t('features.InvestmentScreening.SimulationNewProduct.heading.simulationSettings')}</Heading>
                {/* 入力モード切替ボタン */}
                <ButtonGroup spacing={4} isAttached>
                  <ReadOnlyExemptButton
                    colorScheme={inputModeSimulation === "manual" ? "green" : "gray"}
                    onClick={handleManualClick}
                    isLoading={isSpreadSheetLoading}
                  >
                    {t('features.InvestmentScreening.SimulationNewProduct.button.manualInput')}
                  </ReadOnlyExemptButton>
                  <ReadOnlyExemptButton
                    colorScheme={inputModeSimulation === "google" ? "green" : "gray"}
                    onClick={handleGoogleSpreadClick}
                    isLoading={isSpreadSheetLoading}
                  >
                    GoogleSpread
                  </ReadOnlyExemptButton>
                </ButtonGroup>
                <Button
                  colorScheme="blue"
                  onClick={handleSyncData}
                  isDisabled={inputModeSimulation === "manual"}
                  isLoading={isSpreadSheetLoading}
                >
                  {t('features.InvestmentScreening.SimulationNewProduct.button.syncData')}
                </Button>
              </HStack>
              <Box>
                <Box m={1}>
                  {/* 設定保存 */}
                  <Box p={4} border="2px solid #3182ce" borderRadius="md" shadow="md" bg="blue.50">
                    <Heading size="md" mb={4}>{t('features.InvestmentScreening.SimulationNewProduct.heading.saveCurrentSettings')}</Heading>
                    <HStack mb={4}>
                      <Text fontWeight="bold">{t('features.InvestmentScreening.SimulationNewProduct.label.configName')}</Text>
                      <input
                        key={configNameInput}
                        type="text"
                        defaultValue={configNameInput}
                        onBlur={(e) => setConfigNameInput(e.target.value)}
                        placeholder={t('features.InvestmentScreening.SimulationNewProduct.placeholder.configNameInput')}
                        style={{
                          width: "300px",
                          padding: "8px 12px",
                          border: "1px solid #E2E8F0",
                          borderRadius: "4px",
                          fontSize: "14px",
                        }}
                      />
                      <Button colorScheme="blue" onClick={saveSimulationConfig}>
                        {t('common.button.save')}
                      </Button>
                      <Button colorScheme="gray" onClick={() => resetSimulationConfigInputs(true)}>
                        {t('common.button.reset')}
                      </Button>
                      <HStack spacing={2} ml={4} pl={4} borderLeft="1px solid" borderColor="gray.300">
                        <Text fontSize="sm" fontWeight="bold" whiteSpace="nowrap" color={applyDownsideInput ? "red.600" : "gray.500"}>
                          {t('features.InvestmentScreening.SimulationNewProduct.label.stressReflection')}
                        </Text>
                        <Switch
                          isChecked={applyDownsideInput}
                          onChange={(e) => setApplyDownsideInput(e.target.checked)}
                          colorScheme="red"
                          size="md"
                          isDisabled={!pagePermissions?.isEditable}
                        />
                      </HStack>
                    </HStack>

                    {/* 保存された設定一覧 */}
                    {savedConfigs.length > 0 && (
                      <Box
                        mt={4}
                        pointerEvents={inputModeSimulation === "google" ? "none" : "auto"}
                        opacity={inputModeSimulation === "google" ? 0.5 : 1}
                      >
                        <Text fontWeight="bold" mb={2}>{t('features.InvestmentScreening.SimulationNewProduct.label.savedConfigList')}</Text>
                        <VStack align="stretch" spacing={2}>
                          {savedConfigs.map((config) => (
                            <Box
                              key={config.id}
                              p={4}
                              border="2px solid"
                              borderColor={selectedConfigIdForInput === config.id ? "blue.400" : "#E2E8F0"}
                              borderRadius="md"
                              bg={selectedConfigIdForInput === config.id ? "blue.50" : "white"}
                              transition="all 0.2s"
                              _hover={{ borderColor: "blue.300", shadow: "md" }}
                            >
                              <HStack justify="space-between">
                                <HStack spacing={3} flex={1}>
                                  <Checkbox
                                    isChecked={selectedConfigIdForInput === config.id}
                                    onChange={() => handleConfigSelectionForInput(config.id)}
                                    colorScheme="blue"
                                    size="lg"
                                    isDisabled={!pagePermissions?.isEditable}
                                  />
                                  <Text
                                    fontWeight="bold"
                                    fontSize="lg"
                                    cursor="pointer"
                                    onClick={() => pagePermissions?.isEditable && handleConfigSelectionForInput(config.id)}
                                    flex={1}
                                  >
                                    {config.name}
                                  </Text>
                                </HStack>
                                <Button
                                  colorScheme="red"
                                  size="sm"
                                  onClick={() => deleteSimulationConfig(config.id)}
                                >
                                  {t('common.button.delete')}
                                </Button>
                              </HStack>
                            </Box>
                          ))}
                        </VStack>
                      </Box>
                    )}
                  </Box>

                  {/* GoogleSpreadモード時は編集不可（スクロール・アコーディオンは操作可能・通常表示） */}
                  <Box
                    pointerEvents={inputModeSimulation === "google" ? "none" : "auto"}
                    sx={inputModeSimulation === "google" ? {
                      // 全体を半透明にする（直下の子要素に適用）
                      "& > *": { opacity: 0.5 },
                      // アコーディオンの開閉は操作可能・通常表示
                      ".chakra-accordion__button": { pointerEvents: "auto", opacity: 1 },
                      // スクロール可能なコンテナはスクロール操作を許可・通常表示（中の入力要素は引き続き無効）
                      ".chakra-table__container": { pointerEvents: "auto", opacity: 1 },
                      ".chakra-table__container *": { pointerEvents: "none" },
                      // 横スクロール可能なコンテナはスクロール操作を許可・通常表示（中の入力要素は引き続き無効）
                      ".simulation-scrollable-container": { pointerEvents: "auto", opacity: 1 },
                      ".simulation-scrollable-container *": { pointerEvents: "none" },
                      // 稼働日数・稼働率改善のスクロールコンテナはスクロール操作を許可（中の要素は全て無効、アコーディオン・タブのみ操作可能）
                      ".simulation-working-days-container": { pointerEvents: "auto", opacity: 1 },
                      ".simulation-working-days-container *": { pointerEvents: "none" },
                      ".simulation-working-days-container .chakra-accordion__button": { pointerEvents: "auto" },
                      ".simulation-working-days-container .chakra-tabs__tab": { pointerEvents: "auto" },
                    } : undefined}
                  >
                    <Box mt={6} p={4} border="1px solid #ccc" borderRadius="md" shadow="sm">
                      <Text mb={4} fontSize="lg" fontWeight="bold">{isGeneralPurpose ? t('features.InvestmentScreening.SimulationNewProduct.heading.estimatedQuantityAndPriceChange') : t('features.InvestmentScreening.SimulationNewProduct.heading.salesQuantityAndPriceChange')}</Text>
                      {/* 警告メッセージ */}
                      {qpSyncError.warnings.length > 0 && (
                        <Box mb={2}>
                          {qpSyncError.warnings.map((warning, index) => (
                            <Text key={`warn-${index}`} color="blue.500" fontSize="sm">{warning}</Text>
                          ))}
                        </Box>
                      )}
                      {/* 無効値エラーメッセージ */}
                      {qpSyncError.invalidValueErrors.length > 0 && (
                        <Box mb={2}>
                          {qpSyncError.invalidValueErrors.map((error, index) => (
                            <Text key={index} color="orange.500" fontSize="sm">{error}</Text>
                          ))}
                        </Box>
                      )}

                      {/* 数量・単価変更 */}
                      {quantityAndPriceTables.map((tableItem, tableIndex) => {
                        const table = tableItem.data;
                        const currencyName = selectedCurrencyByPartNo.find((item) => item.tableId === table.id)?.name ?? "";
                        const totals = tableTotalsMap.get(table);
                        return (
                          <QuantityAndPriceSection
                            key={table.id}
                            table={table}
                            tableIndex={tableIndex}
                            projectStartDate={safeProjectData.projectStartDate}
                            projectEndDate={safeProjectData.projectEndDate}
                            baseStartYear={baseStartYear}
                            currencyName={currencyName}
                            partNoList={capexPartNo}
                            errors={errors}
                            totalQuantity={totals?.totalQuantity ?? ZERO_DECIMAL}
                            totalSales={totals?.totalSales ?? ZERO_DECIMAL}
                            priceRows={priceRows}
                            setPriceRows={setPriceRows}
                            labelQuantity={labelQuantity}
                            labelPrice={labelPrice}
                            handleInputChange={handleInputChange}
                            getGraphStartMonth={getGraphStartMonth}
                            getGraphEndMonth={getGraphEndMonth}
                          />
                        );
                      })}
                    </Box>

                    {/* 設備・人員構成変更 */}
                    <EquipmentPersonnelChangeSection
                      equipmentAmounts={equipmentAmounts}
                      esSyncError={esSyncError}
                      conditionTable={conditionTable}
                      pagePermissions={pagePermissions}
                      changeEquipmentAmounts={changeEquipmentAmounts}
                      changeEquipmentQuantity={changeEquipmentQuantity}
                      sumEquipmentAmount={sumEquipmentAmount}
                      sumSelectedEquipmentAmount={sumSelectedEquipmentAmount}
                      rateOfChangeAmount={rateOfChangeAmount}
                    />

                    {/* 段階的設備投資 */}
                    <PhasedEquipmentInvestmentSection
                      equipmentAmounts={equipmentAmounts}
                      pciSyncError={pciSyncError}
                      conditionTable={conditionTable}
                      changeEquipmentAmounts={changeEquipmentAmounts}
                    />

                    {/* 稼働日数 */}
                    <Box mt={6} p={4} border="1px solid #ccc" borderRadius="md" shadow="sm">
                      <Text mb={4} fontSize="lg" fontWeight="bold">{t('features.InvestmentScreening.SimulationNewProduct.heading.workingDaysChange')}</Text>
                      {/* 無効値エラーメッセージ */}
                      {workingDaysSyncError.invalidValueErrors.length > 0 && (
                        <Box mb={2}>
                          {workingDaysSyncError.invalidValueErrors.map((error, index) => (
                            <Text key={index} color="orange.500" fontSize="sm">{error}</Text>
                          ))}
                        </Box>
                      )}
                      <WorkingDays
                        showWorkOnHoliday={true}
                        workingDays={improvedWorkingDaysData}
                        setWorkingDays={setImprovedWorkingDaysData}
                        setIsValidWorkingDays={setIsValidWorkingDays}
                        projectStartDate={safeProjectData.projectStartDate}
                        maxHeight="60dvh"
                      />
                    </Box>

                    {/* 稼働率改善 */}
                    <Box mt={6} p={4} border="1px solid #ccc" borderRadius="md" shadow="sm">
                      <Text mb={4} fontSize="lg" fontWeight="bold">{t('features.InvestmentScreening.SimulationNewProduct.heading.availabilityRateImprovement')}</Text>
                      {/* バリデーションエラーメッセージ */}
                      {nonWorkingHoursSyncError.workingHoursErrors.length > 0 && (
                        <Box mb={2}>
                          {nonWorkingHoursSyncError.workingHoursErrors.map((error, index) => (
                            <Text key={index} color="orange.500" fontSize="sm">{error}</Text>
                          ))}
                        </Box>
                      )}
                      {nonWorkingHoursSyncError.nonWorkingHourErrors.length > 0 && (
                        <Box mb={2}>
                          {nonWorkingHoursSyncError.nonWorkingHourErrors.map((error, index) => (
                            <Text key={index} color="orange.500" fontSize="sm">{error}</Text>
                          ))}
                        </Box>
                      )}
                      {/* 無効値エラーメッセージ */}
                      {nonWorkingHoursSyncError.invalidValueErrors.length > 0 && (
                        <Box mb={2}>
                          {nonWorkingHoursSyncError.invalidValueErrors.map((error, index) => (
                            <Text key={index} color="orange.500" fontSize="sm">{error}</Text>
                          ))}
                        </Box>
                      )}
                      <NonWorkingHours
                        isSimulation={true}
                        nonWorkingHoursData={improvedNonWorkingHoursData}
                        setNonWorkingHoursData={setImprovedNonWorkingHoursData}
                        projectStartDate={safeProjectData?.projectStartDate}
                        maxHeight="60dvh"
                      />
                    </Box>

                    {/* 生産工場費用設定 */}
                    <ProductionFactoryCostSection
                      lcSyncError={lcSyncError}
                      scenarioProductionFactoryLaborUnitPrice={scenarioProductionFactoryLaborUnitPrice}
                      setScenarioProductionFactoryLaborUnitPrice={setScenarioProductionFactoryLaborUnitPrice}
                      scenarioProductionFactoryExpenseUnitPrice={scenarioProductionFactoryExpenseUnitPrice}
                      setScenarioProductionFactoryExpenseUnitPrice={setScenarioProductionFactoryExpenseUnitPrice}
                      scenarioBaseLaborCostIncreaseRate={scenarioBaseLaborCostIncreaseRate}
                      setScenarioBaseLaborCostIncreaseRate={setScenarioBaseLaborCostIncreaseRate}
                      currencyData={currencyData}
                      projectData={projectData}
                      originalProfitAndLossByMonth={originalProfitAndLossByMonth}
                      scenarioLaborCostByMonth={scenarioLaborCostByMonth}
                      setScenarioLaborCostByMonth={setScenarioLaborCostByMonth}
                      scenarioOverseasFactoryExpensesByMonth={scenarioOverseasFactoryExpensesByMonth}
                      setScenarioOverseasFactoryExpensesByMonth={setScenarioOverseasFactoryExpensesByMonth}
                      handleSimulationAutoCalculateLaborCost={handleSimulationAutoCalculateLaborCost}
                      isLaborCostCalculating={isLaborCostCalculating}
                    />

                    {/* 歩留改善 */}
                    <Box mt={6} p={4} border="1px solid #ccc" borderRadius="md" shadow="sm">
                      <Text mb={4} fontSize="lg" fontWeight="bold">{t('features.InvestmentScreening.SimulationNewProduct.heading.yieldImprovement')}</Text>
                      {/* 無効値エラーメッセージ */}
                      {yiSyncError.invalidValueErrors.length > 0 && (
                        <Box mb={2}>
                          {yiSyncError.invalidValueErrors.map((error, index) => (
                            <Text key={index} color="orange.500" fontSize="sm">{error}</Text>
                          ))}
                        </Box>
                      )}

                      {/* 歩留改善リスト */}
                      <VStack mt={4} spacing={3} align="stretch">
                        {improvedYieldRateList.map((item, index) => (
                          <YieldImprovementRow
                            key={index}
                            item={item}
                            index={index}
                            isInvalid={errors.yieldRate.isError}
                            errorMessage={errors.yieldRate.errorMessage}
                            minMonth={getGraphStartMonth()}
                            maxMonth={getGraphEndMonth()}
                            isLast={index === improvedYieldRateList.length - 1}
                            isOnly={improvedYieldRateList.length <= 1}
                            getYieldRateFromBom={getYieldRateFromBom}
                            onMonthChange={updateYieldRateMonth}
                            onTextChange={updateYieldRateText}
                            onBlurCommit={updateYieldRateValue}
                            onAdd={addYieldRateImprovement}
                            onRemove={removeYieldRateImprovement}
                          />
                        ))}
                      </VStack>
                    </Box>

                    {/* サイクルタイム短縮 */}
                    <Box mt={6} p={4} border="1px solid #ccc" borderRadius="md" shadow="sm">
                      <Text mb={4} fontSize="lg" fontWeight="bold">{t('features.InvestmentScreening.SimulationNewProduct.heading.cycleTimeReduction')}</Text>
                      {/* 無効値エラーメッセージ */}
                      {ctrSyncError.invalidValueErrors.length > 0 && (
                        <Box mb={2}>
                          {ctrSyncError.invalidValueErrors.map((error, index) => (
                            <Text key={index} color="orange.500" fontSize="sm">{error}</Text>
                          ))}
                        </Box>
                      )}

                      {/* サイクルタイム改善リスト */}
                      <VStack mt={4} spacing={3} align="stretch">
                        {improvedCycleTimeList.map((item, index) => (
                          <CycleTimeImprovementRow
                            key={index}
                            item={item}
                            index={index}
                            isInvalid={errors.cycleTime.isError}
                            errorMessage={errors.cycleTime.errorMessage}
                            minMonth={getGraphStartMonth()}
                            maxMonth={getGraphEndMonth()}
                            cycleTimeMax={CYCLE_TIME_MAX}
                            isLast={index === improvedCycleTimeList.length - 1}
                            isOnly={improvedCycleTimeList.length <= 1}
                            getCycleTimeFromBom={getCycleTimeFromBom}
                            onMonthChange={updateCycleTimeMonth}
                            onTextChange={updateCycleTimeText}
                            onBlurCommit={updateCycleTimeValue}
                            onAdd={addCycleTimeImprovement}
                            onRemove={removeCycleTimeImprovement}
                          />
                        ))}
                      </VStack>
                    </Box>

                  </Box>{/* GoogleSpreadモード時編集不可ラッパー終了 */}

                </Box>
              </Box>
            </fieldset>
          </>
        )}

        {/* 表示対象選択 */}
        {mode === "selection" && (
          <>
            <fieldset disabled={!pagePermissions?.isEditable}>
              <Box mt={4}>
                <Box>
                  <Heading size="md" mb={4}>{t('features.InvestmentScreening.SimulationNewProduct.heading.displayTargetSelection')}</Heading>

                  {savedConfigs.length === 0 ? (
                    <Box p={4} bg="gray.50" borderRadius="md">
                      <Text color="gray.600">
                        {t('features.InvestmentScreening.SimulationNewProduct.message.simulationNotSaved')}
                        <br />
                        {t('features.InvestmentScreening.SimulationNewProduct.message.saveSettingsInTab')}
                      </Text>
                    </Box>
                  ) : (
                    <>
                      <Text mb={4} color="gray.700">
                        {t('features.InvestmentScreening.SimulationNewProduct.label.selectConfigsForComparison')}
                      </Text>

                      <VStack align="stretch" spacing={3}>
                        {savedConfigs.map((config) => (
                          <Box
                            key={config.id}
                            p={4}
                            border="2px solid"
                            borderColor={selectedConfigIds.includes(config.id) ? "blue.400" : "gray.200"}
                            borderRadius="md"
                            bg={selectedConfigIds.includes(config.id) ? "blue.50" : "white"}
                            transition="all 0.2s"
                            _hover={{ borderColor: "blue.300", shadow: "md" }}
                          >
                            <HStack>
                              <Checkbox
                                isChecked={selectedConfigIds.includes(config.id)}
                                onChange={() => toggleConfigSelection(config.id)}
                                colorScheme="blue"
                                size="lg"
                                isDisabled={!pagePermissions?.isEditable}
                              />
                              <Text
                                fontWeight="bold"
                                fontSize="lg"
                                cursor="pointer"
                                onClick={() => pagePermissions?.isEditable && toggleConfigSelection(config.id)}
                                flex={1}
                              >
                                {config.name}
                              </Text>
                            </HStack>
                          </Box>
                        ))}
                      </VStack>

                      {selectedConfigIds.length > 0 && (
                        <Box mt={6} p={4} bg="blue.50" borderRadius="md">
                          <Text fontWeight="bold" mb={2}>
                            {t('features.InvestmentScreening.SimulationNewProduct.label.selectedCount', { count: selectedConfigIds.length })}
                          </Text>
                          <Text fontSize="sm" color="gray.700">
                            {t('features.InvestmentScreening.SimulationNewProduct.label.displayTabDescription')}
                          </Text>
                        </Box>
                      )}
                    </>
                  )}
                </Box>
              </Box>
            </fieldset>
          </>
        )}
      </Box>

      {/* ストレス指数 */}
      {isOpenDownsideIndex && (
        <Draggable defaultPosition={position} cancel="input,span,button,p">
          <Box
            position="fixed"
            top="0"
            left="0"
            bg="white"
            p={4}
            border="1px solid #ccc"
            borderRadius="md"
            shadow="lg"
            zIndex="1000"
            width={DOWNSIDE_INDEX_POPUP_WIDTH}
          >
            <Text mb={2} fontSize="large" fontWeight="bold" whiteSpace="nowrap" width="fit-content">{t('features.InvestmentScreening.SimulationNewProduct.button.downsideIndex')}</Text>
            <Box style={!pagePermissions?.isEditable ? { pointerEvents: 'none', opacity: 0.6 } : {}}>
              <Table
                id="downsideIndexTable"
                variant="simple"
                width={DOWNSIDE_INDEX_TABLE_WIDTH}
                sx={{
                  borderCollapse: "collapse",
                  tableLayout: "fixed",
                  "& th, & td": {
                    border: "1px solid",
                    borderColor: "gray.200",
                    whiteSpace: "normal",
                    minHeight: "2em",
                    overflowWrap: "break-word",
                    padding: "0.5em",
                  },
                }}
              >
                <Thead>
                  <Tr>
                    <Th style={thStyle} bgColor={"transparent"} width="80px" maxWidth="80px">
                      {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.year')}
                    </Th>
                    <Th style={thStyle} bgColor={downsideIndexEnable.isEnabledQuantityChangeOverTime ? "transparent" : "#eee"} width={DOWNSIDE_INDEX_COLUMN_WIDTH} minWidth={DOWNSIDE_INDEX_COLUMN_WIDTH}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.quantityChangeOverTime')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.quantityChangeOverTimeHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledQuantityChangeOverTime} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledQuantityChangeOverTime", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={thStyle} bgColor={downsideIndexEnable.isEnabledFluctuationInQuantity ? "transparent" : "#eee"} width={DOWNSIDE_INDEX_COLUMN_WIDTH}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.quantityFluctuation')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.quantityFluctuationHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledFluctuationInQuantity} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledFluctuationInQuantity", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={thStyle} bgColor={downsideIndexEnable.isEnabledPriceChangeOverTime ? "transparent" : "#eee"} width={DOWNSIDE_INDEX_COLUMN_WIDTH}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.priceChangeOverTime')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.priceChangeOverTimeHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledPriceChangeOverTime} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledPriceChangeOverTime", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={thStyle} bgColor={downsideIndexEnable.isEnabledCustomerProductLifecycle ? "transparent" : "#eee"} width={i18n.language === "en" ? "145px" : DOWNSIDE_INDEX_COLUMN_WIDTH}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.customerProductLifecycle')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.customerProductLifecycleHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledCustomerProductLifecycle} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledCustomerProductLifecycle", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={thStyle} width={i18n.language === "en" ? "163px" : "140px"} bgColor={downsideIndexEnable.isEnabledCurrencyFluctuationToPrice ? "transparent" : "#eee"}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.exchangeRateFluctuationToPrice')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.exchangeRateFluctuationToPriceHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledCurrencyFluctuationToPrice} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledCurrencyFluctuationToPrice", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={thStyle} width={i18n.language === "en" ? "163px" : "140px"} bgColor={downsideIndexEnable.isEnabledCurrencyFluctuationToCost ? "transparent" : "#eee"}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.exchangeRateFluctuationToCost')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.exchangeRateFluctuationToCostHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledCurrencyFluctuationToCost} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledCurrencyFluctuationToCost", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={thStyle} bgColor={downsideIndexEnable.isEnabledRisingMaterialCosts ? "transparent" : "#eee"} width={i18n.language === "en" ? "150px" : DOWNSIDE_INDEX_COLUMN_WIDTH}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.materialCostIncrease')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.materialCostIncreaseHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledRisingMaterialCosts} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledRisingMaterialCosts", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={thStyle} bgColor={downsideIndexEnable.isEnabledRisingLaborCosts ? "transparent" : "#eee"} width={`calc(${DOWNSIDE_INDEX_COLUMN_WIDTH} + 10px)`}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.laborCostIncrease')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.laborCostIncreaseHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledRisingLaborCosts} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledRisingLaborCosts", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={i18n.language === "en" ? { whiteSpace: "normal" } : thStyle} width={i18n.language === "en" ? "300px" : "260px"} bgColor={downsideIndexEnable.isEnabledCompetitorConditionToQuantity ? "transparent" : "#eee"}>
                      <Flex align="center" justify="space-between" gap={2}>
                        <Text as="span">{t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.competitorStatusToQuantity')}</Text>
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.competitorStatusToQuantityHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml="auto" flexShrink={0} isChecked={downsideIndexEnable.isEnabledCompetitorConditionToQuantity} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledCompetitorConditionToQuantity", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={i18n.language === "en" ? { whiteSpace: "normal" } : thStyle} width={i18n.language === "en" ? "300px" : "260px"} bgColor={downsideIndexEnable.isEnabledCompetitorConditionToPrice ? "transparent" : "#eee"}>
                      <Flex align="center" justify="space-between" gap={2}>
                        <Text as="span">{t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.competitorStatusToPrice')}</Text>
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.competitorStatusToPriceHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml="auto" flexShrink={0} isChecked={downsideIndexEnable.isEnabledCompetitorConditionToPrice} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledCompetitorConditionToPrice", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {
                    downsideIndexTableDisplay.map((row, index) => {
                      return <tr>
                        <Td
                          style={tdStyle}
                          bgColor={"transparent"}
                          width={"80px"}
                          maxWidth={"80px"}
                        >{t('features.InvestmentScreening.SimulationNewProduct.label.yearSuffix', { year: row.yearString })}</Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledQuantityChangeOverTime ? "transparent" : "#eee"}
                        >
                          <HStack>
                            {/* 数量経時変化 */}
                            <NumberInput
                              width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                              min={DOWNSIDE_INDEX_MIN}
                              max={DOWNSIDE_INDEX_MAX}
                              precision={1}
                              step={0.1}
                              value={row?.quantityChangeOverTime}
                              clampValueOnBlur={false}
                              onFocus={(e) => {
                                focusedValueRef.current = Number(e.target.value);
                              }}
                              onChange={(value) => {
                                if (!isNaN(Number(value))) {
                                  updateDownsideIndexTableValue(row.yearString, "quantityChangeOverTime", Number(value), false);
                                }
                              }}
                              onBlur={(e) => {
                                let val = Number(e.target.value);
                                // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                if (val === focusedValueRef.current) return;
                                if (val === -0) {
                                  updateDownsideIndexTableValue(row.yearString, "quantityChangeOverTime", 0);
                                } else if (val > DOWNSIDE_INDEX_MAX) {
                                  updateDownsideIndexTableValue(row.yearString, "quantityChangeOverTime", DOWNSIDE_INDEX_MAX);
                                } else if (val < DOWNSIDE_INDEX_MIN) {
                                  updateDownsideIndexTableValue(row.yearString, "quantityChangeOverTime", DOWNSIDE_INDEX_MIN);
                                } else if (!isNaN(val)) {
                                  updateDownsideIndexTableValue(row.yearString, "quantityChangeOverTime", val);
                                }
                              }}
                            >
                              <NumberInputField
                                textAlign="right"
                                onKeyDown={handleKeyDown(row, "quantityChangeOverTime")}
                              />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>%</Text>
                          </HStack>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledFluctuationInQuantity ? "transparent" : "#eee"}
                        >
                          <HStack>
                            {/* 数量上下変動 */}
                            <NumberInput
                              width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                              min={DOWNSIDE_INDEX_MIN}
                              max={DOWNSIDE_INDEX_MAX}
                              precision={1}
                              step={0.1}
                              value={row?.fluctuationInQuantity}
                              clampValueOnBlur={false}
                              onFocus={(e) => {
                                focusedValueRef.current = Number(e.target.value);
                              }}
                              onChange={(value) => {
                                if (!isNaN(Number(value))) {
                                  updateDownsideIndexTableValue(row.yearString, "fluctuationInQuantity", Number(value), false);
                                }
                              }}
                              onBlur={(e) => {
                                let val = Number(e.target.value);
                                // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                if (val === focusedValueRef.current) return;
                                if (val === -0) {
                                  updateDownsideIndexTableValue(row.yearString, "fluctuationInQuantity", 0);
                                } else if (val > DOWNSIDE_INDEX_MAX) {
                                  updateDownsideIndexTableValue(row.yearString, "fluctuationInQuantity", DOWNSIDE_INDEX_MAX);
                                } else if (val < DOWNSIDE_INDEX_MIN) {
                                  updateDownsideIndexTableValue(row.yearString, "fluctuationInQuantity", DOWNSIDE_INDEX_MIN);
                                } else if (!isNaN(val)) {
                                  updateDownsideIndexTableValue(row.yearString, "fluctuationInQuantity", val);
                                }
                              }}
                            >
                              <NumberInputField
                                textAlign="right"
                                onKeyDown={handleKeyDown(row, "fluctuationInQuantity")}
                              />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>%</Text>
                          </HStack>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledPriceChangeOverTime ? "transparent" : "#eee"}
                        >
                          <HStack>
                            {/* 単価経時変化 */}
                            <NumberInput
                              width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                              min={DOWNSIDE_INDEX_MIN}
                              max={DOWNSIDE_INDEX_MAX}
                              precision={1}
                              step={0.1}
                              value={row?.priceChangeOverTime}
                              clampValueOnBlur={false}
                              onFocus={(e) => {
                                focusedValueRef.current = Number(e.target.value);
                              }}
                              onChange={(value) => {
                                if (!isNaN(Number(value))) {
                                  updateDownsideIndexTableValue(row.yearString, "priceChangeOverTime", Number(value), false);
                                }
                              }}
                              onBlur={(e) => {
                                let val = Number(e.target.value);
                                // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                if (val === focusedValueRef.current) return;
                                if (val === -0) {
                                  updateDownsideIndexTableValue(row.yearString, "priceChangeOverTime", 0);
                                } else if (val > DOWNSIDE_INDEX_MAX) {
                                  updateDownsideIndexTableValue(row.yearString, "priceChangeOverTime", DOWNSIDE_INDEX_MAX);
                                } else if (val < DOWNSIDE_INDEX_MIN) {
                                  updateDownsideIndexTableValue(row.yearString, "priceChangeOverTime", DOWNSIDE_INDEX_MIN);
                                } else if (!isNaN(val)) {
                                  updateDownsideIndexTableValue(row.yearString, "priceChangeOverTime", val);
                                }
                              }}
                            >
                              <NumberInputField
                                textAlign="right"
                                onKeyDown={handleKeyDown(row, "priceChangeOverTime")}
                              />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>%</Text>
                          </HStack>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledCustomerProductLifecycle ? "transparent" : "#eee"}
                        >
                          <div style={{
                            position: "relative",
                            width: "100%",
                            height: "100%"
                          }}>
                            <Text
                              style={{
                                position: "absolute",
                                top: "-1px",
                                left: "-1px",
                                width: "calc(100% + 2px)",
                                height: "calc(100% + 2px)",
                                zIndex: "1"
                              }}
                              display={index > 0 ? "block" : "none"}
                              bgColor={downsideIndexEnable.isEnabledCustomerProductLifecycle ? "#fff" : "#eee"}
                            ></Text>
                            <HStack>
                              {/* 顧客製品寿命 */}
                              <NumberInput
                                isDisabled={index > 0}
                                width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                                min={DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MIN}
                                max={DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MAX}
                                step={1}
                                value={row?.customerProductLifecycle}
                                clampValueOnBlur={false}
                                onFocus={(e) => {
                                  focusedValueRef.current = Number(e.target.value);
                                }}
                                onChange={(value) => {
                                  if (!isNaN(Number(value))) {
                                    updateDownsideIndexTableValue(row.yearString, "customerProductLifecycle", Number(value), false);
                                  }
                                }}
                                onBlur={(e) => {
                                  let val = Number(e.target.value);
                                  // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                  if (val === focusedValueRef.current) return;
                                  if (val === -0) {
                                    updateDownsideIndexTableValue(row.yearString, "customerProductLifecycle", 0);
                                  } else if (val > DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MAX) {
                                    updateDownsideIndexTableValue(row.yearString, "customerProductLifecycle", DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MAX);
                                  } else if (val < DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MIN) {
                                    updateDownsideIndexTableValue(row.yearString, "customerProductLifecycle", DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MIN);
                                  } else if (!isNaN(val)) {
                                    updateDownsideIndexTableValue(row.yearString, "customerProductLifecycle", val);
                                  }
                                }}
                              >
                                <NumberInputField
                                  textAlign="right"
                                  onKeyDown={handleKeyDown(row, "customerProductLifecycle")}
                                />
                                <NumberInputStepper>
                                  <NumberIncrementStepper />
                                  <NumberDecrementStepper />
                                </NumberInputStepper>
                              </NumberInput>
                              <Text>%</Text>
                            </HStack>
                          </div>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledCurrencyFluctuationToPrice ? "transparent" : "#eee"}
                        >
                          <HStack>
                            {/* 為替変動(単価) */}
                            <NumberInput
                              width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                              min={DOWNSIDE_INDEX_MIN}
                              max={DOWNSIDE_INDEX_MAX}
                              precision={1}
                              step={0.1}
                              value={row?.currencyFluctuationToPrice}
                              clampValueOnBlur={false}
                              onFocus={(e) => {
                                focusedValueRef.current = Number(e.target.value);
                              }}
                              onChange={(value) => {
                                if (!isNaN(Number(value))) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToPrice", Number(value), false);
                                }
                              }}
                              onBlur={(e) => {
                                let val = Number(e.target.value);
                                // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                if (val === focusedValueRef.current) return;
                                if (val === -0) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToPrice", 0);
                                } else if (val > DOWNSIDE_INDEX_MAX) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToPrice", DOWNSIDE_INDEX_MAX);
                                } else if (val < DOWNSIDE_INDEX_MIN) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToPrice", DOWNSIDE_INDEX_MIN);
                                } else if (!isNaN(val)) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToPrice", val);
                                }
                              }}
                            >
                              <NumberInputField
                                textAlign="right"
                                onKeyDown={handleKeyDown(row, "currencyFluctuationToPrice")}
                              />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>%</Text>
                          </HStack>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledCurrencyFluctuationToCost ? "transparent" : "#eee"}
                        >
                          <HStack>
                            {/* 為替変動(原価) */}
                            <NumberInput
                              width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                              min={DOWNSIDE_INDEX_MIN}
                              max={DOWNSIDE_INDEX_MAX}
                              precision={1}
                              step={0.1}
                              value={row?.currencyFluctuationToCost}
                              clampValueOnBlur={false}
                              onFocus={(e) => {
                                focusedValueRef.current = Number(e.target.value);
                              }}
                              onChange={(value) => {
                                if (!isNaN(Number(value))) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToCost", Number(value), false);
                                }
                              }}
                              onBlur={(e) => {
                                let val = Number(e.target.value);
                                // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                if (val === focusedValueRef.current) return;
                                if (val === -0) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToCost", 0);
                                } else if (val > DOWNSIDE_INDEX_MAX) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToCost", DOWNSIDE_INDEX_MAX);
                                } else if (val < DOWNSIDE_INDEX_MIN) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToCost", DOWNSIDE_INDEX_MIN);
                                } else if (!isNaN(val)) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToCost", val);
                                }
                              }}
                            >
                              <NumberInputField
                                textAlign="right"
                                onKeyDown={handleKeyDown(row, "currencyFluctuationToCost")}
                              />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>%</Text>
                          </HStack>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledRisingMaterialCosts ? "transparent" : "#eee"}
                        >
                          <HStack>
                            {/* 材料高騰 */}
                            <NumberInput
                              width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                              min={DOWNSIDE_INDEX_MIN}
                              max={DOWNSIDE_INDEX_MAX}
                              precision={1}
                              step={0.1}
                              value={row?.risingMaterialCosts}
                              clampValueOnBlur={false}
                              onFocus={(e) => {
                                focusedValueRef.current = Number(e.target.value);
                              }}
                              onChange={(value) => {
                                if (!isNaN(Number(value))) {
                                  updateDownsideIndexTableValue(row.yearString, "risingMaterialCosts", Number(value), false);
                                }
                              }}
                              onBlur={(e) => {
                                let val = Number(e.target.value);
                                // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                if (val === focusedValueRef.current) return;
                                if (val === -0) {
                                  updateDownsideIndexTableValue(row.yearString, "risingMaterialCosts", 0);
                                } else if (val > DOWNSIDE_INDEX_MAX) {
                                  updateDownsideIndexTableValue(row.yearString, "risingMaterialCosts", DOWNSIDE_INDEX_MAX);
                                } else if (val < DOWNSIDE_INDEX_MIN) {
                                  updateDownsideIndexTableValue(row.yearString, "risingMaterialCosts", DOWNSIDE_INDEX_MIN);
                                } else if (!isNaN(val)) {
                                  updateDownsideIndexTableValue(row.yearString, "risingMaterialCosts", val);
                                }
                              }}
                            >
                              <NumberInputField
                                textAlign="right"
                                onKeyDown={handleKeyDown(row, "risingMaterialCosts")}
                              />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>%</Text>
                          </HStack>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledRisingLaborCosts ? "transparent" : "#eee"}
                        >
                          <HStack>
                            {/* 労務費高騰 */}
                            <NumberInput
                              width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                              min={DOWNSIDE_INDEX_MIN}
                              max={DOWNSIDE_INDEX_MAX}
                              precision={1}
                              step={0.1}
                              value={row?.risingLaborCosts}
                              clampValueOnBlur={false}
                              onFocus={(e) => {
                                focusedValueRef.current = Number(e.target.value);
                              }}
                              onChange={(value) => {
                                if (!isNaN(Number(value))) {
                                  updateDownsideIndexTableValue(row.yearString, "risingLaborCosts", Number(value), false);
                                }
                              }}
                              onBlur={(e) => {
                                let val = Number(e.target.value);
                                // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                if (val === focusedValueRef.current) return;
                                if (val === -0) {
                                  updateDownsideIndexTableValue(row.yearString, "risingLaborCosts", 0);
                                } else if (val > DOWNSIDE_INDEX_MAX) {
                                  updateDownsideIndexTableValue(row.yearString, "risingLaborCosts", DOWNSIDE_INDEX_MAX);
                                } else if (val < DOWNSIDE_INDEX_MIN) {
                                  updateDownsideIndexTableValue(row.yearString, "risingLaborCosts", DOWNSIDE_INDEX_MIN);
                                } else if (!isNaN(val)) {
                                  updateDownsideIndexTableValue(row.yearString, "risingLaborCosts", val);
                                }
                              }}
                            >
                              <NumberInputField
                                textAlign="right"
                                onKeyDown={handleKeyDown(row, "risingLaborCosts")}
                              />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>%</Text>
                          </HStack>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledCompetitorConditionToQuantity ? "transparent" : "#eee"}
                        >
                          <div style={{
                            position: "relative",
                            width: "100%",
                            height: "100%"
                          }}>
                            <HStack>
                              {/* 競合状態(数量) */}
                              <Text>{row.competitorConditionToQuantityStringPre === competitorType.NoCompetitor.value ? competitorType.NoCompetitor.name : row.competitorConditionToQuantityStringPre}</Text>
                              <NumberInput
                                width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                                min={DOWNSIDE_INDEX_MIN}
                                max={DOWNSIDE_INDEX_MAX}
                                precision={1}
                                step={0.1}
                                value={row?.competitorConditionToQuantity}
                                clampValueOnBlur={false}
                                onFocus={(e) => {
                                  focusedValueRef.current = Number(e.target.value);
                                }}
                                onChange={(value) => {
                                  if (!isNaN(Number(value))) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToQuantity", Number(value), false);
                                  }
                                }}
                                onBlur={(e) => {
                                  let val = Number(e.target.value);
                                  // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                  if (val === focusedValueRef.current) return;
                                  if (val === -0) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToQuantity", 0);
                                  } else if (val > DOWNSIDE_INDEX_MAX) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToQuantity", DOWNSIDE_INDEX_MAX);
                                  } else if (val < DOWNSIDE_INDEX_MIN) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToQuantity", DOWNSIDE_INDEX_MIN);
                                  } else if (!isNaN(val)) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToQuantity", val);
                                  }
                                }}
                              >
                                <NumberInputField
                                  textAlign="right"
                                  onKeyDown={handleKeyDown(row, "competitorConditionToQuantity")}
                                />
                                <NumberInputStepper>
                                  <NumberIncrementStepper />
                                  <NumberDecrementStepper />
                                </NumberInputStepper>
                              </NumberInput>
                              <Text>%</Text>
                            </HStack>
                          </div>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledCompetitorConditionToPrice ? "transparent" : "#eee"}
                        >
                          <div style={{
                            position: "relative",
                            width: "100%",
                            height: "100%"
                          }}>
                            <HStack>
                              {/* 競合状態(単価) */}
                              <Text>{row.competitorConditionToPriceStringPre === competitorType.NoCompetitor.value ? competitorType.NoCompetitor.name : row.competitorConditionToPriceStringPre}</Text>
                              <NumberInput
                                width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                                min={DOWNSIDE_INDEX_MIN}
                                max={DOWNSIDE_INDEX_MAX}
                                precision={1}
                                step={0.1}
                                value={row?.competitorConditionToPrice}
                                clampValueOnBlur={false}
                                onFocus={(e) => {
                                  focusedValueRef.current = Number(e.target.value);
                                }}
                                onChange={(value) => {
                                  if (!isNaN(Number(value))) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToPrice", Number(value), false);
                                  }
                                }}
                                onBlur={(e) => {
                                  let val = Number(e.target.value);
                                  // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                  if (val === focusedValueRef.current) return;
                                  if (val === -0) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToPrice", 0);
                                  } else if (val > DOWNSIDE_INDEX_MAX) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToPrice", DOWNSIDE_INDEX_MAX);
                                  } else if (val < DOWNSIDE_INDEX_MIN) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToPrice", DOWNSIDE_INDEX_MIN);
                                  } else if (!isNaN(val)) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToPrice", val);
                                  }
                                }}
                              >
                                <NumberInputField
                                  textAlign="right"
                                  onKeyDown={handleKeyDown(row, "competitorConditionToPrice")}
                                />
                                <NumberInputStepper>
                                  <NumberIncrementStepper />
                                  <NumberDecrementStepper />
                                </NumberInputStepper>
                              </NumberInput>
                              <Text>%</Text>
                            </HStack>
                          </div>
                        </Td>
                      </tr>
                    })
                  }
                </Tbody>
              </Table>

            </Box>
            <Box mt={2} display="flex" justifyContent="flex-end">
              <Button colorScheme="gray" mr={3} isDisabled={!pagePermissions?.isEditable} onClick={() => { resetStressIndex(); }}>
                {t('common.button.reset')}
              </Button>
              <Button colorScheme="gray" mr={3} isDisabled={!pagePermissions?.isEditable} onClick={(e) => handleSaveDownsideIndex(e)}>
                {t('common.button.save')}
              </Button>
              <Button colorScheme="gray" mr={3} onClick={() => { setIsOpenDownsideIndex(false) }}>
                {t('common.button.close')}
              </Button>
            </Box>
          </Box>
        </Draggable>
      )}

      {/* 確認モーダル */}
      < Modal isOpen={isOpenConfirmModal} onClose={onCloseConfirmModal} size="md" >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('features.InvestmentScreening.SimulationNewProduct.modal.confirmTitle', { title: TITLE })}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>{t('features.InvestmentScreening.SimulationNewProduct.modal.confirmMessage')}</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} isDisabled={isSaving} isLoading={isSaving} onClick={(e) => handleConfirm(e)}>
              {t('common.button.save')}
            </Button>
            <Button variant="ghost" onClick={onCloseConfirmModal}>
              {t('common.button.cancel')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal >
    </Box>
  );
};

export default SimulationNewProduct;
